//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { getBaseUrl } from '@env/utils';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class ApiClientBase {
  constructor() {
  }

  getBaseUrl(path: string) {
    return getBaseUrl() + path;
  }
}

export interface IAccountClient {
    /**
     * Get User Info
     */
    getUserInfo(): Observable<ApplicationResultOfUserInfoDto>;
    /**
     * Update User Info
     */
    updateProfile(command: UpdateUserProfileCommand): Observable<ApplicationResult>;
    /**
     * Send Confirmation Link
     */
    sendConfimationLink(command: VerifyUser2FARequestCommand): Observable<ApplicationResult>;
    /**
     * Login
     */
    login(command: LoginCommand): Observable<ApplicationResultOfAccountResultDto>;
    /**
     * Logout
     */
    logout(): Observable<ApplicationResultOfAccountResultDto>;
    /**
     * Refresh Token
     */
    refreshToken(command: RefreshAuthTokenCommand): Observable<ApplicationResultOfAccountResultDto>;
    /**
     * Forgot Password
     */
    resetPasswordRequest(command: ResetPasswordRequestCommand): Observable<ApplicationResult>;
    /**
     * Reset Password
     */
    resetPassword(command: ResetPasswordCommand): Observable<ApplicationResult>;
    /**
     * Register Company User
     */
    registerCompany(command: RegisterCompanyUserCommand): Observable<ApplicationResult>;
    /**
     * Register Internal Company User
     */
    registerInternalCompany(command: RegisterInternalCompanyUserCommand): Observable<ApplicationResultOfCreateCompanyResponse>;
    /**
     * Verify  User
     */
    verifyUser(command: VerifyUserCommand): Observable<ApplicationResultOfUserVerificationResultDto>;
    /**
     * Company User Exist
     */
    companyUserExist(command: CompanyUserExistCommand): Observable<ApplicationResult>;
    /**
     * Register Reviewer
     */
    registerReviewer(command: RegisterReviewerCommand): Observable<ApplicationResult>;
    /**
     * Accept Reviewer Invite
     */
    acceptReviewerInvite(command: AcceptCompanyStaffReviewerInviteCommand): Observable<ApplicationResultOfAcceptReviewerInviteResponse>;
    /**
     * Demo Join Request
     */
    demoJoinRequest(command: RequestJoinCommand): Observable<ApplicationResult>;
    /**
     * Change Password
     */
    changePassword(command: ChangePasswordCommand): Observable<ApplicationResult>;
    /**
     * Get Permissions
     */
    getPermissions(): Observable<ApplicationResultOfListOfUserCompanyPermissionsDto>;
}

@Injectable({
    providedIn: 'root'
})
export class AccountClient extends ApiClientBase implements IAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get User Info
     */
    getUserInfo(): Observable<ApplicationResultOfUserInfoDto> {
        let url_ = this.baseUrl + "/api/account";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfUserInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfUserInfoDto>;
        }));
    }

    protected processGetUserInfo(response: HttpResponseBase): Observable<ApplicationResultOfUserInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfUserInfoDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update User Info
     */
    updateProfile(command: UpdateUserProfileCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateProfile(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send Confirmation Link
     */
    sendConfimationLink(command: VerifyUser2FARequestCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConfimationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfimationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processSendConfimationLink(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Login
     */
    login(command: LoginCommand): Observable<ApplicationResultOfAccountResultDto> {
        let url_ = this.baseUrl + "/api/account/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAccountResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAccountResultDto>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<ApplicationResultOfAccountResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAccountResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Logout
     */
    logout(): Observable<ApplicationResultOfAccountResultDto> {
        let url_ = this.baseUrl + "/api/account/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAccountResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAccountResultDto>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<ApplicationResultOfAccountResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAccountResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Refresh Token
     */
    refreshToken(command: RefreshAuthTokenCommand): Observable<ApplicationResultOfAccountResultDto> {
        let url_ = this.baseUrl + "/api/account/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAccountResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAccountResultDto>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<ApplicationResultOfAccountResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAccountResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Forgot Password
     */
    resetPasswordRequest(command: ResetPasswordRequestCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/account/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processResetPasswordRequest(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reset Password
     */
    resetPassword(command: ResetPasswordCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/account/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Register Company User
     */
    registerCompany(command: RegisterCompanyUserCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/account/register/company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processRegisterCompany(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Register Internal Company User
     */
    registerInternalCompany(command: RegisterInternalCompanyUserCommand): Observable<ApplicationResultOfCreateCompanyResponse> {
        let url_ = this.baseUrl + "/api/account/register/internalcompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterInternalCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterInternalCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCreateCompanyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCreateCompanyResponse>;
        }));
    }

    protected processRegisterInternalCompany(response: HttpResponseBase): Observable<ApplicationResultOfCreateCompanyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCreateCompanyResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Verify  User
     */
    verifyUser(command: VerifyUserCommand): Observable<ApplicationResultOfUserVerificationResultDto> {
        let url_ = this.baseUrl + "/api/account/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfUserVerificationResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfUserVerificationResultDto>;
        }));
    }

    protected processVerifyUser(response: HttpResponseBase): Observable<ApplicationResultOfUserVerificationResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfUserVerificationResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Company User Exist
     */
    companyUserExist(command: CompanyUserExistCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/account/company-user-exist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyUserExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyUserExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processCompanyUserExist(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Register Reviewer
     */
    registerReviewer(command: RegisterReviewerCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/account/register/reviewer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processRegisterReviewer(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Accept Reviewer Invite
     */
    acceptReviewerInvite(command: AcceptCompanyStaffReviewerInviteCommand): Observable<ApplicationResultOfAcceptReviewerInviteResponse> {
        let url_ = this.baseUrl + "/api/account/register/reviewer/invite/accept";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptReviewerInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptReviewerInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAcceptReviewerInviteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAcceptReviewerInviteResponse>;
        }));
    }

    protected processAcceptReviewerInvite(response: HttpResponseBase): Observable<ApplicationResultOfAcceptReviewerInviteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAcceptReviewerInviteResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Demo Join Request
     */
    demoJoinRequest(command: RequestJoinCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/account/demo-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDemoJoinRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDemoJoinRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDemoJoinRequest(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Change Password
     */
    changePassword(command: ChangePasswordCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/account/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Permissions
     */
    getPermissions(): Observable<ApplicationResultOfListOfUserCompanyPermissionsDto> {
        let url_ = this.baseUrl + "/api/account/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfUserCompanyPermissionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfUserCompanyPermissionsDto>;
        }));
    }

    protected processGetPermissions(response: HttpResponseBase): Observable<ApplicationResultOfListOfUserCompanyPermissionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfUserCompanyPermissionsDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAdminAdditionalServicesClient {
    /**
     * Reviewer Type Additional Services
     */
    getAll(): Observable<ApplicationResultOfListOfAdditionalServiceWithReviewerTypeDto>;
    /**
     * Update Reviewer Type Additional Service Status
     */
    updateStatus(id: number, command: UpdateReviewerTypeAdditionalCheckStatusCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class AdminAdditionalServicesClient extends ApiClientBase implements IAdminAdditionalServicesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Reviewer Type Additional Services
     */
    getAll(): Observable<ApplicationResultOfListOfAdditionalServiceWithReviewerTypeDto> {
        let url_ = this.baseUrl + "/api/adminAdditionalServices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfAdditionalServiceWithReviewerTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfAdditionalServiceWithReviewerTypeDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApplicationResultOfListOfAdditionalServiceWithReviewerTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfAdditionalServiceWithReviewerTypeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Reviewer Type Additional Service Status
     */
    updateStatus(id: number, command: UpdateReviewerTypeAdditionalCheckStatusCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/adminAdditionalServices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAdminAgenciesClient {
    /**
     * Get Agencies
     */
    getAll(): Observable<ApplicationResultOfListOfAgencyDto>;
    /**
     * Create Agency
     */
    create(command: CreateAgencyCommand): Observable<ApplicationResultOfAgencyDto>;
    /**
     * Add Agency Project
     */
    addProject(id: number, projectId: number): Observable<ApplicationResult>;
    /**
     * Get Agency Projects
     */
    getProjects(id: number): Observable<ApplicationResultOfListOfLookUpDto>;
}

@Injectable({
    providedIn: 'root'
})
export class AdminAgenciesClient extends ApiClientBase implements IAdminAgenciesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Agencies
     */
    getAll(): Observable<ApplicationResultOfListOfAgencyDto> {
        let url_ = this.baseUrl + "/api/adminAgencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfAgencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfAgencyDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApplicationResultOfListOfAgencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfAgencyDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Agency
     */
    create(command: CreateAgencyCommand): Observable<ApplicationResultOfAgencyDto> {
        let url_ = this.baseUrl + "/api/adminAgencies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAgencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAgencyDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApplicationResultOfAgencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAgencyDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add Agency Project
     */
    addProject(id: number, projectId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/adminAgencies/{id}/projects/{projectId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processAddProject(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Agency Projects
     */
    getProjects(id: number): Observable<ApplicationResultOfListOfLookUpDto> {
        let url_ = this.baseUrl + "/api/adminAgencies/{id}/projects";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfLookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfLookUpDto>;
        }));
    }

    protected processGetProjects(response: HttpResponseBase): Observable<ApplicationResultOfListOfLookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfLookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAdminAnnouncementClient {
    /**
     * Get announcements to manage
     */
    getAnnouncementsToManage(): Observable<ApplicationResultOfAnnouncementManageDto>;
    /**
     * Save announcements
     */
    saveAnnouncements(request: SaveAnnouncementsCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class AdminAnnouncementClient extends ApiClientBase implements IAdminAnnouncementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get announcements to manage
     */
    getAnnouncementsToManage(): Observable<ApplicationResultOfAnnouncementManageDto> {
        let url_ = this.baseUrl + "/api/adminAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnouncementsToManage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnouncementsToManage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAnnouncementManageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAnnouncementManageDto>;
        }));
    }

    protected processGetAnnouncementsToManage(response: HttpResponseBase): Observable<ApplicationResultOfAnnouncementManageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAnnouncementManageDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save announcements
     */
    saveAnnouncements(request: SaveAnnouncementsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/adminAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAnnouncements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAnnouncements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processSaveAnnouncements(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAdminBillingClient {
    getTempBilling(): Observable<ApplicationResultOfListOfTempBillingDto>;
}

@Injectable({
    providedIn: 'root'
})
export class AdminBillingClient extends ApiClientBase implements IAdminBillingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getTempBilling(): Observable<ApplicationResultOfListOfTempBillingDto> {
        let url_ = this.baseUrl + "/api/adminBilling";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTempBilling(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTempBilling(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfTempBillingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfTempBillingDto>;
        }));
    }

    protected processGetTempBilling(response: HttpResponseBase): Observable<ApplicationResultOfListOfTempBillingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfTempBillingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAdminCaseClient {
    /**
     * Case
     * @param companyId (optional) 
     */
    getCompanyCasesForAdmin(companyId?: number | undefined): Observable<ApplicationResultOfListOfLookUpDto>;
}

@Injectable({
    providedIn: 'root'
})
export class AdminCaseClient extends ApiClientBase implements IAdminCaseClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Case
     * @param companyId (optional) 
     */
    getCompanyCasesForAdmin(companyId?: number | undefined): Observable<ApplicationResultOfListOfLookUpDto> {
        let url_ = this.baseUrl + "/api/adminCase/get-company-cases?";
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyCasesForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyCasesForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfLookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfLookUpDto>;
        }));
    }

    protected processGetCompanyCasesForAdmin(response: HttpResponseBase): Observable<ApplicationResultOfListOfLookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfLookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAdminClient {
    /**
     * Search Reviewers
     * @param query (optional) 
     */
    searchReviewers(query?: SearchReviewersQuery | undefined): Observable<ApplicationResultOfListOfReviewerSearchDto>;
    /**
     * Notification Types
     */
    notificationTypes(): Observable<ApplicationResultOfListOfNotificationTypeDto>;
    /**
     * Notifications History
     */
    notificationsHistory(query: NotificationsHistoryQuery): Observable<ApplicationResultOfPaginatedResultOfNotificationsHistoryDto>;
}

@Injectable({
    providedIn: 'root'
})
export class AdminClient extends ApiClientBase implements IAdminClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Search Reviewers
     * @param query (optional) 
     */
    searchReviewers(query?: SearchReviewersQuery | undefined): Observable<ApplicationResultOfListOfReviewerSearchDto> {
        let url_ = this.baseUrl + "/api/admin/search?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerSearchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerSearchDto>;
        }));
    }

    protected processSearchReviewers(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerSearchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerSearchDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Notification Types
     */
    notificationTypes(): Observable<ApplicationResultOfListOfNotificationTypeDto> {
        let url_ = this.baseUrl + "/api/admin/notification-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfNotificationTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfNotificationTypeDto>;
        }));
    }

    protected processNotificationTypes(response: HttpResponseBase): Observable<ApplicationResultOfListOfNotificationTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfNotificationTypeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Notifications History
     */
    notificationsHistory(query: NotificationsHistoryQuery): Observable<ApplicationResultOfPaginatedResultOfNotificationsHistoryDto> {
        let url_ = this.baseUrl + "/api/admin/notifications-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationsHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationsHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfPaginatedResultOfNotificationsHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfPaginatedResultOfNotificationsHistoryDto>;
        }));
    }

    protected processNotificationsHistory(response: HttpResponseBase): Observable<ApplicationResultOfPaginatedResultOfNotificationsHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfPaginatedResultOfNotificationsHistoryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAdminReviewerBackgroundCheckClient {
    /**
     * Get All Reviewers Background Checks
     */
    getAll(): Observable<ApplicationResultOfListOfBackgroundCheckReviewerDto>;
    /**
     * Create Reviewer Background Check
     */
    create(request: CreateReviewerBackgroundCheckCommand): Observable<ApplicationResultOfBackgroundCheckDto>;
    /**
     * Update Reviewer Background Check
     */
    update(id: number, request: UpdateReviewerBackgroundCheckCommand): Observable<ApplicationResultOfBackgroundCheckDto>;
    /**
     * Delete Reviewer Background Check
     */
    delete(id: number): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class AdminReviewerBackgroundCheckClient extends ApiClientBase implements IAdminReviewerBackgroundCheckClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All Reviewers Background Checks
     */
    getAll(): Observable<ApplicationResultOfListOfBackgroundCheckReviewerDto> {
        let url_ = this.baseUrl + "/api/adminReviewerBackgroundCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfBackgroundCheckReviewerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfBackgroundCheckReviewerDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApplicationResultOfListOfBackgroundCheckReviewerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfBackgroundCheckReviewerDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Reviewer Background Check
     */
    create(request: CreateReviewerBackgroundCheckCommand): Observable<ApplicationResultOfBackgroundCheckDto> {
        let url_ = this.baseUrl + "/api/adminReviewerBackgroundCheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfBackgroundCheckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfBackgroundCheckDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApplicationResultOfBackgroundCheckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfBackgroundCheckDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Reviewer Background Check
     */
    update(id: number, request: UpdateReviewerBackgroundCheckCommand): Observable<ApplicationResultOfBackgroundCheckDto> {
        let url_ = this.baseUrl + "/api/adminReviewerBackgroundCheck/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfBackgroundCheckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfBackgroundCheckDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApplicationResultOfBackgroundCheckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfBackgroundCheckDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Reviewer Background Check
     */
    delete(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/adminReviewerBackgroundCheck/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAdminReviewerLanguageTestClient {
    /**
     * Get All Reviewers Language Tests
     */
    getAll(): Observable<ApplicationResultOfListOfLanguageTestReviewerDto>;
    /**
     * Create Reviewers Language Tests
     */
    createTest(command: CreateReviewerLanguageTestCommand): Observable<ApplicationResultOfReviewerLanguageTestDto>;
    /**
     * Update Reviewers Language Tests
     */
    updateTest(id: number, command: UpdateReviewerLanguageTestCommand): Observable<ApplicationResultOfReviewerLanguageTestDto>;
    /**
     * Delete Reviewers Language Tests
     */
    deleteTest(id: number): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class AdminReviewerLanguageTestClient extends ApiClientBase implements IAdminReviewerLanguageTestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All Reviewers Language Tests
     */
    getAll(): Observable<ApplicationResultOfListOfLanguageTestReviewerDto> {
        let url_ = this.baseUrl + "/api/adminReviewerLanguageTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfLanguageTestReviewerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfLanguageTestReviewerDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApplicationResultOfListOfLanguageTestReviewerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfLanguageTestReviewerDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Reviewers Language Tests
     */
    createTest(command: CreateReviewerLanguageTestCommand): Observable<ApplicationResultOfReviewerLanguageTestDto> {
        let url_ = this.baseUrl + "/api/adminReviewerLanguageTest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerLanguageTestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerLanguageTestDto>;
        }));
    }

    protected processCreateTest(response: HttpResponseBase): Observable<ApplicationResultOfReviewerLanguageTestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerLanguageTestDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Reviewers Language Tests
     */
    updateTest(id: number, command: UpdateReviewerLanguageTestCommand): Observable<ApplicationResultOfReviewerLanguageTestDto> {
        let url_ = this.baseUrl + "/api/adminReviewerLanguageTest/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerLanguageTestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerLanguageTestDto>;
        }));
    }

    protected processUpdateTest(response: HttpResponseBase): Observable<ApplicationResultOfReviewerLanguageTestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerLanguageTestDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Reviewers Language Tests
     */
    deleteTest(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/adminReviewerLanguageTest/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteTest(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAdminReviewersClient {
    /**
     * Get Admin Reviewers
     */
    getAll(): Observable<ApplicationResultOfListOfAdminReviewerDto>;
    /**
     * Set Reviewer Global Block
     */
    updateGlobalBlock(id: number, command: UpdateGlobalBlockCommand): Observable<ApplicationResult>;
    /**
     * Set Reviewer Agency
     */
    updateAgency(id: number, command: UpdateReviewerAgencyCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class AdminReviewersClient extends ApiClientBase implements IAdminReviewersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Admin Reviewers
     */
    getAll(): Observable<ApplicationResultOfListOfAdminReviewerDto> {
        let url_ = this.baseUrl + "/api/adminReviewers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfAdminReviewerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfAdminReviewerDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApplicationResultOfListOfAdminReviewerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfAdminReviewerDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Set Reviewer Global Block
     */
    updateGlobalBlock(id: number, command: UpdateGlobalBlockCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/adminReviewers/{id}/block";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGlobalBlock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGlobalBlock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateGlobalBlock(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Set Reviewer Agency
     */
    updateAgency(id: number, command: UpdateReviewerAgencyCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/adminReviewers/{id}/agency";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateAgency(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAnnouncementClient {
    /**
     * Get Active Announcement
     */
    getAnnouncement(): Observable<ApplicationResultOfAnnouncementDto>;
    /**
     * Mark Announcement as Acknowledged
     */
    markAnnouncementAcknowledged(request: MarkAnnouncementAcknowledgedCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class AnnouncementClient extends ApiClientBase implements IAnnouncementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Active Announcement
     */
    getAnnouncement(): Observable<ApplicationResultOfAnnouncementDto> {
        let url_ = this.baseUrl + "/api/announcement";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnouncement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnouncement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAnnouncementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAnnouncementDto>;
        }));
    }

    protected processGetAnnouncement(response: HttpResponseBase): Observable<ApplicationResultOfAnnouncementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAnnouncementDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Mark Announcement as Acknowledged
     */
    markAnnouncementAcknowledged(request: MarkAnnouncementAcknowledgedCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/announcement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAnnouncementAcknowledged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAnnouncementAcknowledged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processMarkAnnouncementAcknowledged(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBillingClient {
    getTempBilling(): Observable<ApplicationResultOfListOfTempBillingDto>;
}

@Injectable({
    providedIn: 'root'
})
export class BillingClient extends ApiClientBase implements IBillingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getTempBilling(): Observable<ApplicationResultOfListOfTempBillingDto> {
        let url_ = this.baseUrl + "/api/billing";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTempBilling(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTempBilling(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfTempBillingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfTempBillingDto>;
        }));
    }

    protected processGetTempBilling(response: HttpResponseBase): Observable<ApplicationResultOfListOfTempBillingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfTempBillingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBoldsignClient {
    signDocument(command: SignBoldsignDocumentCommand): Observable<ApplicationResult>;
    /**
     * Decline
     */
    declineDocument(command: DeclineBoldsignDocumentCommand): Observable<ApplicationResult>;
    getDocument(documentId: number): Observable<ApplicationResultOfDocumentDto>;
    /**
     * Webhook for BoldSign document status update
     */
    webhook(): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class BoldsignClient extends ApiClientBase implements IBoldsignClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    signDocument(command: SignBoldsignDocumentCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/boldsign/sign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processSignDocument(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Decline
     */
    declineDocument(command: DeclineBoldsignDocumentCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/boldsign/decline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeclineDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeclineDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeclineDocument(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocument(documentId: number): Observable<ApplicationResultOfDocumentDto> {
        let url_ = this.baseUrl + "/api/boldsign/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfDocumentDto>;
        }));
    }

    protected processGetDocument(response: HttpResponseBase): Observable<ApplicationResultOfDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Webhook for BoldSign document status update
     */
    webhook(): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/boldsign/webhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processWebhook(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBoldsignTemplatesClient {
    /**
     * Get Boldsign Tempates of company
     * @param showDisabled (optional) 
     * @param type (optional) 
     */
    getTemplates(showDisabled?: boolean | undefined, type?: BoldsignDocumentType | null | undefined): Observable<ApplicationResultOfListOfBoldsignTemplateDto>;
    /**
     * Create Boldsign Tempate of company
     * @param name (optional) 
     * @param description (optional) 
     * @param documentTitle (optional) 
     * @param documentMessage (optional) 
     * @param file (optional) 
     */
    createTemplate(name?: string | undefined, description?: string | null | undefined, documentTitle?: string | null | undefined, documentMessage?: string | null | undefined, file?: FileParameter | null | undefined): Observable<ApplicationResultOfBoldSignTemplateCreateResult>;
    /**
     * Get Boldsign Tempate of company
     */
    getTemplate(templateId: number): Observable<ApplicationResultOfBoldsignTemplateEditDto>;
    /**
     * Update Boldsign Template of company
     */
    updateTemplate(templateId: number, command: UpdateBoldsignTemplateCommand): Observable<ApplicationResultOfBoldsignTemplateEditDto>;
    /**
     * Get Boldsign Tempate Status of company
     */
    getTemplateStatus(templateId: number): Observable<ApplicationResultOfBoldsignTemplateStatus>;
    /**
     * Update Boldsign Document Status
     */
    updateStatus(templateId: number, command: UpdateBoldsignTemplateStatusCommand): Observable<ApplicationResult>;
    /**
     * Copy Boldsign Template of company
     */
    copyTemplate(templateId: number, command: CopyBoldsignTemplateCommand): Observable<ApplicationResultOfInteger>;
    /**
     * Delete Boldsign Document of company
     */
    deleteTemplate(documentId: number): Observable<ApplicationResult>;
    /**
     * Get Boldsign requests
     * @param reviewerTypeId (optional) 
     * @param reviewerId (optional) 
     */
    getBoldsignDocuments(reviewerTypeId?: number | null | undefined, reviewerId?: number | null | undefined): Observable<ApplicationResultOfListOfBoldsignDocumentDto>;
    /**
     * Get Boldsign Template Usages
     */
    getTemplateUsages(templateId: number): Observable<ApplicationResultOfListOfBoldsignTemplateUsageDto>;
    /**
     * Get Boldsign Template Signers
     */
    getTemplateSigners(templateId: number): Observable<ApplicationResultOfListOfBoldsignTemplateSignerDto>;
    /**
     * Get Company Signed Documents
     * @param reviewerTypeId (optional) 
     */
    getCompanySignedDocuments(reviewerTypeId?: number | null | undefined): Observable<ApplicationResultOfListOfBoldsignTemplateSignerDto>;
    /**
     * Update Boldsign Document Status
     * @param isChanged (optional) 
     */
    validateBoldSignTemplate(templateId: number, isChanged?: boolean | undefined): Observable<ApplicationResult>;
    /**
     * Sign a Document
     */
    signDocument(command: SignDocumentCommand): Observable<ApplicationResultOfLinkRequestResult>;
}

@Injectable({
    providedIn: 'root'
})
export class BoldsignTemplatesClient extends ApiClientBase implements IBoldsignTemplatesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Boldsign Tempates of company
     * @param showDisabled (optional) 
     * @param type (optional) 
     */
    getTemplates(showDisabled?: boolean | undefined, type?: BoldsignDocumentType | null | undefined): Observable<ApplicationResultOfListOfBoldsignTemplateDto> {
        let url_ = this.baseUrl + "/api/boldsignTemplates?";
        if (showDisabled === null)
            throw new globalThis.Error("The parameter 'showDisabled' cannot be null.");
        else if (showDisabled !== undefined)
            url_ += "ShowDisabled=" + encodeURIComponent("" + showDisabled) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfBoldsignTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfBoldsignTemplateDto>;
        }));
    }

    protected processGetTemplates(response: HttpResponseBase): Observable<ApplicationResultOfListOfBoldsignTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfBoldsignTemplateDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Boldsign Tempate of company
     * @param name (optional) 
     * @param description (optional) 
     * @param documentTitle (optional) 
     * @param documentMessage (optional) 
     * @param file (optional) 
     */
    createTemplate(name?: string | undefined, description?: string | null | undefined, documentTitle?: string | null | undefined, documentMessage?: string | null | undefined, file?: FileParameter | null | undefined): Observable<ApplicationResultOfBoldSignTemplateCreateResult> {
        let url_ = this.baseUrl + "/api/boldsignTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name === null || name === undefined)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (documentTitle !== null && documentTitle !== undefined)
            content_.append("DocumentTitle", documentTitle.toString());
        if (documentMessage !== null && documentMessage !== undefined)
            content_.append("DocumentMessage", documentMessage.toString());
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfBoldSignTemplateCreateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfBoldSignTemplateCreateResult>;
        }));
    }

    protected processCreateTemplate(response: HttpResponseBase): Observable<ApplicationResultOfBoldSignTemplateCreateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfBoldSignTemplateCreateResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Boldsign Tempate of company
     */
    getTemplate(templateId: number): Observable<ApplicationResultOfBoldsignTemplateEditDto> {
        let url_ = this.baseUrl + "/api/boldsignTemplates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfBoldsignTemplateEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfBoldsignTemplateEditDto>;
        }));
    }

    protected processGetTemplate(response: HttpResponseBase): Observable<ApplicationResultOfBoldsignTemplateEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfBoldsignTemplateEditDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Boldsign Template of company
     */
    updateTemplate(templateId: number, command: UpdateBoldsignTemplateCommand): Observable<ApplicationResultOfBoldsignTemplateEditDto> {
        let url_ = this.baseUrl + "/api/boldsignTemplates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfBoldsignTemplateEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfBoldsignTemplateEditDto>;
        }));
    }

    protected processUpdateTemplate(response: HttpResponseBase): Observable<ApplicationResultOfBoldsignTemplateEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfBoldsignTemplateEditDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Boldsign Tempate Status of company
     */
    getTemplateStatus(templateId: number): Observable<ApplicationResultOfBoldsignTemplateStatus> {
        let url_ = this.baseUrl + "/api/boldsignTemplates/{templateId}/status";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfBoldsignTemplateStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfBoldsignTemplateStatus>;
        }));
    }

    protected processGetTemplateStatus(response: HttpResponseBase): Observable<ApplicationResultOfBoldsignTemplateStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfBoldsignTemplateStatus;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Boldsign Document Status
     */
    updateStatus(templateId: number, command: UpdateBoldsignTemplateStatusCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/boldsignTemplates/{templateId}/status";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Copy Boldsign Template of company
     */
    copyTemplate(templateId: number, command: CopyBoldsignTemplateCommand): Observable<ApplicationResultOfInteger> {
        let url_ = this.baseUrl + "/api/boldsignTemplates/{templateId}/copy";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfInteger>;
        }));
    }

    protected processCopyTemplate(response: HttpResponseBase): Observable<ApplicationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfInteger;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Boldsign Document of company
     */
    deleteTemplate(documentId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/boldsignTemplates/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteTemplate(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Boldsign requests
     * @param reviewerTypeId (optional) 
     * @param reviewerId (optional) 
     */
    getBoldsignDocuments(reviewerTypeId?: number | null | undefined, reviewerId?: number | null | undefined): Observable<ApplicationResultOfListOfBoldsignDocumentDto> {
        let url_ = this.baseUrl + "/api/boldsignTemplates/documents?";
        if (reviewerTypeId !== undefined && reviewerTypeId !== null)
            url_ += "reviewerTypeId=" + encodeURIComponent("" + reviewerTypeId) + "&";
        if (reviewerId !== undefined && reviewerId !== null)
            url_ += "reviewerId=" + encodeURIComponent("" + reviewerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBoldsignDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBoldsignDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfBoldsignDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfBoldsignDocumentDto>;
        }));
    }

    protected processGetBoldsignDocuments(response: HttpResponseBase): Observable<ApplicationResultOfListOfBoldsignDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfBoldsignDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Boldsign Template Usages
     */
    getTemplateUsages(templateId: number): Observable<ApplicationResultOfListOfBoldsignTemplateUsageDto> {
        let url_ = this.baseUrl + "/api/boldsignTemplates/{templateId}/usages";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateUsages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateUsages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfBoldsignTemplateUsageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfBoldsignTemplateUsageDto>;
        }));
    }

    protected processGetTemplateUsages(response: HttpResponseBase): Observable<ApplicationResultOfListOfBoldsignTemplateUsageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfBoldsignTemplateUsageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Boldsign Template Signers
     */
    getTemplateSigners(templateId: number): Observable<ApplicationResultOfListOfBoldsignTemplateSignerDto> {
        let url_ = this.baseUrl + "/api/boldsignTemplates/{templateId}/signers";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateSigners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateSigners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfBoldsignTemplateSignerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfBoldsignTemplateSignerDto>;
        }));
    }

    protected processGetTemplateSigners(response: HttpResponseBase): Observable<ApplicationResultOfListOfBoldsignTemplateSignerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfBoldsignTemplateSignerDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Company Signed Documents
     * @param reviewerTypeId (optional) 
     */
    getCompanySignedDocuments(reviewerTypeId?: number | null | undefined): Observable<ApplicationResultOfListOfBoldsignTemplateSignerDto> {
        let url_ = this.baseUrl + "/api/boldsignTemplates/signed-documents?";
        if (reviewerTypeId !== undefined && reviewerTypeId !== null)
            url_ += "reviewerTypeId=" + encodeURIComponent("" + reviewerTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanySignedDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanySignedDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfBoldsignTemplateSignerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfBoldsignTemplateSignerDto>;
        }));
    }

    protected processGetCompanySignedDocuments(response: HttpResponseBase): Observable<ApplicationResultOfListOfBoldsignTemplateSignerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfBoldsignTemplateSignerDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Boldsign Document Status
     * @param isChanged (optional) 
     */
    validateBoldSignTemplate(templateId: number, isChanged?: boolean | undefined): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/boldsignTemplates/{templateId}/validate?";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (isChanged === null)
            throw new globalThis.Error("The parameter 'isChanged' cannot be null.");
        else if (isChanged !== undefined)
            url_ += "isChanged=" + encodeURIComponent("" + isChanged) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateBoldSignTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateBoldSignTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processValidateBoldSignTemplate(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sign a Document
     */
    signDocument(command: SignDocumentCommand): Observable<ApplicationResultOfLinkRequestResult> {
        let url_ = this.baseUrl + "/api/boldsignTemplates/sign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfLinkRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfLinkRequestResult>;
        }));
    }

    protected processSignDocument(response: HttpResponseBase): Observable<ApplicationResultOfLinkRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfLinkRequestResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICaseAnnouncementClient {
    /**
     * Case Announcement Announcements
     */
    getAnnouncementsByCase(caseId: number): Observable<ApplicationResultOfListOfReviewerTypeAnnouncementDto>;
    /**
     * Add Case Announcement Announcement
     */
    addAnnouncement(command: AddReviewerTypeAnnouncementCommand): Observable<ApplicationResult>;
    /**
     * Get Acknowledgements
     */
    getAcknowledgements(id: number): Observable<ApplicationResultOfListOfAnnouncementAcknowledgementDto>;
    /**
     * Delete Reviewer Type Announcement
     */
    deleteReviewerTypeAnnouncement(id: number): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class CaseAnnouncementClient extends ApiClientBase implements ICaseAnnouncementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Case Announcement Announcements
     */
    getAnnouncementsByCase(caseId: number): Observable<ApplicationResultOfListOfReviewerTypeAnnouncementDto> {
        let url_ = this.baseUrl + "/api/caseAnnouncement/byCase/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnouncementsByCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnouncementsByCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerTypeAnnouncementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerTypeAnnouncementDto>;
        }));
    }

    protected processGetAnnouncementsByCase(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerTypeAnnouncementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerTypeAnnouncementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add Case Announcement Announcement
     */
    addAnnouncement(command: AddReviewerTypeAnnouncementCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAnnouncement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAnnouncement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processAddAnnouncement(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Acknowledgements
     */
    getAcknowledgements(id: number): Observable<ApplicationResultOfListOfAnnouncementAcknowledgementDto> {
        let url_ = this.baseUrl + "/api/caseAnnouncement/{id}/acknowledgements";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcknowledgements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcknowledgements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfAnnouncementAcknowledgementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfAnnouncementAcknowledgementDto>;
        }));
    }

    protected processGetAcknowledgements(response: HttpResponseBase): Observable<ApplicationResultOfListOfAnnouncementAcknowledgementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfAnnouncementAcknowledgementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Reviewer Type Announcement
     */
    deleteReviewerTypeAnnouncement(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseAnnouncement/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReviewerTypeAnnouncement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReviewerTypeAnnouncement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteReviewerTypeAnnouncement(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICaseClient {
    /**
     * Create Case
     */
    createCase(command: CreateCaseCommand): Observable<ApplicationResultOfCreateCaseResponse>;
    /**
     * Update Case
     */
    updateCase(command: UpdateCaseCommand): Observable<ApplicationResultOfCreateCaseResponse>;
    /**
     * Cases
     * @param name (optional) 
     * @param status (optional) 
     * @param sortBy (optional) 
     */
    getCompanyCases(name?: string | null | undefined, status?: CaseStatus | null | undefined, sortBy?: string | null | undefined): Observable<ApplicationResultOfListOfCompanyCaseDto>;
    /**
     * Case
     */
    getCaseDetails(caseId: number): Observable<ApplicationResultOfCaseDetailsResponse>;
    /**
     * Update Case Forecast Lookback Days
     */
    updateCaseForecastLookbackDays(caseId: number, forecastLookbackDays: number): Observable<ApplicationResult>;
    /**
     * Delete Case
     */
    deleteCase(caseId: number): Observable<ApplicationResult>;
    /**
     * Case
     */
    getCasePendingReviewers(caseId: number): Observable<ApplicationResultOfCasePendingReviewersResponse>;
    /**
     * Case
     */
    getCaseActiveReviewers(caseId: number): Observable<ApplicationResultOfListOfCaseReviewerListDto>;
    /**
     * Case
     */
    getCaseInactiveReviewers(caseId: number): Observable<ApplicationResultOfListOfCaseReviewerListDto>;
    /**
     * Case
     */
    getCasePendingRatings(caseId: number): Observable<ApplicationResultOfListOfCasePendingRatingDto>;
    /**
     * Get Case Documents
     * @param reviewerTypeId (optional) 
     */
    getCaseDocuments(caseId: number, reviewerTypeId?: number | null | undefined): Observable<ApplicationResultOfListOfCaseDocumentDto>;
    /**
     * Create Case Document
     */
    createCaseDocument(caseId: number, command: CreateSignableCaseDocumentCommand): Observable<ApplicationResult>;
    /**
     * Upload Case Document
     * @param reviewerTypeId (optional) 
     * @param description (optional) 
     * @param fileType (optional) 
     * @param file (optional) 
     */
    uploadCaseDocument(caseId: number, reviewerTypeId?: number | null | undefined, description?: string | null | undefined, fileType?: string | null | undefined, file?: FileParameter | null | undefined): Observable<ApplicationResultOfCaseDocumentDto>;
    /**
     * Update Case Document
     */
    updateCaseDocument(caseId: number, id: number, command: UpdateCaseDocumentCommand): Observable<ApplicationResultOfCaseDocumentDto>;
    /**
     * Delete Case Document
     */
    deleteCaseDocument(caseId: number, id: number): Observable<ApplicationResult>;
    /**
     * Case
     */
    getCasePendingReviewerDetails(reviewerId: number, reviewerTypeId: number): Observable<ApplicationResultOfCaseReviewerDto>;
    /**
     * Case
     */
    getCasesSummary(): Observable<ApplicationResultOfListOfOverallCasesSummaryDto>;
    /**
     * Case
     */
    getCasesBillingInfo(): Observable<ApplicationResultOfListOfCaseBillingResponse>;
    /**
     * Case
     */
    getCaseMarkup(caseId: number): Observable<ApplicationResultOfDecimal>;
    /**
     * Case
     */
    activateReviewer(command: ActivateReviewerCommand): Observable<ApplicationResult>;
    /**
     * Case
     */
    deactivateReviewers(command: DeactivateReviewersCommand): Observable<ApplicationResult>;
    /**
     * Update Relativity Fields
     */
    updateRelativityFields(caseId: number, command: UpdateRelativityFieldsCommand): Observable<ApplicationResult>;
    /**
     * Get Case Relativity Statistic
     * @param reviewers (optional) 
     * @param reviewerTypes (optional) 
     */
    getRelativityStatistic(caseId: number, reviewers?: number[] | undefined, reviewerTypes?: number[] | undefined): Observable<ApplicationResultOfCaseRelativityStatistic>;
    /**
     * Case
     * @param companyId (optional) 
     */
    getCompanyCasesForAdmin(companyId?: number | undefined): Observable<ApplicationResultOfListOfLookUpDto>;
    /**
     * Template Case
     */
    getTemplateCase(): Observable<ApplicationResultOfCaseDetailsResponse>;
    /**
     * Download Case Reviewer Files
     */
    downloadReviewerFiles(caseId: number, command: DownloadReviewersFilesCommand): Observable<FileResponse>;
    /**
     * Get Case Relativity Statistic
     * @param fields (optional) 
     * @param reviewerTypeIds (optional) 
     */
    getCaseRelativityMetrics(caseId: number, fields?: number[] | undefined, reviewerTypeIds?: number[] | null | undefined): Observable<ApplicationResultOfListOfReviewerOverallMetricsDto>;
    /**
     * Get Case Reviewer Overall Metrics
     */
    getCaseReviewerOverallMetrics(caseId: number, reviewerId: number): Observable<ApplicationResultOfRelativityOverallMetric>;
    /**
     * Get Case Relativity Statistic
     * @param fields (optional) 
     * @param reviewerTypeIds (optional) 
     * @param interval (optional) 
     */
    getCaseRelativityReviewersMetricsTimeSeries(caseId: number, fields?: number[] | null | undefined, reviewerTypeIds?: number[] | null | undefined, interval?: CaseMetricsInterval | undefined): Observable<ApplicationResultOfListOfReviewerTimeSeriesMetricsDto>;
    /**
     * Get Case Relativity Fields
     */
    getCaseRelativityFields(caseId: number): Observable<ApplicationResultOfListOfBaseRelativityFieldDto>;
    /**
     * Get Case Relativity Activity
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param reviewerTypeIds (optional) 
     * @param reviewerIds (optional) 
     */
    getCaseRelativityActivity(caseId: number, startDate?: Date | null | undefined, endDate?: Date | null | undefined, reviewerTypeIds?: number[] | null | undefined, reviewerIds?: number[] | null | undefined): Observable<ApplicationResultOfCaseActivityMetricsDto>;
    /**
     * Get Case Relativity Fields
     */
    getRelativityFieldStatistics(caseId: number): Observable<ApplicationResultOfListOfRelativityFieldStatisticDto>;
    /**
     * Get Relativity Cases
     * @param status (optional) 
     * @param onlyAvailable (optional) 
     */
    getRelativityCases(status?: CaseStatus | null | undefined, onlyAvailable?: boolean | undefined): Observable<ApplicationResultOfListOfRelativityCaseDto>;
    /**
     * Cancel Case
     */
    cancelCase(caseId: number): Observable<ApplicationResult>;
    /**
     * Purge Case Documents
     */
    purgeCaseDocuments(caseId: number): Observable<ApplicationResult>;
    /**
     * Send notification to reviewers
     */
    sendNotificationToReviewers(command: SendNotificationToReviewersCommand): Observable<ApplicationResult>;
    /**
     * Get case metrics schedule settings
     */
    getCaseMetricsScheduleSettings(caseId: number): Observable<ApplicationResultOfListOfCaseMetricsExportScheduleDto>;
    /**
     * Send case metrics
     */
    saveCaseMetricsScheduleSettings(scheduleSettingsCommand: SaveCaseMetricsScheduleSettingsCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class CaseClient extends ApiClientBase implements ICaseClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Create Case
     */
    createCase(command: CreateCaseCommand): Observable<ApplicationResultOfCreateCaseResponse> {
        let url_ = this.baseUrl + "/api/case";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCreateCaseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCreateCaseResponse>;
        }));
    }

    protected processCreateCase(response: HttpResponseBase): Observable<ApplicationResultOfCreateCaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCreateCaseResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Case
     */
    updateCase(command: UpdateCaseCommand): Observable<ApplicationResultOfCreateCaseResponse> {
        let url_ = this.baseUrl + "/api/case";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCreateCaseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCreateCaseResponse>;
        }));
    }

    protected processUpdateCase(response: HttpResponseBase): Observable<ApplicationResultOfCreateCaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCreateCaseResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cases
     * @param name (optional) 
     * @param status (optional) 
     * @param sortBy (optional) 
     */
    getCompanyCases(name?: string | null | undefined, status?: CaseStatus | null | undefined, sortBy?: string | null | undefined): Observable<ApplicationResultOfListOfCompanyCaseDto> {
        let url_ = this.baseUrl + "/api/case?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyCases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyCases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCompanyCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCompanyCaseDto>;
        }));
    }

    protected processGetCompanyCases(response: HttpResponseBase): Observable<ApplicationResultOfListOfCompanyCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCompanyCaseDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     */
    getCaseDetails(caseId: number): Observable<ApplicationResultOfCaseDetailsResponse> {
        let url_ = this.baseUrl + "/api/case/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCaseDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCaseDetailsResponse>;
        }));
    }

    protected processGetCaseDetails(response: HttpResponseBase): Observable<ApplicationResultOfCaseDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCaseDetailsResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Case Forecast Lookback Days
     */
    updateCaseForecastLookbackDays(caseId: number, forecastLookbackDays: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/case/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(forecastLookbackDays);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaseForecastLookbackDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaseForecastLookbackDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateCaseForecastLookbackDays(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Case
     */
    deleteCase(caseId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/case/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteCase(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     */
    getCasePendingReviewers(caseId: number): Observable<ApplicationResultOfCasePendingReviewersResponse> {
        let url_ = this.baseUrl + "/api/case/{caseId}/pending-reviewers";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCasePendingReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCasePendingReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCasePendingReviewersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCasePendingReviewersResponse>;
        }));
    }

    protected processGetCasePendingReviewers(response: HttpResponseBase): Observable<ApplicationResultOfCasePendingReviewersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCasePendingReviewersResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     */
    getCaseActiveReviewers(caseId: number): Observable<ApplicationResultOfListOfCaseReviewerListDto> {
        let url_ = this.baseUrl + "/api/case/{caseId}/active-reviewers";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseActiveReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseActiveReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCaseReviewerListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCaseReviewerListDto>;
        }));
    }

    protected processGetCaseActiveReviewers(response: HttpResponseBase): Observable<ApplicationResultOfListOfCaseReviewerListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCaseReviewerListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     */
    getCaseInactiveReviewers(caseId: number): Observable<ApplicationResultOfListOfCaseReviewerListDto> {
        let url_ = this.baseUrl + "/api/case/{caseId}/inactive-reviewers";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseInactiveReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseInactiveReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCaseReviewerListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCaseReviewerListDto>;
        }));
    }

    protected processGetCaseInactiveReviewers(response: HttpResponseBase): Observable<ApplicationResultOfListOfCaseReviewerListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCaseReviewerListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     */
    getCasePendingRatings(caseId: number): Observable<ApplicationResultOfListOfCasePendingRatingDto> {
        let url_ = this.baseUrl + "/api/case/{caseId}/pending-ratings";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCasePendingRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCasePendingRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCasePendingRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCasePendingRatingDto>;
        }));
    }

    protected processGetCasePendingRatings(response: HttpResponseBase): Observable<ApplicationResultOfListOfCasePendingRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCasePendingRatingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case Documents
     * @param reviewerTypeId (optional) 
     */
    getCaseDocuments(caseId: number, reviewerTypeId?: number | null | undefined): Observable<ApplicationResultOfListOfCaseDocumentDto> {
        let url_ = this.baseUrl + "/api/case/{caseId}/documents?";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (reviewerTypeId !== undefined && reviewerTypeId !== null)
            url_ += "reviewerTypeId=" + encodeURIComponent("" + reviewerTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCaseDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCaseDocumentDto>;
        }));
    }

    protected processGetCaseDocuments(response: HttpResponseBase): Observable<ApplicationResultOfListOfCaseDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCaseDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Case Document
     */
    createCaseDocument(caseId: number, command: CreateSignableCaseDocumentCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/case/{caseId}/documents";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCaseDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCaseDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processCreateCaseDocument(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload Case Document
     * @param reviewerTypeId (optional) 
     * @param description (optional) 
     * @param fileType (optional) 
     * @param file (optional) 
     */
    uploadCaseDocument(caseId: number, reviewerTypeId?: number | null | undefined, description?: string | null | undefined, fileType?: string | null | undefined, file?: FileParameter | null | undefined): Observable<ApplicationResultOfCaseDocumentDto> {
        let url_ = this.baseUrl + "/api/case/{caseId}/documents/upload";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (reviewerTypeId !== null && reviewerTypeId !== undefined)
            content_.append("reviewerTypeId", reviewerTypeId.toString());
        if (description !== null && description !== undefined)
            content_.append("description", description.toString());
        if (fileType !== null && fileType !== undefined)
            content_.append("fileType", fileType.toString());
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCaseDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCaseDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCaseDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCaseDocumentDto>;
        }));
    }

    protected processUploadCaseDocument(response: HttpResponseBase): Observable<ApplicationResultOfCaseDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCaseDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Case Document
     */
    updateCaseDocument(caseId: number, id: number, command: UpdateCaseDocumentCommand): Observable<ApplicationResultOfCaseDocumentDto> {
        let url_ = this.baseUrl + "/api/case/{caseId}/documents/{id}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaseDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaseDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCaseDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCaseDocumentDto>;
        }));
    }

    protected processUpdateCaseDocument(response: HttpResponseBase): Observable<ApplicationResultOfCaseDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCaseDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Case Document
     */
    deleteCaseDocument(caseId: number, id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/case/{caseId}/documents/{id}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCaseDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCaseDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteCaseDocument(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     */
    getCasePendingReviewerDetails(reviewerId: number, reviewerTypeId: number): Observable<ApplicationResultOfCaseReviewerDto> {
        let url_ = this.baseUrl + "/api/case/reviewer/{reviewerId}/{reviewerTypeId}";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCasePendingReviewerDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCasePendingReviewerDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCaseReviewerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCaseReviewerDto>;
        }));
    }

    protected processGetCasePendingReviewerDetails(response: HttpResponseBase): Observable<ApplicationResultOfCaseReviewerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCaseReviewerDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     */
    getCasesSummary(): Observable<ApplicationResultOfListOfOverallCasesSummaryDto> {
        let url_ = this.baseUrl + "/api/case/summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCasesSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCasesSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfOverallCasesSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfOverallCasesSummaryDto>;
        }));
    }

    protected processGetCasesSummary(response: HttpResponseBase): Observable<ApplicationResultOfListOfOverallCasesSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfOverallCasesSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     */
    getCasesBillingInfo(): Observable<ApplicationResultOfListOfCaseBillingResponse> {
        let url_ = this.baseUrl + "/api/case/billing-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCasesBillingInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCasesBillingInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCaseBillingResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCaseBillingResponse>;
        }));
    }

    protected processGetCasesBillingInfo(response: HttpResponseBase): Observable<ApplicationResultOfListOfCaseBillingResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCaseBillingResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     */
    getCaseMarkup(caseId: number): Observable<ApplicationResultOfDecimal> {
        let url_ = this.baseUrl + "/api/case/case-markup/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseMarkup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseMarkup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfDecimal>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfDecimal>;
        }));
    }

    protected processGetCaseMarkup(response: HttpResponseBase): Observable<ApplicationResultOfDecimal> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfDecimal;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     */
    activateReviewer(command: ActivateReviewerCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/case/activate-reviewer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processActivateReviewer(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     */
    deactivateReviewers(command: DeactivateReviewersCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/case/deactivate-reviewers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeactivateReviewers(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Relativity Fields
     */
    updateRelativityFields(caseId: number, command: UpdateRelativityFieldsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/case/{caseId}/relativity";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRelativityFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRelativityFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateRelativityFields(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case Relativity Statistic
     * @param reviewers (optional) 
     * @param reviewerTypes (optional) 
     */
    getRelativityStatistic(caseId: number, reviewers?: number[] | undefined, reviewerTypes?: number[] | undefined): Observable<ApplicationResultOfCaseRelativityStatistic> {
        let url_ = this.baseUrl + "/api/case/{caseId}/relativity?";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (reviewers === null)
            throw new globalThis.Error("The parameter 'reviewers' cannot be null.");
        else if (reviewers !== undefined)
            reviewers && reviewers.forEach(item => { url_ += "Reviewers=" + encodeURIComponent("" + item) + "&"; });
        if (reviewerTypes === null)
            throw new globalThis.Error("The parameter 'reviewerTypes' cannot be null.");
        else if (reviewerTypes !== undefined)
            reviewerTypes && reviewerTypes.forEach(item => { url_ += "ReviewerTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelativityStatistic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelativityStatistic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCaseRelativityStatistic>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCaseRelativityStatistic>;
        }));
    }

    protected processGetRelativityStatistic(response: HttpResponseBase): Observable<ApplicationResultOfCaseRelativityStatistic> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCaseRelativityStatistic;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     * @param companyId (optional) 
     */
    getCompanyCasesForAdmin(companyId?: number | undefined): Observable<ApplicationResultOfListOfLookUpDto> {
        let url_ = this.baseUrl + "/api/case/admin/get-company-cases?";
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyCasesForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyCasesForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfLookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfLookUpDto>;
        }));
    }

    protected processGetCompanyCasesForAdmin(response: HttpResponseBase): Observable<ApplicationResultOfListOfLookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfLookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Template Case
     */
    getTemplateCase(): Observable<ApplicationResultOfCaseDetailsResponse> {
        let url_ = this.baseUrl + "/api/case/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCaseDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCaseDetailsResponse>;
        }));
    }

    protected processGetTemplateCase(response: HttpResponseBase): Observable<ApplicationResultOfCaseDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCaseDetailsResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download Case Reviewer Files
     */
    downloadReviewerFiles(caseId: number, command: DownloadReviewersFilesCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/case/{caseId}/download-reviewer-files";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadReviewerFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadReviewerFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadReviewerFiles(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case Relativity Statistic
     * @param fields (optional) 
     * @param reviewerTypeIds (optional) 
     */
    getCaseRelativityMetrics(caseId: number, fields?: number[] | undefined, reviewerTypeIds?: number[] | null | undefined): Observable<ApplicationResultOfListOfReviewerOverallMetricsDto> {
        let url_ = this.baseUrl + "/api/case/{caseId}/relativity/reviewers?";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (fields === null)
            throw new globalThis.Error("The parameter 'fields' cannot be null.");
        else if (fields !== undefined)
            fields && fields.forEach(item => { url_ += "fields=" + encodeURIComponent("" + item) + "&"; });
        if (reviewerTypeIds !== undefined && reviewerTypeIds !== null)
            reviewerTypeIds && reviewerTypeIds.forEach(item => { url_ += "reviewerTypeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseRelativityMetrics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseRelativityMetrics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerOverallMetricsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerOverallMetricsDto>;
        }));
    }

    protected processGetCaseRelativityMetrics(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerOverallMetricsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerOverallMetricsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case Reviewer Overall Metrics
     */
    getCaseReviewerOverallMetrics(caseId: number, reviewerId: number): Observable<ApplicationResultOfRelativityOverallMetric> {
        let url_ = this.baseUrl + "/api/case/{caseId}/relativity/reviewers/{reviewerId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseReviewerOverallMetrics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseReviewerOverallMetrics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfRelativityOverallMetric>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfRelativityOverallMetric>;
        }));
    }

    protected processGetCaseReviewerOverallMetrics(response: HttpResponseBase): Observable<ApplicationResultOfRelativityOverallMetric> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfRelativityOverallMetric;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case Relativity Statistic
     * @param fields (optional) 
     * @param reviewerTypeIds (optional) 
     * @param interval (optional) 
     */
    getCaseRelativityReviewersMetricsTimeSeries(caseId: number, fields?: number[] | null | undefined, reviewerTypeIds?: number[] | null | undefined, interval?: CaseMetricsInterval | undefined): Observable<ApplicationResultOfListOfReviewerTimeSeriesMetricsDto> {
        let url_ = this.baseUrl + "/api/case/{caseId}/relativity/reviewers/time-series?";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (fields !== undefined && fields !== null)
            fields && fields.forEach(item => { url_ += "fields=" + encodeURIComponent("" + item) + "&"; });
        if (reviewerTypeIds !== undefined && reviewerTypeIds !== null)
            reviewerTypeIds && reviewerTypeIds.forEach(item => { url_ += "reviewerTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (interval === null)
            throw new globalThis.Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseRelativityReviewersMetricsTimeSeries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseRelativityReviewersMetricsTimeSeries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerTimeSeriesMetricsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerTimeSeriesMetricsDto>;
        }));
    }

    protected processGetCaseRelativityReviewersMetricsTimeSeries(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerTimeSeriesMetricsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerTimeSeriesMetricsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case Relativity Fields
     */
    getCaseRelativityFields(caseId: number): Observable<ApplicationResultOfListOfBaseRelativityFieldDto> {
        let url_ = this.baseUrl + "/api/case/{caseId}/relativity/fields";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseRelativityFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseRelativityFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfBaseRelativityFieldDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfBaseRelativityFieldDto>;
        }));
    }

    protected processGetCaseRelativityFields(response: HttpResponseBase): Observable<ApplicationResultOfListOfBaseRelativityFieldDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfBaseRelativityFieldDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case Relativity Activity
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param reviewerTypeIds (optional) 
     * @param reviewerIds (optional) 
     */
    getCaseRelativityActivity(caseId: number, startDate?: Date | null | undefined, endDate?: Date | null | undefined, reviewerTypeIds?: number[] | null | undefined, reviewerIds?: number[] | null | undefined): Observable<ApplicationResultOfCaseActivityMetricsDto> {
        let url_ = this.baseUrl + "/api/case/{caseId}/relativity/activity?";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (reviewerTypeIds !== undefined && reviewerTypeIds !== null)
            reviewerTypeIds && reviewerTypeIds.forEach(item => { url_ += "reviewerTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (reviewerIds !== undefined && reviewerIds !== null)
            reviewerIds && reviewerIds.forEach(item => { url_ += "reviewerIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseRelativityActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseRelativityActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCaseActivityMetricsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCaseActivityMetricsDto>;
        }));
    }

    protected processGetCaseRelativityActivity(response: HttpResponseBase): Observable<ApplicationResultOfCaseActivityMetricsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCaseActivityMetricsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case Relativity Fields
     */
    getRelativityFieldStatistics(caseId: number): Observable<ApplicationResultOfListOfRelativityFieldStatisticDto> {
        let url_ = this.baseUrl + "/api/case/{caseId}/relativity/fields/statistic";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelativityFieldStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelativityFieldStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRelativityFieldStatisticDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRelativityFieldStatisticDto>;
        }));
    }

    protected processGetRelativityFieldStatistics(response: HttpResponseBase): Observable<ApplicationResultOfListOfRelativityFieldStatisticDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRelativityFieldStatisticDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Relativity Cases
     * @param status (optional) 
     * @param onlyAvailable (optional) 
     */
    getRelativityCases(status?: CaseStatus | null | undefined, onlyAvailable?: boolean | undefined): Observable<ApplicationResultOfListOfRelativityCaseDto> {
        let url_ = this.baseUrl + "/api/case/relativity?";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (onlyAvailable === null)
            throw new globalThis.Error("The parameter 'onlyAvailable' cannot be null.");
        else if (onlyAvailable !== undefined)
            url_ += "OnlyAvailable=" + encodeURIComponent("" + onlyAvailable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelativityCases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelativityCases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRelativityCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRelativityCaseDto>;
        }));
    }

    protected processGetRelativityCases(response: HttpResponseBase): Observable<ApplicationResultOfListOfRelativityCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRelativityCaseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel Case
     */
    cancelCase(caseId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/case/{caseId}/cancel";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processCancelCase(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Purge Case Documents
     */
    purgeCaseDocuments(caseId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/case/{caseId}/purge-documents";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPurgeCaseDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurgeCaseDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processPurgeCaseDocuments(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send notification to reviewers
     */
    sendNotificationToReviewers(command: SendNotificationToReviewersCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/case/send-notification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNotificationToReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNotificationToReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processSendNotificationToReviewers(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get case metrics schedule settings
     */
    getCaseMetricsScheduleSettings(caseId: number): Observable<ApplicationResultOfListOfCaseMetricsExportScheduleDto> {
        let url_ = this.baseUrl + "/api/case/{caseId}/case-metrics-schedule-settings";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseMetricsScheduleSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseMetricsScheduleSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCaseMetricsExportScheduleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCaseMetricsExportScheduleDto>;
        }));
    }

    protected processGetCaseMetricsScheduleSettings(response: HttpResponseBase): Observable<ApplicationResultOfListOfCaseMetricsExportScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCaseMetricsExportScheduleDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send case metrics
     */
    saveCaseMetricsScheduleSettings(scheduleSettingsCommand: SaveCaseMetricsScheduleSettingsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/case/case-metrics-schedule-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scheduleSettingsCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCaseMetricsScheduleSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCaseMetricsScheduleSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processSaveCaseMetricsScheduleSettings(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICaseMeetingsClient {
    getCaseMeetings(caseId: number, periodStart?: Date | undefined, periodEnd?: Date | undefined): Observable<ApplicationResultOfListOfCaseMeetingDto>;
    getMeetings(caseId?: number | null | undefined, reviewerTypeId?: number | null | undefined, periodStart?: Date | undefined, periodEnd?: Date | undefined): Observable<ApplicationResultOfListOfCaseMeetingDto>;
    /**
     * Create Case Meeting
     */
    createCaseMeeting(command: CreateCaseMeetingCommand): Observable<ApplicationResult>;
    getCaseMeetingDetails(id: number): Observable<ApplicationResultOfCaseMeetingDetailsDto>;
    /**
     * Update Case Meeting
     */
    updateCaseMeeting(id: number, command: UpdateCaseMeetingCommand): Observable<ApplicationResultOfCaseMeetingDto>;
    /**
     * Delete Case Meeting
     */
    deleteCaseMeeting(id: number): Observable<ApplicationResult>;
    /**
     * Download ICS FIle For Meeting
     */
    downloadIcsFIleForMeeting(id: number): Observable<FileResponse>;
    getUpcomingMeetings(): Observable<ApplicationResultOfListOfCaseMeetingDto>;
    /**
     * Exclude Case Meeting Date
     */
    excludeDateFromRecurringEvent(command: ExcludeDateFromRecurringEventCommand): Observable<ApplicationResult>;
    /**
     * Delete this and the following Meetings
     */
    deleteThisAndTheFollowingMeetings(command: DeleteThisAndTheFollowingEventsCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class CaseMeetingsClient extends ApiClientBase implements ICaseMeetingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getCaseMeetings(caseId: number, periodStart?: Date | undefined, periodEnd?: Date | undefined): Observable<ApplicationResultOfListOfCaseMeetingDto> {
        let url_ = this.baseUrl + "/api/caseMeetings/case/{caseId}?";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (periodStart === null)
            throw new globalThis.Error("The parameter 'periodStart' cannot be null.");
        else if (periodStart !== undefined)
            url_ += "periodStart=" + encodeURIComponent(periodStart ? "" + periodStart.toISOString() : "") + "&";
        if (periodEnd === null)
            throw new globalThis.Error("The parameter 'periodEnd' cannot be null.");
        else if (periodEnd !== undefined)
            url_ += "periodEnd=" + encodeURIComponent(periodEnd ? "" + periodEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseMeetings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseMeetings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCaseMeetingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCaseMeetingDto>;
        }));
    }

    protected processGetCaseMeetings(response: HttpResponseBase): Observable<ApplicationResultOfListOfCaseMeetingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCaseMeetingDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMeetings(caseId?: number | null | undefined, reviewerTypeId?: number | null | undefined, periodStart?: Date | undefined, periodEnd?: Date | undefined): Observable<ApplicationResultOfListOfCaseMeetingDto> {
        let url_ = this.baseUrl + "/api/caseMeetings?";
        if (caseId !== undefined && caseId !== null)
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (reviewerTypeId !== undefined && reviewerTypeId !== null)
            url_ += "ReviewerTypeId=" + encodeURIComponent("" + reviewerTypeId) + "&";
        if (periodStart === null)
            throw new globalThis.Error("The parameter 'periodStart' cannot be null.");
        else if (periodStart !== undefined)
            url_ += "PeriodStart=" + encodeURIComponent(periodStart ? "" + periodStart.toISOString() : "") + "&";
        if (periodEnd === null)
            throw new globalThis.Error("The parameter 'periodEnd' cannot be null.");
        else if (periodEnd !== undefined)
            url_ += "PeriodEnd=" + encodeURIComponent(periodEnd ? "" + periodEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeetings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeetings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCaseMeetingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCaseMeetingDto>;
        }));
    }

    protected processGetMeetings(response: HttpResponseBase): Observable<ApplicationResultOfListOfCaseMeetingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCaseMeetingDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Case Meeting
     */
    createCaseMeeting(command: CreateCaseMeetingCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseMeetings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCaseMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCaseMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processCreateCaseMeeting(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCaseMeetingDetails(id: number): Observable<ApplicationResultOfCaseMeetingDetailsDto> {
        let url_ = this.baseUrl + "/api/caseMeetings/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseMeetingDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseMeetingDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCaseMeetingDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCaseMeetingDetailsDto>;
        }));
    }

    protected processGetCaseMeetingDetails(response: HttpResponseBase): Observable<ApplicationResultOfCaseMeetingDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCaseMeetingDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Case Meeting
     */
    updateCaseMeeting(id: number, command: UpdateCaseMeetingCommand): Observable<ApplicationResultOfCaseMeetingDto> {
        let url_ = this.baseUrl + "/api/caseMeetings/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaseMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaseMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCaseMeetingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCaseMeetingDto>;
        }));
    }

    protected processUpdateCaseMeeting(response: HttpResponseBase): Observable<ApplicationResultOfCaseMeetingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCaseMeetingDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Case Meeting
     */
    deleteCaseMeeting(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseMeetings/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCaseMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCaseMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteCaseMeeting(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download ICS FIle For Meeting
     */
    downloadIcsFIleForMeeting(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/caseMeetings/{id}/download-ics";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadIcsFIleForMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadIcsFIleForMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadIcsFIleForMeeting(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUpcomingMeetings(): Observable<ApplicationResultOfListOfCaseMeetingDto> {
        let url_ = this.baseUrl + "/api/caseMeetings/upcoming";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpcomingMeetings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpcomingMeetings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCaseMeetingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCaseMeetingDto>;
        }));
    }

    protected processGetUpcomingMeetings(response: HttpResponseBase): Observable<ApplicationResultOfListOfCaseMeetingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCaseMeetingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exclude Case Meeting Date
     */
    excludeDateFromRecurringEvent(command: ExcludeDateFromRecurringEventCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseMeetings/exclude";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcludeDateFromRecurringEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcludeDateFromRecurringEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processExcludeDateFromRecurringEvent(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete this and the following Meetings
     */
    deleteThisAndTheFollowingMeetings(command: DeleteThisAndTheFollowingEventsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseMeetings/delete-following";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteThisAndTheFollowingMeetings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteThisAndTheFollowingMeetings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteThisAndTheFollowingMeetings(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICaseMetricsScheduleSettingsClient {
    getCaseMetricsScheduleSettings(caseId: number): Observable<ApplicationResultOfListOfCaseMetricsExportScheduleDto>;
    saveCaseMetricsScheduleSettings(command: SaveCaseMetricsScheduleSettingsCommand): Observable<ApplicationResult>;
    setIsPausedCaseMetricsSchedule(command: SetIsPausedCaseMetricsScheduleCommand): Observable<ApplicationResult>;
    unsubscribe(token?: string | undefined): Observable<ApplicationResultOfCaseMetricsExportScheduleUnsubscribeResultDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CaseMetricsScheduleSettingsClient extends ApiClientBase implements ICaseMetricsScheduleSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getCaseMetricsScheduleSettings(caseId: number): Observable<ApplicationResultOfListOfCaseMetricsExportScheduleDto> {
        let url_ = this.baseUrl + "/api/caseMetricsScheduleSettings/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseMetricsScheduleSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseMetricsScheduleSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCaseMetricsExportScheduleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCaseMetricsExportScheduleDto>;
        }));
    }

    protected processGetCaseMetricsScheduleSettings(response: HttpResponseBase): Observable<ApplicationResultOfListOfCaseMetricsExportScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCaseMetricsExportScheduleDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveCaseMetricsScheduleSettings(command: SaveCaseMetricsScheduleSettingsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseMetricsScheduleSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCaseMetricsScheduleSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCaseMetricsScheduleSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processSaveCaseMetricsScheduleSettings(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setIsPausedCaseMetricsSchedule(command: SetIsPausedCaseMetricsScheduleCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseMetricsScheduleSettings/setPaused";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetIsPausedCaseMetricsSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetIsPausedCaseMetricsSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processSetIsPausedCaseMetricsSchedule(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unsubscribe(token?: string | undefined): Observable<ApplicationResultOfCaseMetricsExportScheduleUnsubscribeResultDto> {
        let url_ = this.baseUrl + "/api/caseMetricsScheduleSettings/unsubscribe?";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnsubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnsubscribe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCaseMetricsExportScheduleUnsubscribeResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCaseMetricsExportScheduleUnsubscribeResultDto>;
        }));
    }

    protected processUnsubscribe(response: HttpResponseBase): Observable<ApplicationResultOfCaseMetricsExportScheduleUnsubscribeResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCaseMetricsExportScheduleUnsubscribeResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICaseSettingsClient {
    /**
     * Get Company Case Settings
     */
    getCaseSettings(): Observable<ApplicationResultOfCompanyCaseSettingsDto>;
    /**
     * Update Company Email Settings
     */
    updateCompanyEmailSettings(command: UpdateCompanyEmailSettingsCommand): Observable<ApplicationResult>;
    /**
     * Update Company Relativity Settings
     */
    updateCompanyRelativitySettings(command: UpdateCompanyRelativitySettings): Observable<ApplicationResult>;
    /**
     * Update Company Reviewer Invites
     */
    updateCompanyReviewerInvites(command: UpdateCompanyReviewerInviteSettingsCommand): Observable<ApplicationResult>;
    /**
     * Update Company Time Entry Type
     */
    updateCompanyTimeEntryType(command: UpdateCompanyTimeEntryTypeCommand): Observable<ApplicationResult>;
    /**
     * Update Company Chat Settings
     */
    updateCompanyChatSettings(command: UpdateCompanyChatSettingsCommand): Observable<ApplicationResult>;
    /**
     * Update Internal Company Settings
     */
    updateInternalCompanySettings(command: UpdateInternalCompanySettingsCommand): Observable<ApplicationResult>;
    /**
     * Template Case
     */
    getTemplateCase(): Observable<ApplicationResultOfCaseDetailsResponse>;
    /**
     * User Company Settings
     */
    getUserCompanySettings(): Observable<ApplicationResultOfUserCompanySettingsDto>;
    /**
     * User Company Settings
     */
    updateUserCompanySettings(command: UpdateUserCompanySettingsCommand): Observable<ApplicationResult>;
    /**
     * Update Company Rating Settings
     */
    updateCompanyRatingSettings(command: UpdateCompanyRatingSettingsCommand): Observable<ApplicationResult>;
    /**
     * Update Company Phase And Task Codes Settings
     */
    updateCompanyPhaseAndTaskCodesSettings(command: UpdateCompanyPhaseAndTaskCodesSettingsCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class CaseSettingsClient extends ApiClientBase implements ICaseSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Company Case Settings
     */
    getCaseSettings(): Observable<ApplicationResultOfCompanyCaseSettingsDto> {
        let url_ = this.baseUrl + "/api/caseSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCompanyCaseSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCompanyCaseSettingsDto>;
        }));
    }

    protected processGetCaseSettings(response: HttpResponseBase): Observable<ApplicationResultOfCompanyCaseSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCompanyCaseSettingsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Company Email Settings
     */
    updateCompanyEmailSettings(command: UpdateCompanyEmailSettingsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseSettings/update-company-email-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompanyEmailSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompanyEmailSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateCompanyEmailSettings(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Company Relativity Settings
     */
    updateCompanyRelativitySettings(command: UpdateCompanyRelativitySettings): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseSettings/update-company-relativity-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompanyRelativitySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompanyRelativitySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateCompanyRelativitySettings(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Company Reviewer Invites
     */
    updateCompanyReviewerInvites(command: UpdateCompanyReviewerInviteSettingsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseSettings/update-company-reviewer-invites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompanyReviewerInvites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompanyReviewerInvites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateCompanyReviewerInvites(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Company Time Entry Type
     */
    updateCompanyTimeEntryType(command: UpdateCompanyTimeEntryTypeCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseSettings/update-company-time-entry-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompanyTimeEntryType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompanyTimeEntryType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateCompanyTimeEntryType(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Company Chat Settings
     */
    updateCompanyChatSettings(command: UpdateCompanyChatSettingsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseSettings/update-company-chat-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompanyChatSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompanyChatSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateCompanyChatSettings(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Internal Company Settings
     */
    updateInternalCompanySettings(command: UpdateInternalCompanySettingsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseSettings/update-internal-company-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInternalCompanySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInternalCompanySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateInternalCompanySettings(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Template Case
     */
    getTemplateCase(): Observable<ApplicationResultOfCaseDetailsResponse> {
        let url_ = this.baseUrl + "/api/caseSettings/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCaseDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCaseDetailsResponse>;
        }));
    }

    protected processGetTemplateCase(response: HttpResponseBase): Observable<ApplicationResultOfCaseDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCaseDetailsResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * User Company Settings
     */
    getUserCompanySettings(): Observable<ApplicationResultOfUserCompanySettingsDto> {
        let url_ = this.baseUrl + "/api/caseSettings/user-company-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCompanySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCompanySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfUserCompanySettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfUserCompanySettingsDto>;
        }));
    }

    protected processGetUserCompanySettings(response: HttpResponseBase): Observable<ApplicationResultOfUserCompanySettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfUserCompanySettingsDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * User Company Settings
     */
    updateUserCompanySettings(command: UpdateUserCompanySettingsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseSettings/user-company-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserCompanySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserCompanySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateUserCompanySettings(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Company Rating Settings
     */
    updateCompanyRatingSettings(command: UpdateCompanyRatingSettingsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseSettings/update-company-rating-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompanyRatingSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompanyRatingSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateCompanyRatingSettings(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Company Phase And Task Codes Settings
     */
    updateCompanyPhaseAndTaskCodesSettings(command: UpdateCompanyPhaseAndTaskCodesSettingsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseSettings/update-company-phase-and-task-codes-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompanyPhaseAndTaskCodesSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompanyPhaseAndTaskCodesSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateCompanyPhaseAndTaskCodesSettings(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICaseUserClient {
    /**
     * Get Case Users
     */
    getCaseUsersByCase(caseId: number): Observable<ApplicationResultOfListOfCaseUserDto>;
    /**
     * Add Case Users
     */
    addCaseUsersByCase(caseId: number, userIds: number[]): Observable<ApplicationResult>;
    /**
     * Get Case Users
     */
    getCaseUsersByUser(userId: number): Observable<ApplicationResultOfListOfCaseUserDto>;
    /**
     * Add Case Users
     */
    addCaseUsersByUser(userId: number, caseIds: number[]): Observable<ApplicationResultOfListOfInteger>;
    /**
     * Get Users in Company
     */
    getUsersInCompany(companyId: number): Observable<ApplicationResultOfListOfUserCompanyDto>;
    /**
     * Get Available cases for User
     */
    getAvailableCasesForUser(userId: number): Observable<ApplicationResultOfListOfAvailableCaseDto>;
    /**
     * Delete Case User
     */
    deleteCaseUsers(caseId: number, userId: number): Observable<ApplicationResult>;
    /**
     * Get Case User
     */
    getCaseUserByCase(caseId: number): Observable<ApplicationResultOfCaseUserDto>;
    /**
     * Update Case User Notification Settings
     */
    updateCaseUserNotificationSettings(command: UpdateCaseUserNotificationSettingsCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class CaseUserClient extends ApiClientBase implements ICaseUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Case Users
     */
    getCaseUsersByCase(caseId: number): Observable<ApplicationResultOfListOfCaseUserDto> {
        let url_ = this.baseUrl + "/api/caseUser/byCase/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseUsersByCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseUsersByCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCaseUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCaseUserDto>;
        }));
    }

    protected processGetCaseUsersByCase(response: HttpResponseBase): Observable<ApplicationResultOfListOfCaseUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCaseUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add Case Users
     */
    addCaseUsersByCase(caseId: number, userIds: number[]): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseUser/byCase/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCaseUsersByCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCaseUsersByCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processAddCaseUsersByCase(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case Users
     */
    getCaseUsersByUser(userId: number): Observable<ApplicationResultOfListOfCaseUserDto> {
        let url_ = this.baseUrl + "/api/caseUser/byUser/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseUsersByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseUsersByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCaseUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCaseUserDto>;
        }));
    }

    protected processGetCaseUsersByUser(response: HttpResponseBase): Observable<ApplicationResultOfListOfCaseUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCaseUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add Case Users
     */
    addCaseUsersByUser(userId: number, caseIds: number[]): Observable<ApplicationResultOfListOfInteger> {
        let url_ = this.baseUrl + "/api/caseUser/byUser/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(caseIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCaseUsersByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCaseUsersByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfInteger>;
        }));
    }

    protected processAddCaseUsersByUser(response: HttpResponseBase): Observable<ApplicationResultOfListOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfInteger;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Users in Company
     */
    getUsersInCompany(companyId: number): Observable<ApplicationResultOfListOfUserCompanyDto> {
        let url_ = this.baseUrl + "/api/caseUser/users/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersInCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersInCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfUserCompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfUserCompanyDto>;
        }));
    }

    protected processGetUsersInCompany(response: HttpResponseBase): Observable<ApplicationResultOfListOfUserCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfUserCompanyDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Available cases for User
     */
    getAvailableCasesForUser(userId: number): Observable<ApplicationResultOfListOfAvailableCaseDto> {
        let url_ = this.baseUrl + "/api/caseUser/cases/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableCasesForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableCasesForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfAvailableCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfAvailableCaseDto>;
        }));
    }

    protected processGetAvailableCasesForUser(response: HttpResponseBase): Observable<ApplicationResultOfListOfAvailableCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfAvailableCaseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Case User
     */
    deleteCaseUsers(caseId: number, userId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseUser/{caseId}/{userId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCaseUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCaseUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteCaseUsers(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case User
     */
    getCaseUserByCase(caseId: number): Observable<ApplicationResultOfCaseUserDto> {
        let url_ = this.baseUrl + "/api/caseUser/case-user/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseUserByCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseUserByCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCaseUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCaseUserDto>;
        }));
    }

    protected processGetCaseUserByCase(response: HttpResponseBase): Observable<ApplicationResultOfCaseUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCaseUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Case User Notification Settings
     */
    updateCaseUserNotificationSettings(command: UpdateCaseUserNotificationSettingsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/caseUser/case-user-notification-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaseUserNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaseUserNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateCaseUserNotificationSettings(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICommunicationServiceClient {
    /**
     * Get Communication Service Token
     */
    getCommunicationServiceToken(): Observable<ApplicationResultOfCommunicationServiceTokenResponse>;
    /**
     * Get Chat Threads
     * @param query (optional) 
     */
    getChatThreads(query?: ChatThreadsQuery | undefined): Observable<ApplicationResultOfListOfChatThreadListDto>;
    /**
     * Get Chat Threads
     * @param lastCheckpoint (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    getChatThreadsSync(lastCheckpoint?: Date | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined): Observable<ApplicationResultOfSyncDataModelOfChatThreadListDto>;
    /**
     * Get Chat Thread
     */
    getThread(id: number): Observable<ApplicationResultOfChatThreadDto>;
    /**
     * Get Chat Thread
     */
    deleteThread(id: number, command: DeleteChatThreadCommand): Observable<ApplicationResult>;
    /**
     * Restore Chat Thread
     * @param file (optional) 
     */
    restoreThread(file?: FileParameter | null | undefined): Observable<ApplicationResult>;
    /**
     * Get Thread Messages
     * @param lastMessageId (optional) 
     * @param pageSize (optional) 
     * @param firstMessageId (optional) 
     */
    getThreadMessages(threadId: number, lastMessageId?: number | null | undefined, pageSize?: number | undefined, firstMessageId?: number | null | undefined): Observable<ApplicationResultOfListOfChatMessageDto>;
    /**
     * Send Chat Message
     * @param azureToken (optional) Azure Communication Service token
     */
    sendChatMessage(threadId: number, command: SendChatMessageCommand, azureToken?: string | undefined): Observable<ApplicationResultOfChatMessageDto>;
    /**
     * Send Chat Message
     * @param azureToken (optional) Azure Communication Service token
     */
    addMessageReaction(threadId: number, messageId: number, command: AddMessageReactionCommand, azureToken?: string | undefined): Observable<ApplicationResultOfChatMessageDto>;
    /**
     * Send Chat Message
     * @param azureToken (optional) Azure Communication Service token
     */
    removeMessageReaction(threadId: number, messageId: number, command: RemoveMessageReactionCommand, azureToken?: string | undefined): Observable<ApplicationResultOfChatMessageDto>;
    /**
     * Get Starred Messages
     */
    getStarredMessages(threadId: number): Observable<ApplicationResultOfChatSearchResponse>;
    /**
     * Toggle Message Star
     * @param azureToken (optional) Azure Communication Service token
     */
    toggleMessageStar(threadId: number, messageId: number, azureToken?: string | undefined): Observable<ApplicationResultOfChatMessageDto>;
    /**
     * Get Or Create Peer To Peer Conversation
     * @param azureToken (optional) Azure Communication Service token
     */
    getOrCreatePeerToPeerConversation(command: GetOrCreatePeerToPeerChatThreadCommand, azureToken?: string | undefined): Observable<ApplicationResultOfChatThreadDto>;
    /**
     * Get Or Create Case Conversation
     * @param azureToken (optional) Azure Communication Service token
     */
    getOrCreateCaseConversation(caseId: number, communicationServiceToken: string, azureToken?: string | undefined): Observable<ApplicationResultOfChatThreadDto>;
    /**
     * Get Or Create Support Conversation
     */
    getOrCreateSupportConversation(communicationServiceToken: string): Observable<ApplicationResultOfChatThreadDto>;
    /**
     * Get Or Create Company Support Conversation
     */
    getOrCreateCompanySupportConversation(communicationServiceToken: string): Observable<ApplicationResultOfChatThreadDto>;
    /**
     * Get Or Create Reviewer Type Conversation
     * @param azureToken (optional) Azure Communication Service token
     */
    getOrCreateReviewerTypeConversation(reviewerTypeId: number, communicationServiceToken: string, azureToken?: string | undefined): Observable<ApplicationResultOfChatThreadDto>;
    /**
     * Get Or Create Client Group Conversation
     * @param azureToken (optional) Azure Communication Service token
     */
    getOrCreateClientGroupConversation(reviewerTypeId: number, communicationServiceToken: string, azureToken?: string | undefined): Observable<ApplicationResultOfChatThreadDto>;
    /**
     * Create Group Conversation
     * @param azureToken (optional) Azure Communication Service token
     */
    createGroupConversation(command: CreateGroupChatThreadCommand, azureToken?: string | undefined): Observable<ApplicationResultOfChatThreadDto>;
    /**
     * Create Message Conversation
     * @param azureToken (optional) Azure Communication Service token
     */
    getOrCreateReplyMessageThread(command: GetOrCreateReplyMessageThreadCommand, azureToken?: string | undefined): Observable<ApplicationResultOfChatThreadDto>;
    /**
     * Get Unread Messages
     */
    getUnreadMessages(): Observable<ApplicationResultOfChatUnreadMessagesResponse>;
    /**
     * Get Grouped Unread Messages
     */
    getGroupedUnreadMessages(): Observable<ApplicationResultOfChatUnreadMessagesGroupedResponse>;
    /**
     * Set Thread As Read
     * @param azureToken (optional) Azure Communication Service token
     */
    setThreadAsRead(threadId: number, command: SetThreadAsReadCommand, azureToken?: string | undefined): Observable<ApplicationResultOfChatUnreadMessagesResponse>;
    /**
     * Add participants to group chat
     * @param azureToken (optional) Azure Communication Service token
     */
    addParticipantsToGroupChat(threadId: number, command: AddParticipantsToGroupChatCommand, azureToken?: string | undefined): Observable<ApplicationResultOfListOfChatParticipantDto>;
    /**
     * Delete participant in group chat
     * @param azureToken (optional) Azure Communication Service token
     */
    removeParticipantsFromGroupChat(threadId: number, chatParticipantId: number, communicationServiceToken: string, azureToken?: string | undefined): Observable<ApplicationResult>;
    /**
     * Get Available Contacts
     */
    getAvailableContacts(threadId: number): Observable<ApplicationResultOfListOfUserDto>;
    /**
     * Get Available Company Users
     */
    getAvailableCompanyUsers(): Observable<ApplicationResultOfListOfUserDto>;
    /**
     * Get Available Company Reviewer Types
     */
    getAvailableCompanyReviewerTypes(): Observable<ApplicationResultOfChatReviewerReviewerTypesResponse>;
    /**
     * Get Company Users
     */
    getCompanyUsers(companyId: number): Observable<ApplicationResultOfListOfUserDto>;
    /**
     * Upload Chat Attachment
     * @param file (optional) 
     */
    uploadDocument(file?: FileParameter | null | undefined): Observable<ApplicationResultOfDocumentDto>;
    /**
     * Download Attachment
     */
    downloadDocument(fileKey: string): Observable<ApplicationResultOfFileUrlDto>;
    /**
     * Get Message Attachments
     */
    getMessageAttachments(id: number): Observable<ApplicationResultOfListOfDocumentDto>;
    /**
     * Export Chat Thread
     */
    exportChatThread(threadId: number, command: ExportChatThreadCommand): Observable<FileResponse>;
    archiveChatThread(command: ArchiveChatThreadCommand): Observable<ApplicationResult>;
    pinChatThread(command: PinChatThreadCommand): Observable<ApplicationResult>;
    searchTitle(searchText?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined): Observable<ApplicationResultOfChatSearchTitleResponse>;
    search(searchText?: string | null | undefined, threadId?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined): Observable<ApplicationResultOfChatSearchResponse>;
    getChatRingtones(): Observable<ApplicationResultOfListOfChatRingtoneDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CommunicationServiceClient extends ApiClientBase implements ICommunicationServiceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Communication Service Token
     */
    getCommunicationServiceToken(): Observable<ApplicationResultOfCommunicationServiceTokenResponse> {
        let url_ = this.baseUrl + "/api/communicationService/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommunicationServiceToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationServiceToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCommunicationServiceTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCommunicationServiceTokenResponse>;
        }));
    }

    protected processGetCommunicationServiceToken(response: HttpResponseBase): Observable<ApplicationResultOfCommunicationServiceTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCommunicationServiceTokenResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Chat Threads
     * @param query (optional) 
     */
    getChatThreads(query?: ChatThreadsQuery | undefined): Observable<ApplicationResultOfListOfChatThreadListDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatThreads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatThreads(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfChatThreadListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfChatThreadListDto>;
        }));
    }

    protected processGetChatThreads(response: HttpResponseBase): Observable<ApplicationResultOfListOfChatThreadListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfChatThreadListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Chat Threads
     * @param lastCheckpoint (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    getChatThreadsSync(lastCheckpoint?: Date | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined): Observable<ApplicationResultOfSyncDataModelOfChatThreadListDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/sync?";
        if (lastCheckpoint !== undefined && lastCheckpoint !== null)
            url_ += "LastCheckpoint=" + encodeURIComponent(lastCheckpoint ? "" + lastCheckpoint.toISOString() : "") + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatThreadsSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatThreadsSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfSyncDataModelOfChatThreadListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfSyncDataModelOfChatThreadListDto>;
        }));
    }

    protected processGetChatThreadsSync(response: HttpResponseBase): Observable<ApplicationResultOfSyncDataModelOfChatThreadListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfSyncDataModelOfChatThreadListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Chat Thread
     */
    getThread(id: number): Observable<ApplicationResultOfChatThreadDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThread(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThread(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatThreadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatThreadDto>;
        }));
    }

    protected processGetThread(response: HttpResponseBase): Observable<ApplicationResultOfChatThreadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatThreadDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Chat Thread
     */
    deleteThread(id: number, command: DeleteChatThreadCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/communicationService/threads/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteThread(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteThread(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteThread(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Restore Chat Thread
     * @param file (optional) 
     */
    restoreThread(file?: FileParameter | null | undefined): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/communicationService/threads/restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreThread(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreThread(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processRestoreThread(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Thread Messages
     * @param lastMessageId (optional) 
     * @param pageSize (optional) 
     * @param firstMessageId (optional) 
     */
    getThreadMessages(threadId: number, lastMessageId?: number | null | undefined, pageSize?: number | undefined, firstMessageId?: number | null | undefined): Observable<ApplicationResultOfListOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/{threadId}/messages?";
        if (threadId === undefined || threadId === null)
            throw new globalThis.Error("The parameter 'threadId' must be defined.");
        url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
        if (lastMessageId !== undefined && lastMessageId !== null)
            url_ += "lastMessageId=" + encodeURIComponent("" + lastMessageId) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (firstMessageId !== undefined && firstMessageId !== null)
            url_ += "firstMessageId=" + encodeURIComponent("" + firstMessageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThreadMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThreadMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfChatMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfChatMessageDto>;
        }));
    }

    protected processGetThreadMessages(response: HttpResponseBase): Observable<ApplicationResultOfListOfChatMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfChatMessageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send Chat Message
     * @param azureToken (optional) Azure Communication Service token
     */
    sendChatMessage(threadId: number, command: SendChatMessageCommand, azureToken?: string | undefined): Observable<ApplicationResultOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/{threadId}/messages";
        if (threadId === undefined || threadId === null)
            throw new globalThis.Error("The parameter 'threadId' must be defined.");
        url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "AzureToken": azureToken !== undefined && azureToken !== null ? "" + azureToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendChatMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendChatMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatMessageDto>;
        }));
    }

    protected processSendChatMessage(response: HttpResponseBase): Observable<ApplicationResultOfChatMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatMessageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send Chat Message
     * @param azureToken (optional) Azure Communication Service token
     */
    addMessageReaction(threadId: number, messageId: number, command: AddMessageReactionCommand, azureToken?: string | undefined): Observable<ApplicationResultOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/{threadId}/messages/{messageId}/reaction";
        if (threadId === undefined || threadId === null)
            throw new globalThis.Error("The parameter 'threadId' must be defined.");
        url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
        if (messageId === undefined || messageId === null)
            throw new globalThis.Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "AzureToken": azureToken !== undefined && azureToken !== null ? "" + azureToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMessageReaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMessageReaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatMessageDto>;
        }));
    }

    protected processAddMessageReaction(response: HttpResponseBase): Observable<ApplicationResultOfChatMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatMessageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send Chat Message
     * @param azureToken (optional) Azure Communication Service token
     */
    removeMessageReaction(threadId: number, messageId: number, command: RemoveMessageReactionCommand, azureToken?: string | undefined): Observable<ApplicationResultOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/{threadId}/messages/{messageId}/reaction";
        if (threadId === undefined || threadId === null)
            throw new globalThis.Error("The parameter 'threadId' must be defined.");
        url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
        if (messageId === undefined || messageId === null)
            throw new globalThis.Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "AzureToken": azureToken !== undefined && azureToken !== null ? "" + azureToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveMessageReaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveMessageReaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatMessageDto>;
        }));
    }

    protected processRemoveMessageReaction(response: HttpResponseBase): Observable<ApplicationResultOfChatMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatMessageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Starred Messages
     */
    getStarredMessages(threadId: number): Observable<ApplicationResultOfChatSearchResponse> {
        let url_ = this.baseUrl + "/api/communicationService/threads/{threadId}/messages/starred";
        if (threadId === undefined || threadId === null)
            throw new globalThis.Error("The parameter 'threadId' must be defined.");
        url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStarredMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStarredMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatSearchResponse>;
        }));
    }

    protected processGetStarredMessages(response: HttpResponseBase): Observable<ApplicationResultOfChatSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Toggle Message Star
     * @param azureToken (optional) Azure Communication Service token
     */
    toggleMessageStar(threadId: number, messageId: number, azureToken?: string | undefined): Observable<ApplicationResultOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/{threadId}/messages/{messageId}/star";
        if (threadId === undefined || threadId === null)
            throw new globalThis.Error("The parameter 'threadId' must be defined.");
        url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
        if (messageId === undefined || messageId === null)
            throw new globalThis.Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "AzureToken": azureToken !== undefined && azureToken !== null ? "" + azureToken : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleMessageStar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleMessageStar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatMessageDto>;
        }));
    }

    protected processToggleMessageStar(response: HttpResponseBase): Observable<ApplicationResultOfChatMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatMessageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Or Create Peer To Peer Conversation
     * @param azureToken (optional) Azure Communication Service token
     */
    getOrCreatePeerToPeerConversation(command: GetOrCreatePeerToPeerChatThreadCommand, azureToken?: string | undefined): Observable<ApplicationResultOfChatThreadDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/p2p";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "AzureToken": azureToken !== undefined && azureToken !== null ? "" + azureToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrCreatePeerToPeerConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrCreatePeerToPeerConversation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatThreadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatThreadDto>;
        }));
    }

    protected processGetOrCreatePeerToPeerConversation(response: HttpResponseBase): Observable<ApplicationResultOfChatThreadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatThreadDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Or Create Case Conversation
     * @param azureToken (optional) Azure Communication Service token
     */
    getOrCreateCaseConversation(caseId: number, communicationServiceToken: string, azureToken?: string | undefined): Observable<ApplicationResultOfChatThreadDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/case/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(communicationServiceToken);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "AzureToken": azureToken !== undefined && azureToken !== null ? "" + azureToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrCreateCaseConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrCreateCaseConversation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatThreadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatThreadDto>;
        }));
    }

    protected processGetOrCreateCaseConversation(response: HttpResponseBase): Observable<ApplicationResultOfChatThreadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatThreadDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Or Create Support Conversation
     */
    getOrCreateSupportConversation(communicationServiceToken: string): Observable<ApplicationResultOfChatThreadDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/support";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(communicationServiceToken);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrCreateSupportConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrCreateSupportConversation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatThreadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatThreadDto>;
        }));
    }

    protected processGetOrCreateSupportConversation(response: HttpResponseBase): Observable<ApplicationResultOfChatThreadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatThreadDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Or Create Company Support Conversation
     */
    getOrCreateCompanySupportConversation(communicationServiceToken: string): Observable<ApplicationResultOfChatThreadDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/company-support";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(communicationServiceToken);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrCreateCompanySupportConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrCreateCompanySupportConversation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatThreadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatThreadDto>;
        }));
    }

    protected processGetOrCreateCompanySupportConversation(response: HttpResponseBase): Observable<ApplicationResultOfChatThreadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatThreadDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Or Create Reviewer Type Conversation
     * @param azureToken (optional) Azure Communication Service token
     */
    getOrCreateReviewerTypeConversation(reviewerTypeId: number, communicationServiceToken: string, azureToken?: string | undefined): Observable<ApplicationResultOfChatThreadDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/reviewerType/{reviewerTypeId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(communicationServiceToken);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "AzureToken": azureToken !== undefined && azureToken !== null ? "" + azureToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrCreateReviewerTypeConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrCreateReviewerTypeConversation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatThreadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatThreadDto>;
        }));
    }

    protected processGetOrCreateReviewerTypeConversation(response: HttpResponseBase): Observable<ApplicationResultOfChatThreadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatThreadDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Or Create Client Group Conversation
     * @param azureToken (optional) Azure Communication Service token
     */
    getOrCreateClientGroupConversation(reviewerTypeId: number, communicationServiceToken: string, azureToken?: string | undefined): Observable<ApplicationResultOfChatThreadDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/reviewerType/{reviewerTypeId}/reviewer";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(communicationServiceToken);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "AzureToken": azureToken !== undefined && azureToken !== null ? "" + azureToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrCreateClientGroupConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrCreateClientGroupConversation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatThreadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatThreadDto>;
        }));
    }

    protected processGetOrCreateClientGroupConversation(response: HttpResponseBase): Observable<ApplicationResultOfChatThreadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatThreadDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Group Conversation
     * @param azureToken (optional) Azure Communication Service token
     */
    createGroupConversation(command: CreateGroupChatThreadCommand, azureToken?: string | undefined): Observable<ApplicationResultOfChatThreadDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "AzureToken": azureToken !== undefined && azureToken !== null ? "" + azureToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGroupConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGroupConversation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatThreadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatThreadDto>;
        }));
    }

    protected processCreateGroupConversation(response: HttpResponseBase): Observable<ApplicationResultOfChatThreadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatThreadDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Message Conversation
     * @param azureToken (optional) Azure Communication Service token
     */
    getOrCreateReplyMessageThread(command: GetOrCreateReplyMessageThreadCommand, azureToken?: string | undefined): Observable<ApplicationResultOfChatThreadDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/reply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "AzureToken": azureToken !== undefined && azureToken !== null ? "" + azureToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrCreateReplyMessageThread(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrCreateReplyMessageThread(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatThreadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatThreadDto>;
        }));
    }

    protected processGetOrCreateReplyMessageThread(response: HttpResponseBase): Observable<ApplicationResultOfChatThreadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatThreadDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Unread Messages
     */
    getUnreadMessages(): Observable<ApplicationResultOfChatUnreadMessagesResponse> {
        let url_ = this.baseUrl + "/api/communicationService/messages/unread";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnreadMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnreadMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatUnreadMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatUnreadMessagesResponse>;
        }));
    }

    protected processGetUnreadMessages(response: HttpResponseBase): Observable<ApplicationResultOfChatUnreadMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatUnreadMessagesResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Grouped Unread Messages
     */
    getGroupedUnreadMessages(): Observable<ApplicationResultOfChatUnreadMessagesGroupedResponse> {
        let url_ = this.baseUrl + "/api/communicationService/messages/unread/grouped";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupedUnreadMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupedUnreadMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatUnreadMessagesGroupedResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatUnreadMessagesGroupedResponse>;
        }));
    }

    protected processGetGroupedUnreadMessages(response: HttpResponseBase): Observable<ApplicationResultOfChatUnreadMessagesGroupedResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatUnreadMessagesGroupedResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Set Thread As Read
     * @param azureToken (optional) Azure Communication Service token
     */
    setThreadAsRead(threadId: number, command: SetThreadAsReadCommand, azureToken?: string | undefined): Observable<ApplicationResultOfChatUnreadMessagesResponse> {
        let url_ = this.baseUrl + "/api/communicationService/threads/{threadId}/read";
        if (threadId === undefined || threadId === null)
            throw new globalThis.Error("The parameter 'threadId' must be defined.");
        url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "AzureToken": azureToken !== undefined && azureToken !== null ? "" + azureToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetThreadAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetThreadAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatUnreadMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatUnreadMessagesResponse>;
        }));
    }

    protected processSetThreadAsRead(response: HttpResponseBase): Observable<ApplicationResultOfChatUnreadMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatUnreadMessagesResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add participants to group chat
     * @param azureToken (optional) Azure Communication Service token
     */
    addParticipantsToGroupChat(threadId: number, command: AddParticipantsToGroupChatCommand, azureToken?: string | undefined): Observable<ApplicationResultOfListOfChatParticipantDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/{threadId}/participants";
        if (threadId === undefined || threadId === null)
            throw new globalThis.Error("The parameter 'threadId' must be defined.");
        url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "AzureToken": azureToken !== undefined && azureToken !== null ? "" + azureToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddParticipantsToGroupChat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddParticipantsToGroupChat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfChatParticipantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfChatParticipantDto>;
        }));
    }

    protected processAddParticipantsToGroupChat(response: HttpResponseBase): Observable<ApplicationResultOfListOfChatParticipantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfChatParticipantDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete participant in group chat
     * @param azureToken (optional) Azure Communication Service token
     */
    removeParticipantsFromGroupChat(threadId: number, chatParticipantId: number, communicationServiceToken: string, azureToken?: string | undefined): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/communicationService/threads/{threadId}/participants/{chatParticipantId}";
        if (threadId === undefined || threadId === null)
            throw new globalThis.Error("The parameter 'threadId' must be defined.");
        url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
        if (chatParticipantId === undefined || chatParticipantId === null)
            throw new globalThis.Error("The parameter 'chatParticipantId' must be defined.");
        url_ = url_.replace("{chatParticipantId}", encodeURIComponent("" + chatParticipantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(communicationServiceToken);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "AzureToken": azureToken !== undefined && azureToken !== null ? "" + azureToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveParticipantsFromGroupChat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveParticipantsFromGroupChat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processRemoveParticipantsFromGroupChat(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Available Contacts
     */
    getAvailableContacts(threadId: number): Observable<ApplicationResultOfListOfUserDto> {
        let url_ = this.baseUrl + "/api/communicationService/threads/{threadId}/contacts";
        if (threadId === undefined || threadId === null)
            throw new globalThis.Error("The parameter 'threadId' must be defined.");
        url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfUserDto>;
        }));
    }

    protected processGetAvailableContacts(response: HttpResponseBase): Observable<ApplicationResultOfListOfUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Available Company Users
     */
    getAvailableCompanyUsers(): Observable<ApplicationResultOfListOfUserDto> {
        let url_ = this.baseUrl + "/api/communicationService/available-company-users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableCompanyUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableCompanyUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfUserDto>;
        }));
    }

    protected processGetAvailableCompanyUsers(response: HttpResponseBase): Observable<ApplicationResultOfListOfUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Available Company Reviewer Types
     */
    getAvailableCompanyReviewerTypes(): Observable<ApplicationResultOfChatReviewerReviewerTypesResponse> {
        let url_ = this.baseUrl + "/api/communicationService/available-reviewer-type";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableCompanyReviewerTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableCompanyReviewerTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatReviewerReviewerTypesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatReviewerReviewerTypesResponse>;
        }));
    }

    protected processGetAvailableCompanyReviewerTypes(response: HttpResponseBase): Observable<ApplicationResultOfChatReviewerReviewerTypesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatReviewerReviewerTypesResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Company Users
     */
    getCompanyUsers(companyId: number): Observable<ApplicationResultOfListOfUserDto> {
        let url_ = this.baseUrl + "/api/communicationService/company/{companyId}/users";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfUserDto>;
        }));
    }

    protected processGetCompanyUsers(response: HttpResponseBase): Observable<ApplicationResultOfListOfUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload Chat Attachment
     * @param file (optional) 
     */
    uploadDocument(file?: FileParameter | null | undefined): Observable<ApplicationResultOfDocumentDto> {
        let url_ = this.baseUrl + "/api/communicationService/attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfDocumentDto>;
        }));
    }

    protected processUploadDocument(response: HttpResponseBase): Observable<ApplicationResultOfDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download Attachment
     */
    downloadDocument(fileKey: string): Observable<ApplicationResultOfFileUrlDto> {
        let url_ = this.baseUrl + "/api/communicationService/attachment/{fileKey}";
        if (fileKey === undefined || fileKey === null)
            throw new globalThis.Error("The parameter 'fileKey' must be defined.");
        url_ = url_.replace("{fileKey}", encodeURIComponent("" + fileKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfFileUrlDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfFileUrlDto>;
        }));
    }

    protected processDownloadDocument(response: HttpResponseBase): Observable<ApplicationResultOfFileUrlDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfFileUrlDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Message Attachments
     */
    getMessageAttachments(id: number): Observable<ApplicationResultOfListOfDocumentDto> {
        let url_ = this.baseUrl + "/api/communicationService/messages/{id}/attachments";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMessageAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMessageAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfDocumentDto>;
        }));
    }

    protected processGetMessageAttachments(response: HttpResponseBase): Observable<ApplicationResultOfListOfDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export Chat Thread
     */
    exportChatThread(threadId: number, command: ExportChatThreadCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/communicationService/export/{threadId}";
        if (threadId === undefined || threadId === null)
            throw new globalThis.Error("The parameter 'threadId' must be defined.");
        url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportChatThread(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportChatThread(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportChatThread(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    archiveChatThread(command: ArchiveChatThreadCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/communicationService/archive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveChatThread(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveChatThread(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processArchiveChatThread(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pinChatThread(command: PinChatThreadCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/communicationService/pin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPinChatThread(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPinChatThread(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processPinChatThread(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchTitle(searchText?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined): Observable<ApplicationResultOfChatSearchTitleResponse> {
        let url_ = this.baseUrl + "/api/communicationService/search/title?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatSearchTitleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatSearchTitleResponse>;
        }));
    }

    protected processSearchTitle(response: HttpResponseBase): Observable<ApplicationResultOfChatSearchTitleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatSearchTitleResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(searchText?: string | null | undefined, threadId?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined): Observable<ApplicationResultOfChatSearchResponse> {
        let url_ = this.baseUrl + "/api/communicationService/search?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (threadId !== undefined && threadId !== null)
            url_ += "ThreadId=" + encodeURIComponent("" + threadId) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfChatSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfChatSearchResponse>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ApplicationResultOfChatSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfChatSearchResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChatRingtones(): Observable<ApplicationResultOfListOfChatRingtoneDto> {
        let url_ = this.baseUrl + "/api/communicationService/ringtones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatRingtones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatRingtones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfChatRingtoneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfChatRingtoneDto>;
        }));
    }

    protected processGetChatRingtones(response: HttpResponseBase): Observable<ApplicationResultOfListOfChatRingtoneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfChatRingtoneDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyAgreementClient {
    /**
     * Get Agreement Status of company
     */
    getClientAgreementStatus(companyId: number): Observable<ApplicationResultOfClientAgreementStatus>;
    /**
     * Generate Signing Link for Company
     */
    generateSigningLinkForCompany(command: GenerateClientSubscriptionAgreementLinkCommand): Observable<ApplicationResultOfLinkRequestResult>;
    /**
     * Get Agreement Status of company
     */
    getCompanyAgreement(): Observable<ApplicationResultOfDocumentDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CompanyAgreementClient extends ApiClientBase implements ICompanyAgreementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Agreement Status of company
     */
    getClientAgreementStatus(companyId: number): Observable<ApplicationResultOfClientAgreementStatus> {
        let url_ = this.baseUrl + "/api/companyAgreement/company/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientAgreementStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientAgreementStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfClientAgreementStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfClientAgreementStatus>;
        }));
    }

    protected processGetClientAgreementStatus(response: HttpResponseBase): Observable<ApplicationResultOfClientAgreementStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfClientAgreementStatus;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generate Signing Link for Company
     */
    generateSigningLinkForCompany(command: GenerateClientSubscriptionAgreementLinkCommand): Observable<ApplicationResultOfLinkRequestResult> {
        let url_ = this.baseUrl + "/api/companyAgreement/links";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateSigningLinkForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateSigningLinkForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfLinkRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfLinkRequestResult>;
        }));
    }

    protected processGenerateSigningLinkForCompany(response: HttpResponseBase): Observable<ApplicationResultOfLinkRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfLinkRequestResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Agreement Status of company
     */
    getCompanyAgreement(): Observable<ApplicationResultOfDocumentDto> {
        let url_ = this.baseUrl + "/api/companyAgreement/company/agreement";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyAgreement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfDocumentDto>;
        }));
    }

    protected processGetCompanyAgreement(response: HttpResponseBase): Observable<ApplicationResultOfDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyClient {
    /**
     * Get User Companies By Assigned Permission
     * @param permission (optional) 
     */
    getUserCompaniesInfo(permission?: string | null | undefined): Observable<ApplicationResultOfListOfUserUserCompanyDto>;
    /**
     * Select Company
     */
    selectCompany(companyId: number): Observable<ApplicationResultOfSelectCompanyResultDto>;
    /**
     * Get Current Company Info
     */
    getCurrentCompany(): Observable<ApplicationResultOfCompanyDto>;
    /**
     * Get Company Manage Info
     */
    getPrimaryCompanyManageInfo(): Observable<ApplicationResultOfCompanyManageInfoDto>;
    /**
     * Create Company
     */
    registerClient(command: CreateCompanyCommand): Observable<ApplicationResultOfCreateCompanyResponse>;
    /**
     * Get Company users
     */
    getAllCompanyUsers(): Observable<ApplicationResultOfListOfUserCompanyDto>;
    /**
     * Get Company users
     */
    deleteCompanyUser(command: DeleteCompanyUserCommand): Observable<ApplicationResultOfIListOfUserCompanyDto>;
    /**
     * Update Company Billing Info
     */
    updateCompanyBillingInfo(command: UpdateCompanyBillingInfoCommand): Observable<ApplicationResultOfAccountResultDto>;
    /**
     * Update Company Info
     */
    updateCompanyInfo(command: UpdateCompanyInfoCommand): Observable<ApplicationResultOfAccountResultDto>;
    /**
     * Update Company User Info
     */
    updateCompanyUserInfo(command: UpdateCompanyUserCommand): Observable<ApplicationResult>;
    /**
     * Company
     */
    getAll(): Observable<ApplicationResultOfListOfLookUpDto>;
    /**
     * Company
     */
    getDashboardTiles(): Observable<ApplicationResultOfCompanyDashboardTilesDto>;
    /**
     * Company
     */
    getDashboardTimeEntries(): Observable<ApplicationResultOfListOfDashboardTimeEntryDto>;
    /**
     * Get All Companies
     */
    getAllCompaniesForAdmin(): Observable<ApplicationResultOfListOfLookUpDto>;
    /**
     * Get All Companies for Admin Management
     */
    getAllCompaniesForAdminManagement(): Observable<ApplicationResultOfListOfAdminCompanyDto>;
    /**
     * Update Company for Admin
     */
    updateCompanyForAdmin(command: UpdateCompanyForAdminCommand): Observable<ApplicationResult>;
    /**
     * Update Time Entries Threshold
     */
    updateCompanyUserTimeEntriesThreshold(command: UpdateCompanyUserTimeEntriesThresholdCommand): Observable<ApplicationResult>;
    /**
     * Get Time Entries Threshold
     */
    getCompanyUserTimeEntriesThreshold(): Observable<ApplicationResultOfCompanyUserTimeEntriesThresholdDto>;
    /**
     * Get Company Documents
     */
    companyDocuments(): Observable<ApplicationResultOfListOfBoldsignDocumentDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CompanyClient extends ApiClientBase implements ICompanyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get User Companies By Assigned Permission
     * @param permission (optional) 
     */
    getUserCompaniesInfo(permission?: string | null | undefined): Observable<ApplicationResultOfListOfUserUserCompanyDto> {
        let url_ = this.baseUrl + "/api/company/user-company?";
        if (permission !== undefined && permission !== null)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCompaniesInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCompaniesInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfUserUserCompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfUserUserCompanyDto>;
        }));
    }

    protected processGetUserCompaniesInfo(response: HttpResponseBase): Observable<ApplicationResultOfListOfUserUserCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfUserUserCompanyDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Select Company
     */
    selectCompany(companyId: number): Observable<ApplicationResultOfSelectCompanyResultDto> {
        let url_ = this.baseUrl + "/api/company/select/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfSelectCompanyResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfSelectCompanyResultDto>;
        }));
    }

    protected processSelectCompany(response: HttpResponseBase): Observable<ApplicationResultOfSelectCompanyResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfSelectCompanyResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Current Company Info
     */
    getCurrentCompany(): Observable<ApplicationResultOfCompanyDto> {
        let url_ = this.baseUrl + "/api/company/current-company";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCompanyDto>;
        }));
    }

    protected processGetCurrentCompany(response: HttpResponseBase): Observable<ApplicationResultOfCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCompanyDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Company Manage Info
     */
    getPrimaryCompanyManageInfo(): Observable<ApplicationResultOfCompanyManageInfoDto> {
        let url_ = this.baseUrl + "/api/company/current-manage-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrimaryCompanyManageInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrimaryCompanyManageInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCompanyManageInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCompanyManageInfoDto>;
        }));
    }

    protected processGetPrimaryCompanyManageInfo(response: HttpResponseBase): Observable<ApplicationResultOfCompanyManageInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCompanyManageInfoDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Company
     */
    registerClient(command: CreateCompanyCommand): Observable<ApplicationResultOfCreateCompanyResponse> {
        let url_ = this.baseUrl + "/api/company/create-company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCreateCompanyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCreateCompanyResponse>;
        }));
    }

    protected processRegisterClient(response: HttpResponseBase): Observable<ApplicationResultOfCreateCompanyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCreateCompanyResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Company users
     */
    getAllCompanyUsers(): Observable<ApplicationResultOfListOfUserCompanyDto> {
        let url_ = this.baseUrl + "/api/company/get-company-users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompanyUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompanyUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfUserCompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfUserCompanyDto>;
        }));
    }

    protected processGetAllCompanyUsers(response: HttpResponseBase): Observable<ApplicationResultOfListOfUserCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfUserCompanyDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Company users
     */
    deleteCompanyUser(command: DeleteCompanyUserCommand): Observable<ApplicationResultOfIListOfUserCompanyDto> {
        let url_ = this.baseUrl + "/api/company/company-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompanyUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompanyUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfIListOfUserCompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfIListOfUserCompanyDto>;
        }));
    }

    protected processDeleteCompanyUser(response: HttpResponseBase): Observable<ApplicationResultOfIListOfUserCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfIListOfUserCompanyDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Company Billing Info
     */
    updateCompanyBillingInfo(command: UpdateCompanyBillingInfoCommand): Observable<ApplicationResultOfAccountResultDto> {
        let url_ = this.baseUrl + "/api/company/update-company-billing-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompanyBillingInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompanyBillingInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAccountResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAccountResultDto>;
        }));
    }

    protected processUpdateCompanyBillingInfo(response: HttpResponseBase): Observable<ApplicationResultOfAccountResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAccountResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Company Info
     */
    updateCompanyInfo(command: UpdateCompanyInfoCommand): Observable<ApplicationResultOfAccountResultDto> {
        let url_ = this.baseUrl + "/api/company/update-company-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompanyInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompanyInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAccountResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAccountResultDto>;
        }));
    }

    protected processUpdateCompanyInfo(response: HttpResponseBase): Observable<ApplicationResultOfAccountResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAccountResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Company User Info
     */
    updateCompanyUserInfo(command: UpdateCompanyUserCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/company/update-company-user-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompanyUserInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompanyUserInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateCompanyUserInfo(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Company
     */
    getAll(): Observable<ApplicationResultOfListOfLookUpDto> {
        let url_ = this.baseUrl + "/api/company/get-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfLookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfLookUpDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApplicationResultOfListOfLookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfLookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Company
     */
    getDashboardTiles(): Observable<ApplicationResultOfCompanyDashboardTilesDto> {
        let url_ = this.baseUrl + "/api/company/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardTiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardTiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCompanyDashboardTilesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCompanyDashboardTilesDto>;
        }));
    }

    protected processGetDashboardTiles(response: HttpResponseBase): Observable<ApplicationResultOfCompanyDashboardTilesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCompanyDashboardTilesDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Company
     */
    getDashboardTimeEntries(): Observable<ApplicationResultOfListOfDashboardTimeEntryDto> {
        let url_ = this.baseUrl + "/api/company/get-time-entries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardTimeEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardTimeEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfDashboardTimeEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfDashboardTimeEntryDto>;
        }));
    }

    protected processGetDashboardTimeEntries(response: HttpResponseBase): Observable<ApplicationResultOfListOfDashboardTimeEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfDashboardTimeEntryDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Companies
     */
    getAllCompaniesForAdmin(): Observable<ApplicationResultOfListOfLookUpDto> {
        let url_ = this.baseUrl + "/api/company/admin/get-all-companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompaniesForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompaniesForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfLookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfLookUpDto>;
        }));
    }

    protected processGetAllCompaniesForAdmin(response: HttpResponseBase): Observable<ApplicationResultOfListOfLookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfLookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Companies for Admin Management
     */
    getAllCompaniesForAdminManagement(): Observable<ApplicationResultOfListOfAdminCompanyDto> {
        let url_ = this.baseUrl + "/api/company/admin/get-all-companies-management";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompaniesForAdminManagement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompaniesForAdminManagement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfAdminCompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfAdminCompanyDto>;
        }));
    }

    protected processGetAllCompaniesForAdminManagement(response: HttpResponseBase): Observable<ApplicationResultOfListOfAdminCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfAdminCompanyDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Company for Admin
     */
    updateCompanyForAdmin(command: UpdateCompanyForAdminCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/company/admin/update-company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompanyForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompanyForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateCompanyForAdmin(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Time Entries Threshold
     */
    updateCompanyUserTimeEntriesThreshold(command: UpdateCompanyUserTimeEntriesThresholdCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/company/time-entries-threshold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompanyUserTimeEntriesThreshold(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompanyUserTimeEntriesThreshold(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateCompanyUserTimeEntriesThreshold(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Time Entries Threshold
     */
    getCompanyUserTimeEntriesThreshold(): Observable<ApplicationResultOfCompanyUserTimeEntriesThresholdDto> {
        let url_ = this.baseUrl + "/api/company/time-entries-threshold";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyUserTimeEntriesThreshold(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyUserTimeEntriesThreshold(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCompanyUserTimeEntriesThresholdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCompanyUserTimeEntriesThresholdDto>;
        }));
    }

    protected processGetCompanyUserTimeEntriesThreshold(response: HttpResponseBase): Observable<ApplicationResultOfCompanyUserTimeEntriesThresholdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCompanyUserTimeEntriesThresholdDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Company Documents
     */
    companyDocuments(): Observable<ApplicationResultOfListOfBoldsignDocumentDto> {
        let url_ = this.baseUrl + "/api/company/documents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfBoldsignDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfBoldsignDocumentDto>;
        }));
    }

    protected processCompanyDocuments(response: HttpResponseBase): Observable<ApplicationResultOfListOfBoldsignDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfBoldsignDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyReviewerExperienceClient {
    /**
     * Get Reviewer Experiences
     */
    getAll(reviewerId: number): Observable<ApplicationResultOfListOfReviewerExperienceDto>;
    /**
     * Upsert Reviewer Experience
     */
    upsert(reviewerId: number, command: UpsertReviewerExperienceCommand): Observable<ApplicationResult>;
    /**
     * Get Reviewer Experience
     */
    get(id: number): Observable<ApplicationResultOfReviewerExperienceDto>;
    /**
     * Delete Reviewer Experience
     */
    delete(id: number): Observable<ApplicationResult>;
    /**
     * Upload Reviewer Project History
     * @param file (optional) 
     */
    uploadReviewerProjectHistory(reviewerId: string, file?: FileParameter | null | undefined): Observable<ApplicationResultOfUploadReviewerProjectHistoryResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class CompanyReviewerExperienceClient extends ApiClientBase implements ICompanyReviewerExperienceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Reviewer Experiences
     */
    getAll(reviewerId: number): Observable<ApplicationResultOfListOfReviewerExperienceDto> {
        let url_ = this.baseUrl + "/api/companyReviewerExperience/reviewer/{reviewerId}";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerExperienceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerExperienceDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerExperienceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerExperienceDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upsert Reviewer Experience
     */
    upsert(reviewerId: number, command: UpsertReviewerExperienceCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/companyReviewerExperience/reviewer/{reviewerId}";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Experience
     */
    get(id: number): Observable<ApplicationResultOfReviewerExperienceDto> {
        let url_ = this.baseUrl + "/api/companyReviewerExperience/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerExperienceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerExperienceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApplicationResultOfReviewerExperienceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerExperienceDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Reviewer Experience
     */
    delete(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/companyReviewerExperience/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload Reviewer Project History
     * @param file (optional) 
     */
    uploadReviewerProjectHistory(reviewerId: string, file?: FileParameter | null | undefined): Observable<ApplicationResultOfUploadReviewerProjectHistoryResponse> {
        let url_ = this.baseUrl + "/api/companyReviewerExperience/reviewer/{reviewerId}/upload-reviewer-project-history";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadReviewerProjectHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadReviewerProjectHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfUploadReviewerProjectHistoryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfUploadReviewerProjectHistoryResponse>;
        }));
    }

    protected processUploadReviewerProjectHistory(response: HttpResponseBase): Observable<ApplicationResultOfUploadReviewerProjectHistoryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfUploadReviewerProjectHistoryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyReviewerLanguageTestClient {
    /**
     * Get Reviewers Language Tests
     */
    getAll(reviewerId: number): Observable<ApplicationResultOfListOfReviewerLanguageTestDto>;
    /**
     * Create Reviewers Language Tests
     */
    createTest(reviewerId: number, command: CreateReviewerLanguageTestCommand): Observable<ApplicationResultOfReviewerLanguageTestDto>;
    /**
     * Update Reviewers Language Tests
     */
    updateTest(id: number, command: UpdateReviewerLanguageTestCommand): Observable<ApplicationResultOfReviewerLanguageTestDto>;
    /**
     * Delete Reviewers Language Tests
     */
    deleteTest(id: number): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class CompanyReviewerLanguageTestClient extends ApiClientBase implements ICompanyReviewerLanguageTestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Reviewers Language Tests
     */
    getAll(reviewerId: number): Observable<ApplicationResultOfListOfReviewerLanguageTestDto> {
        let url_ = this.baseUrl + "/api/companyReviewerLanguageTest/{reviewerId}";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerLanguageTestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerLanguageTestDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerLanguageTestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerLanguageTestDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Reviewers Language Tests
     */
    createTest(reviewerId: number, command: CreateReviewerLanguageTestCommand): Observable<ApplicationResultOfReviewerLanguageTestDto> {
        let url_ = this.baseUrl + "/api/companyReviewerLanguageTest/{reviewerId}";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerLanguageTestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerLanguageTestDto>;
        }));
    }

    protected processCreateTest(response: HttpResponseBase): Observable<ApplicationResultOfReviewerLanguageTestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerLanguageTestDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Reviewers Language Tests
     */
    updateTest(id: number, command: UpdateReviewerLanguageTestCommand): Observable<ApplicationResultOfReviewerLanguageTestDto> {
        let url_ = this.baseUrl + "/api/companyReviewerLanguageTest/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerLanguageTestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerLanguageTestDto>;
        }));
    }

    protected processUpdateTest(response: HttpResponseBase): Observable<ApplicationResultOfReviewerLanguageTestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerLanguageTestDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Reviewers Language Tests
     */
    deleteTest(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/companyReviewerLanguageTest/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteTest(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyReviewerManagementClient {
    /**
     * Get Reviewers for Company
     */
    getReviewersForCompany(): Observable<ApplicationResultOfListOfReviewerForCompanyDto>;
    updateReviewerCompany(request: UpdateCompanyReviewerCommand): Observable<ApplicationResult>;
    /**
     * Get Reviewers for Company
     */
    getInternalInvitesForCompany(): Observable<ApplicationResultOfListOfReviewerCompanyInviteDto>;
    /**
     * Get Reviewer for Company
     */
    getReviewerForCompany(reviewerId: number): Observable<ApplicationResultOfCompanyReviewerDto>;
    /**
     * Mark Reviewer as Favorite
     */
    markReviewerAsFavorite(request: MarkReviewerAsFavoriteCommand): Observable<ApplicationResult>;
    /**
     * Check if Reviewer is Active on Any RTs
     */
    isReviewerActiveOnAnyRTs(reviewerId: number): Observable<ApplicationResultOfBoolean>;
    /**
     * Mark Reviewer as Blocked
     */
    markReviewerAsBlocked(request: MarkReviewerAsBlockedCommand): Observable<ApplicationResult>;
    /**
     * Reset Reviewer Status
     */
    resetReviewerStatus(request: ResetReviewerStatusCommand): Observable<ApplicationResult>;
    updatePlatformUserName(reviewerId: number, request: UpdateReviewerPlatformUserNameCommand): Observable<ApplicationResult>;
    updateClientEmployeeId(request: UpdateClientEmployeeIdCommand): Observable<ApplicationResult>;
    inviteCompanyReviewers(request: InviteCompanyStaffReviewersCommand): Observable<ApplicationResultOfInviteCompanyStaffReviewersResultDto>;
    revokeCompanyReviewerInvitation(inviteId: number): Observable<ApplicationResult>;
    /**
     * Get Reviewer Relativity Overall Statistic
     */
    getOverallMetrics(companyId: number, reviewerId: number): Observable<ApplicationResultOfRelativityOverallMetric>;
    /**
     * Get Reviewer Relativity Statistic
     * @param fields (optional) 
     */
    getMetrics(companyId: number, reviewerId: number, fields?: number[] | undefined): Observable<ApplicationResultOfListOfCaseOverallMetricsDto>;
    /**
     * Get Reviewer Relativity Statistic Time Series
     * @param fields (optional) 
     * @param interval (optional) 
     */
    getMetricsTimeSeries(companyId: number, reviewerId: number, fields?: number[] | undefined, interval?: CaseMetricsInterval | undefined): Observable<ApplicationResultOfListOfCaseTimeSeriesMetricsDto>;
    /**
     * Get Reviewer Relativity Fields
     */
    getMetricFields(companyId: number, reviewerId: number): Observable<ApplicationResultOfListOfBaseRelativityFieldDto>;
    /**
     * Get Reviewer Relativity Fields Statistic
     * @param caseId (optional) 
     */
    getMetricsFieldStatistics(companyId: number, reviewerId: number, caseId?: number | null | undefined): Observable<ApplicationResultOfListOfRelativityFieldStatisticDto>;
    /**
     * Get Reviewer
     */
    getReviewer(reviewerId: number): Observable<ApplicationResultOfReviewerProfileDto>;
    /**
     * Get Reviewer Details
     */
    getReviewerDetails(reviewerId: number): Observable<ApplicationResultOfReviewerDetailsDto>;
    /**
     * Get Reviewer Requirements
     */
    getReviewerRequirements(reviewerId: number): Observable<ApplicationResultOfReviewerRequirementsDto>;
    /**
     * Add Reviewer Requirements
     */
    addReviewerRequirements(reviewerId: number, command: CreateReviewerRequirementCommand): Observable<ApplicationResultOfProfileSaveResultDto>;
    /**
     * Get technology proficiency
     */
    getReviewerBasicInfo(reviewerId: number): Observable<ApplicationResultOfReviewerBasicInfoResponse>;
    /**
     * Create Reviewer Basic Info
     */
    createReviewerBasicInfo(reviewerId: number, command: ReviewerBasicInfoCommand): Observable<ApplicationResultOfProfileSaveResultDto>;
    /**
     * Add General Experience
     */
    addGeneralExperience(reviewerId: number, command: CreateGeneralExperienceCommand): Observable<ApplicationResultOfProfileSaveResultDto>;
    /**
     * Get Reviewer Schedule
     */
    getReviewerSchedule(reviewerId: number): Observable<ApplicationResultOfReviewerScheduleResponseDto>;
    /**
     * Save Reviewer Schedule
     */
    saveReviewerSchedule(reviewerId: number, command: SaveReviewerScheduleCommand): Observable<ApplicationResultOfReviewerScheduleResponseDto>;
    /**
     * Validate Reviewer Profile
     */
    validateReviewerProfile(reviewerId: number): Observable<ApplicationResultOfReviewerProfileValidationResult>;
    /**
     * Delete Reviewer Bar Membership
     */
    deleteBarMembershipForReviewer(reviewerId: number, command: DeleteReviewerBarMembershipCommand): Observable<ApplicationResult>;
    /**
     * Get All Reviewer Spans
     * @param companyId (optional) 
     */
    getAllReviewerSpans(reviewerId: number, companyId?: number | undefined): Observable<ApplicationResultOfListOfReviewerReviewerTypeSpanListDto>;
    /**
     * Search Reviewers
     */
    searchReviewers(query: SearchReviewersDirectoryQuery): Observable<ApplicationResultOfReviewerDirectorySearchResultDto>;
    /**
     * Get Reviewer Resume
     */
    getReviewerResume(reviewerId: number): Observable<ApplicationResultOfReviewerResumeDto>;
    /**
     * Get All Reviewer Inactive Reviewer Types
     */
    getAllReviewerInactiveReviewerTypes(reviewerId: number): Observable<ApplicationResultOfListOfReviewerInactiveReviewerTypeListDto>;
    /**
     * Invite Reviewers by Email Without Case
     */
    companyInviteReviewersByEmail(command: CompanyInviteReviewersByEmailCommand): Observable<ApplicationResultOfCompanyInviteReviewersByEmailResultDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CompanyReviewerManagementClient extends ApiClientBase implements ICompanyReviewerManagementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Reviewers for Company
     */
    getReviewersForCompany(): Observable<ApplicationResultOfListOfReviewerForCompanyDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewersForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewersForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerForCompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerForCompanyDto>;
        }));
    }

    protected processGetReviewersForCompany(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerForCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerForCompanyDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateReviewerCompany(request: UpdateCompanyReviewerCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewerCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewerCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateReviewerCompany(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewers for Company
     */
    getInternalInvitesForCompany(): Observable<ApplicationResultOfListOfReviewerCompanyInviteDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/internal-invites";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalInvitesForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalInvitesForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerCompanyInviteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerCompanyInviteDto>;
        }));
    }

    protected processGetInternalInvitesForCompany(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerCompanyInviteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerCompanyInviteDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer for Company
     */
    getReviewerForCompany(reviewerId: number): Observable<ApplicationResultOfCompanyReviewerDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/{reviewerId}";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCompanyReviewerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCompanyReviewerDto>;
        }));
    }

    protected processGetReviewerForCompany(response: HttpResponseBase): Observable<ApplicationResultOfCompanyReviewerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCompanyReviewerDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Mark Reviewer as Favorite
     */
    markReviewerAsFavorite(request: MarkReviewerAsFavoriteCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/mark-as-favorite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkReviewerAsFavorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkReviewerAsFavorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processMarkReviewerAsFavorite(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check if Reviewer is Active on Any RTs
     */
    isReviewerActiveOnAnyRTs(reviewerId: number): Observable<ApplicationResultOfBoolean> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/{reviewerId}/is-active";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsReviewerActiveOnAnyRTs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsReviewerActiveOnAnyRTs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfBoolean>;
        }));
    }

    protected processIsReviewerActiveOnAnyRTs(response: HttpResponseBase): Observable<ApplicationResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfBoolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Mark Reviewer as Blocked
     */
    markReviewerAsBlocked(request: MarkReviewerAsBlockedCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/mark-as-blocked";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkReviewerAsBlocked(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkReviewerAsBlocked(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processMarkReviewerAsBlocked(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reset Reviewer Status
     */
    resetReviewerStatus(request: ResetReviewerStatusCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/reset-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetReviewerStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetReviewerStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processResetReviewerStatus(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePlatformUserName(reviewerId: number, request: UpdateReviewerPlatformUserNameCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/{reviewerId}/username";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePlatformUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePlatformUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdatePlatformUserName(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateClientEmployeeId(request: UpdateClientEmployeeIdCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/client-employee-id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClientEmployeeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClientEmployeeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateClientEmployeeId(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inviteCompanyReviewers(request: InviteCompanyStaffReviewersCommand): Observable<ApplicationResultOfInviteCompanyStaffReviewersResultDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteCompanyReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteCompanyReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfInviteCompanyStaffReviewersResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfInviteCompanyStaffReviewersResultDto>;
        }));
    }

    protected processInviteCompanyReviewers(response: HttpResponseBase): Observable<ApplicationResultOfInviteCompanyStaffReviewersResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfInviteCompanyStaffReviewersResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    revokeCompanyReviewerInvitation(inviteId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/invite/{inviteId}/revoke";
        if (inviteId === undefined || inviteId === null)
            throw new globalThis.Error("The parameter 'inviteId' must be defined.");
        url_ = url_.replace("{inviteId}", encodeURIComponent("" + inviteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokeCompanyReviewerInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeCompanyReviewerInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processRevokeCompanyReviewerInvitation(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Relativity Overall Statistic
     */
    getOverallMetrics(companyId: number, reviewerId: number): Observable<ApplicationResultOfRelativityOverallMetric> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/{companyId}/{reviewerId}/metrics/overall";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverallMetrics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverallMetrics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfRelativityOverallMetric>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfRelativityOverallMetric>;
        }));
    }

    protected processGetOverallMetrics(response: HttpResponseBase): Observable<ApplicationResultOfRelativityOverallMetric> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfRelativityOverallMetric;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Relativity Statistic
     * @param fields (optional) 
     */
    getMetrics(companyId: number, reviewerId: number, fields?: number[] | undefined): Observable<ApplicationResultOfListOfCaseOverallMetricsDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/{companyId}/{reviewerId}/metrics?";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        if (fields === null)
            throw new globalThis.Error("The parameter 'fields' cannot be null.");
        else if (fields !== undefined)
            fields && fields.forEach(item => { url_ += "fields=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMetrics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetrics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCaseOverallMetricsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCaseOverallMetricsDto>;
        }));
    }

    protected processGetMetrics(response: HttpResponseBase): Observable<ApplicationResultOfListOfCaseOverallMetricsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCaseOverallMetricsDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Relativity Statistic Time Series
     * @param fields (optional) 
     * @param interval (optional) 
     */
    getMetricsTimeSeries(companyId: number, reviewerId: number, fields?: number[] | undefined, interval?: CaseMetricsInterval | undefined): Observable<ApplicationResultOfListOfCaseTimeSeriesMetricsDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/{companyId}/{reviewerId}/metrics/time-series?";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        if (fields === null)
            throw new globalThis.Error("The parameter 'fields' cannot be null.");
        else if (fields !== undefined)
            fields && fields.forEach(item => { url_ += "fields=" + encodeURIComponent("" + item) + "&"; });
        if (interval === null)
            throw new globalThis.Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMetricsTimeSeries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetricsTimeSeries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCaseTimeSeriesMetricsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCaseTimeSeriesMetricsDto>;
        }));
    }

    protected processGetMetricsTimeSeries(response: HttpResponseBase): Observable<ApplicationResultOfListOfCaseTimeSeriesMetricsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCaseTimeSeriesMetricsDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Relativity Fields
     */
    getMetricFields(companyId: number, reviewerId: number): Observable<ApplicationResultOfListOfBaseRelativityFieldDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/{companyId}/{reviewerId}/fields";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMetricFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetricFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfBaseRelativityFieldDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfBaseRelativityFieldDto>;
        }));
    }

    protected processGetMetricFields(response: HttpResponseBase): Observable<ApplicationResultOfListOfBaseRelativityFieldDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfBaseRelativityFieldDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Relativity Fields Statistic
     * @param caseId (optional) 
     */
    getMetricsFieldStatistics(companyId: number, reviewerId: number, caseId?: number | null | undefined): Observable<ApplicationResultOfListOfRelativityFieldStatisticDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/{companyId}/{reviewerId}/metrics/fields?";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMetricsFieldStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetricsFieldStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRelativityFieldStatisticDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRelativityFieldStatisticDto>;
        }));
    }

    protected processGetMetricsFieldStatistics(response: HttpResponseBase): Observable<ApplicationResultOfListOfRelativityFieldStatisticDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRelativityFieldStatisticDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer
     */
    getReviewer(reviewerId: number): Observable<ApplicationResultOfReviewerProfileDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/reviewer/{reviewerId}";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerProfileDto>;
        }));
    }

    protected processGetReviewer(response: HttpResponseBase): Observable<ApplicationResultOfReviewerProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerProfileDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Details
     */
    getReviewerDetails(reviewerId: number): Observable<ApplicationResultOfReviewerDetailsDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/reviewer/{reviewerId}/details";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerDetailsDto>;
        }));
    }

    protected processGetReviewerDetails(response: HttpResponseBase): Observable<ApplicationResultOfReviewerDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Requirements
     */
    getReviewerRequirements(reviewerId: number): Observable<ApplicationResultOfReviewerRequirementsDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/reviewer/{reviewerId}/requirements";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerRequirements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerRequirements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerRequirementsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerRequirementsDto>;
        }));
    }

    protected processGetReviewerRequirements(response: HttpResponseBase): Observable<ApplicationResultOfReviewerRequirementsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerRequirementsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add Reviewer Requirements
     */
    addReviewerRequirements(reviewerId: number, command: CreateReviewerRequirementCommand): Observable<ApplicationResultOfProfileSaveResultDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/reviewer/{reviewerId}/requirements";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddReviewerRequirements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddReviewerRequirements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfProfileSaveResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfProfileSaveResultDto>;
        }));
    }

    protected processAddReviewerRequirements(response: HttpResponseBase): Observable<ApplicationResultOfProfileSaveResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfProfileSaveResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get technology proficiency
     */
    getReviewerBasicInfo(reviewerId: number): Observable<ApplicationResultOfReviewerBasicInfoResponse> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/reviewer/{reviewerId}/basic-info";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerBasicInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerBasicInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerBasicInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerBasicInfoResponse>;
        }));
    }

    protected processGetReviewerBasicInfo(response: HttpResponseBase): Observable<ApplicationResultOfReviewerBasicInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerBasicInfoResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Reviewer Basic Info
     */
    createReviewerBasicInfo(reviewerId: number, command: ReviewerBasicInfoCommand): Observable<ApplicationResultOfProfileSaveResultDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/reviewer/{reviewerId}/basic-info";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReviewerBasicInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReviewerBasicInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfProfileSaveResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfProfileSaveResultDto>;
        }));
    }

    protected processCreateReviewerBasicInfo(response: HttpResponseBase): Observable<ApplicationResultOfProfileSaveResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfProfileSaveResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add General Experience
     */
    addGeneralExperience(reviewerId: number, command: CreateGeneralExperienceCommand): Observable<ApplicationResultOfProfileSaveResultDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/reviewer/{reviewerId}/general-experience";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddGeneralExperience(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddGeneralExperience(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfProfileSaveResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfProfileSaveResultDto>;
        }));
    }

    protected processAddGeneralExperience(response: HttpResponseBase): Observable<ApplicationResultOfProfileSaveResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfProfileSaveResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Schedule
     */
    getReviewerSchedule(reviewerId: number): Observable<ApplicationResultOfReviewerScheduleResponseDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/reviewer/{reviewerId}/schedule";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerScheduleResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerScheduleResponseDto>;
        }));
    }

    protected processGetReviewerSchedule(response: HttpResponseBase): Observable<ApplicationResultOfReviewerScheduleResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerScheduleResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save Reviewer Schedule
     */
    saveReviewerSchedule(reviewerId: number, command: SaveReviewerScheduleCommand): Observable<ApplicationResultOfReviewerScheduleResponseDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/reviewer/{reviewerId}/schedule";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveReviewerSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveReviewerSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerScheduleResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerScheduleResponseDto>;
        }));
    }

    protected processSaveReviewerSchedule(response: HttpResponseBase): Observable<ApplicationResultOfReviewerScheduleResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerScheduleResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validate Reviewer Profile
     */
    validateReviewerProfile(reviewerId: number): Observable<ApplicationResultOfReviewerProfileValidationResult> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/reviewer/{reviewerId}/validate";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateReviewerProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateReviewerProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerProfileValidationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerProfileValidationResult>;
        }));
    }

    protected processValidateReviewerProfile(response: HttpResponseBase): Observable<ApplicationResultOfReviewerProfileValidationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerProfileValidationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Reviewer Bar Membership
     */
    deleteBarMembershipForReviewer(reviewerId: number, command: DeleteReviewerBarMembershipCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/reviewer/{reviewerId}/bar-membership";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBarMembershipForReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBarMembershipForReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteBarMembershipForReviewer(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Reviewer Spans
     * @param companyId (optional) 
     */
    getAllReviewerSpans(reviewerId: number, companyId?: number | undefined): Observable<ApplicationResultOfListOfReviewerReviewerTypeSpanListDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/{reviewerId}/spans?";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReviewerSpans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReviewerSpans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerReviewerTypeSpanListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerReviewerTypeSpanListDto>;
        }));
    }

    protected processGetAllReviewerSpans(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerReviewerTypeSpanListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerReviewerTypeSpanListDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search Reviewers
     */
    searchReviewers(query: SearchReviewersDirectoryQuery): Observable<ApplicationResultOfReviewerDirectorySearchResultDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerDirectorySearchResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerDirectorySearchResultDto>;
        }));
    }

    protected processSearchReviewers(response: HttpResponseBase): Observable<ApplicationResultOfReviewerDirectorySearchResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerDirectorySearchResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Resume
     */
    getReviewerResume(reviewerId: number): Observable<ApplicationResultOfReviewerResumeDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/reviewer/{reviewerId}/resume";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerResume(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerResume(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerResumeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerResumeDto>;
        }));
    }

    protected processGetReviewerResume(response: HttpResponseBase): Observable<ApplicationResultOfReviewerResumeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerResumeDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Reviewer Inactive Reviewer Types
     */
    getAllReviewerInactiveReviewerTypes(reviewerId: number): Observable<ApplicationResultOfListOfReviewerInactiveReviewerTypeListDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/{reviewerId}/reviewerTypes/inactive";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReviewerInactiveReviewerTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReviewerInactiveReviewerTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerInactiveReviewerTypeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerInactiveReviewerTypeListDto>;
        }));
    }

    protected processGetAllReviewerInactiveReviewerTypes(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerInactiveReviewerTypeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerInactiveReviewerTypeListDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Invite Reviewers by Email Without Case
     */
    companyInviteReviewersByEmail(command: CompanyInviteReviewersByEmailCommand): Observable<ApplicationResultOfCompanyInviteReviewersByEmailResultDto> {
        let url_ = this.baseUrl + "/api/companyReviewerManagement/company-invite-reviewers-by-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyInviteReviewersByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyInviteReviewersByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCompanyInviteReviewersByEmailResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCompanyInviteReviewersByEmailResultDto>;
        }));
    }

    protected processCompanyInviteReviewersByEmail(response: HttpResponseBase): Observable<ApplicationResultOfCompanyInviteReviewersByEmailResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCompanyInviteReviewersByEmailResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyReviewerNotesClient {
    getForReviewer(companyId: number, reviewerId: number): Observable<ApplicationResultOfListOfCompanyReviewerNoteDto>;
    create(request: CreateCompanyReviewerNotesCommand): Observable<ApplicationResultOfCompanyReviewerNoteDto>;
    update(id: number, request: UpdateCompanyReviewerNotesCommand): Observable<ApplicationResultOfCompanyReviewerNoteDto>;
    delete(id: number): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class CompanyReviewerNotesClient extends ApiClientBase implements ICompanyReviewerNotesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getForReviewer(companyId: number, reviewerId: number): Observable<ApplicationResultOfListOfCompanyReviewerNoteDto> {
        let url_ = this.baseUrl + "/api/companyReviewerNotes/forReviewer/{companyId}/{reviewerId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCompanyReviewerNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCompanyReviewerNoteDto>;
        }));
    }

    protected processGetForReviewer(response: HttpResponseBase): Observable<ApplicationResultOfListOfCompanyReviewerNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCompanyReviewerNoteDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(request: CreateCompanyReviewerNotesCommand): Observable<ApplicationResultOfCompanyReviewerNoteDto> {
        let url_ = this.baseUrl + "/api/companyReviewerNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCompanyReviewerNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCompanyReviewerNoteDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApplicationResultOfCompanyReviewerNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCompanyReviewerNoteDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: number, request: UpdateCompanyReviewerNotesCommand): Observable<ApplicationResultOfCompanyReviewerNoteDto> {
        let url_ = this.baseUrl + "/api/companyReviewerNotes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCompanyReviewerNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCompanyReviewerNoteDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApplicationResultOfCompanyReviewerNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCompanyReviewerNoteDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/companyReviewerNotes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyReviewerSummaryClient {
    /**
     * Get Reviewer Summaries for Case
     * @param caseId (optional) 
     * @param reviewerId (optional) 
     * @param reviewerTypeId (optional) 
     */
    getReviewerSummaries(caseId?: number | null | undefined, reviewerId?: number | null | undefined, reviewerTypeId?: number | null | undefined): Observable<ApplicationResultOfListOfCompanyReviewerSummaryDto>;
    /**
     * Get Reviewer Summary Notification Schedule
     * @param reviewerTypeId (optional) 
     */
    getReviewerSummaryNotificationSchedule(reviewerTypeId?: number | undefined): Observable<ApplicationResultOfListOfReviewerSummaryNotificationScheduleDto>;
    /**
     * Update Reviewer Summary Notification Schedule
     */
    updateReviewerSummaryNotificationSchedule(command: UpdateReviewerSummaryNotificationScheduleCommand): Observable<ApplicationResult>;
    /**
     * Pause Reviewer Summary Notification Schedule
     */
    pauseReviewerSummaryNotificationSchedule(command: SetIsPausedReviewerSummaryScheduleCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class CompanyReviewerSummaryClient extends ApiClientBase implements ICompanyReviewerSummaryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Reviewer Summaries for Case
     * @param caseId (optional) 
     * @param reviewerId (optional) 
     * @param reviewerTypeId (optional) 
     */
    getReviewerSummaries(caseId?: number | null | undefined, reviewerId?: number | null | undefined, reviewerTypeId?: number | null | undefined): Observable<ApplicationResultOfListOfCompanyReviewerSummaryDto> {
        let url_ = this.baseUrl + "/api/companyReviewerSummary?";
        if (caseId !== undefined && caseId !== null)
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (reviewerId !== undefined && reviewerId !== null)
            url_ += "ReviewerId=" + encodeURIComponent("" + reviewerId) + "&";
        if (reviewerTypeId !== undefined && reviewerTypeId !== null)
            url_ += "ReviewerTypeId=" + encodeURIComponent("" + reviewerTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerSummaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerSummaries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCompanyReviewerSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCompanyReviewerSummaryDto>;
        }));
    }

    protected processGetReviewerSummaries(response: HttpResponseBase): Observable<ApplicationResultOfListOfCompanyReviewerSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCompanyReviewerSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Summary Notification Schedule
     * @param reviewerTypeId (optional) 
     */
    getReviewerSummaryNotificationSchedule(reviewerTypeId?: number | undefined): Observable<ApplicationResultOfListOfReviewerSummaryNotificationScheduleDto> {
        let url_ = this.baseUrl + "/api/companyReviewerSummary/schedule?";
        if (reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' cannot be null.");
        else if (reviewerTypeId !== undefined)
            url_ += "ReviewerTypeId=" + encodeURIComponent("" + reviewerTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerSummaryNotificationSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerSummaryNotificationSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerSummaryNotificationScheduleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerSummaryNotificationScheduleDto>;
        }));
    }

    protected processGetReviewerSummaryNotificationSchedule(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerSummaryNotificationScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerSummaryNotificationScheduleDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Reviewer Summary Notification Schedule
     */
    updateReviewerSummaryNotificationSchedule(command: UpdateReviewerSummaryNotificationScheduleCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/companyReviewerSummary/schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewerSummaryNotificationSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewerSummaryNotificationSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateReviewerSummaryNotificationSchedule(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Pause Reviewer Summary Notification Schedule
     */
    pauseReviewerSummaryNotificationSchedule(command: SetIsPausedReviewerSummaryScheduleCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/companyReviewerSummary/schedule/pause";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPauseReviewerSummaryNotificationSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPauseReviewerSummaryNotificationSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processPauseReviewerSummaryNotificationSchedule(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IContactUsClient {
    /**
     * Contact Us
     */
    sendContactUs(command: ContactUsCommand): Observable<ApplicationResultOfAccountResultDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ContactUsClient extends ApiClientBase implements IContactUsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Contact Us
     */
    sendContactUs(command: ContactUsCommand): Observable<ApplicationResultOfAccountResultDto> {
        let url_ = this.baseUrl + "/api/contactUs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendContactUs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendContactUs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAccountResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAccountResultDto>;
        }));
    }

    protected processSendContactUs(response: HttpResponseBase): Observable<ApplicationResultOfAccountResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAccountResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDateDimensionClient {
    /**
     * Get DateDimension
     */
    getDates(): Observable<ApplicationResultOfListOfDateDimensionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class DateDimensionClient extends ApiClientBase implements IDateDimensionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get DateDimension
     */
    getDates(): Observable<ApplicationResultOfListOfDateDimensionDto> {
        let url_ = this.baseUrl + "/api/dateDimension";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfDateDimensionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfDateDimensionDto>;
        }));
    }

    protected processGetDates(response: HttpResponseBase): Observable<ApplicationResultOfListOfDateDimensionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfDateDimensionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDocusignClient {
    /**
     * Generate Signing Links for Reviewer
     */
    generateSigningLinksForReviewer(command: GenerateReviewerTypeLinksCommand): Observable<ApplicationResultOfListOfString>;
    /**
     * Webhook for DocuSign envelope status update
     */
    webhook(command: UpdateDocuSignDocumentStatusCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class DocusignClient extends ApiClientBase implements IDocusignClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Generate Signing Links for Reviewer
     */
    generateSigningLinksForReviewer(command: GenerateReviewerTypeLinksCommand): Observable<ApplicationResultOfListOfString> {
        let url_ = this.baseUrl + "/api/docusign/links";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateSigningLinksForReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateSigningLinksForReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfString>;
        }));
    }

    protected processGenerateSigningLinksForReviewer(response: HttpResponseBase): Observable<ApplicationResultOfListOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Webhook for DocuSign envelope status update
     */
    webhook(command: UpdateDocuSignDocumentStatusCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/docusign/webhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processWebhook(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmailTemplateClient {
    /**
     * Get Template
     * @param templateType (optional) 
     */
    getTemplate(data: any, templateType?: string | undefined): Observable<ApplicationResultOfITemplate>;
}

@Injectable({
    providedIn: 'root'
})
export class EmailTemplateClient extends ApiClientBase implements IEmailTemplateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Template
     * @param templateType (optional) 
     */
    getTemplate(data: any, templateType?: string | undefined): Observable<ApplicationResultOfITemplate> {
        let url_ = this.baseUrl + "/api/emailTemplate?";
        if (templateType === null)
            throw new globalThis.Error("The parameter 'templateType' cannot be null.");
        else if (templateType !== undefined)
            url_ += "templateType=" + encodeURIComponent("" + templateType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfITemplate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfITemplate>;
        }));
    }

    protected processGetTemplate(response: HttpResponseBase): Observable<ApplicationResultOfITemplate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfITemplate;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFaqClient {
    /**
     * Get FAQs
     */
    getFaqs(faqType: FAQType): Observable<ApplicationResultOfListOfFaqDto>;
    /**
     * Create FAQ
     */
    createFaq(command: CreateFaqCommand): Observable<ApplicationResultOfFaqDto>;
    /**
     * Update FAQ
     */
    updateFaq(command: UpdateFaqCommand): Observable<ApplicationResultOfFaqDto>;
    /**
     * Delete FAQ
     */
    deleteFaq(id: number): Observable<ApplicationResult>;
    /**
     * Reorder FAQs
     */
    reorderFaqs(command: ReorderFaqsCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class FaqClient extends ApiClientBase implements IFaqClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get FAQs
     */
    getFaqs(faqType: FAQType): Observable<ApplicationResultOfListOfFaqDto> {
        let url_ = this.baseUrl + "/api/faq/get-faqs/{faqType}";
        if (faqType === undefined || faqType === null)
            throw new globalThis.Error("The parameter 'faqType' must be defined.");
        url_ = url_.replace("{faqType}", encodeURIComponent("" + faqType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaqs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaqs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfFaqDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfFaqDto>;
        }));
    }

    protected processGetFaqs(response: HttpResponseBase): Observable<ApplicationResultOfListOfFaqDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfFaqDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create FAQ
     */
    createFaq(command: CreateFaqCommand): Observable<ApplicationResultOfFaqDto> {
        let url_ = this.baseUrl + "/api/faq/admin/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFaq(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFaq(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfFaqDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfFaqDto>;
        }));
    }

    protected processCreateFaq(response: HttpResponseBase): Observable<ApplicationResultOfFaqDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfFaqDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update FAQ
     */
    updateFaq(command: UpdateFaqCommand): Observable<ApplicationResultOfFaqDto> {
        let url_ = this.baseUrl + "/api/faq/admin/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFaq(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFaq(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfFaqDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfFaqDto>;
        }));
    }

    protected processUpdateFaq(response: HttpResponseBase): Observable<ApplicationResultOfFaqDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfFaqDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete FAQ
     */
    deleteFaq(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/faq/admin/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFaq(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFaq(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteFaq(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reorder FAQs
     */
    reorderFaqs(command: ReorderFaqsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/faq/admin/reorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorderFaqs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorderFaqs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processReorderFaqs(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFlatFileClient {
    /**
     * Auth FlatFile
     */
    auth(portal: string): Observable<FlatFileAuthResult>;
    /**
     * Import FlatFile Data
     */
    import(portal: string, model: FlatFileImportModel): Observable<FlatFileImportResult>;
}

@Injectable({
    providedIn: 'root'
})
export class FlatFileClient extends ApiClientBase implements IFlatFileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Auth FlatFile
     */
    auth(portal: string): Observable<FlatFileAuthResult> {
        let url_ = this.baseUrl + "/api/flatFile/auth/{portal}";
        if (portal === undefined || portal === null)
            throw new globalThis.Error("The parameter 'portal' must be defined.");
        url_ = url_.replace("{portal}", encodeURIComponent("" + portal));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlatFileAuthResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlatFileAuthResult>;
        }));
    }

    protected processAuth(response: HttpResponseBase): Observable<FlatFileAuthResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlatFileAuthResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Import FlatFile Data
     */
    import(portal: string, model: FlatFileImportModel): Observable<FlatFileImportResult> {
        let url_ = this.baseUrl + "/api/flatFile/import/{portal}";
        if (portal === undefined || portal === null)
            throw new globalThis.Error("The parameter 'portal' must be defined.");
        url_ = url_.replace("{portal}", encodeURIComponent("" + portal));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlatFileImportResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlatFileImportResult>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<FlatFileImportResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlatFileImportResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IHolidaysClient {
    /**
     * Get Holidays
     */
    getHolidays(): Observable<ApplicationResultOfListOfHolidayDto>;
}

@Injectable({
    providedIn: 'root'
})
export class HolidaysClient extends ApiClientBase implements IHolidaysClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Holidays
     */
    getHolidays(): Observable<ApplicationResultOfListOfHolidayDto> {
        let url_ = this.baseUrl + "/api/holidays";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHolidays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfHolidayDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfHolidayDto>;
        }));
    }

    protected processGetHolidays(response: HttpResponseBase): Observable<ApplicationResultOfListOfHolidayDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfHolidayDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IInviteUserClient {
    /**
     * Invite Company User
     */
    inviteCompanyUsers(command: InviteCompanyUserCommand): Observable<ApplicationResultOfInviteCompanyUserResult>;
    /**
     * Revoke Company User Invite
     */
    revokeCompanyUserInvite(command: RevokeCompanyUserInvite): Observable<ApplicationResult>;
    /**
     * Accept Company Invite
     */
    acceptCompanyInvite(command: AcceptCompanyInviteCommand): Observable<ApplicationResultOfAcceptCompanyInviteResponse>;
    /**
     * Invite Referral User
     */
    inviteReferral(command: SendReferralInviteCommand): Observable<ApplicationResult>;
    /**
     * Accept Referral Invite
     */
    acceptReferralInvite(command: AcceptReferralInviteCommand): Observable<ApplicationResult>;
    /**
     * Get company roles
     */
    getCompanyRoles(): Observable<ApplicationResultOfListOfCompanyRolesDto>;
}

@Injectable({
    providedIn: 'root'
})
export class InviteUserClient extends ApiClientBase implements IInviteUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Invite Company User
     */
    inviteCompanyUsers(command: InviteCompanyUserCommand): Observable<ApplicationResultOfInviteCompanyUserResult> {
        let url_ = this.baseUrl + "/api/inviteUser/company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteCompanyUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteCompanyUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfInviteCompanyUserResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfInviteCompanyUserResult>;
        }));
    }

    protected processInviteCompanyUsers(response: HttpResponseBase): Observable<ApplicationResultOfInviteCompanyUserResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfInviteCompanyUserResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Revoke Company User Invite
     */
    revokeCompanyUserInvite(command: RevokeCompanyUserInvite): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/inviteUser/company/revoke";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokeCompanyUserInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeCompanyUserInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processRevokeCompanyUserInvite(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Accept Company Invite
     */
    acceptCompanyInvite(command: AcceptCompanyInviteCommand): Observable<ApplicationResultOfAcceptCompanyInviteResponse> {
        let url_ = this.baseUrl + "/api/inviteUser/company/accept";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptCompanyInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptCompanyInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAcceptCompanyInviteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAcceptCompanyInviteResponse>;
        }));
    }

    protected processAcceptCompanyInvite(response: HttpResponseBase): Observable<ApplicationResultOfAcceptCompanyInviteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAcceptCompanyInviteResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Invite Referral User
     */
    inviteReferral(command: SendReferralInviteCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/inviteUser/referral";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteReferral(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteReferral(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processInviteReferral(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Accept Referral Invite
     */
    acceptReferralInvite(command: AcceptReferralInviteCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/inviteUser/referral/accept";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptReferralInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptReferralInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processAcceptReferralInvite(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get company roles
     */
    getCompanyRoles(): Observable<ApplicationResultOfListOfCompanyRolesDto> {
        let url_ = this.baseUrl + "/api/inviteUser/get-company-roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCompanyRolesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCompanyRolesDto>;
        }));
    }

    protected processGetCompanyRoles(response: HttpResponseBase): Observable<ApplicationResultOfListOfCompanyRolesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCompanyRolesDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IInvoiceClient {
    /**
     * Generate Invoices
     */
    generateInvoices(command: GenerateInvoicesCommand): Observable<ApplicationResultOfGenerateInvoiceResult>;
    /**
     * Get Invoice History
     */
    getInvoices(): Observable<ApplicationResultOfListOfInvoiceDto>;
    /**
     * Get Invoice Details
     */
    get(id: number): Observable<ApplicationResultOfGenerateInvoiceResult>;
    /**
     * Delete Invoice
     */
    delete(id: number): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class InvoiceClient extends ApiClientBase implements IInvoiceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Generate Invoices
     */
    generateInvoices(command: GenerateInvoicesCommand): Observable<ApplicationResultOfGenerateInvoiceResult> {
        let url_ = this.baseUrl + "/api/invoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfGenerateInvoiceResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfGenerateInvoiceResult>;
        }));
    }

    protected processGenerateInvoices(response: HttpResponseBase): Observable<ApplicationResultOfGenerateInvoiceResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfGenerateInvoiceResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Invoice History
     */
    getInvoices(): Observable<ApplicationResultOfListOfInvoiceDto> {
        let url_ = this.baseUrl + "/api/invoice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfInvoiceDto>;
        }));
    }

    protected processGetInvoices(response: HttpResponseBase): Observable<ApplicationResultOfListOfInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfInvoiceDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Invoice Details
     */
    get(id: number): Observable<ApplicationResultOfGenerateInvoiceResult> {
        let url_ = this.baseUrl + "/api/invoice/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfGenerateInvoiceResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfGenerateInvoiceResult>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApplicationResultOfGenerateInvoiceResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfGenerateInvoiceResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Invoice
     */
    delete(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/invoice/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ILanguageClient {
    /**
     * Get All Language
     */
    getAll(): Observable<LocalizedString[]>;
    /**
     * Get All
     * @param search (optional) 
     */
    getAll2(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfLanguageAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class LanguageClient extends ApiClientBase implements ILanguageClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All Language
     */
    getAll(): Observable<LocalizedString[]> {
        let url_ = this.baseUrl + "/api/language";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocalizedString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocalizedString[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LocalizedString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocalizedString[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll2(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/language?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll2(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfLanguageAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/language";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/language/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ILocationClient {
    /**
     * Get Countries
     */
    getCountries(): Observable<ApplicationResultOfListOfCountryDto>;
    /**
     * Get States
     * @param countryId (optional) 
     */
    getStates(countryId?: number | undefined): Observable<ApplicationResultOfListOfStateDto>;
    /**
     * Get Cities
     * @param stateId (optional) 
     */
    getCities(stateId?: number | undefined): Observable<ApplicationResultOfListOfLocationDto>;
}

@Injectable({
    providedIn: 'root'
})
export class LocationClient extends ApiClientBase implements ILocationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Countries
     */
    getCountries(): Observable<ApplicationResultOfListOfCountryDto> {
        let url_ = this.baseUrl + "/api/location/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCountryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCountryDto>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<ApplicationResultOfListOfCountryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCountryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get States
     * @param countryId (optional) 
     */
    getStates(countryId?: number | undefined): Observable<ApplicationResultOfListOfStateDto> {
        let url_ = this.baseUrl + "/api/location/states?";
        if (countryId === null)
            throw new globalThis.Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfStateDto>;
        }));
    }

    protected processGetStates(response: HttpResponseBase): Observable<ApplicationResultOfListOfStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfStateDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Cities
     * @param stateId (optional) 
     */
    getCities(stateId?: number | undefined): Observable<ApplicationResultOfListOfLocationDto> {
        let url_ = this.baseUrl + "/api/location/cities?";
        if (stateId === null)
            throw new globalThis.Error("The parameter 'stateId' cannot be null.");
        else if (stateId !== undefined)
            url_ += "StateId=" + encodeURIComponent("" + stateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfLocationDto>;
        }));
    }

    protected processGetCities(response: HttpResponseBase): Observable<ApplicationResultOfListOfLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfLocationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMatchingClient {
    matchReviewerAndProject(reviewerTypeId: number, reviewerId: number, mode?: MatchingMode | null | undefined): Observable<MatchResult>;
    getMatchingReviewer(reviewerTypeId: number, mode?: MatchingMode | null | undefined, excludedRequirements?: string[] | null | undefined): Observable<ApplicationResultOfListOfReviewerMatchingDto>;
    getMatchingRequirements(): Observable<ApplicationResultOfListOfString>;
    matchProject(reviewerTypeId: number, mode?: MatchingMode | null | undefined): Observable<MatchResult>;
}

@Injectable({
    providedIn: 'root'
})
export class MatchingClient extends ApiClientBase implements IMatchingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    matchReviewerAndProject(reviewerTypeId: number, reviewerId: number, mode?: MatchingMode | null | undefined): Observable<MatchResult> {
        let url_ = this.baseUrl + "/api/matching/{reviewerTypeId}/{reviewerId}?";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        if (mode !== undefined && mode !== null)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatchReviewerAndProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatchReviewerAndProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MatchResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MatchResult>;
        }));
    }

    protected processMatchReviewerAndProject(response: HttpResponseBase): Observable<MatchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MatchResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMatchingReviewer(reviewerTypeId: number, mode?: MatchingMode | null | undefined, excludedRequirements?: string[] | null | undefined): Observable<ApplicationResultOfListOfReviewerMatchingDto> {
        let url_ = this.baseUrl + "/api/matching/matches/{reviewerTypeId}?";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        if (mode !== undefined && mode !== null)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        if (excludedRequirements !== undefined && excludedRequirements !== null)
            excludedRequirements && excludedRequirements.forEach(item => { url_ += "excludedRequirements=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchingReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchingReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerMatchingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerMatchingDto>;
        }));
    }

    protected processGetMatchingReviewer(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerMatchingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerMatchingDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMatchingRequirements(): Observable<ApplicationResultOfListOfString> {
        let url_ = this.baseUrl + "/api/matching/requirements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchingRequirements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchingRequirements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfString>;
        }));
    }

    protected processGetMatchingRequirements(response: HttpResponseBase): Observable<ApplicationResultOfListOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    matchProject(reviewerTypeId: number, mode?: MatchingMode | null | undefined): Observable<MatchResult> {
        let url_ = this.baseUrl + "/api/matching/{reviewerTypeId}?";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        if (mode !== undefined && mode !== null)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatchProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatchProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MatchResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MatchResult>;
        }));
    }

    protected processMatchProject(response: HttpResponseBase): Observable<MatchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MatchResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INotificationClient {
    /**
     * Get User Notifications
     */
    getUserNotification(): Observable<ApplicationResultOfListOfNotificationDto>;
    /**
     * Archive Notification
     */
    archiveNotification(command: ArchiveNotificationCommand): Observable<ApplicationResult>;
    /**
     * Get User Notification Settings
     */
    getUserNotificationSettings(): Observable<ApplicationResultOfListOfNotificationTypeDto>;
    /**
     * Save User Notification Type Settings
     */
    saveUserNotificationSettings(command: SaveUserNotificationSettingsCommand): Observable<ApplicationResult>;
    /**
     * Send Admin Notification
     */
    sendAdminNotification(command: SendAdminNotificationCommand): Observable<ApplicationResultOfInteger>;
    /**
     * Get User Notification Count
     */
    getUserNotificationCount(): Observable<ApplicationResultOfNotificationCountDto>;
    /**
     * Reset User Notification Count
     */
    resetUserNotificationCount(): Observable<ApplicationResultOfNotificationCountDto>;
    /**
     * Get User Notifications Paged
     */
    getUserNotificationsPaged(query: GetUserNotificationsPagedQuery): Observable<ApplicationResultOfPaginatedResultOfNotificationDto>;
    /**
     * Download Notification Attachment
     */
    downloadNotificationAttachment(id: number): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationClient extends ApiClientBase implements INotificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get User Notifications
     */
    getUserNotification(): Observable<ApplicationResultOfListOfNotificationDto> {
        let url_ = this.baseUrl + "/api/notification/get-user-notification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfNotificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfNotificationDto>;
        }));
    }

    protected processGetUserNotification(response: HttpResponseBase): Observable<ApplicationResultOfListOfNotificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfNotificationDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Archive Notification
     */
    archiveNotification(command: ArchiveNotificationCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/notification/archive-notification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processArchiveNotification(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get User Notification Settings
     */
    getUserNotificationSettings(): Observable<ApplicationResultOfListOfNotificationTypeDto> {
        let url_ = this.baseUrl + "/api/notification/get-user-notification-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfNotificationTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfNotificationTypeDto>;
        }));
    }

    protected processGetUserNotificationSettings(response: HttpResponseBase): Observable<ApplicationResultOfListOfNotificationTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfNotificationTypeDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save User Notification Type Settings
     */
    saveUserNotificationSettings(command: SaveUserNotificationSettingsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/notification/save-user-notification-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveUserNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUserNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processSaveUserNotificationSettings(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send Admin Notification
     */
    sendAdminNotification(command: SendAdminNotificationCommand): Observable<ApplicationResultOfInteger> {
        let url_ = this.baseUrl + "/api/notification/send-admin-notification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAdminNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAdminNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfInteger>;
        }));
    }

    protected processSendAdminNotification(response: HttpResponseBase): Observable<ApplicationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfInteger;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get User Notification Count
     */
    getUserNotificationCount(): Observable<ApplicationResultOfNotificationCountDto> {
        let url_ = this.baseUrl + "/api/notification/get-user-notification-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotificationCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotificationCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfNotificationCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfNotificationCountDto>;
        }));
    }

    protected processGetUserNotificationCount(response: HttpResponseBase): Observable<ApplicationResultOfNotificationCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfNotificationCountDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reset User Notification Count
     */
    resetUserNotificationCount(): Observable<ApplicationResultOfNotificationCountDto> {
        let url_ = this.baseUrl + "/api/notification/reset-user-notification-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserNotificationCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserNotificationCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfNotificationCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfNotificationCountDto>;
        }));
    }

    protected processResetUserNotificationCount(response: HttpResponseBase): Observable<ApplicationResultOfNotificationCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfNotificationCountDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get User Notifications Paged
     */
    getUserNotificationsPaged(query: GetUserNotificationsPagedQuery): Observable<ApplicationResultOfPaginatedResultOfNotificationDto> {
        let url_ = this.baseUrl + "/api/notification/get-user-notifications-paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotificationsPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotificationsPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfPaginatedResultOfNotificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfPaginatedResultOfNotificationDto>;
        }));
    }

    protected processGetUserNotificationsPaged(response: HttpResponseBase): Observable<ApplicationResultOfPaginatedResultOfNotificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfPaginatedResultOfNotificationDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download Notification Attachment
     */
    downloadNotificationAttachment(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/notification/attachments/{id}/download";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadNotificationAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadNotificationAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadNotificationAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPayrollsClient {
    /**
     * Get Payroll Dates
     */
    getPayrollDates(): Observable<ApplicationResultOfListOfPayrollDateDto>;
    /**
     * Run Payrolls
     */
    runPayrolls(command: RunPayrollsCommand): Observable<ApplicationResultOfRunPayrollResult>;
    /**
     * Get Payrolls
     */
    getPayrolls(): Observable<ApplicationResultOfListOfPayrollDto>;
}

@Injectable({
    providedIn: 'root'
})
export class PayrollsClient extends ApiClientBase implements IPayrollsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Payroll Dates
     */
    getPayrollDates(): Observable<ApplicationResultOfListOfPayrollDateDto> {
        let url_ = this.baseUrl + "/api/payrolls/dates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayrollDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayrollDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfPayrollDateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfPayrollDateDto>;
        }));
    }

    protected processGetPayrollDates(response: HttpResponseBase): Observable<ApplicationResultOfListOfPayrollDateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfPayrollDateDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Run Payrolls
     */
    runPayrolls(command: RunPayrollsCommand): Observable<ApplicationResultOfRunPayrollResult> {
        let url_ = this.baseUrl + "/api/payrolls/run";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunPayrolls(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunPayrolls(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfRunPayrollResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfRunPayrollResult>;
        }));
    }

    protected processRunPayrolls(response: HttpResponseBase): Observable<ApplicationResultOfRunPayrollResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfRunPayrollResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Payrolls
     */
    getPayrolls(): Observable<ApplicationResultOfListOfPayrollDto> {
        let url_ = this.baseUrl + "/api/payrolls";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayrolls(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayrolls(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfPayrollDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfPayrollDto>;
        }));
    }

    protected processGetPayrolls(response: HttpResponseBase): Observable<ApplicationResultOfListOfPayrollDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfPayrollDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPermissionsClient {
    /**
     * Get All Permissions
     */
    getPermissions(): Observable<ApplicationResultOfPermissionNode>;
    /**
     * Get User Permissions
     */
    getUserPermissions(userId: number): Observable<ApplicationResultOfUserCompanyPermissionsDto>;
    /**
     * Update User Permissions
     */
    updateUserPermissions(command: UpdateUserCompanyPermissionsCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class PermissionsClient extends ApiClientBase implements IPermissionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All Permissions
     */
    getPermissions(): Observable<ApplicationResultOfPermissionNode> {
        let url_ = this.baseUrl + "/api/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfPermissionNode>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfPermissionNode>;
        }));
    }

    protected processGetPermissions(response: HttpResponseBase): Observable<ApplicationResultOfPermissionNode> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfPermissionNode;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get User Permissions
     */
    getUserPermissions(userId: number): Observable<ApplicationResultOfUserCompanyPermissionsDto> {
        let url_ = this.baseUrl + "/api/permissions/user/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfUserCompanyPermissionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfUserCompanyPermissionsDto>;
        }));
    }

    protected processGetUserPermissions(response: HttpResponseBase): Observable<ApplicationResultOfUserCompanyPermissionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfUserCompanyPermissionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update User Permissions
     */
    updateUserPermissions(command: UpdateUserCompanyPermissionsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/permissions/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectClient {
    /**
     * Search Projects
     * @param minimumPayRate (optional) 
     * @param reviewerTypeRoles (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param requiredSpecialties (optional) 
     * @param requiredLanguages (optional) 
     * @param locationStates (optional) 
     * @param locationCountries (optional) 
     * @param residencyStates (optional) 
     * @param residencyCountries (optional) 
     * @param barAdmissionStates (optional) 
     * @param barAdmissionCountries (optional) 
     * @param timeZones (optional) 
     * @param experienceLevel (optional) 
     * @param caseTypes (optional) 
     * @param reviewTechnology (optional) 
     * @param companies (optional) 
     * @param requiresJD (optional) 
     * @param requiresOvertime (optional) 
     * @param requiresWeekend (optional) 
     * @param requiresHolidays (optional) 
     * @param requiresSecurityClearance (optional) 
     * @param allowConcurrent (optional) 
     * @param hasWeeklyHrsLimit (optional) 
     * @param isW2Company (optional) 
     * @param excludeRequirements (optional) 
     */
    search(minimumPayRate?: number | null | undefined, reviewerTypeRoles?: number[] | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, requiredSpecialties?: number[] | undefined, requiredLanguages?: number[] | undefined, locationStates?: string[] | undefined, locationCountries?: string[] | undefined, residencyStates?: string[] | undefined, residencyCountries?: string[] | undefined, barAdmissionStates?: string[] | undefined, barAdmissionCountries?: string[] | undefined, timeZones?: number[] | undefined, experienceLevel?: number | null | undefined, caseTypes?: number[] | undefined, reviewTechnology?: number[] | undefined, companies?: number[] | undefined, requiresJD?: boolean | null | undefined, requiresOvertime?: boolean | null | undefined, requiresWeekend?: RequiredValues | null | undefined, requiresHolidays?: RequiredValues | null | undefined, requiresSecurityClearance?: boolean | null | undefined, allowConcurrent?: boolean | null | undefined, hasWeeklyHrsLimit?: boolean | null | undefined, isW2Company?: boolean | null | undefined, excludeRequirements?: string[] | undefined): Observable<ApplicationResultOfReviewerProjectResponse>;
    /**
     * Update Application
     */
    updateApplication(command: ReviewerUpdateApplicationCommand): Observable<ApplicationResult>;
    /**
     * Unapprove For Project
     */
    unApproveReviewer(command: UnApproveForProjectCommand): Observable<ApplicationResult>;
    /**
     * Unapprove For Project
     */
    unApproveReviewers(command: UnApproveForProjectBulkCommand): Observable<ApplicationResult>;
    /**
     * Reject For Project
     */
    rejectReviewer(command: RejectForProjectCommand): Observable<ApplicationResult>;
    /**
     * Reject For Project
     */
    rejectReviewers(command: RejectForProjectBulkCommand): Observable<ApplicationResult>;
    /**
     * Pend For Project
     */
    pendReviewer(command: PendForProjectCommand): Observable<ApplicationResult>;
    /**
     * Pend For Project
     */
    pendReviewers(command: PendForProjectBulkCommand): Observable<ApplicationResult>;
    /**
     * Accept Project
     */
    acceptReviewer(command: AcceptProjectCommand): Observable<ApplicationResultOfAcceptProjectResponse>;
    /**
     * Decline Project
     */
    declineReviewer(command: DeclineProjectCommand): Observable<ApplicationResult>;
    /**
     * Withdraw Decline Project
     */
    withdrawDeclineReviewer(command: WithdrawDeclineProjectCommand): Observable<ApplicationResult>;
    /**
     * Withdraw From Project
     */
    withdrawFromProject(command: ReviewerWithdrawApplicationCommand): Observable<ApplicationResult>;
    /**
     * Bulk Invite Reviewers
     */
    bulkInviteReviewers(command: InviteReviewersBulkCommand): Observable<ApplicationResultOfInviteReviewersResultDto>;
    /**
     * Get next Pending Reviewer
     * @param caseId (optional) 
     */
    getNextPendingReviewer(caseId?: number | undefined): Observable<ApplicationResultOfNextPendingReviewerDto>;
    getProjectsHistory(reviewerId: number, reviewerTypeId?: number | null | undefined): Observable<ApplicationResultOfListOfReviewerProjectDto>;
    /**
     * Get Project
     */
    get(id: number): Observable<ApplicationResultOfProjectDetailDto>;
    /**
     * Apply For Project
     */
    applyForProject(command: ReviewerApplyToProjectCommand): Observable<ApplicationResultOfApplyToProjectResponse>;
    /**
     * Approve For Project
     */
    approveReviewer(command: ApproveForProjectCommand): Observable<ApplicationResultOfInviteReviewersResultDto>;
    /**
     * Sign a Document For Project
     */
    signReviewerDocument(command: SignReviewerDocumentCommand): Observable<ApplicationResultOfLinkRequestResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectClient extends ApiClientBase implements IProjectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Search Projects
     * @param minimumPayRate (optional) 
     * @param reviewerTypeRoles (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param requiredSpecialties (optional) 
     * @param requiredLanguages (optional) 
     * @param locationStates (optional) 
     * @param locationCountries (optional) 
     * @param residencyStates (optional) 
     * @param residencyCountries (optional) 
     * @param barAdmissionStates (optional) 
     * @param barAdmissionCountries (optional) 
     * @param timeZones (optional) 
     * @param experienceLevel (optional) 
     * @param caseTypes (optional) 
     * @param reviewTechnology (optional) 
     * @param companies (optional) 
     * @param requiresJD (optional) 
     * @param requiresOvertime (optional) 
     * @param requiresWeekend (optional) 
     * @param requiresHolidays (optional) 
     * @param requiresSecurityClearance (optional) 
     * @param allowConcurrent (optional) 
     * @param hasWeeklyHrsLimit (optional) 
     * @param isW2Company (optional) 
     * @param excludeRequirements (optional) 
     */
    search(minimumPayRate?: number | null | undefined, reviewerTypeRoles?: number[] | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, requiredSpecialties?: number[] | undefined, requiredLanguages?: number[] | undefined, locationStates?: string[] | undefined, locationCountries?: string[] | undefined, residencyStates?: string[] | undefined, residencyCountries?: string[] | undefined, barAdmissionStates?: string[] | undefined, barAdmissionCountries?: string[] | undefined, timeZones?: number[] | undefined, experienceLevel?: number | null | undefined, caseTypes?: number[] | undefined, reviewTechnology?: number[] | undefined, companies?: number[] | undefined, requiresJD?: boolean | null | undefined, requiresOvertime?: boolean | null | undefined, requiresWeekend?: RequiredValues | null | undefined, requiresHolidays?: RequiredValues | null | undefined, requiresSecurityClearance?: boolean | null | undefined, allowConcurrent?: boolean | null | undefined, hasWeeklyHrsLimit?: boolean | null | undefined, isW2Company?: boolean | null | undefined, excludeRequirements?: string[] | undefined): Observable<ApplicationResultOfReviewerProjectResponse> {
        let url_ = this.baseUrl + "/api/project/search?";
        if (minimumPayRate !== undefined && minimumPayRate !== null)
            url_ += "MinimumPayRate=" + encodeURIComponent("" + minimumPayRate) + "&";
        if (reviewerTypeRoles === null)
            throw new globalThis.Error("The parameter 'reviewerTypeRoles' cannot be null.");
        else if (reviewerTypeRoles !== undefined)
            reviewerTypeRoles && reviewerTypeRoles.forEach(item => { url_ += "ReviewerTypeRoles=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (requiredSpecialties === null)
            throw new globalThis.Error("The parameter 'requiredSpecialties' cannot be null.");
        else if (requiredSpecialties !== undefined)
            requiredSpecialties && requiredSpecialties.forEach(item => { url_ += "RequiredSpecialties=" + encodeURIComponent("" + item) + "&"; });
        if (requiredLanguages === null)
            throw new globalThis.Error("The parameter 'requiredLanguages' cannot be null.");
        else if (requiredLanguages !== undefined)
            requiredLanguages && requiredLanguages.forEach(item => { url_ += "RequiredLanguages=" + encodeURIComponent("" + item) + "&"; });
        if (locationStates === null)
            throw new globalThis.Error("The parameter 'locationStates' cannot be null.");
        else if (locationStates !== undefined)
            locationStates && locationStates.forEach(item => { url_ += "LocationStates=" + encodeURIComponent("" + item) + "&"; });
        if (locationCountries === null)
            throw new globalThis.Error("The parameter 'locationCountries' cannot be null.");
        else if (locationCountries !== undefined)
            locationCountries && locationCountries.forEach(item => { url_ += "LocationCountries=" + encodeURIComponent("" + item) + "&"; });
        if (residencyStates === null)
            throw new globalThis.Error("The parameter 'residencyStates' cannot be null.");
        else if (residencyStates !== undefined)
            residencyStates && residencyStates.forEach(item => { url_ += "ResidencyStates=" + encodeURIComponent("" + item) + "&"; });
        if (residencyCountries === null)
            throw new globalThis.Error("The parameter 'residencyCountries' cannot be null.");
        else if (residencyCountries !== undefined)
            residencyCountries && residencyCountries.forEach(item => { url_ += "ResidencyCountries=" + encodeURIComponent("" + item) + "&"; });
        if (barAdmissionStates === null)
            throw new globalThis.Error("The parameter 'barAdmissionStates' cannot be null.");
        else if (barAdmissionStates !== undefined)
            barAdmissionStates && barAdmissionStates.forEach(item => { url_ += "BarAdmissionStates=" + encodeURIComponent("" + item) + "&"; });
        if (barAdmissionCountries === null)
            throw new globalThis.Error("The parameter 'barAdmissionCountries' cannot be null.");
        else if (barAdmissionCountries !== undefined)
            barAdmissionCountries && barAdmissionCountries.forEach(item => { url_ += "BarAdmissionCountries=" + encodeURIComponent("" + item) + "&"; });
        if (timeZones === null)
            throw new globalThis.Error("The parameter 'timeZones' cannot be null.");
        else if (timeZones !== undefined)
            timeZones && timeZones.forEach(item => { url_ += "TimeZones=" + encodeURIComponent("" + item) + "&"; });
        if (experienceLevel !== undefined && experienceLevel !== null)
            url_ += "ExperienceLevel=" + encodeURIComponent("" + experienceLevel) + "&";
        if (caseTypes === null)
            throw new globalThis.Error("The parameter 'caseTypes' cannot be null.");
        else if (caseTypes !== undefined)
            caseTypes && caseTypes.forEach(item => { url_ += "CaseTypes=" + encodeURIComponent("" + item) + "&"; });
        if (reviewTechnology === null)
            throw new globalThis.Error("The parameter 'reviewTechnology' cannot be null.");
        else if (reviewTechnology !== undefined)
            reviewTechnology && reviewTechnology.forEach(item => { url_ += "ReviewTechnology=" + encodeURIComponent("" + item) + "&"; });
        if (companies === null)
            throw new globalThis.Error("The parameter 'companies' cannot be null.");
        else if (companies !== undefined)
            companies && companies.forEach(item => { url_ += "Companies=" + encodeURIComponent("" + item) + "&"; });
        if (requiresJD !== undefined && requiresJD !== null)
            url_ += "RequiresJD=" + encodeURIComponent("" + requiresJD) + "&";
        if (requiresOvertime !== undefined && requiresOvertime !== null)
            url_ += "RequiresOvertime=" + encodeURIComponent("" + requiresOvertime) + "&";
        if (requiresWeekend !== undefined && requiresWeekend !== null)
            url_ += "RequiresWeekend=" + encodeURIComponent("" + requiresWeekend) + "&";
        if (requiresHolidays !== undefined && requiresHolidays !== null)
            url_ += "RequiresHolidays=" + encodeURIComponent("" + requiresHolidays) + "&";
        if (requiresSecurityClearance !== undefined && requiresSecurityClearance !== null)
            url_ += "RequiresSecurityClearance=" + encodeURIComponent("" + requiresSecurityClearance) + "&";
        if (allowConcurrent !== undefined && allowConcurrent !== null)
            url_ += "AllowConcurrent=" + encodeURIComponent("" + allowConcurrent) + "&";
        if (hasWeeklyHrsLimit !== undefined && hasWeeklyHrsLimit !== null)
            url_ += "HasWeeklyHrsLimit=" + encodeURIComponent("" + hasWeeklyHrsLimit) + "&";
        if (isW2Company !== undefined && isW2Company !== null)
            url_ += "IsW2Company=" + encodeURIComponent("" + isW2Company) + "&";
        if (excludeRequirements === null)
            throw new globalThis.Error("The parameter 'excludeRequirements' cannot be null.");
        else if (excludeRequirements !== undefined)
            excludeRequirements && excludeRequirements.forEach(item => { url_ += "ExcludeRequirements=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerProjectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerProjectResponse>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ApplicationResultOfReviewerProjectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerProjectResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Application
     */
    updateApplication(command: ReviewerUpdateApplicationCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/project/application/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateApplication(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Unapprove For Project
     */
    unApproveReviewer(command: UnApproveForProjectCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/project/reviewer/unApprove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnApproveReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnApproveReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUnApproveReviewer(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Unapprove For Project
     */
    unApproveReviewers(command: UnApproveForProjectBulkCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/project/reviewer/bulk/unApprove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnApproveReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnApproveReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUnApproveReviewers(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reject For Project
     */
    rejectReviewer(command: RejectForProjectCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/project/reviewer/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processRejectReviewer(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reject For Project
     */
    rejectReviewers(command: RejectForProjectBulkCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/project/reviewer/bulk/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processRejectReviewers(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Pend For Project
     */
    pendReviewer(command: PendForProjectCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/project/reviewer/pend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPendReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPendReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processPendReviewer(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Pend For Project
     */
    pendReviewers(command: PendForProjectBulkCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/project/reviewer/bulk/pend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPendReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPendReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processPendReviewers(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Accept Project
     */
    acceptReviewer(command: AcceptProjectCommand): Observable<ApplicationResultOfAcceptProjectResponse> {
        let url_ = this.baseUrl + "/api/project/reviewer/accept";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAcceptProjectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAcceptProjectResponse>;
        }));
    }

    protected processAcceptReviewer(response: HttpResponseBase): Observable<ApplicationResultOfAcceptProjectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAcceptProjectResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Decline Project
     */
    declineReviewer(command: DeclineProjectCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/project/reviewer/decline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeclineReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeclineReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeclineReviewer(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Withdraw Decline Project
     */
    withdrawDeclineReviewer(command: WithdrawDeclineProjectCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/project/reviewer/withdrawDecline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithdrawDeclineReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithdrawDeclineReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processWithdrawDeclineReviewer(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Withdraw From Project
     */
    withdrawFromProject(command: ReviewerWithdrawApplicationCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/project/withdraw";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithdrawFromProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithdrawFromProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processWithdrawFromProject(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Bulk Invite Reviewers
     */
    bulkInviteReviewers(command: InviteReviewersBulkCommand): Observable<ApplicationResultOfInviteReviewersResultDto> {
        let url_ = this.baseUrl + "/api/project/reviewer/bulkInvite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkInviteReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkInviteReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfInviteReviewersResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfInviteReviewersResultDto>;
        }));
    }

    protected processBulkInviteReviewers(response: HttpResponseBase): Observable<ApplicationResultOfInviteReviewersResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfInviteReviewersResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get next Pending Reviewer
     * @param caseId (optional) 
     */
    getNextPendingReviewer(caseId?: number | undefined): Observable<ApplicationResultOfNextPendingReviewerDto> {
        let url_ = this.baseUrl + "/api/project/company/nextPendingReviewer?";
        if (caseId === null)
            throw new globalThis.Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextPendingReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextPendingReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfNextPendingReviewerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfNextPendingReviewerDto>;
        }));
    }

    protected processGetNextPendingReviewer(response: HttpResponseBase): Observable<ApplicationResultOfNextPendingReviewerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfNextPendingReviewerDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProjectsHistory(reviewerId: number, reviewerTypeId?: number | null | undefined): Observable<ApplicationResultOfListOfReviewerProjectDto> {
        let url_ = this.baseUrl + "/api/project/reviewer/history/{reviewerId}?";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        if (reviewerTypeId !== undefined && reviewerTypeId !== null)
            url_ += "reviewerTypeId=" + encodeURIComponent("" + reviewerTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerProjectDto>;
        }));
    }

    protected processGetProjectsHistory(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerProjectDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Project
     */
    get(id: number): Observable<ApplicationResultOfProjectDetailDto> {
        let url_ = this.baseUrl + "/api/project/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfProjectDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfProjectDetailDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApplicationResultOfProjectDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfProjectDetailDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Apply For Project
     */
    applyForProject(command: ReviewerApplyToProjectCommand): Observable<ApplicationResultOfApplyToProjectResponse> {
        let url_ = this.baseUrl + "/api/project/application/apply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfApplyToProjectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfApplyToProjectResponse>;
        }));
    }

    protected processApplyForProject(response: HttpResponseBase): Observable<ApplicationResultOfApplyToProjectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfApplyToProjectResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Approve For Project
     */
    approveReviewer(command: ApproveForProjectCommand): Observable<ApplicationResultOfInviteReviewersResultDto> {
        let url_ = this.baseUrl + "/api/project/reviewer/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfInviteReviewersResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfInviteReviewersResultDto>;
        }));
    }

    protected processApproveReviewer(response: HttpResponseBase): Observable<ApplicationResultOfInviteReviewersResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfInviteReviewersResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sign a Document For Project
     */
    signReviewerDocument(command: SignReviewerDocumentCommand): Observable<ApplicationResultOfLinkRequestResult> {
        let url_ = this.baseUrl + "/api/project/sign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignReviewerDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignReviewerDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfLinkRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfLinkRequestResult>;
        }));
    }

    protected processSignReviewerDocument(response: HttpResponseBase): Observable<ApplicationResultOfLinkRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfLinkRequestResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPushNotificationsClient {
    subscribe(command: SubscribeForPushNotificationsCommand): Observable<ApplicationResult>;
    subscribe2(command: UnSubscribeFromPushNotificationsCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class PushNotificationsClient extends ApiClientBase implements IPushNotificationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    subscribe(command: SubscribeForPushNotificationsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/pushNotifications/subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscribe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processSubscribe(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    subscribe2(command: UnSubscribeFromPushNotificationsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/pushNotifications/unsubscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscribe2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscribe2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processSubscribe2(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRelativityClient {
    /**
     * Get Relativity Instances
     */
    getInstances(): Observable<ApplicationResultOfListOfRelativityInstanceListDto>;
    /**
     * Connect Relativity Instance
     */
    connectInstance(command: ConnectRelativityInstanceCommand): Observable<ApplicationResultOfRelativityInstanceListDto>;
    /**
     * Get Relativity Instance
     */
    getInstance(id: number): Observable<ApplicationResultOfRelativityInstanceDto>;
    /**
     * Delete Relativity Instance
     */
    deleteInstance(id: number): Observable<ApplicationResult>;
    /**
     * Update Relativity Instance
     */
    updateInstance(id: number, command: UpdateRelativityInstanceCommand): Observable<ApplicationResultOfRelativityInstanceDto>;
    /**
     * Check Relativity Instance Connection
     */
    checkInstanceConnection(instanceId: number): Observable<ApplicationResultOfRelativityInstanceDto>;
    /**
     * Get Relativity Workspaces
     */
    getWorkspaces(instanceId: number): Observable<ApplicationResultOfListOfRelativityWorkspaceListDto>;
    /**
     * Get Relativity Workspaces
     */
    getAuditsPullLogs(instanceId: number, workspaceArtifactId: number): Observable<ApplicationResultOfListOfRelativityAuditsLogDto>;
    /**
     * Connect Relativity Workspace
     */
    connectWorkspace(command: ConnectRelativityWorkspaceCommand): Observable<ApplicationResultOfRelativityWorkspaceDto>;
    /**
     * Get Relativity Workspace
     */
    getAllWorkspaces(): Observable<ApplicationResultOfListOfRelativityWorkspaceListDto>;
    /**
     * Get Relativity Workspace
     * @param reloadFields (optional) 
     */
    getWorkspace(id: number, reloadFields?: boolean | undefined): Observable<ApplicationResultOfRelativityWorkspaceDto>;
    /**
     * Delete Relativity Workspace
     */
    deleteWorkspace(id: number): Observable<ApplicationResult>;
    /**
     * Update Relativity Workspace
     */
    updateWorkspaces(id: number, command: UpdateRelativityWorkspaceCommand): Observable<ApplicationResultOfRelativityWorkspaceDto>;
    /**
     * Get Relativity Workspace Status
     */
    getWorkspaceStatus(id: number): Observable<ApplicationResultOfRelativityWorkspaceStatusDto>;
    /**
     * Schedule Workspace Audits Poll
     */
    scheduleAudits(id: number, command: ScheduleAuditsPollingCommand): Observable<ApplicationResult>;
    /**
     * Load Relativity Workspaces
     */
    loadWorkspaces(instanceId: number): Observable<ApplicationResultOfListOfWorkspace>;
    /**
     * Load Relativity Clients
     */
    loadClients(instanceId: number): Observable<ApplicationResultOfListOfClient>;
    /**
     * Get Case Relativity Groups
     */
    loadGroups(workspaceId: number): Observable<ApplicationResultOfListOfGroup>;
    /**
     * Get Case Relativity Saved Searches
     */
    loadSavedSearches(workspaceId: number): Observable<ApplicationResultOfListOfSavedSearchDto>;
    /**
     * Get Case Relativity Users
     */
    loadUsers(workspaceId: number): Observable<ApplicationResultOfListOfRelativityWorkspaceUserDto>;
    /**
     * Connect Saved Search
     */
    connectSavedSearch(command: ConnectSavedSearchCommand): Observable<ApplicationResultOfRelativitySavedSearchDto>;
    /**
     * Refresh Saved Search
     */
    refreshSavedSearch(savedSearchId: number): Observable<ApplicationResult>;
    /**
     * Get Case Relativity Fields
     */
    loadFields(instanceId: number, workspaceArtifactId: number): Observable<ApplicationResultOfListOfField>;
    /**
     * Get Case Relativity Groups
     */
    confirmCredentials(command: ConfirmRelativityCredentialsCommand): Observable<ApplicationResult>;
    /**
     * Get Relativity Choices
     */
    getChoices(): Observable<ApplicationResultOfListOfRelativityChoiceDto>;
    /**
     * Get Relativity Users
     */
    getUsers(): Observable<ApplicationResultOfListOfRelativityUserDto>;
    /**
     * Send Relativity User Invite
     */
    sendUserInvite(userId: number): Observable<ApplicationResult>;
    /**
     * Update Relativity User Password
     */
    updateUserPassword(command: UpdateRelativityUserPasswordCommand): Observable<ApplicationResult>;
    /**
     * Update Relativity User Access
     */
    updateUserAccess(command: UpdateRelativityUserAccessCommand): Observable<ApplicationResult>;
    /**
     * Relativity Pull Logs Datatable
     */
    getPullLogsDatatable(id: number, workspaceArtifactId: number, query: GetRelativityPullAuditPagedQuery): Observable<ApplicationResultOfPaginatedResultOfRelativityAuditsLogDto>;
    /**
     * Get Relativity Actions
     */
    getActions(): Observable<ApplicationResultOfListOfRelativityActionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class RelativityClient extends ApiClientBase implements IRelativityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Relativity Instances
     */
    getInstances(): Observable<ApplicationResultOfListOfRelativityInstanceListDto> {
        let url_ = this.baseUrl + "/api/relativity/instances";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInstances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInstances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRelativityInstanceListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRelativityInstanceListDto>;
        }));
    }

    protected processGetInstances(response: HttpResponseBase): Observable<ApplicationResultOfListOfRelativityInstanceListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRelativityInstanceListDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Connect Relativity Instance
     */
    connectInstance(command: ConnectRelativityInstanceCommand): Observable<ApplicationResultOfRelativityInstanceListDto> {
        let url_ = this.baseUrl + "/api/relativity/instances";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConnectInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConnectInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfRelativityInstanceListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfRelativityInstanceListDto>;
        }));
    }

    protected processConnectInstance(response: HttpResponseBase): Observable<ApplicationResultOfRelativityInstanceListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfRelativityInstanceListDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Relativity Instance
     */
    getInstance(id: number): Observable<ApplicationResultOfRelativityInstanceDto> {
        let url_ = this.baseUrl + "/api/relativity/instances/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfRelativityInstanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfRelativityInstanceDto>;
        }));
    }

    protected processGetInstance(response: HttpResponseBase): Observable<ApplicationResultOfRelativityInstanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfRelativityInstanceDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Relativity Instance
     */
    deleteInstance(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/relativity/instances/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteInstance(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Relativity Instance
     */
    updateInstance(id: number, command: UpdateRelativityInstanceCommand): Observable<ApplicationResultOfRelativityInstanceDto> {
        let url_ = this.baseUrl + "/api/relativity/instances/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfRelativityInstanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfRelativityInstanceDto>;
        }));
    }

    protected processUpdateInstance(response: HttpResponseBase): Observable<ApplicationResultOfRelativityInstanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfRelativityInstanceDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check Relativity Instance Connection
     */
    checkInstanceConnection(instanceId: number): Observable<ApplicationResultOfRelativityInstanceDto> {
        let url_ = this.baseUrl + "/api/relativity/instances/{instanceId}/connection";
        if (instanceId === undefined || instanceId === null)
            throw new globalThis.Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckInstanceConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckInstanceConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfRelativityInstanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfRelativityInstanceDto>;
        }));
    }

    protected processCheckInstanceConnection(response: HttpResponseBase): Observable<ApplicationResultOfRelativityInstanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfRelativityInstanceDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Relativity Workspaces
     */
    getWorkspaces(instanceId: number): Observable<ApplicationResultOfListOfRelativityWorkspaceListDto> {
        let url_ = this.baseUrl + "/api/relativity/instances/{instanceId}/workspaces";
        if (instanceId === undefined || instanceId === null)
            throw new globalThis.Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkspaces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkspaces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRelativityWorkspaceListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRelativityWorkspaceListDto>;
        }));
    }

    protected processGetWorkspaces(response: HttpResponseBase): Observable<ApplicationResultOfListOfRelativityWorkspaceListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRelativityWorkspaceListDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Relativity Workspaces
     */
    getAuditsPullLogs(instanceId: number, workspaceArtifactId: number): Observable<ApplicationResultOfListOfRelativityAuditsLogDto> {
        let url_ = this.baseUrl + "/api/relativity/instances/{instanceId}/workspaces/{workspaceArtifactId}";
        if (instanceId === undefined || instanceId === null)
            throw new globalThis.Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        if (workspaceArtifactId === undefined || workspaceArtifactId === null)
            throw new globalThis.Error("The parameter 'workspaceArtifactId' must be defined.");
        url_ = url_.replace("{workspaceArtifactId}", encodeURIComponent("" + workspaceArtifactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditsPullLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditsPullLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRelativityAuditsLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRelativityAuditsLogDto>;
        }));
    }

    protected processGetAuditsPullLogs(response: HttpResponseBase): Observable<ApplicationResultOfListOfRelativityAuditsLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRelativityAuditsLogDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Connect Relativity Workspace
     */
    connectWorkspace(command: ConnectRelativityWorkspaceCommand): Observable<ApplicationResultOfRelativityWorkspaceDto> {
        let url_ = this.baseUrl + "/api/relativity/workspace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConnectWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConnectWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfRelativityWorkspaceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfRelativityWorkspaceDto>;
        }));
    }

    protected processConnectWorkspace(response: HttpResponseBase): Observable<ApplicationResultOfRelativityWorkspaceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfRelativityWorkspaceDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Relativity Workspace
     */
    getAllWorkspaces(): Observable<ApplicationResultOfListOfRelativityWorkspaceListDto> {
        let url_ = this.baseUrl + "/api/relativity/workspaces";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWorkspaces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWorkspaces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRelativityWorkspaceListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRelativityWorkspaceListDto>;
        }));
    }

    protected processGetAllWorkspaces(response: HttpResponseBase): Observable<ApplicationResultOfListOfRelativityWorkspaceListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRelativityWorkspaceListDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Relativity Workspace
     * @param reloadFields (optional) 
     */
    getWorkspace(id: number, reloadFields?: boolean | undefined): Observable<ApplicationResultOfRelativityWorkspaceDto> {
        let url_ = this.baseUrl + "/api/relativity/workspaces/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (reloadFields === null)
            throw new globalThis.Error("The parameter 'reloadFields' cannot be null.");
        else if (reloadFields !== undefined)
            url_ += "reloadFields=" + encodeURIComponent("" + reloadFields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfRelativityWorkspaceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfRelativityWorkspaceDto>;
        }));
    }

    protected processGetWorkspace(response: HttpResponseBase): Observable<ApplicationResultOfRelativityWorkspaceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfRelativityWorkspaceDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Relativity Workspace
     */
    deleteWorkspace(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/relativity/workspaces/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteWorkspace(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Relativity Workspace
     */
    updateWorkspaces(id: number, command: UpdateRelativityWorkspaceCommand): Observable<ApplicationResultOfRelativityWorkspaceDto> {
        let url_ = this.baseUrl + "/api/relativity/workspaces/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkspaces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkspaces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfRelativityWorkspaceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfRelativityWorkspaceDto>;
        }));
    }

    protected processUpdateWorkspaces(response: HttpResponseBase): Observable<ApplicationResultOfRelativityWorkspaceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfRelativityWorkspaceDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Relativity Workspace Status
     */
    getWorkspaceStatus(id: number): Observable<ApplicationResultOfRelativityWorkspaceStatusDto> {
        let url_ = this.baseUrl + "/api/relativity/workspaces/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkspaceStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkspaceStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfRelativityWorkspaceStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfRelativityWorkspaceStatusDto>;
        }));
    }

    protected processGetWorkspaceStatus(response: HttpResponseBase): Observable<ApplicationResultOfRelativityWorkspaceStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfRelativityWorkspaceStatusDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Schedule Workspace Audits Poll
     */
    scheduleAudits(id: number, command: ScheduleAuditsPollingCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/relativity/workspace/{id}/audits";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleAudits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleAudits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processScheduleAudits(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Load Relativity Workspaces
     */
    loadWorkspaces(instanceId: number): Observable<ApplicationResultOfListOfWorkspace> {
        let url_ = this.baseUrl + "/api/relativity/instances/{instanceId}/workspaces/load";
        if (instanceId === undefined || instanceId === null)
            throw new globalThis.Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadWorkspaces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadWorkspaces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfWorkspace>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfWorkspace>;
        }));
    }

    protected processLoadWorkspaces(response: HttpResponseBase): Observable<ApplicationResultOfListOfWorkspace> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfWorkspace;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Load Relativity Clients
     */
    loadClients(instanceId: number): Observable<ApplicationResultOfListOfClient> {
        let url_ = this.baseUrl + "/api/relativity/instances/{instanceId}/clients/load";
        if (instanceId === undefined || instanceId === null)
            throw new globalThis.Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfClient>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfClient>;
        }));
    }

    protected processLoadClients(response: HttpResponseBase): Observable<ApplicationResultOfListOfClient> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfClient;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case Relativity Groups
     */
    loadGroups(workspaceId: number): Observable<ApplicationResultOfListOfGroup> {
        let url_ = this.baseUrl + "/api/relativity/workspaces/{workspaceId}/groups/load";
        if (workspaceId === undefined || workspaceId === null)
            throw new globalThis.Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfGroup>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfGroup>;
        }));
    }

    protected processLoadGroups(response: HttpResponseBase): Observable<ApplicationResultOfListOfGroup> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfGroup;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case Relativity Saved Searches
     */
    loadSavedSearches(workspaceId: number): Observable<ApplicationResultOfListOfSavedSearchDto> {
        let url_ = this.baseUrl + "/api/relativity/workspaces/{workspaceId}/saved-searches/load";
        if (workspaceId === undefined || workspaceId === null)
            throw new globalThis.Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadSavedSearches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadSavedSearches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfSavedSearchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfSavedSearchDto>;
        }));
    }

    protected processLoadSavedSearches(response: HttpResponseBase): Observable<ApplicationResultOfListOfSavedSearchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfSavedSearchDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case Relativity Users
     */
    loadUsers(workspaceId: number): Observable<ApplicationResultOfListOfRelativityWorkspaceUserDto> {
        let url_ = this.baseUrl + "/api/relativity/workspaces/{workspaceId}/users/load";
        if (workspaceId === undefined || workspaceId === null)
            throw new globalThis.Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRelativityWorkspaceUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRelativityWorkspaceUserDto>;
        }));
    }

    protected processLoadUsers(response: HttpResponseBase): Observable<ApplicationResultOfListOfRelativityWorkspaceUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRelativityWorkspaceUserDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Connect Saved Search
     */
    connectSavedSearch(command: ConnectSavedSearchCommand): Observable<ApplicationResultOfRelativitySavedSearchDto> {
        let url_ = this.baseUrl + "/api/relativity/saved-searches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConnectSavedSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConnectSavedSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfRelativitySavedSearchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfRelativitySavedSearchDto>;
        }));
    }

    protected processConnectSavedSearch(response: HttpResponseBase): Observable<ApplicationResultOfRelativitySavedSearchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfRelativitySavedSearchDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Refresh Saved Search
     */
    refreshSavedSearch(savedSearchId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/relativity/saved-searches/{savedSearchId}/refresh";
        if (savedSearchId === undefined || savedSearchId === null)
            throw new globalThis.Error("The parameter 'savedSearchId' must be defined.");
        url_ = url_.replace("{savedSearchId}", encodeURIComponent("" + savedSearchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshSavedSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshSavedSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processRefreshSavedSearch(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case Relativity Fields
     */
    loadFields(instanceId: number, workspaceArtifactId: number): Observable<ApplicationResultOfListOfField> {
        let url_ = this.baseUrl + "/api/relativity/instances/{instanceId}/workspaces/{workspaceArtifactId}/fields/load";
        if (instanceId === undefined || instanceId === null)
            throw new globalThis.Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        if (workspaceArtifactId === undefined || workspaceArtifactId === null)
            throw new globalThis.Error("The parameter 'workspaceArtifactId' must be defined.");
        url_ = url_.replace("{workspaceArtifactId}", encodeURIComponent("" + workspaceArtifactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfField>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfField>;
        }));
    }

    protected processLoadFields(response: HttpResponseBase): Observable<ApplicationResultOfListOfField> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfField;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case Relativity Groups
     */
    confirmCredentials(command: ConfirmRelativityCredentialsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/relativity/credentials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmCredentials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmCredentials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processConfirmCredentials(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Relativity Choices
     */
    getChoices(): Observable<ApplicationResultOfListOfRelativityChoiceDto> {
        let url_ = this.baseUrl + "/api/relativity/choices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRelativityChoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRelativityChoiceDto>;
        }));
    }

    protected processGetChoices(response: HttpResponseBase): Observable<ApplicationResultOfListOfRelativityChoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRelativityChoiceDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Relativity Users
     */
    getUsers(): Observable<ApplicationResultOfListOfRelativityUserDto> {
        let url_ = this.baseUrl + "/api/relativity/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRelativityUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRelativityUserDto>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<ApplicationResultOfListOfRelativityUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRelativityUserDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send Relativity User Invite
     */
    sendUserInvite(userId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/relativity/users/{userId}/invite";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendUserInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendUserInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processSendUserInvite(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Relativity User Password
     */
    updateUserPassword(command: UpdateRelativityUserPasswordCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/relativity/users/password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateUserPassword(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Relativity User Access
     */
    updateUserAccess(command: UpdateRelativityUserAccessCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/relativity/users/access";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateUserAccess(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Relativity Pull Logs Datatable
     */
    getPullLogsDatatable(id: number, workspaceArtifactId: number, query: GetRelativityPullAuditPagedQuery): Observable<ApplicationResultOfPaginatedResultOfRelativityAuditsLogDto> {
        let url_ = this.baseUrl + "/api/relativity/instances/{id}/workspaces/{workspaceArtifactId}/logs/datatable";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (workspaceArtifactId === undefined || workspaceArtifactId === null)
            throw new globalThis.Error("The parameter 'workspaceArtifactId' must be defined.");
        url_ = url_.replace("{workspaceArtifactId}", encodeURIComponent("" + workspaceArtifactId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPullLogsDatatable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPullLogsDatatable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfPaginatedResultOfRelativityAuditsLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfPaginatedResultOfRelativityAuditsLogDto>;
        }));
    }

    protected processGetPullLogsDatatable(response: HttpResponseBase): Observable<ApplicationResultOfPaginatedResultOfRelativityAuditsLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfPaginatedResultOfRelativityAuditsLogDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Relativity Actions
     */
    getActions(): Observable<ApplicationResultOfListOfRelativityActionDto> {
        let url_ = this.baseUrl + "/api/relativity/actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRelativityActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRelativityActionDto>;
        }));
    }

    protected processGetActions(response: HttpResponseBase): Observable<ApplicationResultOfListOfRelativityActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRelativityActionDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReleaseHistoryClient {
    /**
     * GetReleaseHistory
     */
    getReleaseHistory(): Observable<ApplicationResultOfListOfReleaseHistoryDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ReleaseHistoryClient extends ApiClientBase implements IReleaseHistoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * GetReleaseHistory
     */
    getReleaseHistory(): Observable<ApplicationResultOfListOfReleaseHistoryDto> {
        let url_ = this.baseUrl + "/api/releaseHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReleaseHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReleaseHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReleaseHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReleaseHistoryDto>;
        }));
    }

    protected processGetReleaseHistory(response: HttpResponseBase): Observable<ApplicationResultOfListOfReleaseHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReleaseHistoryDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerBarMembershipClient {
    /**
     * Get Bar Statuses
     * @param query (optional) 
     */
    getBarStatuses(query?: GetBarStatusesQuery | undefined): Observable<ApplicationResultOfListOfReviewerBarStatusDto>;
    /**
     * Get Bar Confirmation Screenshot
     * @param reviewerBarMembershipId (optional) 
     */
    getBarConfirmationScreenshot(reviewerBarMembershipId?: number | undefined): Observable<ApplicationResultOfDocumentDto>;
    /**
     * Get Bar Confirmation Screenshot
     */
    deleteBarMembershipScreenshot(id: number): Observable<ApplicationResult>;
    /**
     * Approve Bar Status
     */
    approveBarStatus(command: ApproveBarStatusCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerBarMembershipClient extends ApiClientBase implements IReviewerBarMembershipClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Bar Statuses
     * @param query (optional) 
     */
    getBarStatuses(query?: GetBarStatusesQuery | undefined): Observable<ApplicationResultOfListOfReviewerBarStatusDto> {
        let url_ = this.baseUrl + "/api/reviewerBarMembership?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBarStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBarStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerBarStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerBarStatusDto>;
        }));
    }

    protected processGetBarStatuses(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerBarStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerBarStatusDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Bar Confirmation Screenshot
     * @param reviewerBarMembershipId (optional) 
     */
    getBarConfirmationScreenshot(reviewerBarMembershipId?: number | undefined): Observable<ApplicationResultOfDocumentDto> {
        let url_ = this.baseUrl + "/api/reviewerBarMembership/bar-confirmation-screenshot?";
        if (reviewerBarMembershipId === null)
            throw new globalThis.Error("The parameter 'reviewerBarMembershipId' cannot be null.");
        else if (reviewerBarMembershipId !== undefined)
            url_ += "ReviewerBarMembershipId=" + encodeURIComponent("" + reviewerBarMembershipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBarConfirmationScreenshot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBarConfirmationScreenshot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfDocumentDto>;
        }));
    }

    protected processGetBarConfirmationScreenshot(response: HttpResponseBase): Observable<ApplicationResultOfDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Bar Confirmation Screenshot
     */
    deleteBarMembershipScreenshot(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerBarMembership/screenshot/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBarMembershipScreenshot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBarMembershipScreenshot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteBarMembershipScreenshot(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Approve Bar Status
     */
    approveBarStatus(command: ApproveBarStatusCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerBarMembership/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveBarStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveBarStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processApproveBarStatus(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerCaseAnnouncementClient {
    /**
     * Acknowledge Reviewer Type Announcement
     */
    acknowledgeReviewerTypeAnnouncement(command: AcknowledgeReviewerTypeAnnouncementCommand): Observable<ApplicationResult>;
    /**
     * Mark Announcement As Seen
     */
    markAnnouncementAsSeen(command: MarkAnnouncementsAsSeenCommand): Observable<ApplicationResult>;
    /**
     * Bulk Acknowledge Reviewer Type Announcement
     */
    bulkAcknowledgeReviewerTypeAnnouncement(command: BulkAcknowledgeAnnouncementCommand): Observable<ApplicationResult>;
    /**
     * Get All Reviewer Announcements
     */
    getAllReviewerAnnouncements(): Observable<ApplicationResultOfListOfCurrentReviewerTypeAnnouncementDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerCaseAnnouncementClient extends ApiClientBase implements IReviewerCaseAnnouncementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Acknowledge Reviewer Type Announcement
     */
    acknowledgeReviewerTypeAnnouncement(command: AcknowledgeReviewerTypeAnnouncementCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerCaseAnnouncement/acknowledge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcknowledgeReviewerTypeAnnouncement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcknowledgeReviewerTypeAnnouncement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processAcknowledgeReviewerTypeAnnouncement(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Mark Announcement As Seen
     */
    markAnnouncementAsSeen(command: MarkAnnouncementsAsSeenCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerCaseAnnouncement/markAsSeen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAnnouncementAsSeen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAnnouncementAsSeen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processMarkAnnouncementAsSeen(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Bulk Acknowledge Reviewer Type Announcement
     */
    bulkAcknowledgeReviewerTypeAnnouncement(command: BulkAcknowledgeAnnouncementCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerCaseAnnouncement/bulkAcknowledge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkAcknowledgeReviewerTypeAnnouncement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkAcknowledgeReviewerTypeAnnouncement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processBulkAcknowledgeReviewerTypeAnnouncement(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Reviewer Announcements
     */
    getAllReviewerAnnouncements(): Observable<ApplicationResultOfListOfCurrentReviewerTypeAnnouncementDto> {
        let url_ = this.baseUrl + "/api/reviewerCaseAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReviewerAnnouncements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReviewerAnnouncements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCurrentReviewerTypeAnnouncementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCurrentReviewerTypeAnnouncementDto>;
        }));
    }

    protected processGetAllReviewerAnnouncements(response: HttpResponseBase): Observable<ApplicationResultOfListOfCurrentReviewerTypeAnnouncementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCurrentReviewerTypeAnnouncementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerClient {
    /**
     * Case
     * @param query (optional) 
     */
    getReviewerCases(query?: ReviewerCasesQuery | undefined): Observable<ApplicationResultOfListOfReviewerCaseDto>;
    /**
     * Case
     * @param name (optional) 
     * @param statuses (optional) 
     * @param sortBy (optional) 
     */
    getReviewerActiveCases(name?: string | null | undefined, statuses?: ReviewerReviewerTypeStatus[] | undefined, sortBy?: string | null | undefined): Observable<ApplicationResultOfListOfReviewerCaseDto>;
    /**
     * Case
     * @param name (optional) 
     * @param statuses (optional) 
     * @param sortBy (optional) 
     */
    getReviewerActiveCasesCount(name?: string | null | undefined, statuses?: ReviewerReviewerTypeStatus[] | undefined, sortBy?: string | null | undefined): Observable<ApplicationResultOfListOfReviewerCaseDto>;
    /**
     * Case
     * @param name (optional) 
     * @param statuses (optional) 
     * @param sortBy (optional) 
     */
    getReviewerPendingCases(name?: string | null | undefined, statuses?: ReviewerReviewerTypeStatus[] | undefined, sortBy?: string | null | undefined): Observable<ApplicationResultOfListOfReviewerCaseDto>;
    /**
     * Case
     */
    getReviewerPendingCasesCount(): Observable<ApplicationResultOfInteger>;
    /**
     * Inactive Projects
     * @param name (optional) 
     * @param statuses (optional) 
     * @param sortBy (optional) 
     */
    getReviewerInactiveProjects(name?: string | null | undefined, statuses?: ReviewerReviewerTypeStatus[] | undefined, sortBy?: string | null | undefined): Observable<ApplicationResultOfListOfReviewerCaseDto>;
    /**
     * Inactive Projects Count
     * @param name (optional) 
     * @param statuses (optional) 
     * @param sortBy (optional) 
     */
    getReviewerInactiveProjectsCount(name?: string | null | undefined, statuses?: ReviewerReviewerTypeStatus[] | undefined, sortBy?: string | null | undefined): Observable<ApplicationResultOfInteger>;
    /**
     * Add General Experience
     */
    addGeneralExperience(command: CreateGeneralExperienceCommand): Observable<ApplicationResultOfProfileSaveResultDto>;
    /**
     * Add Reviewer Requirements
     */
    addReviewerRequirements(command: CreateReviewerRequirementCommand): Observable<ApplicationResultOfProfileSaveResultDto>;
    /**
     * Get Reviewer Requirements
     */
    getReviewerRequirements(): Observable<ApplicationResultOfReviewerRequirementsDto>;
    /**
     * Get Reviewer Exists
     */
    createReviewer(command: CreateReviewerCommand): Observable<ApplicationResultOfCreateReviewerResultDto>;
    /**
     * Update Reviewer Address Info
     */
    updateReviewerAddressInfo(command: UpdateReviewerAddressCommand): Observable<ApplicationResult>;
    /**
     * Get Reviewer details
     */
    getReviewerDetails(): Observable<ApplicationResultOfReviewerDetailsDto>;
    /**
     * Get Reviewer Reviewer Types
     */
    getReviewerReviewerTypes(): Observable<ApplicationResultOfListOfReviewerReviewerTypesDto>;
    /**
     * Create Reviewer Basic Info
     */
    createReviewerBasicInfo(command: ReviewerBasicInfoCommand): Observable<ApplicationResultOfProfileSaveResultDto>;
    /**
     * Get technology proficiency
     */
    getReviewerBasicInfo(): Observable<ApplicationResultOfReviewerBasicInfoResponse>;
    /**
     * Save Reviewer Schedule
     */
    saveReviewerSchedule(command: SaveReviewerScheduleCommand): Observable<ApplicationResultOfReviewerScheduleResponseDto>;
    /**
     * Get Reviewer Schedule
     */
    getReviewerSchedule(): Observable<ApplicationResultOfReviewerScheduleResponseDto>;
    /**
     * Get Reviewer Earning
     */
    getReviewerEarning(): Observable<ApplicationResultOfListOfPayrollResponseDto>;
    /**
     * Update Reviewer Compensation and Notification
     */
    updateReviewerCompensationAndNotification(command: UpdateReviewerCompensationAndNotificationCommand): Observable<ApplicationResultOfProfileSaveResultDto>;
    /**
     * Get Reviewer Pay Rates
     */
    getPayRatesForReviewer(): Observable<ApplicationResultOfListOfReviewerPayRateDto>;
    /**
     * Delete Reviewer Pay Rates
     */
    deletePayRatesForReviewer(command: DeleteReviewerPayRatesCommand): Observable<ApplicationResult>;
    /**
     * Save Reviewer Policies
     */
    saveReviewerPolicies(command: SaveReviewerPolicyCommand): Observable<ApplicationResultOfReviewerProfileValidationResult>;
    /**
     * Get Reviewer Profile
     */
    getReviewerProfile(): Observable<ApplicationResultOfReviewerProfileDto>;
    /**
     * Validate Reviewer Profile
     */
    validateReviewerProfile(): Observable<ApplicationResultOfReviewerProfileValidationResult>;
    /**
     * Get Dashboard cards
     */
    getDashboard(): Observable<ApplicationResultOfReviewerDashboardDto>;
    /**
     * Delete Reviewer barmembership
     */
    deleteBarMembershipForReviewer(command: DeleteReviewerBarMembershipCommand): Observable<ApplicationResult>;
    /**
     * Get Dashboard cards
     */
    getReviewerSelectedRoles(): Observable<ApplicationResultOfListOfLookUpDto>;
    /**
     * Send On Boarding Email
     */
    sendReviewerOnBoardEmail(): Observable<ApplicationResult>;
    /**
     * Get reviewer application attachments
     */
    getReviewerApplicationAttachments(reviewerTypeId: number): Observable<ApplicationResultOfListOfDocumentDto>;
    /**
     * Delete application attachment
     */
    deleteApplicationAttachment(documentId: number, reviewerTypeId: number): Observable<ApplicationResult>;
    /**
     * Delete resume
     */
    deleteResume(): Observable<ApplicationResult>;
    /**
     * Apply resume data
     */
    applyResumeData(command: ApplyResumeParsedValuesCommand): Observable<ApplicationResultOfApplyResumeParsedValuesResultDto>;
    /**
     * Get Resume Parsing Data
     */
    getResumeParsingData(documentId: number): Observable<ApplicationResultOfResumeParsingResultDto>;
    /**
     * Perks
     * @param query (optional) 
     */
    getReviewerPerks(query?: ReviewerPerksQuery | undefined): Observable<ApplicationResultOfListOfReviewerPerksDto>;
    /**
     * Get Reviewer Relativity Overall Statistic
     * @param caseId (optional) 
     */
    getOverallMetrics(caseId?: number | null | undefined): Observable<ApplicationResultOfRelativityOverallMetric>;
    /**
     * Get Reviewer Relativity Statistic
     * @param fields (optional) 
     */
    getMetrics(fields?: number[] | undefined): Observable<ApplicationResultOfListOfCaseOverallMetricsDto>;
    /**
     * Get Case Relativity Statistic
     * @param fields (optional) 
     * @param interval (optional) 
     */
    getMetricsTimeSeries(fields?: number[] | undefined, interval?: CaseMetricsInterval | undefined): Observable<ApplicationResultOfListOfCaseTimeSeriesMetricsDto>;
    /**
     * Get Case Relativity Statistic
     * @param caseId (optional) 
     */
    getMetricsFieldStatistics(caseId?: number | null | undefined): Observable<ApplicationResultOfListOfRelativityFieldStatisticDto>;
    /**
     * Get Reviewer Relativity Fields
     */
    getMetricFields(): Observable<ApplicationResultOfListOfBaseRelativityFieldDto>;
    /**
     * Get Reviewer Documents
     */
    getDocuments(): Observable<ApplicationResultOfListOfBoldsignDocumentDto>;
    /**
     * Get Reviewer Pending Documents
     */
    getPendingDocuments(): Observable<ApplicationResultOfListOfProjectWithPendingBoldsignDocumentDto>;
    /**
     * Disable Referral Popup
     */
    disableReferralPopup(): Observable<ApplicationResult>;
    /**
     * Parse Current Resume
     */
    parseCurrentResume(): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerClient extends ApiClientBase implements IReviewerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Case
     * @param query (optional) 
     */
    getReviewerCases(query?: ReviewerCasesQuery | undefined): Observable<ApplicationResultOfListOfReviewerCaseDto> {
        let url_ = this.baseUrl + "/api/reviewer/cases?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerCases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerCases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerCaseDto>;
        }));
    }

    protected processGetReviewerCases(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerCaseDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     * @param name (optional) 
     * @param statuses (optional) 
     * @param sortBy (optional) 
     */
    getReviewerActiveCases(name?: string | null | undefined, statuses?: ReviewerReviewerTypeStatus[] | undefined, sortBy?: string | null | undefined): Observable<ApplicationResultOfListOfReviewerCaseDto> {
        let url_ = this.baseUrl + "/api/reviewer/active-cases?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (statuses === null)
            throw new globalThis.Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerActiveCases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerActiveCases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerCaseDto>;
        }));
    }

    protected processGetReviewerActiveCases(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerCaseDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     * @param name (optional) 
     * @param statuses (optional) 
     * @param sortBy (optional) 
     */
    getReviewerActiveCasesCount(name?: string | null | undefined, statuses?: ReviewerReviewerTypeStatus[] | undefined, sortBy?: string | null | undefined): Observable<ApplicationResultOfListOfReviewerCaseDto> {
        let url_ = this.baseUrl + "/api/reviewer/active-cases-count?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (statuses === null)
            throw new globalThis.Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerActiveCasesCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerActiveCasesCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerCaseDto>;
        }));
    }

    protected processGetReviewerActiveCasesCount(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerCaseDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     * @param name (optional) 
     * @param statuses (optional) 
     * @param sortBy (optional) 
     */
    getReviewerPendingCases(name?: string | null | undefined, statuses?: ReviewerReviewerTypeStatus[] | undefined, sortBy?: string | null | undefined): Observable<ApplicationResultOfListOfReviewerCaseDto> {
        let url_ = this.baseUrl + "/api/reviewer/pending-cases?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (statuses === null)
            throw new globalThis.Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerPendingCases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerPendingCases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerCaseDto>;
        }));
    }

    protected processGetReviewerPendingCases(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerCaseDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     */
    getReviewerPendingCasesCount(): Observable<ApplicationResultOfInteger> {
        let url_ = this.baseUrl + "/api/reviewer/pending-cases-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerPendingCasesCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerPendingCasesCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfInteger>;
        }));
    }

    protected processGetReviewerPendingCasesCount(response: HttpResponseBase): Observable<ApplicationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfInteger;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Inactive Projects
     * @param name (optional) 
     * @param statuses (optional) 
     * @param sortBy (optional) 
     */
    getReviewerInactiveProjects(name?: string | null | undefined, statuses?: ReviewerReviewerTypeStatus[] | undefined, sortBy?: string | null | undefined): Observable<ApplicationResultOfListOfReviewerCaseDto> {
        let url_ = this.baseUrl + "/api/reviewer/inactive-projects?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (statuses === null)
            throw new globalThis.Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerInactiveProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerInactiveProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerCaseDto>;
        }));
    }

    protected processGetReviewerInactiveProjects(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerCaseDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Inactive Projects Count
     * @param name (optional) 
     * @param statuses (optional) 
     * @param sortBy (optional) 
     */
    getReviewerInactiveProjectsCount(name?: string | null | undefined, statuses?: ReviewerReviewerTypeStatus[] | undefined, sortBy?: string | null | undefined): Observable<ApplicationResultOfInteger> {
        let url_ = this.baseUrl + "/api/reviewer/inactive-projects-count?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (statuses === null)
            throw new globalThis.Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerInactiveProjectsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerInactiveProjectsCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfInteger>;
        }));
    }

    protected processGetReviewerInactiveProjectsCount(response: HttpResponseBase): Observable<ApplicationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfInteger;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add General Experience
     */
    addGeneralExperience(command: CreateGeneralExperienceCommand): Observable<ApplicationResultOfProfileSaveResultDto> {
        let url_ = this.baseUrl + "/api/reviewer/add-general-experience";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddGeneralExperience(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddGeneralExperience(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfProfileSaveResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfProfileSaveResultDto>;
        }));
    }

    protected processAddGeneralExperience(response: HttpResponseBase): Observable<ApplicationResultOfProfileSaveResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfProfileSaveResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add Reviewer Requirements
     */
    addReviewerRequirements(command: CreateReviewerRequirementCommand): Observable<ApplicationResultOfProfileSaveResultDto> {
        let url_ = this.baseUrl + "/api/reviewer/add-reviewer-requirements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddReviewerRequirements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddReviewerRequirements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfProfileSaveResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfProfileSaveResultDto>;
        }));
    }

    protected processAddReviewerRequirements(response: HttpResponseBase): Observable<ApplicationResultOfProfileSaveResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfProfileSaveResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Requirements
     */
    getReviewerRequirements(): Observable<ApplicationResultOfReviewerRequirementsDto> {
        let url_ = this.baseUrl + "/api/reviewer/get-reviewer-requirements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerRequirements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerRequirements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerRequirementsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerRequirementsDto>;
        }));
    }

    protected processGetReviewerRequirements(response: HttpResponseBase): Observable<ApplicationResultOfReviewerRequirementsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerRequirementsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Exists
     */
    createReviewer(command: CreateReviewerCommand): Observable<ApplicationResultOfCreateReviewerResultDto> {
        let url_ = this.baseUrl + "/api/reviewer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCreateReviewerResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCreateReviewerResultDto>;
        }));
    }

    protected processCreateReviewer(response: HttpResponseBase): Observable<ApplicationResultOfCreateReviewerResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCreateReviewerResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Reviewer Address Info
     */
    updateReviewerAddressInfo(command: UpdateReviewerAddressCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewer/update-reviewer-address-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewerAddressInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewerAddressInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateReviewerAddressInfo(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer details
     */
    getReviewerDetails(): Observable<ApplicationResultOfReviewerDetailsDto> {
        let url_ = this.baseUrl + "/api/reviewer/get-reviewer-details";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerDetailsDto>;
        }));
    }

    protected processGetReviewerDetails(response: HttpResponseBase): Observable<ApplicationResultOfReviewerDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Reviewer Types
     */
    getReviewerReviewerTypes(): Observable<ApplicationResultOfListOfReviewerReviewerTypesDto> {
        let url_ = this.baseUrl + "/api/reviewer/get-reviewer-reviewer-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerReviewerTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerReviewerTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerReviewerTypesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerReviewerTypesDto>;
        }));
    }

    protected processGetReviewerReviewerTypes(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerReviewerTypesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerReviewerTypesDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Reviewer Basic Info
     */
    createReviewerBasicInfo(command: ReviewerBasicInfoCommand): Observable<ApplicationResultOfProfileSaveResultDto> {
        let url_ = this.baseUrl + "/api/reviewer/create-reviewer-basic-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReviewerBasicInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReviewerBasicInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfProfileSaveResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfProfileSaveResultDto>;
        }));
    }

    protected processCreateReviewerBasicInfo(response: HttpResponseBase): Observable<ApplicationResultOfProfileSaveResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfProfileSaveResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get technology proficiency
     */
    getReviewerBasicInfo(): Observable<ApplicationResultOfReviewerBasicInfoResponse> {
        let url_ = this.baseUrl + "/api/reviewer/get-reviewer-basic-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerBasicInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerBasicInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerBasicInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerBasicInfoResponse>;
        }));
    }

    protected processGetReviewerBasicInfo(response: HttpResponseBase): Observable<ApplicationResultOfReviewerBasicInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerBasicInfoResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save Reviewer Schedule
     */
    saveReviewerSchedule(command: SaveReviewerScheduleCommand): Observable<ApplicationResultOfReviewerScheduleResponseDto> {
        let url_ = this.baseUrl + "/api/reviewer/save-reviewer-schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveReviewerSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveReviewerSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerScheduleResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerScheduleResponseDto>;
        }));
    }

    protected processSaveReviewerSchedule(response: HttpResponseBase): Observable<ApplicationResultOfReviewerScheduleResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerScheduleResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Schedule
     */
    getReviewerSchedule(): Observable<ApplicationResultOfReviewerScheduleResponseDto> {
        let url_ = this.baseUrl + "/api/reviewer/get-reviewer-schedule";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerScheduleResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerScheduleResponseDto>;
        }));
    }

    protected processGetReviewerSchedule(response: HttpResponseBase): Observable<ApplicationResultOfReviewerScheduleResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerScheduleResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Earning
     */
    getReviewerEarning(): Observable<ApplicationResultOfListOfPayrollResponseDto> {
        let url_ = this.baseUrl + "/api/reviewer/get-reviewer-earning";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerEarning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerEarning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfPayrollResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfPayrollResponseDto>;
        }));
    }

    protected processGetReviewerEarning(response: HttpResponseBase): Observable<ApplicationResultOfListOfPayrollResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfPayrollResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Reviewer Compensation and Notification
     */
    updateReviewerCompensationAndNotification(command: UpdateReviewerCompensationAndNotificationCommand): Observable<ApplicationResultOfProfileSaveResultDto> {
        let url_ = this.baseUrl + "/api/reviewer/update-reviewer-compensation-and-notification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewerCompensationAndNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewerCompensationAndNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfProfileSaveResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfProfileSaveResultDto>;
        }));
    }

    protected processUpdateReviewerCompensationAndNotification(response: HttpResponseBase): Observable<ApplicationResultOfProfileSaveResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfProfileSaveResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Pay Rates
     */
    getPayRatesForReviewer(): Observable<ApplicationResultOfListOfReviewerPayRateDto> {
        let url_ = this.baseUrl + "/api/reviewer/get-reviewer-payrates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayRatesForReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayRatesForReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerPayRateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerPayRateDto>;
        }));
    }

    protected processGetPayRatesForReviewer(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerPayRateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerPayRateDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Reviewer Pay Rates
     */
    deletePayRatesForReviewer(command: DeleteReviewerPayRatesCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewer/delete-reviewer-payrates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePayRatesForReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePayRatesForReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeletePayRatesForReviewer(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save Reviewer Policies
     */
    saveReviewerPolicies(command: SaveReviewerPolicyCommand): Observable<ApplicationResultOfReviewerProfileValidationResult> {
        let url_ = this.baseUrl + "/api/reviewer/save-reviewer-policies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveReviewerPolicies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveReviewerPolicies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerProfileValidationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerProfileValidationResult>;
        }));
    }

    protected processSaveReviewerPolicies(response: HttpResponseBase): Observable<ApplicationResultOfReviewerProfileValidationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerProfileValidationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Profile
     */
    getReviewerProfile(): Observable<ApplicationResultOfReviewerProfileDto> {
        let url_ = this.baseUrl + "/api/reviewer/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerProfileDto>;
        }));
    }

    protected processGetReviewerProfile(response: HttpResponseBase): Observable<ApplicationResultOfReviewerProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerProfileDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validate Reviewer Profile
     */
    validateReviewerProfile(): Observable<ApplicationResultOfReviewerProfileValidationResult> {
        let url_ = this.baseUrl + "/api/reviewer/validate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateReviewerProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateReviewerProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerProfileValidationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerProfileValidationResult>;
        }));
    }

    protected processValidateReviewerProfile(response: HttpResponseBase): Observable<ApplicationResultOfReviewerProfileValidationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerProfileValidationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Dashboard cards
     */
    getDashboard(): Observable<ApplicationResultOfReviewerDashboardDto> {
        let url_ = this.baseUrl + "/api/reviewer/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerDashboardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerDashboardDto>;
        }));
    }

    protected processGetDashboard(response: HttpResponseBase): Observable<ApplicationResultOfReviewerDashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerDashboardDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Reviewer barmembership
     */
    deleteBarMembershipForReviewer(command: DeleteReviewerBarMembershipCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewer/delete-reviewer-barmembership";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBarMembershipForReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBarMembershipForReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteBarMembershipForReviewer(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Dashboard cards
     */
    getReviewerSelectedRoles(): Observable<ApplicationResultOfListOfLookUpDto> {
        let url_ = this.baseUrl + "/api/reviewer/get-reviewer-selected-roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerSelectedRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerSelectedRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfLookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfLookUpDto>;
        }));
    }

    protected processGetReviewerSelectedRoles(response: HttpResponseBase): Observable<ApplicationResultOfListOfLookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfLookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send On Boarding Email
     */
    sendReviewerOnBoardEmail(): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewer/send-on-boarding";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendReviewerOnBoardEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendReviewerOnBoardEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processSendReviewerOnBoardEmail(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get reviewer application attachments
     */
    getReviewerApplicationAttachments(reviewerTypeId: number): Observable<ApplicationResultOfListOfDocumentDto> {
        let url_ = this.baseUrl + "/api/reviewer/application-attachments/{reviewerTypeId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerApplicationAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerApplicationAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfDocumentDto>;
        }));
    }

    protected processGetReviewerApplicationAttachments(response: HttpResponseBase): Observable<ApplicationResultOfListOfDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete application attachment
     */
    deleteApplicationAttachment(documentId: number, reviewerTypeId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewer/reviewer-type-attachments/{documentId}/{reviewerTypeId}";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteApplicationAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteApplicationAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteApplicationAttachment(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete resume
     */
    deleteResume(): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewer/resume";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteResume(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteResume(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteResume(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Apply resume data
     */
    applyResumeData(command: ApplyResumeParsedValuesCommand): Observable<ApplicationResultOfApplyResumeParsedValuesResultDto> {
        let url_ = this.baseUrl + "/api/reviewer/resume/data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyResumeData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyResumeData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfApplyResumeParsedValuesResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfApplyResumeParsedValuesResultDto>;
        }));
    }

    protected processApplyResumeData(response: HttpResponseBase): Observable<ApplicationResultOfApplyResumeParsedValuesResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfApplyResumeParsedValuesResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Resume Parsing Data
     */
    getResumeParsingData(documentId: number): Observable<ApplicationResultOfResumeParsingResultDto> {
        let url_ = this.baseUrl + "/api/reviewer/resume/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResumeParsingData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResumeParsingData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfResumeParsingResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfResumeParsingResultDto>;
        }));
    }

    protected processGetResumeParsingData(response: HttpResponseBase): Observable<ApplicationResultOfResumeParsingResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfResumeParsingResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Perks
     * @param query (optional) 
     */
    getReviewerPerks(query?: ReviewerPerksQuery | undefined): Observable<ApplicationResultOfListOfReviewerPerksDto> {
        let url_ = this.baseUrl + "/api/reviewer/perks?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerPerks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerPerks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerPerksDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerPerksDto>;
        }));
    }

    protected processGetReviewerPerks(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerPerksDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerPerksDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Relativity Overall Statistic
     * @param caseId (optional) 
     */
    getOverallMetrics(caseId?: number | null | undefined): Observable<ApplicationResultOfRelativityOverallMetric> {
        let url_ = this.baseUrl + "/api/reviewer/metrics/overall?";
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverallMetrics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverallMetrics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfRelativityOverallMetric>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfRelativityOverallMetric>;
        }));
    }

    protected processGetOverallMetrics(response: HttpResponseBase): Observable<ApplicationResultOfRelativityOverallMetric> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfRelativityOverallMetric;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Relativity Statistic
     * @param fields (optional) 
     */
    getMetrics(fields?: number[] | undefined): Observable<ApplicationResultOfListOfCaseOverallMetricsDto> {
        let url_ = this.baseUrl + "/api/reviewer/metrics?";
        if (fields === null)
            throw new globalThis.Error("The parameter 'fields' cannot be null.");
        else if (fields !== undefined)
            fields && fields.forEach(item => { url_ += "fields=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMetrics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetrics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCaseOverallMetricsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCaseOverallMetricsDto>;
        }));
    }

    protected processGetMetrics(response: HttpResponseBase): Observable<ApplicationResultOfListOfCaseOverallMetricsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCaseOverallMetricsDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case Relativity Statistic
     * @param fields (optional) 
     * @param interval (optional) 
     */
    getMetricsTimeSeries(fields?: number[] | undefined, interval?: CaseMetricsInterval | undefined): Observable<ApplicationResultOfListOfCaseTimeSeriesMetricsDto> {
        let url_ = this.baseUrl + "/api/reviewer/metrics/time-series?";
        if (fields === null)
            throw new globalThis.Error("The parameter 'fields' cannot be null.");
        else if (fields !== undefined)
            fields && fields.forEach(item => { url_ += "fields=" + encodeURIComponent("" + item) + "&"; });
        if (interval === null)
            throw new globalThis.Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMetricsTimeSeries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetricsTimeSeries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCaseTimeSeriesMetricsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCaseTimeSeriesMetricsDto>;
        }));
    }

    protected processGetMetricsTimeSeries(response: HttpResponseBase): Observable<ApplicationResultOfListOfCaseTimeSeriesMetricsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCaseTimeSeriesMetricsDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Case Relativity Statistic
     * @param caseId (optional) 
     */
    getMetricsFieldStatistics(caseId?: number | null | undefined): Observable<ApplicationResultOfListOfRelativityFieldStatisticDto> {
        let url_ = this.baseUrl + "/api/reviewer/metrics/fields?";
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMetricsFieldStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetricsFieldStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRelativityFieldStatisticDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRelativityFieldStatisticDto>;
        }));
    }

    protected processGetMetricsFieldStatistics(response: HttpResponseBase): Observable<ApplicationResultOfListOfRelativityFieldStatisticDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRelativityFieldStatisticDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Relativity Fields
     */
    getMetricFields(): Observable<ApplicationResultOfListOfBaseRelativityFieldDto> {
        let url_ = this.baseUrl + "/api/reviewer/fields";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMetricFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetricFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfBaseRelativityFieldDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfBaseRelativityFieldDto>;
        }));
    }

    protected processGetMetricFields(response: HttpResponseBase): Observable<ApplicationResultOfListOfBaseRelativityFieldDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfBaseRelativityFieldDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Documents
     */
    getDocuments(): Observable<ApplicationResultOfListOfBoldsignDocumentDto> {
        let url_ = this.baseUrl + "/api/reviewer/documents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfBoldsignDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfBoldsignDocumentDto>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<ApplicationResultOfListOfBoldsignDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfBoldsignDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Pending Documents
     */
    getPendingDocuments(): Observable<ApplicationResultOfListOfProjectWithPendingBoldsignDocumentDto> {
        let url_ = this.baseUrl + "/api/reviewer/pending-documents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfProjectWithPendingBoldsignDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfProjectWithPendingBoldsignDocumentDto>;
        }));
    }

    protected processGetPendingDocuments(response: HttpResponseBase): Observable<ApplicationResultOfListOfProjectWithPendingBoldsignDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfProjectWithPendingBoldsignDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Disable Referral Popup
     */
    disableReferralPopup(): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewer/disable-referral-popup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableReferralPopup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableReferralPopup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDisableReferralPopup(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Parse Current Resume
     */
    parseCurrentResume(): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewer/parse-current-resume";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParseCurrentResume(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParseCurrentResume(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processParseCurrentResume(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerExperienceClient {
    /**
     * Get Reviewer Experiences
     */
    getAll(): Observable<ApplicationResultOfListOfReviewerExperienceDto>;
    /**
     * Upsert Reviewer Experience
     */
    upsert(command: UpsertReviewerExperienceCommand): Observable<ApplicationResult>;
    /**
     * Get Reviewer Experience
     */
    get(id: number): Observable<ApplicationResultOfReviewerExperienceDto>;
    /**
     * Delete Reviewer Experience
     */
    delete(id: number): Observable<ApplicationResult>;
    /**
     * Upload Reviewer Project History
     * @param file (optional) 
     */
    uploadReviewerProjectHistory(file?: FileParameter | null | undefined): Observable<ApplicationResultOfUploadReviewerProjectHistoryResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerExperienceClient extends ApiClientBase implements IReviewerExperienceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Reviewer Experiences
     */
    getAll(): Observable<ApplicationResultOfListOfReviewerExperienceDto> {
        let url_ = this.baseUrl + "/api/reviewerExperience";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerExperienceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerExperienceDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerExperienceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerExperienceDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upsert Reviewer Experience
     */
    upsert(command: UpsertReviewerExperienceCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerExperience";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Experience
     */
    get(id: number): Observable<ApplicationResultOfReviewerExperienceDto> {
        let url_ = this.baseUrl + "/api/reviewerExperience/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerExperienceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerExperienceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApplicationResultOfReviewerExperienceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerExperienceDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Reviewer Experience
     */
    delete(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerExperience/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload Reviewer Project History
     * @param file (optional) 
     */
    uploadReviewerProjectHistory(file?: FileParameter | null | undefined): Observable<ApplicationResultOfUploadReviewerProjectHistoryResponse> {
        let url_ = this.baseUrl + "/api/reviewerExperience/upload-reviewer-project-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadReviewerProjectHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadReviewerProjectHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfUploadReviewerProjectHistoryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfUploadReviewerProjectHistoryResponse>;
        }));
    }

    protected processUploadReviewerProjectHistory(response: HttpResponseBase): Observable<ApplicationResultOfUploadReviewerProjectHistoryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfUploadReviewerProjectHistoryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerInvitationClient {
    /**
     * Get Invite for project
     */
    getForProject(reviewerTypeId: number): Observable<ApplicationResultOfReviewerTypeInvitationDto>;
    /**
     * Get Available Reviewers
     */
    getAvailableReviewers(reviewerTypeId: number): Observable<ApplicationResultOfListOfReviewerAvailableDto>;
    /**
     * Get Last Invite
     */
    getLastInvite(): Observable<ApplicationResultOfReviewerTypeInvitationDto>;
    /**
     * Invite Reviewers
     */
    inviteReviewers(reviewerTypeId: number, command: InviteReviewersCommand): Observable<ApplicationResultOfInviteReviewersResultDto>;
    /**
     * Invite Favorite Reviewers
     */
    inviteFavoriteReviewers(reviewerTypeId: number, command: InviteFavoriteReviewersCommand): Observable<ApplicationResultOfInviteReviewersResultDto>;
    /**
     * Get Matched Reviewers
     */
    getMatchedReviewers(reviewerTypeId: number): Observable<ApplicationResultOfListOfReviewerAvailableDto>;
    /**
     * Invite Matched Reviewers
     */
    inviteMatchedReviewers(command: InviteMatchedReviewersCommand): Observable<ApplicationResultOfInviteReviewersResultDto>;
    /**
     * Invite Reviewers by Emails
     */
    inviteByEmails(reviewerTypeId: number, command: InviteReviewersByEmailsCommand): Observable<ApplicationResultOfInviteReviewersByEmailResultDto>;
    /**
     * Revoke Invite
     */
    revokeInvite(id: number): Observable<ApplicationResult>;
    /**
     * Revoke Invite
     */
    revokeInvites(command: RevokeReviewerInvitationBulkCommand): Observable<ApplicationResult>;
    /**
     * Decline Invite
     */
    declineInvite(id: number): Observable<ApplicationResult>;
    /**
     * Withdraw Decline Invite
     */
    withdrawDeclineInvite(command: WithdrawDeclineReviewerTypeInvitationCommand): Observable<ApplicationResult>;
    /**
     * Accept Invite
     */
    acceptInvite(id: number): Observable<ApplicationResult>;
    /**
     * Resend Invite
     */
    resendInvite(id: number): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerInvitationClient extends ApiClientBase implements IReviewerInvitationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Invite for project
     */
    getForProject(reviewerTypeId: number): Observable<ApplicationResultOfReviewerTypeInvitationDto> {
        let url_ = this.baseUrl + "/api/reviewerInvitation/forProject/{reviewerTypeId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTypeInvitationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTypeInvitationDto>;
        }));
    }

    protected processGetForProject(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTypeInvitationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTypeInvitationDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Available Reviewers
     */
    getAvailableReviewers(reviewerTypeId: number): Observable<ApplicationResultOfListOfReviewerAvailableDto> {
        let url_ = this.baseUrl + "/api/reviewerInvitation/reviewers/{reviewerTypeId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerAvailableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerAvailableDto>;
        }));
    }

    protected processGetAvailableReviewers(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerAvailableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerAvailableDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Last Invite
     */
    getLastInvite(): Observable<ApplicationResultOfReviewerTypeInvitationDto> {
        let url_ = this.baseUrl + "/api/reviewerInvitation/last";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTypeInvitationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTypeInvitationDto>;
        }));
    }

    protected processGetLastInvite(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTypeInvitationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTypeInvitationDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Invite Reviewers
     */
    inviteReviewers(reviewerTypeId: number, command: InviteReviewersCommand): Observable<ApplicationResultOfInviteReviewersResultDto> {
        let url_ = this.baseUrl + "/api/reviewerInvitation/{reviewerTypeId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfInviteReviewersResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfInviteReviewersResultDto>;
        }));
    }

    protected processInviteReviewers(response: HttpResponseBase): Observable<ApplicationResultOfInviteReviewersResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfInviteReviewersResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Invite Favorite Reviewers
     */
    inviteFavoriteReviewers(reviewerTypeId: number, command: InviteFavoriteReviewersCommand): Observable<ApplicationResultOfInviteReviewersResultDto> {
        let url_ = this.baseUrl + "/api/reviewerInvitation/{reviewerTypeId}/favorite";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteFavoriteReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteFavoriteReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfInviteReviewersResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfInviteReviewersResultDto>;
        }));
    }

    protected processInviteFavoriteReviewers(response: HttpResponseBase): Observable<ApplicationResultOfInviteReviewersResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfInviteReviewersResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Matched Reviewers
     */
    getMatchedReviewers(reviewerTypeId: number): Observable<ApplicationResultOfListOfReviewerAvailableDto> {
        let url_ = this.baseUrl + "/api/reviewerInvitation/{reviewerTypeId}/matches";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchedReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchedReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerAvailableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerAvailableDto>;
        }));
    }

    protected processGetMatchedReviewers(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerAvailableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerAvailableDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Invite Matched Reviewers
     */
    inviteMatchedReviewers(command: InviteMatchedReviewersCommand): Observable<ApplicationResultOfInviteReviewersResultDto> {
        let url_ = this.baseUrl + "/api/reviewerInvitation/matches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteMatchedReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteMatchedReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfInviteReviewersResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfInviteReviewersResultDto>;
        }));
    }

    protected processInviteMatchedReviewers(response: HttpResponseBase): Observable<ApplicationResultOfInviteReviewersResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfInviteReviewersResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Invite Reviewers by Emails
     */
    inviteByEmails(reviewerTypeId: number, command: InviteReviewersByEmailsCommand): Observable<ApplicationResultOfInviteReviewersByEmailResultDto> {
        let url_ = this.baseUrl + "/api/reviewerInvitation/{reviewerTypeId}/emails";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteByEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteByEmails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfInviteReviewersByEmailResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfInviteReviewersByEmailResultDto>;
        }));
    }

    protected processInviteByEmails(response: HttpResponseBase): Observable<ApplicationResultOfInviteReviewersByEmailResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfInviteReviewersByEmailResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Revoke Invite
     */
    revokeInvite(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerInvitation/revoke/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokeInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processRevokeInvite(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Revoke Invite
     */
    revokeInvites(command: RevokeReviewerInvitationBulkCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerInvitation/revoke/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokeInvites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeInvites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processRevokeInvites(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Decline Invite
     */
    declineInvite(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerInvitation/decline/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeclineInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeclineInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeclineInvite(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Withdraw Decline Invite
     */
    withdrawDeclineInvite(command: WithdrawDeclineReviewerTypeInvitationCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerInvitation/withdrawDecline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithdrawDeclineInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithdrawDeclineInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processWithdrawDeclineInvite(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Accept Invite
     */
    acceptInvite(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerInvitation/accept/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processAcceptInvite(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resend Invite
     */
    resendInvite(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerInvitation/resend/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processResendInvite(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerLanguageTestClient {
    /**
     * Get Reviewers Language Tests
     */
    getAll(): Observable<ApplicationResultOfListOfReviewerLanguageTestDto>;
    /**
     * Create Reviewers Language Tests
     */
    createTest(command: CreateReviewerLanguageTestCommand): Observable<ApplicationResultOfReviewerLanguageTestDto>;
    /**
     * Update Reviewers Language Tests
     */
    updateTest(id: number, command: UpdateReviewerLanguageTestCommand): Observable<ApplicationResultOfReviewerLanguageTestDto>;
    /**
     * Delete Reviewers Language Tests
     */
    deleteTest(id: number): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerLanguageTestClient extends ApiClientBase implements IReviewerLanguageTestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Reviewers Language Tests
     */
    getAll(): Observable<ApplicationResultOfListOfReviewerLanguageTestDto> {
        let url_ = this.baseUrl + "/api/reviewerLanguageTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerLanguageTestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerLanguageTestDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerLanguageTestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerLanguageTestDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Reviewers Language Tests
     */
    createTest(command: CreateReviewerLanguageTestCommand): Observable<ApplicationResultOfReviewerLanguageTestDto> {
        let url_ = this.baseUrl + "/api/reviewerLanguageTest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerLanguageTestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerLanguageTestDto>;
        }));
    }

    protected processCreateTest(response: HttpResponseBase): Observable<ApplicationResultOfReviewerLanguageTestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerLanguageTestDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Reviewers Language Tests
     */
    updateTest(id: number, command: UpdateReviewerLanguageTestCommand): Observable<ApplicationResultOfReviewerLanguageTestDto> {
        let url_ = this.baseUrl + "/api/reviewerLanguageTest/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerLanguageTestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerLanguageTestDto>;
        }));
    }

    protected processUpdateTest(response: HttpResponseBase): Observable<ApplicationResultOfReviewerLanguageTestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerLanguageTestDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Reviewers Language Tests
     */
    deleteTest(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerLanguageTest/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteTest(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerMatchInviteClient {
    /**
     * UpdateReviewerMatchInviteStatus
     */
    updateReviewerMatchInviteStatusInterested(reviewerTypeId: number): Observable<ApplicationResult>;
    /**
     * UpdateReviewerMatchInviteStatus
     */
    updateReviewerMatchInviteStatusNotInterested(reviewerId: number, reviewerTypeId: number): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerMatchInviteClient extends ApiClientBase implements IReviewerMatchInviteClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * UpdateReviewerMatchInviteStatus
     */
    updateReviewerMatchInviteStatusInterested(reviewerTypeId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerMatchInvite/{reviewerTypeId}/interested";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewerMatchInviteStatusInterested(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewerMatchInviteStatusInterested(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateReviewerMatchInviteStatusInterested(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * UpdateReviewerMatchInviteStatus
     */
    updateReviewerMatchInviteStatusNotInterested(reviewerId: number, reviewerTypeId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerMatchInvite/{reviewerId}/{reviewerTypeId}/not-interested";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewerMatchInviteStatusNotInterested(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewerMatchInviteStatusNotInterested(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateReviewerMatchInviteStatusNotInterested(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerPlatformTimeClient {
    /**
     * Get Platform Time For Reviewer and Reviewer Type
     * @param reviewerTypeId (optional) 
     */
    getReviewerReviewerTypePlatformTime(reviewerId: number, reviewerTypeId?: number | undefined): Observable<ApplicationResultOfListOfReviewerPlatformTimeDto>;
    /**
     * Get Platform Time For Reviewer and Company
     * @param companyId (optional) 
     */
    getReviewerCompanyPlatformTime(reviewerId: number, companyId?: number | undefined): Observable<ApplicationResultOfListOfReviewerPlatformTimeDto>;
    /**
     * Get Platform Time For Reviewer and Case
     * @param caseId (optional) 
     */
    getReviewerCasePlatformTime(reviewerId: number, caseId?: number | undefined): Observable<ApplicationResultOfListOfReviewerPlatformTimeDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerPlatformTimeClient extends ApiClientBase implements IReviewerPlatformTimeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Platform Time For Reviewer and Reviewer Type
     * @param reviewerTypeId (optional) 
     */
    getReviewerReviewerTypePlatformTime(reviewerId: number, reviewerTypeId?: number | undefined): Observable<ApplicationResultOfListOfReviewerPlatformTimeDto> {
        let url_ = this.baseUrl + "/api/reviewerPlatformTime/{reviewerId}/reviewerType?";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        if (reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' cannot be null.");
        else if (reviewerTypeId !== undefined)
            url_ += "reviewerTypeId=" + encodeURIComponent("" + reviewerTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerReviewerTypePlatformTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerReviewerTypePlatformTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerPlatformTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerPlatformTimeDto>;
        }));
    }

    protected processGetReviewerReviewerTypePlatformTime(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerPlatformTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerPlatformTimeDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Platform Time For Reviewer and Company
     * @param companyId (optional) 
     */
    getReviewerCompanyPlatformTime(reviewerId: number, companyId?: number | undefined): Observable<ApplicationResultOfListOfReviewerPlatformTimeDto> {
        let url_ = this.baseUrl + "/api/reviewerPlatformTime/{reviewerId}/company?";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerCompanyPlatformTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerCompanyPlatformTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerPlatformTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerPlatformTimeDto>;
        }));
    }

    protected processGetReviewerCompanyPlatformTime(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerPlatformTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerPlatformTimeDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Platform Time For Reviewer and Case
     * @param caseId (optional) 
     */
    getReviewerCasePlatformTime(reviewerId: number, caseId?: number | undefined): Observable<ApplicationResultOfListOfReviewerPlatformTimeDto> {
        let url_ = this.baseUrl + "/api/reviewerPlatformTime/{reviewerId}/case?";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        if (caseId === null)
            throw new globalThis.Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerCasePlatformTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerCasePlatformTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerPlatformTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerPlatformTimeDto>;
        }));
    }

    protected processGetReviewerCasePlatformTime(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerPlatformTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerPlatformTimeDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerReviewerTypeClient {
    /**
     * Get Reviewer Spans
     */
    getReviewerSpans(reviewerReviewerTypeId: number): Observable<ApplicationResultOfListOfReviewerReviewerTypeSpanListDto>;
    /**
     * Get Current Span
     */
    getCurrentSpan(reviewerReviewerTypeId: number): Observable<ApplicationResultOfReviewerReviewerTypeSpanDto>;
    /**
     * Get Span
     */
    getReviewerSpan(reviewerTypeId: number, reviewerId: number): Observable<ApplicationResultOfReviewerReviewerTypeSpanDto>;
    /**
     * Update Span
     */
    updateReviewerSpan(command: UpdateReviewerActiveSpanCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerReviewerTypeClient extends ApiClientBase implements IReviewerReviewerTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Reviewer Spans
     */
    getReviewerSpans(reviewerReviewerTypeId: number): Observable<ApplicationResultOfListOfReviewerReviewerTypeSpanListDto> {
        let url_ = this.baseUrl + "/api/reviewerReviewerType/{reviewerReviewerTypeId}/spans";
        if (reviewerReviewerTypeId === undefined || reviewerReviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerReviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerReviewerTypeId}", encodeURIComponent("" + reviewerReviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerSpans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerSpans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerReviewerTypeSpanListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerReviewerTypeSpanListDto>;
        }));
    }

    protected processGetReviewerSpans(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerReviewerTypeSpanListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerReviewerTypeSpanListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Current Span
     */
    getCurrentSpan(reviewerReviewerTypeId: number): Observable<ApplicationResultOfReviewerReviewerTypeSpanDto> {
        let url_ = this.baseUrl + "/api/reviewerReviewerType/{reviewerReviewerTypeId}/currentSpan";
        if (reviewerReviewerTypeId === undefined || reviewerReviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerReviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerReviewerTypeId}", encodeURIComponent("" + reviewerReviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentSpan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentSpan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerReviewerTypeSpanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerReviewerTypeSpanDto>;
        }));
    }

    protected processGetCurrentSpan(response: HttpResponseBase): Observable<ApplicationResultOfReviewerReviewerTypeSpanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerReviewerTypeSpanDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Span
     */
    getReviewerSpan(reviewerTypeId: number, reviewerId: number): Observable<ApplicationResultOfReviewerReviewerTypeSpanDto> {
        let url_ = this.baseUrl + "/api/reviewerReviewerType/{reviewerTypeId}/{reviewerId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerSpan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerSpan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerReviewerTypeSpanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerReviewerTypeSpanDto>;
        }));
    }

    protected processGetReviewerSpan(response: HttpResponseBase): Observable<ApplicationResultOfReviewerReviewerTypeSpanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerReviewerTypeSpanDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Span
     */
    updateReviewerSpan(command: UpdateReviewerActiveSpanCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerReviewerType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewerSpan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewerSpan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateReviewerSpan(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerSummaryClient {
    /**
     * Get Reviewer Summary
     * @param reviewerTypeId (optional) 
     * @param dateWorked (optional) 
     */
    getReviewerSummaryByDate(reviewerTypeId?: number | undefined, dateWorked?: Date | undefined): Observable<ApplicationResultOfReviewerSummaryDto>;
    /**
     * Get Reviewer Summaries
     */
    getReviewerSummaries(): Observable<ApplicationResultOfListOfReviewerSummaryDto>;
    /**
     * Update Reviewer Summary
     * @param id (optional) 
     */
    upsertReviewerSummary(command: UpsertReviewerSummaryCommand, id?: number | undefined): Observable<ApplicationResult>;
    /**
     * Get Reviewer Missing Summaries
     */
    getReviewerMissingSummaries(): Observable<ApplicationResultOfListOfReviewerSummaryMissingDto>;
    /**
     * Get Reviewer Cases
     */
    getReviewerCases(): Observable<ApplicationResultOfListOfReviewerSummaryCaseDto>;
    /**
     * Delete Reviewer Summary
     */
    deleteReviewerSummary(id: number): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerSummaryClient extends ApiClientBase implements IReviewerSummaryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Reviewer Summary
     * @param reviewerTypeId (optional) 
     * @param dateWorked (optional) 
     */
    getReviewerSummaryByDate(reviewerTypeId?: number | undefined, dateWorked?: Date | undefined): Observable<ApplicationResultOfReviewerSummaryDto> {
        let url_ = this.baseUrl + "/api/reviewerSummary/daily?";
        if (reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' cannot be null.");
        else if (reviewerTypeId !== undefined)
            url_ += "ReviewerTypeId=" + encodeURIComponent("" + reviewerTypeId) + "&";
        if (dateWorked === null)
            throw new globalThis.Error("The parameter 'dateWorked' cannot be null.");
        else if (dateWorked !== undefined)
            url_ += "DateWorked=" + encodeURIComponent(dateWorked ? "" + dateWorked.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerSummaryByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerSummaryByDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerSummaryDto>;
        }));
    }

    protected processGetReviewerSummaryByDate(response: HttpResponseBase): Observable<ApplicationResultOfReviewerSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Summaries
     */
    getReviewerSummaries(): Observable<ApplicationResultOfListOfReviewerSummaryDto> {
        let url_ = this.baseUrl + "/api/reviewerSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerSummaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerSummaries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerSummaryDto>;
        }));
    }

    protected processGetReviewerSummaries(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Reviewer Summary
     * @param id (optional) 
     */
    upsertReviewerSummary(command: UpsertReviewerSummaryCommand, id?: number | undefined): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerSummary?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertReviewerSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertReviewerSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpsertReviewerSummary(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Missing Summaries
     */
    getReviewerMissingSummaries(): Observable<ApplicationResultOfListOfReviewerSummaryMissingDto> {
        let url_ = this.baseUrl + "/api/reviewerSummary/missing";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerMissingSummaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerMissingSummaries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerSummaryMissingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerSummaryMissingDto>;
        }));
    }

    protected processGetReviewerMissingSummaries(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerSummaryMissingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerSummaryMissingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Cases
     */
    getReviewerCases(): Observable<ApplicationResultOfListOfReviewerSummaryCaseDto> {
        let url_ = this.baseUrl + "/api/reviewerSummary/cases";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerCases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerCases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerSummaryCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerSummaryCaseDto>;
        }));
    }

    protected processGetReviewerCases(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerSummaryCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerSummaryCaseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Reviewer Summary
     */
    deleteReviewerSummary(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerSummary/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReviewerSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReviewerSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteReviewerSummary(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerTagClient {
    /**
     * Get Reviewer Tags
     * @param includeArchived (optional) 
     * @param caseId (optional) 
     * @param onlyCaseTags (optional) 
     */
    getReviewerTags(includeArchived?: boolean | undefined, caseId?: number | null | undefined, onlyCaseTags?: boolean | undefined): Observable<ApplicationResultOfListOfReviewerTagDto>;
    /**
     * Create Reviewer Tag
     */
    createReviewerTag(command: CreateReviewerTagCommand): Observable<ApplicationResultOfReviewerTagDto>;
    /**
     * Create and Select Reviewer Tag
     */
    createAndSelectReviewerTag(command: CreateAndSelectReviewerTagCommand): Observable<ApplicationResultOfReviewerTagDto>;
    /**
     * Update Reviewer Tag
     */
    updateReviewerTag(id: number, command: UpdateReviewerTagCommand): Observable<ApplicationResultOfReviewerTagDto>;
    /**
     * Delete Reviewer Tag
     */
    deleteReviewerTag(id: number): Observable<ApplicationResult>;
    /**
     * Archive Reviewer Tag
     */
    archiveReviewerTag(id: number, command: ArchiveReviewerTagCommand): Observable<ApplicationResult>;
    /**
     * Batch Update Reviewer Type Tags
     */
    batchUpdateReviewerReviewerTypeTags(reviewerReviewerTypeId: number, command: BatchUpdateReviewerReviewerTypeTagsCommand): Observable<ApplicationResultOfListOfInteger>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerTagClient extends ApiClientBase implements IReviewerTagClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Reviewer Tags
     * @param includeArchived (optional) 
     * @param caseId (optional) 
     * @param onlyCaseTags (optional) 
     */
    getReviewerTags(includeArchived?: boolean | undefined, caseId?: number | null | undefined, onlyCaseTags?: boolean | undefined): Observable<ApplicationResultOfListOfReviewerTagDto> {
        let url_ = this.baseUrl + "/api/reviewerTag?";
        if (includeArchived === null)
            throw new globalThis.Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "IncludeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        if (caseId !== undefined && caseId !== null)
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (onlyCaseTags === null)
            throw new globalThis.Error("The parameter 'onlyCaseTags' cannot be null.");
        else if (onlyCaseTags !== undefined)
            url_ += "OnlyCaseTags=" + encodeURIComponent("" + onlyCaseTags) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerTagDto>;
        }));
    }

    protected processGetReviewerTags(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerTagDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Reviewer Tag
     */
    createReviewerTag(command: CreateReviewerTagCommand): Observable<ApplicationResultOfReviewerTagDto> {
        let url_ = this.baseUrl + "/api/reviewerTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReviewerTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReviewerTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTagDto>;
        }));
    }

    protected processCreateReviewerTag(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTagDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create and Select Reviewer Tag
     */
    createAndSelectReviewerTag(command: CreateAndSelectReviewerTagCommand): Observable<ApplicationResultOfReviewerTagDto> {
        let url_ = this.baseUrl + "/api/reviewerTag/create-and-select";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndSelectReviewerTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndSelectReviewerTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTagDto>;
        }));
    }

    protected processCreateAndSelectReviewerTag(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTagDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Reviewer Tag
     */
    updateReviewerTag(id: number, command: UpdateReviewerTagCommand): Observable<ApplicationResultOfReviewerTagDto> {
        let url_ = this.baseUrl + "/api/reviewerTag/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewerTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewerTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTagDto>;
        }));
    }

    protected processUpdateReviewerTag(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTagDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Reviewer Tag
     */
    deleteReviewerTag(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerTag/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReviewerTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReviewerTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteReviewerTag(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Archive Reviewer Tag
     */
    archiveReviewerTag(id: number, command: ArchiveReviewerTagCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerTag/{id}/archive";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveReviewerTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveReviewerTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processArchiveReviewerTag(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Batch Update Reviewer Type Tags
     */
    batchUpdateReviewerReviewerTypeTags(reviewerReviewerTypeId: number, command: BatchUpdateReviewerReviewerTypeTagsCommand): Observable<ApplicationResultOfListOfInteger> {
        let url_ = this.baseUrl + "/api/reviewerTag/reviewer-reviewer-type/{reviewerReviewerTypeId}/tags/batch";
        if (reviewerReviewerTypeId === undefined || reviewerReviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerReviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerReviewerTypeId}", encodeURIComponent("" + reviewerReviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchUpdateReviewerReviewerTypeTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchUpdateReviewerReviewerTypeTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfInteger>;
        }));
    }

    protected processBatchUpdateReviewerReviewerTypeTags(response: HttpResponseBase): Observable<ApplicationResultOfListOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfInteger;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerTimeEntryEarningClient {
    /**
     * Get Reviewer Time Entry Earnings
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param lookback (optional) 
     * @param caseIds (optional) 
     */
    getReviewerTimeEntryEarnings(dateFrom?: Date | undefined, dateTo?: Date | undefined, lookback?: number | undefined, caseIds?: number[] | undefined): Observable<ApplicationResultOfForecastChartDto>;
    /**
     * Get Reviewer Time Entry Earnings
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param lookback (optional) 
     */
    getReviewerTimeEntryEarningsByCase(caseId: number, dateFrom?: Date | undefined, dateTo?: Date | undefined, lookback?: number | undefined): Observable<ApplicationResultOfForecastChartDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerTimeEntryEarningClient extends ApiClientBase implements IReviewerTimeEntryEarningClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Reviewer Time Entry Earnings
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param lookback (optional) 
     * @param caseIds (optional) 
     */
    getReviewerTimeEntryEarnings(dateFrom?: Date | undefined, dateTo?: Date | undefined, lookback?: number | undefined, caseIds?: number[] | undefined): Observable<ApplicationResultOfForecastChartDto> {
        let url_ = this.baseUrl + "/api/reviewerTimeEntryEarning?";
        if (dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (lookback === null)
            throw new globalThis.Error("The parameter 'lookback' cannot be null.");
        else if (lookback !== undefined)
            url_ += "lookback=" + encodeURIComponent("" + lookback) + "&";
        if (caseIds === null)
            throw new globalThis.Error("The parameter 'caseIds' cannot be null.");
        else if (caseIds !== undefined)
            caseIds && caseIds.forEach(item => { url_ += "caseIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerTimeEntryEarnings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerTimeEntryEarnings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfForecastChartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfForecastChartDto>;
        }));
    }

    protected processGetReviewerTimeEntryEarnings(response: HttpResponseBase): Observable<ApplicationResultOfForecastChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfForecastChartDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Time Entry Earnings
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param lookback (optional) 
     */
    getReviewerTimeEntryEarningsByCase(caseId: number, dateFrom?: Date | undefined, dateTo?: Date | undefined, lookback?: number | undefined): Observable<ApplicationResultOfForecastChartDto> {
        let url_ = this.baseUrl + "/api/reviewerTimeEntryEarning/{caseId}?";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (lookback === null)
            throw new globalThis.Error("The parameter 'lookback' cannot be null.");
        else if (lookback !== undefined)
            url_ += "lookback=" + encodeURIComponent("" + lookback) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerTimeEntryEarningsByCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerTimeEntryEarningsByCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfForecastChartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfForecastChartDto>;
        }));
    }

    protected processGetReviewerTimeEntryEarningsByCase(response: HttpResponseBase): Observable<ApplicationResultOfForecastChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfForecastChartDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerTypeAssignmentClient {
    /**
     * Get Case Reviewer Type Assignments
     * @param weekOfYear (optional) 
     * @param year (optional) 
     */
    getCaseReviewerTypeAssignments(weekOfYear?: number | undefined, year?: number | undefined): Observable<ApplicationResultOfGroupedReviewerTypeAssignmentsDto>;
    /**
     * Update Reviewer Type Assignment
     */
    updateReviewerTypeAssignment(command: UpdateReviewerTypeAssignmentCommand): Observable<ApplicationResult>;
    /**
     * Update Week Assignment
     */
    updateReviewerTypeReviewerAssignments(command: UpdateReviewerTypeReviewerAssignmentsCommand): Observable<ApplicationResult>;
    /**
     * Update Reviewer Assignment
     */
    updateReviewerAssignment(command: UpdateReviewerTypeReviewerAssignmentCommand): Observable<ApplicationResult>;
    /**
     * Auto Assign Reviewer Assignments
     */
    autoAssign(command: AutoAssignReviewerTypeAssignmentsCommand): Observable<ApplicationResultOfListOfGroupedReviewerTypeAssignmentReviewerDto>;
    /**
     * Auto Assign Reviewer Assignments
     */
    applyAssignments(command: ApplyReviewerReviewerTypeAllocationsCommand): Observable<ApplicationResult>;
    /**
     * Get Allocation Assignments
     * @param startWeekOfYear (optional) 
     * @param startYear (optional) 
     * @param weekCount (optional) 
     */
    allocationAssignments(startWeekOfYear?: number | undefined, startYear?: number | undefined, weekCount?: number | undefined): Observable<ApplicationResultOfAllocationAssignmentsDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerTypeAssignmentClient extends ApiClientBase implements IReviewerTypeAssignmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Case Reviewer Type Assignments
     * @param weekOfYear (optional) 
     * @param year (optional) 
     */
    getCaseReviewerTypeAssignments(weekOfYear?: number | undefined, year?: number | undefined): Observable<ApplicationResultOfGroupedReviewerTypeAssignmentsDto> {
        let url_ = this.baseUrl + "/api/reviewerTypeAssignment/case?";
        if (weekOfYear === null)
            throw new globalThis.Error("The parameter 'weekOfYear' cannot be null.");
        else if (weekOfYear !== undefined)
            url_ += "WeekOfYear=" + encodeURIComponent("" + weekOfYear) + "&";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseReviewerTypeAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseReviewerTypeAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfGroupedReviewerTypeAssignmentsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfGroupedReviewerTypeAssignmentsDto>;
        }));
    }

    protected processGetCaseReviewerTypeAssignments(response: HttpResponseBase): Observable<ApplicationResultOfGroupedReviewerTypeAssignmentsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfGroupedReviewerTypeAssignmentsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Reviewer Type Assignment
     */
    updateReviewerTypeAssignment(command: UpdateReviewerTypeAssignmentCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerTypeAssignment/reviewer-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewerTypeAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewerTypeAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateReviewerTypeAssignment(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Week Assignment
     */
    updateReviewerTypeReviewerAssignments(command: UpdateReviewerTypeReviewerAssignmentsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerTypeAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewerTypeReviewerAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewerTypeReviewerAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateReviewerTypeReviewerAssignments(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Reviewer Assignment
     */
    updateReviewerAssignment(command: UpdateReviewerTypeReviewerAssignmentCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerTypeAssignment/reviewer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewerAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewerAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateReviewerAssignment(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Auto Assign Reviewer Assignments
     */
    autoAssign(command: AutoAssignReviewerTypeAssignmentsCommand): Observable<ApplicationResultOfListOfGroupedReviewerTypeAssignmentReviewerDto> {
        let url_ = this.baseUrl + "/api/reviewerTypeAssignment/auto-assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAutoAssign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAutoAssign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfGroupedReviewerTypeAssignmentReviewerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfGroupedReviewerTypeAssignmentReviewerDto>;
        }));
    }

    protected processAutoAssign(response: HttpResponseBase): Observable<ApplicationResultOfListOfGroupedReviewerTypeAssignmentReviewerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfGroupedReviewerTypeAssignmentReviewerDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Auto Assign Reviewer Assignments
     */
    applyAssignments(command: ApplyReviewerReviewerTypeAllocationsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerTypeAssignment/apply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processApplyAssignments(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Allocation Assignments
     * @param startWeekOfYear (optional) 
     * @param startYear (optional) 
     * @param weekCount (optional) 
     */
    allocationAssignments(startWeekOfYear?: number | undefined, startYear?: number | undefined, weekCount?: number | undefined): Observable<ApplicationResultOfAllocationAssignmentsDto> {
        let url_ = this.baseUrl + "/api/reviewerTypeAssignment/allocation-assignments?";
        if (startWeekOfYear === null)
            throw new globalThis.Error("The parameter 'startWeekOfYear' cannot be null.");
        else if (startWeekOfYear !== undefined)
            url_ += "StartWeekOfYear=" + encodeURIComponent("" + startWeekOfYear) + "&";
        if (startYear === null)
            throw new globalThis.Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined)
            url_ += "StartYear=" + encodeURIComponent("" + startYear) + "&";
        if (weekCount === null)
            throw new globalThis.Error("The parameter 'weekCount' cannot be null.");
        else if (weekCount !== undefined)
            url_ += "WeekCount=" + encodeURIComponent("" + weekCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllocationAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllocationAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAllocationAssignmentsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAllocationAssignmentsDto>;
        }));
    }

    protected processAllocationAssignments(response: HttpResponseBase): Observable<ApplicationResultOfAllocationAssignmentsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAllocationAssignmentsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerTypeClient {
    /**
     * Reviewer Type
     */
    create(command: CreateReviewerTypeCommand): Observable<ApplicationResultOfReviewerTypeListDto>;
    /**
     * Reviewer Type
     */
    update(reviewerTypeId: number, command: UpdateReviewerTypeCommand): Observable<ApplicationResultOfReviewerTypeListDto>;
    /**
     * Reviewer Type
     */
    get(reviewerTypeId: number): Observable<ApplicationResultOfReviewerTypeDto>;
    /**
     * Delete Reviewer Type
     */
    deleteReviewerType(reviewerTypeId: number): Observable<ApplicationResult>;
    /**
     * Reviewer Type For Case
     */
    getForCase(caseId: number): Observable<ApplicationResultOfListOfReviewerTypeListDto>;
    /**
     * Get Active Reviewer Types For Case
     */
    getActiveForCase(caseId: number, reviewerId: number): Observable<ApplicationResultOfListOfReviewerTypeActiveDto>;
    /**
     * Get Active Reviewer Types For Case
     */
    getEligibleReviewerTypesForReviewerCase(caseId: number, reviewerId: number): Observable<ApplicationResultOfListOfReviewerTypeActiveDto>;
    /**
     * Get Active Reviewer Types For Case
     */
    getEligibleReviewerTypesForCase(caseId: number): Observable<ApplicationResultOfListOfReviewerTypeActiveDto>;
    /**
     * Reviewer Type Requirements
     */
    getReviewerRequirements(reviewerTypeId: number): Observable<ApplicationResultOfReviewerRequirementResponse>;
    /**
     * Reviewer Type
     */
    updateCount(reviewerTypeId: number, command: UpdateReviewersCountCommand): Observable<ApplicationResult>;
    /**
     * Reviewer Type
     */
    updateRate(reviewerTypeId: number, command: UpdateReviewerTypeRateCommand): Observable<ApplicationResult>;
    /**
     * Reviewer Type
     */
    updateClientBudget(reviewerTypeId: number, command: UpdateReviewerTypeClientBudgetCommand): Observable<ApplicationResult>;
    /**
     * Reviewer Type
     */
    calculateClientBudget(reviewerTypeId: number, command: CalculateReviewerTypeClientBudgetCommand): Observable<ApplicationResultOfCalculatedReviewerTypeClientBudgetDto>;
    /**
     * Reviewer Type
     */
    updateDates(reviewerTypeId: number, command: UpdateReviewerTypeDatesCommand): Observable<ApplicationResultOfUpdateReviewerTypeDatesResponse>;
    /**
     * Reviewer Type review likelihood
     */
    updateReviewerTypeReviewLikelihood(reviewerTypeId: number, command: UpdateReviewLikelihoodCommand): Observable<ApplicationResult>;
    /**
     * Get Reviewer Application Attachments
     */
    getReviewerApplicationAttachment(reviewerTypeId: number, reviewerId: number): Observable<ApplicationResultOfListOfDocumentDto>;
    /**
     * Reviewer Type
     */
    deleteDocument(documentId: number): Observable<ApplicationResult>;
    /**
     * Transfer Reviewer to Another Case
     */
    transferReviewer(request: TransferReviewerCommand): Observable<ApplicationResultOfInviteReviewersResultDto>;
    /**
     * Transfer Reviewers to Another Case
     */
    transferReviewers(request: TransferReviewersCommand): Observable<ApplicationResultOfInviteReviewersResultDto>;
    /**
     * Start Reviewer Type
     */
    startReviewerType(reviewerTypeId: number): Observable<ApplicationResult>;
    /**
     * Stop Reviewer Type
     */
    stopReviewerType(reviewerTypeId: number): Observable<ApplicationResult>;
    /**
     * Get Recruitment Statistic
     * @param reviewerTypeId (optional) 
     * @param excludeRequirements (optional) 
     */
    getRecruitmentStatistic(reviewerTypeId?: number | undefined, excludeRequirements?: string[] | undefined): Observable<ApplicationResultOfRecruitmentStatisticDto>;
    /**
     * Get Recruitment Statistic
     */
    calculateRecruitmentStatistic(query: CalculateRecruitmentStatisticCommand): Observable<ApplicationResultOfRecruitmentStatisticDto>;
    /**
     * Get Suggested Rate
     * @param reviewerTypeId (optional) 
     */
    getSuggestedRate(reviewerTypeId?: number | undefined): Observable<ApplicationResultOfSuggestedRateDto>;
    /**
     * Get Reviewer Types for Case
     * @param caseId (optional) 
     * @param isActive (optional) 
     */
    getCaseReviewerTypesForAdmin(caseId?: number | undefined, isActive?: boolean | null | undefined): Observable<ApplicationResultOfListOfLookUpDto>;
    /**
     * Reviewer Type Templates
     */
    getTemplateReviewerTypes(): Observable<ApplicationResultOfListOfReviewerTypeTemplateListDto>;
    /**
     * Leave Reviewer Type
     */
    leaveReviewerType(command: LeaveReviewerTypeCommand): Observable<ApplicationResult>;
    /**
     * Calculate Reviewer Type Projected Cost
     */
    calculateReviewerTypeProjectedCost(query: GetProjectedCostQuery): Observable<ApplicationResultOfReviewerTypeProjectedCostCalculationResult>;
    /**
     * Get Recent RT Contacts
     * @param caseId (optional) 
     */
    getRecentContactsQuery(caseId?: number | undefined): Observable<ApplicationResultOfReviewerTypeContacts>;
    /**
     * Send Follow Up Notifications
     */
    sendFollowUpNotifications(reviewerTypeId: number, command: SendFollowUpNotificationsCommand): Observable<ApplicationResult>;
    /**
     * Cancel Reviewer Type
     */
    cancelReviewerType(reviewerTypeId: number): Observable<ApplicationResult>;
    /**
     * Case
     */
    getReviewerTypeReviewers(reviewerTypeId: number): Observable<ApplicationResultOfReviewerTypeReviewerResponse>;
    /**
     * Get Reviewer Type Priorities
     */
    getReviewerTypePriorities(): Observable<ApplicationResultOfReviewerTypePrioritiesDto>;
    /**
     * Update Reviewer Type Priorities
     */
    updateReviewerTypePriorities(command: UpdateReviewerTypePrioritiesCommand): Observable<ApplicationResult>;
    /**
     * Approve Leave Project Request
     */
    approveLeaveProjectRequest(command: ApproveLeaveProjectRequestCommand): Observable<ApplicationResult>;
    /**
     * Deny Leave Project Request
     */
    denyLeaveProjectRequest(command: DenyLeaveProjectRequestCommand): Observable<ApplicationResult>;
    /**
     * Revoke Leave Reviewer Type Request
     */
    revokeLeaveRequest(command: RevokeLeaveRequestCommand): Observable<ApplicationResult>;
    /**
     * Hold Reviewer Type
     */
    holdReviewerType(command: HoldReviewerTypeCommand): Observable<ApplicationResult>;
    /**
     * Resume Reviewer Type
     */
    resumeReviewerType(command: ResumeReviewerTypeCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerTypeClient extends ApiClientBase implements IReviewerTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Reviewer Type
     */
    create(command: CreateReviewerTypeCommand): Observable<ApplicationResultOfReviewerTypeListDto> {
        let url_ = this.baseUrl + "/api/reviewerType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTypeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTypeListDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTypeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTypeListDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reviewer Type
     */
    update(reviewerTypeId: number, command: UpdateReviewerTypeCommand): Observable<ApplicationResultOfReviewerTypeListDto> {
        let url_ = this.baseUrl + "/api/reviewerType/{reviewerTypeId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTypeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTypeListDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTypeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTypeListDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reviewer Type
     */
    get(reviewerTypeId: number): Observable<ApplicationResultOfReviewerTypeDto> {
        let url_ = this.baseUrl + "/api/reviewerType/{reviewerTypeId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTypeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTypeDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Reviewer Type
     */
    deleteReviewerType(reviewerTypeId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/{reviewerTypeId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReviewerType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReviewerType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteReviewerType(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reviewer Type For Case
     */
    getForCase(caseId: number): Observable<ApplicationResultOfListOfReviewerTypeListDto> {
        let url_ = this.baseUrl + "/api/reviewerType/forCase/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerTypeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerTypeListDto>;
        }));
    }

    protected processGetForCase(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerTypeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerTypeListDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Active Reviewer Types For Case
     */
    getActiveForCase(caseId: number, reviewerId: number): Observable<ApplicationResultOfListOfReviewerTypeActiveDto> {
        let url_ = this.baseUrl + "/api/reviewerType/forCase/{caseId}/active/{reviewerId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveForCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveForCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerTypeActiveDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerTypeActiveDto>;
        }));
    }

    protected processGetActiveForCase(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerTypeActiveDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerTypeActiveDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Active Reviewer Types For Case
     */
    getEligibleReviewerTypesForReviewerCase(caseId: number, reviewerId: number): Observable<ApplicationResultOfListOfReviewerTypeActiveDto> {
        let url_ = this.baseUrl + "/api/reviewerType/forCase/{caseId}/eligible/{reviewerId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEligibleReviewerTypesForReviewerCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEligibleReviewerTypesForReviewerCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerTypeActiveDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerTypeActiveDto>;
        }));
    }

    protected processGetEligibleReviewerTypesForReviewerCase(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerTypeActiveDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerTypeActiveDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Active Reviewer Types For Case
     */
    getEligibleReviewerTypesForCase(caseId: number): Observable<ApplicationResultOfListOfReviewerTypeActiveDto> {
        let url_ = this.baseUrl + "/api/reviewerType/forCase/{caseId}/eligible";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEligibleReviewerTypesForCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEligibleReviewerTypesForCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerTypeActiveDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerTypeActiveDto>;
        }));
    }

    protected processGetEligibleReviewerTypesForCase(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerTypeActiveDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerTypeActiveDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reviewer Type Requirements
     */
    getReviewerRequirements(reviewerTypeId: number): Observable<ApplicationResultOfReviewerRequirementResponse> {
        let url_ = this.baseUrl + "/api/reviewerType/requirements/{reviewerTypeId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerRequirements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerRequirements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerRequirementResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerRequirementResponse>;
        }));
    }

    protected processGetReviewerRequirements(response: HttpResponseBase): Observable<ApplicationResultOfReviewerRequirementResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerRequirementResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reviewer Type
     */
    updateCount(reviewerTypeId: number, command: UpdateReviewersCountCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/{reviewerTypeId}/count";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateCount(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reviewer Type
     */
    updateRate(reviewerTypeId: number, command: UpdateReviewerTypeRateCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/{reviewerTypeId}/rate";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateRate(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reviewer Type
     */
    updateClientBudget(reviewerTypeId: number, command: UpdateReviewerTypeClientBudgetCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/{reviewerTypeId}/client-budget";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClientBudget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClientBudget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateClientBudget(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reviewer Type
     */
    calculateClientBudget(reviewerTypeId: number, command: CalculateReviewerTypeClientBudgetCommand): Observable<ApplicationResultOfCalculatedReviewerTypeClientBudgetDto> {
        let url_ = this.baseUrl + "/api/reviewerType/{reviewerTypeId}/client-budget-calculate";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateClientBudget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateClientBudget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCalculatedReviewerTypeClientBudgetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCalculatedReviewerTypeClientBudgetDto>;
        }));
    }

    protected processCalculateClientBudget(response: HttpResponseBase): Observable<ApplicationResultOfCalculatedReviewerTypeClientBudgetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCalculatedReviewerTypeClientBudgetDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reviewer Type
     */
    updateDates(reviewerTypeId: number, command: UpdateReviewerTypeDatesCommand): Observable<ApplicationResultOfUpdateReviewerTypeDatesResponse> {
        let url_ = this.baseUrl + "/api/reviewerType/{reviewerTypeId}/dates";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfUpdateReviewerTypeDatesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfUpdateReviewerTypeDatesResponse>;
        }));
    }

    protected processUpdateDates(response: HttpResponseBase): Observable<ApplicationResultOfUpdateReviewerTypeDatesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfUpdateReviewerTypeDatesResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reviewer Type review likelihood
     */
    updateReviewerTypeReviewLikelihood(reviewerTypeId: number, command: UpdateReviewLikelihoodCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/{reviewerTypeId}/review-likelihood";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewerTypeReviewLikelihood(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewerTypeReviewLikelihood(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateReviewerTypeReviewLikelihood(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Application Attachments
     */
    getReviewerApplicationAttachment(reviewerTypeId: number, reviewerId: number): Observable<ApplicationResultOfListOfDocumentDto> {
        let url_ = this.baseUrl + "/api/reviewerType/reviewer-attachments/{reviewerTypeId}/{reviewerId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerApplicationAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerApplicationAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfDocumentDto>;
        }));
    }

    protected processGetReviewerApplicationAttachment(response: HttpResponseBase): Observable<ApplicationResultOfListOfDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reviewer Type
     */
    deleteDocument(documentId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/reviewer-type-attachment/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Transfer Reviewer to Another Case
     */
    transferReviewer(request: TransferReviewerCommand): Observable<ApplicationResultOfInviteReviewersResultDto> {
        let url_ = this.baseUrl + "/api/reviewerType/transfer-reviewer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfInviteReviewersResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfInviteReviewersResultDto>;
        }));
    }

    protected processTransferReviewer(response: HttpResponseBase): Observable<ApplicationResultOfInviteReviewersResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfInviteReviewersResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Transfer Reviewers to Another Case
     */
    transferReviewers(request: TransferReviewersCommand): Observable<ApplicationResultOfInviteReviewersResultDto> {
        let url_ = this.baseUrl + "/api/reviewerType/transfer-reviewers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfInviteReviewersResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfInviteReviewersResultDto>;
        }));
    }

    protected processTransferReviewers(response: HttpResponseBase): Observable<ApplicationResultOfInviteReviewersResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfInviteReviewersResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Start Reviewer Type
     */
    startReviewerType(reviewerTypeId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/start/{reviewerTypeId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartReviewerType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartReviewerType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processStartReviewerType(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Stop Reviewer Type
     */
    stopReviewerType(reviewerTypeId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/stop/{reviewerTypeId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStopReviewerType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopReviewerType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processStopReviewerType(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Recruitment Statistic
     * @param reviewerTypeId (optional) 
     * @param excludeRequirements (optional) 
     */
    getRecruitmentStatistic(reviewerTypeId?: number | undefined, excludeRequirements?: string[] | undefined): Observable<ApplicationResultOfRecruitmentStatisticDto> {
        let url_ = this.baseUrl + "/api/reviewerType/recruitment-statistic?";
        if (reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' cannot be null.");
        else if (reviewerTypeId !== undefined)
            url_ += "ReviewerTypeId=" + encodeURIComponent("" + reviewerTypeId) + "&";
        if (excludeRequirements === null)
            throw new globalThis.Error("The parameter 'excludeRequirements' cannot be null.");
        else if (excludeRequirements !== undefined)
            excludeRequirements && excludeRequirements.forEach(item => { url_ += "ExcludeRequirements=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecruitmentStatistic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecruitmentStatistic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfRecruitmentStatisticDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfRecruitmentStatisticDto>;
        }));
    }

    protected processGetRecruitmentStatistic(response: HttpResponseBase): Observable<ApplicationResultOfRecruitmentStatisticDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfRecruitmentStatisticDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Recruitment Statistic
     */
    calculateRecruitmentStatistic(query: CalculateRecruitmentStatisticCommand): Observable<ApplicationResultOfRecruitmentStatisticDto> {
        let url_ = this.baseUrl + "/api/reviewerType/recruitment-statistic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateRecruitmentStatistic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateRecruitmentStatistic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfRecruitmentStatisticDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfRecruitmentStatisticDto>;
        }));
    }

    protected processCalculateRecruitmentStatistic(response: HttpResponseBase): Observable<ApplicationResultOfRecruitmentStatisticDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfRecruitmentStatisticDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Suggested Rate
     * @param reviewerTypeId (optional) 
     */
    getSuggestedRate(reviewerTypeId?: number | undefined): Observable<ApplicationResultOfSuggestedRateDto> {
        let url_ = this.baseUrl + "/api/reviewerType/suggested-rate?";
        if (reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' cannot be null.");
        else if (reviewerTypeId !== undefined)
            url_ += "ReviewerTypeId=" + encodeURIComponent("" + reviewerTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuggestedRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestedRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfSuggestedRateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfSuggestedRateDto>;
        }));
    }

    protected processGetSuggestedRate(response: HttpResponseBase): Observable<ApplicationResultOfSuggestedRateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfSuggestedRateDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Types for Case
     * @param caseId (optional) 
     * @param isActive (optional) 
     */
    getCaseReviewerTypesForAdmin(caseId?: number | undefined, isActive?: boolean | null | undefined): Observable<ApplicationResultOfListOfLookUpDto> {
        let url_ = this.baseUrl + "/api/reviewerType/admin/forCase?";
        if (caseId === null)
            throw new globalThis.Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseReviewerTypesForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseReviewerTypesForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfLookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfLookUpDto>;
        }));
    }

    protected processGetCaseReviewerTypesForAdmin(response: HttpResponseBase): Observable<ApplicationResultOfListOfLookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfLookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reviewer Type Templates
     */
    getTemplateReviewerTypes(): Observable<ApplicationResultOfListOfReviewerTypeTemplateListDto> {
        let url_ = this.baseUrl + "/api/reviewerType/templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateReviewerTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateReviewerTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerTypeTemplateListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerTypeTemplateListDto>;
        }));
    }

    protected processGetTemplateReviewerTypes(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerTypeTemplateListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerTypeTemplateListDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Leave Reviewer Type
     */
    leaveReviewerType(command: LeaveReviewerTypeCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/leave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLeaveReviewerType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeaveReviewerType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processLeaveReviewerType(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Calculate Reviewer Type Projected Cost
     */
    calculateReviewerTypeProjectedCost(query: GetProjectedCostQuery): Observable<ApplicationResultOfReviewerTypeProjectedCostCalculationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/projected-cost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateReviewerTypeProjectedCost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateReviewerTypeProjectedCost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTypeProjectedCostCalculationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTypeProjectedCostCalculationResult>;
        }));
    }

    protected processCalculateReviewerTypeProjectedCost(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTypeProjectedCostCalculationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTypeProjectedCostCalculationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Recent RT Contacts
     * @param caseId (optional) 
     */
    getRecentContactsQuery(caseId?: number | undefined): Observable<ApplicationResultOfReviewerTypeContacts> {
        let url_ = this.baseUrl + "/api/reviewerType/recent-contacts?";
        if (caseId === null)
            throw new globalThis.Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentContactsQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentContactsQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTypeContacts>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTypeContacts>;
        }));
    }

    protected processGetRecentContactsQuery(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTypeContacts> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTypeContacts;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send Follow Up Notifications
     */
    sendFollowUpNotifications(reviewerTypeId: number, command: SendFollowUpNotificationsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/{reviewerTypeId}/send-follow-up-notifications";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendFollowUpNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendFollowUpNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processSendFollowUpNotifications(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel Reviewer Type
     */
    cancelReviewerType(reviewerTypeId: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/{reviewerTypeId}/cancel";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelReviewerType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelReviewerType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processCancelReviewerType(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Case
     */
    getReviewerTypeReviewers(reviewerTypeId: number): Observable<ApplicationResultOfReviewerTypeReviewerResponse> {
        let url_ = this.baseUrl + "/api/reviewerType/{reviewerTypeId}/reviewers";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerTypeReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerTypeReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTypeReviewerResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTypeReviewerResponse>;
        }));
    }

    protected processGetReviewerTypeReviewers(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTypeReviewerResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTypeReviewerResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Type Priorities
     */
    getReviewerTypePriorities(): Observable<ApplicationResultOfReviewerTypePrioritiesDto> {
        let url_ = this.baseUrl + "/api/reviewerType/priorities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerTypePriorities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerTypePriorities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTypePrioritiesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTypePrioritiesDto>;
        }));
    }

    protected processGetReviewerTypePriorities(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTypePrioritiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTypePrioritiesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Reviewer Type Priorities
     */
    updateReviewerTypePriorities(command: UpdateReviewerTypePrioritiesCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/priorities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewerTypePriorities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewerTypePriorities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateReviewerTypePriorities(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Approve Leave Project Request
     */
    approveLeaveProjectRequest(command: ApproveLeaveProjectRequestCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/approve-leave-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveLeaveProjectRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveLeaveProjectRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processApproveLeaveProjectRequest(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deny Leave Project Request
     */
    denyLeaveProjectRequest(command: DenyLeaveProjectRequestCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/deny-leave-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDenyLeaveProjectRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDenyLeaveProjectRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDenyLeaveProjectRequest(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Revoke Leave Reviewer Type Request
     */
    revokeLeaveRequest(command: RevokeLeaveRequestCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/revoke-leave-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokeLeaveRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeLeaveRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processRevokeLeaveRequest(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Hold Reviewer Type
     */
    holdReviewerType(command: HoldReviewerTypeCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/hold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHoldReviewerType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHoldReviewerType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processHoldReviewerType(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resume Reviewer Type
     */
    resumeReviewerType(command: ResumeReviewerTypeCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/reviewerType/resume";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResumeReviewerType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResumeReviewerType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processResumeReviewerType(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewStatusClient {
    /**
     * Get Case Review Status
     */
    getReviewerTypes(caseId: number): Observable<ApplicationResultOfListOfReviewerTypeReviewStatusListDto>;
    /**
     * Get Reviewer Type Review Status
     */
    getForReviewerType(reviewerTypeId: number): Observable<ApplicationResultOfReviewerTypeReviewStatusDto>;
    /**
     * Get Reviewer Type Burn Down report
     */
    getReviewerTypeBurnDown(reviewerTypeId: number): Observable<ApplicationResultOfReviewerTypeBurnDownReportDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewStatusClient extends ApiClientBase implements IReviewStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Case Review Status
     */
    getReviewerTypes(caseId: number): Observable<ApplicationResultOfListOfReviewerTypeReviewStatusListDto> {
        let url_ = this.baseUrl + "/api/reviewStatus/case/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerTypeReviewStatusListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerTypeReviewStatusListDto>;
        }));
    }

    protected processGetReviewerTypes(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerTypeReviewStatusListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerTypeReviewStatusListDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Type Review Status
     */
    getForReviewerType(reviewerTypeId: number): Observable<ApplicationResultOfReviewerTypeReviewStatusDto> {
        let url_ = this.baseUrl + "/api/reviewStatus/reviewer-type/{reviewerTypeId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForReviewerType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForReviewerType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTypeReviewStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTypeReviewStatusDto>;
        }));
    }

    protected processGetForReviewerType(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTypeReviewStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTypeReviewStatusDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Type Burn Down report
     */
    getReviewerTypeBurnDown(reviewerTypeId: number): Observable<ApplicationResultOfReviewerTypeBurnDownReportDto> {
        let url_ = this.baseUrl + "/api/reviewStatus/reviewer-type/{reviewerTypeId}/burn-down";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerTypeBurnDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerTypeBurnDown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTypeBurnDownReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTypeBurnDownReportDto>;
        }));
    }

    protected processGetReviewerTypeBurnDown(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTypeBurnDownReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTypeBurnDownReportDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITimeEntriesClient {
    /**
     * Get Individual Time Entries for Company
     * @param caseId (optional) 
     */
    getCompanyTimeEntries(caseId?: number | null | undefined): Observable<ApplicationResultOfPaginatedResultOfCompanyTimeEntryDto>;
    /**
     * Get Individual Time Entries for Company
     */
    getCompanyTimeEntriesDatatable(query: GetCompanyTimeEntriesQuery): Observable<ApplicationResultOfPaginatedResultOfCompanyTimeEntryDto>;
    /**
     * Get Individual Time Entries Count for Company
     */
    getCompanyTimeEntriesCount(query: GetCompanyTimeEntriesCountQuery): Observable<ApplicationResultOfInteger>;
    /**
     * Get Company Time Entries Filters
     * @param caseId (optional) 
     */
    getCompanyFilters(caseId?: number | null | undefined): Observable<ApplicationResultOfFiltersModel>;
    /**
     * Get Daily Time Entries for Company
     * @param caseId (optional) 
     * @param onlyReviewTime (optional) 
     * @param statuses (optional) 
     */
    getCompanyDailyTimeEntries(caseId?: number | null | undefined, onlyReviewTime?: boolean | undefined, statuses?: AggregatedTimeEntryStatus[] | undefined): Observable<ApplicationResultOfListOfCompanyAggregatedDailyTimeEntryDto>;
    /**
     * Get Weekly Time Entries for Company
     * @param caseId (optional) 
     * @param onlyReviewTime (optional) 
     * @param statuses (optional) 
     */
    getCompanyWeeklyTimeEntries(caseId?: number | null | undefined, onlyReviewTime?: boolean | undefined, statuses?: AggregatedTimeEntryStatus[] | undefined): Observable<ApplicationResultOfListOfCompanyAggregatedWeeklyTimeEntryDto>;
    /**
     * Mark Time Entries as Exported
     */
    markTimeEntriesAsExported(command: MarkTimeEntriesAsExportedCommand): Observable<ApplicationResult>;
    /**
     * Get Time Entries
     */
    getReviewerTimeEntries(): Observable<ApplicationResultOfReviewerTimeEntriesResultDto>;
    /**
     * Get daily Time Entries
     */
    getReviewerDailtTimeEntries(): Observable<ApplicationResultOfListOfReviewerAggregatedTimeEntryDto>;
    /**
     * Get Time Entries
     */
    getReviewerDashboardTimeEntries(): Observable<ApplicationResultOfReviewerTimeEntriesResultDto>;
    /**
     * Get Reviewer Time Entry by Id
     */
    get(id: number): Observable<ApplicationResultOfReviewerTimeEntryDto>;
    /**
     * Delete Reviewer Time Entry
     */
    delete(id: number): Observable<ApplicationResult>;
    /**
     * Create Time Entry
     */
    upsert(command: UpsertTimeEntryCommand): Observable<ApplicationResultOfUpsertTimeEntryResult>;
    /**
     * Create Time Entry
     */
    createForReviewer(reviewerId: number, forReviewer: CreateTimeEntryForReviewer): Observable<ApplicationResultOfUpsertTimeEntryResult>;
    /**
     * Get Available Cases
     * @param onlyAvailableForToday (optional) 
     * @param timeEntryType (optional) 
     */
    getAvailableCases(onlyAvailableForToday?: boolean | undefined, timeEntryType?: TimeEntryType | null | undefined): Observable<ApplicationResultOfListOfTimeEntriesCaseDto>;
    /**
     * Get Reviewer Time Spans
     */
    getAvailableTimeSpans(reviewerTypeId: number): Observable<ApplicationResultOfListOfTimeEntryAvailableTimeSpanDto>;
    /**
     * Approve Reject Time Entry
     */
    updateStatus(status: UpdateTimeEntryStatusCommand): Observable<ApplicationResult>;
    /**
     * Reject Time Entry
     */
    rejectTimeEntry(status: RejectTimeEntryCommand): Observable<ApplicationResult>;
    /**
     * Bulk Approve Time Entry
     */
    bulkUpdateStatus(command: BulkUpdateTimeEntryStatus): Observable<ApplicationResult>;
    /**
     * Bulk Approve Time Entry
     */
    bulkReject(command: BulkRejectTimeEntryCommand): Observable<ApplicationResult>;
    /**
     * Get Reviewer Actual Working Time
     * @param dateWorked (optional) 
     * @param caseId (optional) 
     * @param reviewerId (optional) 
     */
    getActualWorkingTime(dateWorked?: Date | undefined, caseId?: number | undefined, reviewerId?: number | undefined): Observable<ApplicationResultOfActualWorkingTimeDto>;
    /**
     * Get Reviewer Entered Working Time
     * @param dateWorked (optional) 
     * @param reviewerId (optional) 
     */
    getEnteredWorkingTime(dateWorked?: Date | undefined, reviewerId?: number | undefined): Observable<ApplicationResultOfEnteredWorkingTimeDto>;
    /**
     * Get Reviewer Relativity Time Spans
     * @param reviewerId (optional) 
     * @param dateWorked (optional) 
     * @param weekOf (optional) 
     * @param caseId (optional) 
     */
    getReviewerRelativityTimeSpans(reviewerId?: number | null | undefined, dateWorked?: Date | null | undefined, weekOf?: Date | null | undefined, caseId?: number | null | undefined): Observable<ApplicationResultOfListOfRelativityAuditsTimeSpanDto>;
    /**
     * Get Company Relativity Time Spans
     * @param reviewerId (optional) 
     * @param dateWorked (optional) 
     * @param weekOf (optional) 
     * @param caseId (optional) 
     */
    getCompanyRelativityTimeSpans(reviewerId?: number | null | undefined, dateWorked?: Date | null | undefined, weekOf?: Date | null | undefined, caseId?: number | null | undefined): Observable<ApplicationResultOfListOfRelativityAuditsTimeSpanDto>;
}

@Injectable({
    providedIn: 'root'
})
export class TimeEntriesClient extends ApiClientBase implements ITimeEntriesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Individual Time Entries for Company
     * @param caseId (optional) 
     */
    getCompanyTimeEntries(caseId?: number | null | undefined): Observable<ApplicationResultOfPaginatedResultOfCompanyTimeEntryDto> {
        let url_ = this.baseUrl + "/api/timeEntries/company?";
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyTimeEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyTimeEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfPaginatedResultOfCompanyTimeEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfPaginatedResultOfCompanyTimeEntryDto>;
        }));
    }

    protected processGetCompanyTimeEntries(response: HttpResponseBase): Observable<ApplicationResultOfPaginatedResultOfCompanyTimeEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfPaginatedResultOfCompanyTimeEntryDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Individual Time Entries for Company
     */
    getCompanyTimeEntriesDatatable(query: GetCompanyTimeEntriesQuery): Observable<ApplicationResultOfPaginatedResultOfCompanyTimeEntryDto> {
        let url_ = this.baseUrl + "/api/timeEntries/company/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyTimeEntriesDatatable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyTimeEntriesDatatable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfPaginatedResultOfCompanyTimeEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfPaginatedResultOfCompanyTimeEntryDto>;
        }));
    }

    protected processGetCompanyTimeEntriesDatatable(response: HttpResponseBase): Observable<ApplicationResultOfPaginatedResultOfCompanyTimeEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfPaginatedResultOfCompanyTimeEntryDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Individual Time Entries Count for Company
     */
    getCompanyTimeEntriesCount(query: GetCompanyTimeEntriesCountQuery): Observable<ApplicationResultOfInteger> {
        let url_ = this.baseUrl + "/api/timeEntries/company/count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyTimeEntriesCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyTimeEntriesCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfInteger>;
        }));
    }

    protected processGetCompanyTimeEntriesCount(response: HttpResponseBase): Observable<ApplicationResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfInteger;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Company Time Entries Filters
     * @param caseId (optional) 
     */
    getCompanyFilters(caseId?: number | null | undefined): Observable<ApplicationResultOfFiltersModel> {
        let url_ = this.baseUrl + "/api/timeEntries/company/filters?";
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfFiltersModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfFiltersModel>;
        }));
    }

    protected processGetCompanyFilters(response: HttpResponseBase): Observable<ApplicationResultOfFiltersModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfFiltersModel;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Daily Time Entries for Company
     * @param caseId (optional) 
     * @param onlyReviewTime (optional) 
     * @param statuses (optional) 
     */
    getCompanyDailyTimeEntries(caseId?: number | null | undefined, onlyReviewTime?: boolean | undefined, statuses?: AggregatedTimeEntryStatus[] | undefined): Observable<ApplicationResultOfListOfCompanyAggregatedDailyTimeEntryDto> {
        let url_ = this.baseUrl + "/api/timeEntries/company/daily?";
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (onlyReviewTime === null)
            throw new globalThis.Error("The parameter 'onlyReviewTime' cannot be null.");
        else if (onlyReviewTime !== undefined)
            url_ += "onlyReviewTime=" + encodeURIComponent("" + onlyReviewTime) + "&";
        if (statuses === null)
            throw new globalThis.Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyDailyTimeEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyDailyTimeEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCompanyAggregatedDailyTimeEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCompanyAggregatedDailyTimeEntryDto>;
        }));
    }

    protected processGetCompanyDailyTimeEntries(response: HttpResponseBase): Observable<ApplicationResultOfListOfCompanyAggregatedDailyTimeEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCompanyAggregatedDailyTimeEntryDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Weekly Time Entries for Company
     * @param caseId (optional) 
     * @param onlyReviewTime (optional) 
     * @param statuses (optional) 
     */
    getCompanyWeeklyTimeEntries(caseId?: number | null | undefined, onlyReviewTime?: boolean | undefined, statuses?: AggregatedTimeEntryStatus[] | undefined): Observable<ApplicationResultOfListOfCompanyAggregatedWeeklyTimeEntryDto> {
        let url_ = this.baseUrl + "/api/timeEntries/company/weekly?";
        if (caseId !== undefined && caseId !== null)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (onlyReviewTime === null)
            throw new globalThis.Error("The parameter 'onlyReviewTime' cannot be null.");
        else if (onlyReviewTime !== undefined)
            url_ += "onlyReviewTime=" + encodeURIComponent("" + onlyReviewTime) + "&";
        if (statuses === null)
            throw new globalThis.Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyWeeklyTimeEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyWeeklyTimeEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCompanyAggregatedWeeklyTimeEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCompanyAggregatedWeeklyTimeEntryDto>;
        }));
    }

    protected processGetCompanyWeeklyTimeEntries(response: HttpResponseBase): Observable<ApplicationResultOfListOfCompanyAggregatedWeeklyTimeEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCompanyAggregatedWeeklyTimeEntryDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Mark Time Entries as Exported
     */
    markTimeEntriesAsExported(command: MarkTimeEntriesAsExportedCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/timeEntries/company/mark-exported";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkTimeEntriesAsExported(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkTimeEntriesAsExported(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processMarkTimeEntriesAsExported(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Time Entries
     */
    getReviewerTimeEntries(): Observable<ApplicationResultOfReviewerTimeEntriesResultDto> {
        let url_ = this.baseUrl + "/api/timeEntries/reviewer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerTimeEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerTimeEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTimeEntriesResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTimeEntriesResultDto>;
        }));
    }

    protected processGetReviewerTimeEntries(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTimeEntriesResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTimeEntriesResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get daily Time Entries
     */
    getReviewerDailtTimeEntries(): Observable<ApplicationResultOfListOfReviewerAggregatedTimeEntryDto> {
        let url_ = this.baseUrl + "/api/timeEntries/reviewer/daily";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerDailtTimeEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerDailtTimeEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfReviewerAggregatedTimeEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfReviewerAggregatedTimeEntryDto>;
        }));
    }

    protected processGetReviewerDailtTimeEntries(response: HttpResponseBase): Observable<ApplicationResultOfListOfReviewerAggregatedTimeEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfReviewerAggregatedTimeEntryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Time Entries
     */
    getReviewerDashboardTimeEntries(): Observable<ApplicationResultOfReviewerTimeEntriesResultDto> {
        let url_ = this.baseUrl + "/api/timeEntries/reviewer/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerDashboardTimeEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerDashboardTimeEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTimeEntriesResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTimeEntriesResultDto>;
        }));
    }

    protected processGetReviewerDashboardTimeEntries(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTimeEntriesResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTimeEntriesResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Time Entry by Id
     */
    get(id: number): Observable<ApplicationResultOfReviewerTimeEntryDto> {
        let url_ = this.baseUrl + "/api/timeEntries/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfReviewerTimeEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfReviewerTimeEntryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApplicationResultOfReviewerTimeEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfReviewerTimeEntryDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Reviewer Time Entry
     */
    delete(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/timeEntries/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Time Entry
     */
    upsert(command: UpsertTimeEntryCommand): Observable<ApplicationResultOfUpsertTimeEntryResult> {
        let url_ = this.baseUrl + "/api/timeEntries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfUpsertTimeEntryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfUpsertTimeEntryResult>;
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<ApplicationResultOfUpsertTimeEntryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfUpsertTimeEntryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Time Entry
     */
    createForReviewer(reviewerId: number, forReviewer: CreateTimeEntryForReviewer): Observable<ApplicationResultOfUpsertTimeEntryResult> {
        let url_ = this.baseUrl + "/api/timeEntries/{reviewerId}";
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(forReviewer);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateForReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateForReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfUpsertTimeEntryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfUpsertTimeEntryResult>;
        }));
    }

    protected processCreateForReviewer(response: HttpResponseBase): Observable<ApplicationResultOfUpsertTimeEntryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfUpsertTimeEntryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Available Cases
     * @param onlyAvailableForToday (optional) 
     * @param timeEntryType (optional) 
     */
    getAvailableCases(onlyAvailableForToday?: boolean | undefined, timeEntryType?: TimeEntryType | null | undefined): Observable<ApplicationResultOfListOfTimeEntriesCaseDto> {
        let url_ = this.baseUrl + "/api/timeEntries/cases?";
        if (onlyAvailableForToday === null)
            throw new globalThis.Error("The parameter 'onlyAvailableForToday' cannot be null.");
        else if (onlyAvailableForToday !== undefined)
            url_ += "OnlyAvailableForToday=" + encodeURIComponent("" + onlyAvailableForToday) + "&";
        if (timeEntryType !== undefined && timeEntryType !== null)
            url_ += "TimeEntryType=" + encodeURIComponent("" + timeEntryType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableCases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableCases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfTimeEntriesCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfTimeEntriesCaseDto>;
        }));
    }

    protected processGetAvailableCases(response: HttpResponseBase): Observable<ApplicationResultOfListOfTimeEntriesCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfTimeEntriesCaseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Time Spans
     */
    getAvailableTimeSpans(reviewerTypeId: number): Observable<ApplicationResultOfListOfTimeEntryAvailableTimeSpanDto> {
        let url_ = this.baseUrl + "/api/timeEntries/spans/{reviewerTypeId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableTimeSpans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableTimeSpans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfTimeEntryAvailableTimeSpanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfTimeEntryAvailableTimeSpanDto>;
        }));
    }

    protected processGetAvailableTimeSpans(response: HttpResponseBase): Observable<ApplicationResultOfListOfTimeEntryAvailableTimeSpanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfTimeEntryAvailableTimeSpanDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Approve Reject Time Entry
     */
    updateStatus(status: UpdateTimeEntryStatusCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/timeEntries/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(status);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reject Time Entry
     */
    rejectTimeEntry(status: RejectTimeEntryCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/timeEntries/status/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(status);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectTimeEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectTimeEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processRejectTimeEntry(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Bulk Approve Time Entry
     */
    bulkUpdateStatus(command: BulkUpdateTimeEntryStatus): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/timeEntries/status/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processBulkUpdateStatus(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Bulk Approve Time Entry
     */
    bulkReject(command: BulkRejectTimeEntryCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/timeEntries/status/reject/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processBulkReject(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Actual Working Time
     * @param dateWorked (optional) 
     * @param caseId (optional) 
     * @param reviewerId (optional) 
     */
    getActualWorkingTime(dateWorked?: Date | undefined, caseId?: number | undefined, reviewerId?: number | undefined): Observable<ApplicationResultOfActualWorkingTimeDto> {
        let url_ = this.baseUrl + "/api/timeEntries/working-time?";
        if (dateWorked === null)
            throw new globalThis.Error("The parameter 'dateWorked' cannot be null.");
        else if (dateWorked !== undefined)
            url_ += "DateWorked=" + encodeURIComponent(dateWorked ? "" + dateWorked.toISOString() : "") + "&";
        if (caseId === null)
            throw new globalThis.Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' cannot be null.");
        else if (reviewerId !== undefined)
            url_ += "ReviewerId=" + encodeURIComponent("" + reviewerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActualWorkingTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActualWorkingTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfActualWorkingTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfActualWorkingTimeDto>;
        }));
    }

    protected processGetActualWorkingTime(response: HttpResponseBase): Observable<ApplicationResultOfActualWorkingTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfActualWorkingTimeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Entered Working Time
     * @param dateWorked (optional) 
     * @param reviewerId (optional) 
     */
    getEnteredWorkingTime(dateWorked?: Date | undefined, reviewerId?: number | undefined): Observable<ApplicationResultOfEnteredWorkingTimeDto> {
        let url_ = this.baseUrl + "/api/timeEntries/entered-time?";
        if (dateWorked === null)
            throw new globalThis.Error("The parameter 'dateWorked' cannot be null.");
        else if (dateWorked !== undefined)
            url_ += "DateWorked=" + encodeURIComponent(dateWorked ? "" + dateWorked.toISOString() : "") + "&";
        if (reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' cannot be null.");
        else if (reviewerId !== undefined)
            url_ += "ReviewerId=" + encodeURIComponent("" + reviewerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnteredWorkingTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnteredWorkingTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfEnteredWorkingTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfEnteredWorkingTimeDto>;
        }));
    }

    protected processGetEnteredWorkingTime(response: HttpResponseBase): Observable<ApplicationResultOfEnteredWorkingTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfEnteredWorkingTimeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Relativity Time Spans
     * @param reviewerId (optional) 
     * @param dateWorked (optional) 
     * @param weekOf (optional) 
     * @param caseId (optional) 
     */
    getReviewerRelativityTimeSpans(reviewerId?: number | null | undefined, dateWorked?: Date | null | undefined, weekOf?: Date | null | undefined, caseId?: number | null | undefined): Observable<ApplicationResultOfListOfRelativityAuditsTimeSpanDto> {
        let url_ = this.baseUrl + "/api/timeEntries/reviwer/relativity/spans?";
        if (reviewerId !== undefined && reviewerId !== null)
            url_ += "ReviewerId=" + encodeURIComponent("" + reviewerId) + "&";
        if (dateWorked !== undefined && dateWorked !== null)
            url_ += "DateWorked=" + encodeURIComponent(dateWorked ? "" + dateWorked.toISOString() : "") + "&";
        if (weekOf !== undefined && weekOf !== null)
            url_ += "WeekOf=" + encodeURIComponent(weekOf ? "" + weekOf.toISOString() : "") + "&";
        if (caseId !== undefined && caseId !== null)
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerRelativityTimeSpans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerRelativityTimeSpans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRelativityAuditsTimeSpanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRelativityAuditsTimeSpanDto>;
        }));
    }

    protected processGetReviewerRelativityTimeSpans(response: HttpResponseBase): Observable<ApplicationResultOfListOfRelativityAuditsTimeSpanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRelativityAuditsTimeSpanDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Company Relativity Time Spans
     * @param reviewerId (optional) 
     * @param dateWorked (optional) 
     * @param weekOf (optional) 
     * @param caseId (optional) 
     */
    getCompanyRelativityTimeSpans(reviewerId?: number | null | undefined, dateWorked?: Date | null | undefined, weekOf?: Date | null | undefined, caseId?: number | null | undefined): Observable<ApplicationResultOfListOfRelativityAuditsTimeSpanDto> {
        let url_ = this.baseUrl + "/api/timeEntries/company/relativity/spans?";
        if (reviewerId !== undefined && reviewerId !== null)
            url_ += "ReviewerId=" + encodeURIComponent("" + reviewerId) + "&";
        if (dateWorked !== undefined && dateWorked !== null)
            url_ += "DateWorked=" + encodeURIComponent(dateWorked ? "" + dateWorked.toISOString() : "") + "&";
        if (weekOf !== undefined && weekOf !== null)
            url_ += "WeekOf=" + encodeURIComponent(weekOf ? "" + weekOf.toISOString() : "") + "&";
        if (caseId !== undefined && caseId !== null)
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyRelativityTimeSpans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyRelativityTimeSpans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRelativityAuditsTimeSpanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRelativityAuditsTimeSpanDto>;
        }));
    }

    protected processGetCompanyRelativityTimeSpans(response: HttpResponseBase): Observable<ApplicationResultOfListOfRelativityAuditsTimeSpanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRelativityAuditsTimeSpanDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITimeZoneClient {
    /**
     * Get Timezones
     */
    getTimezones(): Observable<ApplicationResultOfListOfTimeZoneDto>;
}

@Injectable({
    providedIn: 'root'
})
export class TimeZoneClient extends ApiClientBase implements ITimeZoneClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Timezones
     */
    getTimezones(): Observable<ApplicationResultOfListOfTimeZoneDto> {
        let url_ = this.baseUrl + "/api/timeZone";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfTimeZoneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfTimeZoneDto>;
        }));
    }

    protected processGetTimezones(response: HttpResponseBase): Observable<ApplicationResultOfListOfTimeZoneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfTimeZoneDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITranslationClient {
    /**
     * Get Translations
     */
    getTranslations(language: string): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class TranslationClient extends ApiClientBase implements ITranslationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Translations
     */
    getTranslations(language: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/translation/{language}";
        if (language === undefined || language === null)
            throw new globalThis.Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTranslations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTranslations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetTranslations(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITrustedIpsClient {
    /**
     * Get Case Reviewer Type Assignments
     */
    getTrustedIps(): Observable<ApplicationResultOfListOfCompanyTrustedIpDto>;
}

@Injectable({
    providedIn: 'root'
})
export class TrustedIpsClient extends ApiClientBase implements ITrustedIpsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Case Reviewer Type Assignments
     */
    getTrustedIps(): Observable<ApplicationResultOfListOfCompanyTrustedIpDto> {
        let url_ = this.baseUrl + "/api/trustedIps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrustedIps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrustedIps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfCompanyTrustedIpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfCompanyTrustedIpDto>;
        }));
    }

    protected processGetTrustedIps(response: HttpResponseBase): Observable<ApplicationResultOfListOfCompanyTrustedIpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfCompanyTrustedIpDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUploadClient {
    /**
     * Upload Reviewer Attachment
     * @param description (optional) 
     * @param file (optional) 
     */
    uploadDocument(description?: string | null | undefined, file?: FileParameter | null | undefined): Observable<ApplicationResultOfDocumentDto>;
    /**
     * Upload Reviewer Attachment
     * @param reviewerId (optional) 
     * @param description (optional) 
     * @param file (optional) 
     */
    uploadReviewerAttachment(reviewerId?: number | undefined, description?: string | null | undefined, file?: FileParameter | null | undefined): Observable<ApplicationResultOfDocumentDto>;
    /**
     * Upload Bar Status attachment
     * @param file (optional) 
     */
    uploadBarStatusAttachment(reviewerBarMembershipId: number, file?: FileParameter | null | undefined): Observable<ApplicationResultOfDocumentDto>;
}

@Injectable({
    providedIn: 'root'
})
export class UploadClient extends ApiClientBase implements IUploadClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Upload Reviewer Attachment
     * @param description (optional) 
     * @param file (optional) 
     */
    uploadDocument(description?: string | null | undefined, file?: FileParameter | null | undefined): Observable<ApplicationResultOfDocumentDto> {
        let url_ = this.baseUrl + "/api/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (description !== null && description !== undefined)
            content_.append("description", description.toString());
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfDocumentDto>;
        }));
    }

    protected processUploadDocument(response: HttpResponseBase): Observable<ApplicationResultOfDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload Reviewer Attachment
     * @param reviewerId (optional) 
     * @param description (optional) 
     * @param file (optional) 
     */
    uploadReviewerAttachment(reviewerId?: number | undefined, description?: string | null | undefined, file?: FileParameter | null | undefined): Observable<ApplicationResultOfDocumentDto> {
        let url_ = this.baseUrl + "/api/upload/reviewer-attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (reviewerId === null || reviewerId === undefined)
            throw new globalThis.Error("The parameter 'reviewerId' cannot be null.");
        else
            content_.append("reviewerId", reviewerId.toString());
        if (description !== null && description !== undefined)
            content_.append("description", description.toString());
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadReviewerAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadReviewerAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfDocumentDto>;
        }));
    }

    protected processUploadReviewerAttachment(response: HttpResponseBase): Observable<ApplicationResultOfDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload Bar Status attachment
     * @param file (optional) 
     */
    uploadBarStatusAttachment(reviewerBarMembershipId: number, file?: FileParameter | null | undefined): Observable<ApplicationResultOfDocumentDto> {
        let url_ = this.baseUrl + "/api/upload/admin-bar-status-attachment/{reviewerBarMembershipId}";
        if (reviewerBarMembershipId === undefined || reviewerBarMembershipId === null)
            throw new globalThis.Error("The parameter 'reviewerBarMembershipId' must be defined.");
        url_ = url_.replace("{reviewerBarMembershipId}", encodeURIComponent("" + reviewerBarMembershipId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBarStatusAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBarStatusAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfDocumentDto>;
        }));
    }

    protected processUploadBarStatusAttachment(response: HttpResponseBase): Observable<ApplicationResultOfDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserClient {
    /**
     * Get all users
     */
    getAll(): Observable<ApplicationResultOfListOfAdminUserDto>;
    /**
     * Deactivate user
     */
    createAdmin(requet: CreateAdminCommand): Observable<ApplicationResult>;
    /**
     * Activate user
     */
    activate(id: number): Observable<ApplicationResult>;
    /**
     * Deactivate user
     */
    dectivate(id: number): Observable<ApplicationResult>;
    /**
     * Confirm user
     */
    confirm(id: number): Observable<ApplicationResult>;
    /**
     * Delete user
     */
    delete(id: number): Observable<ApplicationResult>;
    /**
     * Deactivate user
     */
    impersonate(userId: number): Observable<ApplicationResultOfAccountResultDto>;
}

@Injectable({
    providedIn: 'root'
})
export class UserClient extends ApiClientBase implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get all users
     */
    getAll(): Observable<ApplicationResultOfListOfAdminUserDto> {
        let url_ = this.baseUrl + "/api/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfAdminUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfAdminUserDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApplicationResultOfListOfAdminUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfAdminUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deactivate user
     */
    createAdmin(requet: CreateAdminCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/user/admin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requet);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processCreateAdmin(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Activate user
     */
    activate(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/user/activate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deactivate user
     */
    dectivate(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/user/deactivate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDectivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDectivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDectivate(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Confirm user
     */
    confirm(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/user/confirm/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete user
     */
    delete(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deactivate user
     */
    impersonate(userId: number): Observable<ApplicationResultOfAccountResultDto> {
        let url_ = this.baseUrl + "/api/user/impersonate/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAccountResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAccountResultDto>;
        }));
    }

    protected processImpersonate(response: HttpResponseBase): Observable<ApplicationResultOfAccountResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAccountResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserPermissionRoleClient {
    getUserPermissionRoles(): Observable<ApplicationResultOfListOfUserPermissionRoleDto>;
}

@Injectable({
    providedIn: 'root'
})
export class UserPermissionRoleClient extends ApiClientBase implements IUserPermissionRoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getUserPermissionRoles(): Observable<ApplicationResultOfListOfUserPermissionRoleDto> {
        let url_ = this.baseUrl + "/api/userPermissionRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissionRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissionRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfUserPermissionRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfUserPermissionRoleDto>;
        }));
    }

    protected processGetUserPermissionRoles(response: HttpResponseBase): Observable<ApplicationResultOfListOfUserPermissionRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfUserPermissionRoleDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserSettingsClient {
    /**
     * Get User Settings
     */
    getUserSettings(): Observable<ApplicationResultOfUserSettingsDto>;
    /**
     * Update User Settings
     */
    saveUserSettings(command: SaveUserSettingsCommand): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class UserSettingsClient extends ApiClientBase implements IUserSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get User Settings
     */
    getUserSettings(): Observable<ApplicationResultOfUserSettingsDto> {
        let url_ = this.baseUrl + "/api/userSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfUserSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfUserSettingsDto>;
        }));
    }

    protected processGetUserSettings(response: HttpResponseBase): Observable<ApplicationResultOfUserSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfUserSettingsDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update User Settings
     */
    saveUserSettings(command: SaveUserSettingsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/userSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveUserSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUserSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processSaveUserSettings(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserStatesClient {
    /**
     * Get User State
     * @param key (optional) 
     */
    getUserState(key?: string | undefined): Observable<ApplicationResultOfUserStateDto>;
    /**
     * Save User State
     */
    saveUserState(command: SaveUserStateCommand): Observable<ApplicationResultOfUserStateDto>;
}

@Injectable({
    providedIn: 'root'
})
export class UserStatesClient extends ApiClientBase implements IUserStatesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get User State
     * @param key (optional) 
     */
    getUserState(key?: string | undefined): Observable<ApplicationResultOfUserStateDto> {
        let url_ = this.baseUrl + "/api/userStates?";
        if (key === null)
            throw new globalThis.Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfUserStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfUserStateDto>;
        }));
    }

    protected processGetUserState(response: HttpResponseBase): Observable<ApplicationResultOfUserStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfUserStateDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save User State
     */
    saveUserState(command: SaveUserStateCommand): Observable<ApplicationResultOfUserStateDto> {
        let url_ = this.baseUrl + "/api/userStates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveUserState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUserState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfUserStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfUserStateDto>;
        }));
    }

    protected processSaveUserState(response: HttpResponseBase): Observable<ApplicationResultOfUserStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfUserStateDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVersionClient {
    get(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class VersionClient extends ApiClientBase implements IVersionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAdminRatingClient {
    /**
     * Get Reviewer Ratings
     * @param query (optional) 
     */
    getReviewerRatings(query?: AdminGetReviewerRatingsQuery | undefined): Observable<ApplicationResultOfListOfAdminRatingDto>;
    /**
     * Approve Reviewer Rating
     */
    approveReviewerRating(id: number): Observable<ApplicationResultOfAdminRatingDto>;
    /**
     * Bulk Approve Reviewer Rating
     */
    bulkApproveReviewerRatings(request: AdminBulkApproveReviewerRatingsCommand): Observable<ApplicationResult>;
    /**
     * Pend Reviewer Rating
     */
    pendReviewerRating(id: number): Observable<ApplicationResultOfAdminRatingDto>;
    /**
     * Approve Reviewer Rating Reply
     */
    approveReviewerRatingReply(id: number): Observable<ApplicationResultOfAdminRatingDto>;
    /**
     * Pend Reviewer Rating Reply
     */
    pendReviewerRatingReply(id: number): Observable<ApplicationResultOfAdminRatingDto>;
    /**
     * Send Reviewer Rating For Revision
     */
    sendReviewerRatingForRevision(command: AdminSendReviewerRatingForRevisionCommand): Observable<ApplicationResultOfAdminRatingDto>;
    /**
     * Reject Reviewer Rating
     */
    rejectReviewerRating(id: number): Observable<ApplicationResultOfAdminRatingDto>;
    /**
     * Withdraw Reviewer Rating Rejection
     */
    withdrawRejectionReviewerRating(id: number): Observable<ApplicationResultOfAdminRatingDto>;
    /**
     * Get Company Ratings
     * @param query (optional) 
     */
    getCompanyRatings(query?: AdminGetCompanyRatingsQuery | undefined): Observable<ApplicationResultOfListOfAdminRatingDto>;
    /**
     * Approve Company Rating
     */
    approveCompanyRating(id: number): Observable<ApplicationResultOfAdminRatingDto>;
    /**
     * Bulk Approve Company Rating
     */
    bulkApproveCompanyRatings(request: AdminBulkApproveCompanyRatingsCommand): Observable<ApplicationResult>;
    /**
     * Pend Company Rating
     */
    pendCompanyRating(id: number): Observable<ApplicationResultOfAdminRatingDto>;
    /**
     * Approve Company Rating Reply
     */
    approveCompanyRatingReply(id: number): Observable<ApplicationResultOfAdminRatingDto>;
    /**
     * Pend Company Rating Reply
     */
    pendCompanyRatingReply(id: number): Observable<ApplicationResultOfAdminRatingDto>;
    /**
     * Send Company Rating For Revision
     */
    sendCompanyRatingForRevision(command: AdminSendCompanyRatingForRevisionCommand): Observable<ApplicationResultOfAdminRatingDto>;
    /**
     * Reject Company Rating
     */
    rejectCompanyRating(id: number): Observable<ApplicationResultOfAdminRatingDto>;
    /**
     * Withdraw Company Rating Rejection
     */
    withdrawRejectionCompanyRating(id: number): Observable<ApplicationResultOfAdminRatingDto>;
}

@Injectable({
    providedIn: 'root'
})
export class AdminRatingClient extends ApiClientBase implements IAdminRatingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Reviewer Ratings
     * @param query (optional) 
     */
    getReviewerRatings(query?: AdminGetReviewerRatingsQuery | undefined): Observable<ApplicationResultOfListOfAdminRatingDto> {
        let url_ = this.baseUrl + "/api/adminRating/reviewer?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfAdminRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfAdminRatingDto>;
        }));
    }

    protected processGetReviewerRatings(response: HttpResponseBase): Observable<ApplicationResultOfListOfAdminRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfAdminRatingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Approve Reviewer Rating
     */
    approveReviewerRating(id: number): Observable<ApplicationResultOfAdminRatingDto> {
        let url_ = this.baseUrl + "/api/adminRating/reviewer/approve/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveReviewerRating(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveReviewerRating(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAdminRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAdminRatingDto>;
        }));
    }

    protected processApproveReviewerRating(response: HttpResponseBase): Observable<ApplicationResultOfAdminRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAdminRatingDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Bulk Approve Reviewer Rating
     */
    bulkApproveReviewerRatings(request: AdminBulkApproveReviewerRatingsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/adminRating/reviewer/bulk-approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkApproveReviewerRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkApproveReviewerRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processBulkApproveReviewerRatings(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Pend Reviewer Rating
     */
    pendReviewerRating(id: number): Observable<ApplicationResultOfAdminRatingDto> {
        let url_ = this.baseUrl + "/api/adminRating/reviewer/pend/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPendReviewerRating(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPendReviewerRating(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAdminRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAdminRatingDto>;
        }));
    }

    protected processPendReviewerRating(response: HttpResponseBase): Observable<ApplicationResultOfAdminRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAdminRatingDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Approve Reviewer Rating Reply
     */
    approveReviewerRatingReply(id: number): Observable<ApplicationResultOfAdminRatingDto> {
        let url_ = this.baseUrl + "/api/adminRating/reviewer/reply/approve/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveReviewerRatingReply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveReviewerRatingReply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAdminRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAdminRatingDto>;
        }));
    }

    protected processApproveReviewerRatingReply(response: HttpResponseBase): Observable<ApplicationResultOfAdminRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAdminRatingDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Pend Reviewer Rating Reply
     */
    pendReviewerRatingReply(id: number): Observable<ApplicationResultOfAdminRatingDto> {
        let url_ = this.baseUrl + "/api/adminRating/reviewer/reply/pend/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPendReviewerRatingReply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPendReviewerRatingReply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAdminRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAdminRatingDto>;
        }));
    }

    protected processPendReviewerRatingReply(response: HttpResponseBase): Observable<ApplicationResultOfAdminRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAdminRatingDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send Reviewer Rating For Revision
     */
    sendReviewerRatingForRevision(command: AdminSendReviewerRatingForRevisionCommand): Observable<ApplicationResultOfAdminRatingDto> {
        let url_ = this.baseUrl + "/api/adminRating/reviewer/send-for-revision";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendReviewerRatingForRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendReviewerRatingForRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAdminRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAdminRatingDto>;
        }));
    }

    protected processSendReviewerRatingForRevision(response: HttpResponseBase): Observable<ApplicationResultOfAdminRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAdminRatingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reject Reviewer Rating
     */
    rejectReviewerRating(id: number): Observable<ApplicationResultOfAdminRatingDto> {
        let url_ = this.baseUrl + "/api/adminRating/reviewer/reject/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectReviewerRating(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectReviewerRating(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAdminRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAdminRatingDto>;
        }));
    }

    protected processRejectReviewerRating(response: HttpResponseBase): Observable<ApplicationResultOfAdminRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAdminRatingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Withdraw Reviewer Rating Rejection
     */
    withdrawRejectionReviewerRating(id: number): Observable<ApplicationResultOfAdminRatingDto> {
        let url_ = this.baseUrl + "/api/adminRating/reviewer/withdraw-rejection/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithdrawRejectionReviewerRating(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithdrawRejectionReviewerRating(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAdminRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAdminRatingDto>;
        }));
    }

    protected processWithdrawRejectionReviewerRating(response: HttpResponseBase): Observable<ApplicationResultOfAdminRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAdminRatingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Company Ratings
     * @param query (optional) 
     */
    getCompanyRatings(query?: AdminGetCompanyRatingsQuery | undefined): Observable<ApplicationResultOfListOfAdminRatingDto> {
        let url_ = this.baseUrl + "/api/adminRating/company?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfAdminRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfAdminRatingDto>;
        }));
    }

    protected processGetCompanyRatings(response: HttpResponseBase): Observable<ApplicationResultOfListOfAdminRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfAdminRatingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Approve Company Rating
     */
    approveCompanyRating(id: number): Observable<ApplicationResultOfAdminRatingDto> {
        let url_ = this.baseUrl + "/api/adminRating/company/approve/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveCompanyRating(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveCompanyRating(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAdminRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAdminRatingDto>;
        }));
    }

    protected processApproveCompanyRating(response: HttpResponseBase): Observable<ApplicationResultOfAdminRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAdminRatingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Bulk Approve Company Rating
     */
    bulkApproveCompanyRatings(request: AdminBulkApproveCompanyRatingsCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/adminRating/company/bulk-approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkApproveCompanyRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkApproveCompanyRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processBulkApproveCompanyRatings(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Pend Company Rating
     */
    pendCompanyRating(id: number): Observable<ApplicationResultOfAdminRatingDto> {
        let url_ = this.baseUrl + "/api/adminRating/company/pend/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPendCompanyRating(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPendCompanyRating(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAdminRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAdminRatingDto>;
        }));
    }

    protected processPendCompanyRating(response: HttpResponseBase): Observable<ApplicationResultOfAdminRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAdminRatingDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Approve Company Rating Reply
     */
    approveCompanyRatingReply(id: number): Observable<ApplicationResultOfAdminRatingDto> {
        let url_ = this.baseUrl + "/api/adminRating/company/reply/approve/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveCompanyRatingReply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveCompanyRatingReply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAdminRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAdminRatingDto>;
        }));
    }

    protected processApproveCompanyRatingReply(response: HttpResponseBase): Observable<ApplicationResultOfAdminRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAdminRatingDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Pend Company Rating Reply
     */
    pendCompanyRatingReply(id: number): Observable<ApplicationResultOfAdminRatingDto> {
        let url_ = this.baseUrl + "/api/adminRating/company/reply/pend/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPendCompanyRatingReply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPendCompanyRatingReply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAdminRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAdminRatingDto>;
        }));
    }

    protected processPendCompanyRatingReply(response: HttpResponseBase): Observable<ApplicationResultOfAdminRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAdminRatingDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send Company Rating For Revision
     */
    sendCompanyRatingForRevision(command: AdminSendCompanyRatingForRevisionCommand): Observable<ApplicationResultOfAdminRatingDto> {
        let url_ = this.baseUrl + "/api/adminRating/company/send-for-revision";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendCompanyRatingForRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendCompanyRatingForRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAdminRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAdminRatingDto>;
        }));
    }

    protected processSendCompanyRatingForRevision(response: HttpResponseBase): Observable<ApplicationResultOfAdminRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAdminRatingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reject Company Rating
     */
    rejectCompanyRating(id: number): Observable<ApplicationResultOfAdminRatingDto> {
        let url_ = this.baseUrl + "/api/adminRating/company/reject/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectCompanyRating(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectCompanyRating(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAdminRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAdminRatingDto>;
        }));
    }

    protected processRejectCompanyRating(response: HttpResponseBase): Observable<ApplicationResultOfAdminRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAdminRatingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Withdraw Company Rating Rejection
     */
    withdrawRejectionCompanyRating(id: number): Observable<ApplicationResultOfAdminRatingDto> {
        let url_ = this.baseUrl + "/api/adminRating/company/withdraw-rejection/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithdrawRejectionCompanyRating(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithdrawRejectionCompanyRating(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfAdminRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfAdminRatingDto>;
        }));
    }

    protected processWithdrawRejectionCompanyRating(response: HttpResponseBase): Observable<ApplicationResultOfAdminRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfAdminRatingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyRatingsClient {
    /**
     * Rate Reviewer
     */
    rate(command: CompanyRateReviewerCommand): Observable<ApplicationResult>;
    /**
     * Reply for Reviewer rating
     */
    reply(command: CompanyRepliesReviewerRatingCommand): Observable<ApplicationResult>;
    /**
     * Bulk Rate Reviewers
     */
    bulkRate(command: CompanyBulkRateReviewersCommand): Observable<ApplicationResult>;
    /**
     * Get Company Project Ratings
     */
    getCompanyProjectRatings(reviewerTypeId: number, reviewerId: number): Observable<ApplicationResultOfListOfRatingDto>;
    /**
     * Get Reviewer Project Ratings
     */
    getReviewerProjectRatings(reviewerTypeId: number, reviewerId: number): Observable<ApplicationResultOfListOfRatingDto>;
    /**
     * Get Company Received Ratings
     */
    getReceivedRatings(): Observable<ApplicationResultOfListOfRatingSpanDto>;
    /**
     * Get Company Given Ratings
     */
    getGivenRatings(): Observable<ApplicationResultOfListOfRatingSpanDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CompanyRatingsClient extends ApiClientBase implements ICompanyRatingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Rate Reviewer
     */
    rate(command: CompanyRateReviewerCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/rating/company/rate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processRate(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reply for Reviewer rating
     */
    reply(command: CompanyRepliesReviewerRatingCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/rating/company/reply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processReply(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Bulk Rate Reviewers
     */
    bulkRate(command: CompanyBulkRateReviewersCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/rating/company/bulk-rate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processBulkRate(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Company Project Ratings
     */
    getCompanyProjectRatings(reviewerTypeId: number, reviewerId: number): Observable<ApplicationResultOfListOfRatingDto> {
        let url_ = this.baseUrl + "/api/rating/company/project/company/{reviewerTypeId}/{reviewerId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyProjectRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyProjectRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRatingDto>;
        }));
    }

    protected processGetCompanyProjectRatings(response: HttpResponseBase): Observable<ApplicationResultOfListOfRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRatingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Project Ratings
     */
    getReviewerProjectRatings(reviewerTypeId: number, reviewerId: number): Observable<ApplicationResultOfListOfRatingDto> {
        let url_ = this.baseUrl + "/api/rating/company/project/reviewer/{reviewerTypeId}/{reviewerId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        if (reviewerId === undefined || reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerProjectRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerProjectRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRatingDto>;
        }));
    }

    protected processGetReviewerProjectRatings(response: HttpResponseBase): Observable<ApplicationResultOfListOfRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRatingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Company Received Ratings
     */
    getReceivedRatings(): Observable<ApplicationResultOfListOfRatingSpanDto> {
        let url_ = this.baseUrl + "/api/rating/company/received";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceivedRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceivedRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRatingSpanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRatingSpanDto>;
        }));
    }

    protected processGetReceivedRatings(response: HttpResponseBase): Observable<ApplicationResultOfListOfRatingSpanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRatingSpanDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Company Given Ratings
     */
    getGivenRatings(): Observable<ApplicationResultOfListOfRatingSpanDto> {
        let url_ = this.baseUrl + "/api/rating/company/given";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGivenRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGivenRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRatingSpanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRatingSpanDto>;
        }));
    }

    protected processGetGivenRatings(response: HttpResponseBase): Observable<ApplicationResultOfListOfRatingSpanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRatingSpanDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOverallRatingClient {
    /**
     * Get Company Ratings
     * @param companyId (optional) 
     */
    getCompanyRatings(companyId?: number | undefined): Observable<ApplicationResultOfListOfRatingDto>;
    /**
     * Get Reviewer Ratings
     * @param reviewerId (optional) 
     */
    getReviewerRatings(reviewerId?: number | undefined): Observable<ApplicationResultOfListOfRatingDto>;
}

@Injectable({
    providedIn: 'root'
})
export class OverallRatingClient extends ApiClientBase implements IOverallRatingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get Company Ratings
     * @param companyId (optional) 
     */
    getCompanyRatings(companyId?: number | undefined): Observable<ApplicationResultOfListOfRatingDto> {
        let url_ = this.baseUrl + "/api/rating/overall/company?";
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRatingDto>;
        }));
    }

    protected processGetCompanyRatings(response: HttpResponseBase): Observable<ApplicationResultOfListOfRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRatingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Ratings
     * @param reviewerId (optional) 
     */
    getReviewerRatings(reviewerId?: number | undefined): Observable<ApplicationResultOfListOfRatingDto> {
        let url_ = this.baseUrl + "/api/rating/overall/reviewer?";
        if (reviewerId === null)
            throw new globalThis.Error("The parameter 'reviewerId' cannot be null.");
        else if (reviewerId !== undefined)
            url_ += "ReviewerId=" + encodeURIComponent("" + reviewerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRatingDto>;
        }));
    }

    protected processGetReviewerRatings(response: HttpResponseBase): Observable<ApplicationResultOfListOfRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRatingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerRatingClient {
    /**
     * Rate Company
     */
    rate(command: ReviewerRateCompanyCommand): Observable<ApplicationResult>;
    /**
     * Reply for Company rating
     */
    reply(command: ReviewerRepliesCompanyRatingCommand): Observable<ApplicationResult>;
    /**
     * Get Company Project Ratings
     */
    getCompanyProjectRatings(reviewerTypeId: number): Observable<ApplicationResultOfListOfRatingDto>;
    /**
     * Get Reviewer Project Ratings
     */
    getReviewerProjectRatings(reviewerTypeId: number): Observable<ApplicationResultOfListOfRatingDto>;
    /**
     * Get Reviewer Received Ratings
     */
    getReceivedRatings(): Observable<ApplicationResultOfListOfRatingSpanDto>;
    /**
     * Get Reviewer Given Ratings
     */
    getGivenRatings(): Observable<ApplicationResultOfListOfRatingSpanDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerRatingClient extends ApiClientBase implements IReviewerRatingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Rate Company
     */
    rate(command: ReviewerRateCompanyCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/rating/reviewer/rate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processRate(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reply for Company rating
     */
    reply(command: ReviewerRepliesCompanyRatingCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/rating/reviewer/reply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processReply(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Company Project Ratings
     */
    getCompanyProjectRatings(reviewerTypeId: number): Observable<ApplicationResultOfListOfRatingDto> {
        let url_ = this.baseUrl + "/api/rating/reviewer/project/company/{reviewerTypeId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyProjectRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyProjectRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRatingDto>;
        }));
    }

    protected processGetCompanyProjectRatings(response: HttpResponseBase): Observable<ApplicationResultOfListOfRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRatingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Project Ratings
     */
    getReviewerProjectRatings(reviewerTypeId: number): Observable<ApplicationResultOfListOfRatingDto> {
        let url_ = this.baseUrl + "/api/rating/reviewer/project/reviewer/{reviewerTypeId}";
        if (reviewerTypeId === undefined || reviewerTypeId === null)
            throw new globalThis.Error("The parameter 'reviewerTypeId' must be defined.");
        url_ = url_.replace("{reviewerTypeId}", encodeURIComponent("" + reviewerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerProjectRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerProjectRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRatingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRatingDto>;
        }));
    }

    protected processGetReviewerProjectRatings(response: HttpResponseBase): Observable<ApplicationResultOfListOfRatingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRatingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Received Ratings
     */
    getReceivedRatings(): Observable<ApplicationResultOfListOfRatingSpanDto> {
        let url_ = this.baseUrl + "/api/rating/reviewer/received";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceivedRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceivedRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRatingSpanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRatingSpanDto>;
        }));
    }

    protected processGetReceivedRatings(response: HttpResponseBase): Observable<ApplicationResultOfListOfRatingSpanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRatingSpanDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Reviewer Given Ratings
     */
    getGivenRatings(): Observable<ApplicationResultOfListOfRatingSpanDto> {
        let url_ = this.baseUrl + "/api/rating/reviewer/given";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGivenRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGivenRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfRatingSpanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfRatingSpanDto>;
        }));
    }

    protected processGetGivenRatings(response: HttpResponseBase): Observable<ApplicationResultOfListOfRatingSpanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfRatingSpanDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IActionCodeClient {
    /**
     * Get All
     * @param caseId (optional) 
     */
    getAll(caseId?: number | null | undefined): Observable<ActionCodeDto[]>;
    /**
     * Create
     */
    create(command: CreateActionCodeCommand): Observable<ApplicationResultOfActionCodeDto>;
    /**
     * Update
     */
    update(command: UpdateActionCodeCommand): Observable<ApplicationResultOfActionCodeDto>;
    /**
     * Delete
     */
    delete(id: number): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ActionCodeClient extends ApiClientBase implements IActionCodeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param caseId (optional) 
     */
    getAll(caseId?: number | null | undefined): Observable<ActionCodeDto[]> {
        let url_ = this.baseUrl + "/api/lookup/action-code?";
        if (caseId !== undefined && caseId !== null)
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActionCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActionCodeDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ActionCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActionCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateActionCodeCommand): Observable<ApplicationResultOfActionCodeDto> {
        let url_ = this.baseUrl + "/api/lookup/action-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfActionCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfActionCodeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApplicationResultOfActionCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfActionCodeDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     */
    update(command: UpdateActionCodeCommand): Observable<ApplicationResultOfActionCodeDto> {
        let url_ = this.baseUrl + "/api/lookup/action-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfActionCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfActionCodeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApplicationResultOfActionCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfActionCodeDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete
     */
    delete(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/lookup/action-code/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAdditionalServiceClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<AdditionalServiceDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfAdditionalServiceAndAdditionalServiceDto): Observable<AdditionalServiceDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class AdditionalServiceClient extends ApiClientBase implements IAdditionalServiceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<AdditionalServiceDto[]> {
        let url_ = this.baseUrl + "/api/lookup/additionalService?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdditionalServiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdditionalServiceDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AdditionalServiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdditionalServiceDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfAdditionalServiceAndAdditionalServiceDto): Observable<AdditionalServiceDto> {
        let url_ = this.baseUrl + "/api/lookup/additionalService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdditionalServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdditionalServiceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AdditionalServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdditionalServiceDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/additionalService/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAttorneyClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfAttorneyAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class AttorneyClient extends ApiClientBase implements IAttorneyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/attorney?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfAttorneyAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/attorney";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/attorney/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICaseRequirementClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfCaseRequirementAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CaseRequirementClient extends ApiClientBase implements ICaseRequirementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/caseRequirement?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfCaseRequirementAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/caseRequirement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/caseRequirement/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICaseSettingLocationClient {
    /**
     * Get All
     * @param query (optional) 
     */
    getAll(query?: CaseSettingLocationQuery | undefined): Observable<CaseSettingLocationDto[]>;
    /**
     * Create
     */
    create(command: CreateCaseSettingLocationCommand): Observable<ApplicationResultOfCaseSettingLocationDto>;
    /**
     * Update
     */
    update(command: UpdateCaseSettingLocationCommand): Observable<ApplicationResultOfCaseSettingLocationDto>;
    /**
     * Delete
     */
    delete(id: number): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class CaseSettingLocationClient extends ApiClientBase implements ICaseSettingLocationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param query (optional) 
     */
    getAll(query?: CaseSettingLocationQuery | undefined): Observable<CaseSettingLocationDto[]> {
        let url_ = this.baseUrl + "/api/lookup/case-setting-location?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaseSettingLocationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaseSettingLocationDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CaseSettingLocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseSettingLocationDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateCaseSettingLocationCommand): Observable<ApplicationResultOfCaseSettingLocationDto> {
        let url_ = this.baseUrl + "/api/lookup/case-setting-location";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCaseSettingLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCaseSettingLocationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApplicationResultOfCaseSettingLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCaseSettingLocationDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     */
    update(command: UpdateCaseSettingLocationCommand): Observable<ApplicationResultOfCaseSettingLocationDto> {
        let url_ = this.baseUrl + "/api/lookup/case-setting-location";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfCaseSettingLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfCaseSettingLocationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApplicationResultOfCaseSettingLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfCaseSettingLocationDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete
     */
    delete(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/lookup/case-setting-location/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICaseTypeClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfCaseTypeAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CaseTypeClient extends ApiClientBase implements ICaseTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/caseType?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfCaseTypeAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/caseType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/caseType/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IClientClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfClientAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ClientClient extends ApiClientBase implements IClientClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/client?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfClientAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/client/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IExperienceLevelClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<ExperienceLevelDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfExperienceLevelAndExperienceLevelDto): Observable<ExperienceLevelDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ExperienceLevelClient extends ApiClientBase implements IExperienceLevelClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<ExperienceLevelDto[]> {
        let url_ = this.baseUrl + "/api/lookup/experienceLevel?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExperienceLevelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExperienceLevelDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ExperienceLevelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExperienceLevelDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfExperienceLevelAndExperienceLevelDto): Observable<ExperienceLevelDto> {
        let url_ = this.baseUrl + "/api/lookup/experienceLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExperienceLevelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExperienceLevelDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ExperienceLevelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExperienceLevelDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/experienceLevel/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFirmClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfFirmAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class FirmClient extends ApiClientBase implements IFirmClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/firm?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfFirmAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/firm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/firm/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ILanguageForCredentialClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfLanguageForCredentialAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class LanguageForCredentialClient extends ApiClientBase implements ILanguageForCredentialClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/languageForCredential?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfLanguageForCredentialAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/languageForCredential";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/languageForCredential/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ILawSchoolClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfLawSchoolAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class LawSchoolClient extends ApiClientBase implements ILawSchoolClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/lawSchool?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfLawSchoolAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/lawSchool";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/lawSchool/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMatterCodeClient {
    /**
     * Get All
     * @param query (optional) 
     */
    getAll(query?: MatterCodeQuery | undefined): Observable<MatterCodeDto[]>;
    /**
     * Create
     */
    create(command: CreateMatterCodeCommand): Observable<ApplicationResultOfMatterCodeDto>;
    /**
     * Update
     */
    update(command: UpdateMatterCodeCommand): Observable<ApplicationResultOfMatterCodeDto>;
    /**
     * Delete
     */
    delete(id: number): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class MatterCodeClient extends ApiClientBase implements IMatterCodeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param query (optional) 
     */
    getAll(query?: MatterCodeQuery | undefined): Observable<MatterCodeDto[]> {
        let url_ = this.baseUrl + "/api/lookup/matter-code?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MatterCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MatterCodeDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MatterCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MatterCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateMatterCodeCommand): Observable<ApplicationResultOfMatterCodeDto> {
        let url_ = this.baseUrl + "/api/lookup/matter-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfMatterCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfMatterCodeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApplicationResultOfMatterCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfMatterCodeDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     */
    update(command: UpdateMatterCodeCommand): Observable<ApplicationResultOfMatterCodeDto> {
        let url_ = this.baseUrl + "/api/lookup/matter-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfMatterCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfMatterCodeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApplicationResultOfMatterCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfMatterCodeDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete
     */
    delete(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/lookup/matter-code/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPhaseCodeClient {
    /**
     * Get All
     * @param caseId (optional) 
     */
    getAll(caseId?: number | null | undefined): Observable<PhaseCodeDto[]>;
    /**
     * Create
     */
    create(command: CreatePhaseCodeCommand): Observable<ApplicationResultOfPhaseCodeDto>;
    /**
     * Update
     */
    update(command: UpdatePhaseCodeCommand): Observable<ApplicationResultOfPhaseCodeDto>;
    /**
     * Delete
     */
    delete(id: number): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class PhaseCodeClient extends ApiClientBase implements IPhaseCodeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param caseId (optional) 
     */
    getAll(caseId?: number | null | undefined): Observable<PhaseCodeDto[]> {
        let url_ = this.baseUrl + "/api/lookup/phase-code?";
        if (caseId !== undefined && caseId !== null)
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhaseCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhaseCodeDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PhaseCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PhaseCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreatePhaseCodeCommand): Observable<ApplicationResultOfPhaseCodeDto> {
        let url_ = this.baseUrl + "/api/lookup/phase-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfPhaseCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfPhaseCodeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApplicationResultOfPhaseCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfPhaseCodeDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     */
    update(command: UpdatePhaseCodeCommand): Observable<ApplicationResultOfPhaseCodeDto> {
        let url_ = this.baseUrl + "/api/lookup/phase-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfPhaseCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfPhaseCodeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApplicationResultOfPhaseCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfPhaseCodeDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete
     */
    delete(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/lookup/phase-code/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerRejectedReasonClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerRejectedReasonAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerRejectedReasonClient extends ApiClientBase implements IReviewerRejectedReasonClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewerRejectedReason?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerRejectedReasonAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/reviewerRejectedReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewerRejectedReason/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerRequirementClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerRequirementAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerRequirementClient extends ApiClientBase implements IReviewerRequirementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewerRequirement?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerRequirementAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/reviewerRequirement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewerRequirement/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerTechnologyClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<ReviewerTechnologyDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerTechnologyAndReviewerTechnologyDto): Observable<ReviewerTechnologyDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerTechnologyClient extends ApiClientBase implements IReviewerTechnologyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<ReviewerTechnologyDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTechnology?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewerTechnologyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewerTechnologyDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReviewerTechnologyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewerTechnologyDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerTechnologyAndReviewerTechnologyDto): Observable<ReviewerTechnologyDto> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTechnology";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewerTechnologyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewerTechnologyDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ReviewerTechnologyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewerTechnologyDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTechnology/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerTimeEntryRejectedReasonClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerTimeEntryRejectedReasonAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerTimeEntryRejectedReasonClient extends ApiClientBase implements IReviewerTimeEntryRejectedReasonClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTimeEntryRejectedReason?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerTimeEntryRejectedReasonAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTimeEntryRejectedReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTimeEntryRejectedReason/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerTypeDeactivateReasonClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerTypeDeactivateReasonAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerTypeDeactivateReasonClient extends ApiClientBase implements IReviewerTypeDeactivateReasonClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTypeDeactivateReason?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerTypeDeactivateReasonAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTypeDeactivateReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTypeDeactivateReason/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerTypeWithdrawReasonClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerTypeWithdrawReasonAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerTypeWithdrawReasonClient extends ApiClientBase implements IReviewerTypeWithdrawReasonClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTypeWithdrawReason?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerTypeWithdrawReasonAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTypeWithdrawReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTypeWithdrawReason/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerTypeQuestionClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerTypeQuestionAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerTypeQuestionClient extends ApiClientBase implements IReviewerTypeQuestionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTypeQuestion?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerTypeQuestionAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTypeQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTypeQuestion/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerTypeRoleClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerTypeRoleAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerTypeRoleClient extends ApiClientBase implements IReviewerTypeRoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTypeRole?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerTypeRoleAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTypeRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewerTypeRole/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewLikelihoodClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<ReviewerTypeReviewLikelihoodDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerTypeReviewLikelihoodAndReviewerTypeReviewLikelihoodDto): Observable<ReviewerTypeReviewLikelihoodDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewLikelihoodClient extends ApiClientBase implements IReviewLikelihoodClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<ReviewerTypeReviewLikelihoodDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewLikelihood?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewerTypeReviewLikelihoodDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewerTypeReviewLikelihoodDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReviewerTypeReviewLikelihoodDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewerTypeReviewLikelihoodDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfReviewerTypeReviewLikelihoodAndReviewerTypeReviewLikelihoodDto): Observable<ReviewerTypeReviewLikelihoodDto> {
        let url_ = this.baseUrl + "/api/lookup/reviewLikelihood";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewerTypeReviewLikelihoodDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewerTypeReviewLikelihoodDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ReviewerTypeReviewLikelihoodDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewerTypeReviewLikelihoodDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/reviewLikelihood/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISpecialtyClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfSpecialtyAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class SpecialtyClient extends ApiClientBase implements ISpecialtyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/specialty?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfSpecialtyAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/specialty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/specialty/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStateBarStatusClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfStateBarStatusAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class StateBarStatusClient extends ApiClientBase implements IStateBarStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/stateBarStatus?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfStateBarStatusAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/stateBarStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/stateBarStatus/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITaskCodeClient {
    /**
     * Get By Phase
     */
    getByPhase(phaseCodeId: number): Observable<TaskCodeDto[]>;
    /**
     * Create
     */
    create(command: CreateTaskCodeCommand): Observable<ApplicationResultOfTaskCodeDto>;
    /**
     * Update
     */
    update(command: UpdateTaskCodeCommand): Observable<ApplicationResultOfTaskCodeDto>;
    /**
     * Delete
     */
    delete(id: number): Observable<ApplicationResult>;
}

@Injectable({
    providedIn: 'root'
})
export class TaskCodeClient extends ApiClientBase implements ITaskCodeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get By Phase
     */
    getByPhase(phaseCodeId: number): Observable<TaskCodeDto[]> {
        let url_ = this.baseUrl + "/api/lookup/task-code/by-phase/{phaseCodeId}";
        if (phaseCodeId === undefined || phaseCodeId === null)
            throw new globalThis.Error("The parameter 'phaseCodeId' must be defined.");
        url_ = url_.replace("{phaseCodeId}", encodeURIComponent("" + phaseCodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskCodeDto[]>;
        }));
    }

    protected processGetByPhase(response: HttpResponseBase): Observable<TaskCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateTaskCodeCommand): Observable<ApplicationResultOfTaskCodeDto> {
        let url_ = this.baseUrl + "/api/lookup/task-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfTaskCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfTaskCodeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApplicationResultOfTaskCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfTaskCodeDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update
     */
    update(command: UpdateTaskCodeCommand): Observable<ApplicationResultOfTaskCodeDto> {
        let url_ = this.baseUrl + "/api/lookup/task-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfTaskCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfTaskCodeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApplicationResultOfTaskCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfTaskCodeDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete
     */
    delete(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/lookup/task-code/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITechnologyDurationClient {
    /**
     * Get technology proficiency
     */
    getTechnologyProficiencies(): Observable<ApplicationResultOfListOfTechnologyProficiencyDto>;
}

@Injectable({
    providedIn: 'root'
})
export class TechnologyDurationClient extends ApiClientBase implements ITechnologyDurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get technology proficiency
     */
    getTechnologyProficiencies(): Observable<ApplicationResultOfListOfTechnologyProficiencyDto> {
        let url_ = this.baseUrl + "/api/technologyDuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTechnologyProficiencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTechnologyProficiencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfTechnologyProficiencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfTechnologyProficiencyDto>;
        }));
    }

    protected processGetTechnologyProficiencies(response: HttpResponseBase): Observable<ApplicationResultOfListOfTechnologyProficiencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfTechnologyProficiencyDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITechnologyServiceProviderClient {
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]>;
    /**
     * Create
     */
    create(command: CreateLookUpCommandOfTechnologyServiceProviderAndLookUpDto): Observable<LookUpDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class TechnologyServiceProviderClient extends ApiClientBase implements ITechnologyServiceProviderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/technologyServiceProvider?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateLookUpCommandOfTechnologyServiceProviderAndLookUpDto): Observable<LookUpDto> {
        let url_ = this.baseUrl + "/api/lookup/technologyServiceProvider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/technologyServiceProvider/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITimeCategoryClient {
    /**
     * Update Time Category
     */
    update(command: UpdateTimeCategoryCommand): Observable<ApplicationResult>;
    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<TimeCategoryDto[]>;
    /**
     * Create
     */
    create(command: CreateTimeCategoryCommand): Observable<TimeCategoryDto>;
    /**
     * Delete Time Category
     */
    delete(id: number): Observable<ApplicationResult>;
    /**
     * Get by company
     */
    getByCaseId(caseId: number): Observable<ApplicationResultOfListOfTimeCategoryDto>;
    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class TimeCategoryClient extends ApiClientBase implements ITimeCategoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Update Time Category
     */
    update(command: UpdateTimeCategoryCommand): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/lookup/timeCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param search (optional) 
     */
    getAll(search?: string | null | undefined): Observable<TimeCategoryDto[]> {
        let url_ = this.baseUrl + "/api/lookup/timeCategory?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeCategoryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TimeCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TimeCategoryDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create
     */
    create(command: CreateTimeCategoryCommand): Observable<TimeCategoryDto> {
        let url_ = this.baseUrl + "/api/lookup/timeCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeCategoryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TimeCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TimeCategoryDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Time Category
     */
    delete(id: number): Observable<ApplicationResult> {
        let url_ = this.baseUrl + "/api/lookup/timeCategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResult>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ApplicationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResult;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get by company
     */
    getByCaseId(caseId: number): Observable<ApplicationResultOfListOfTimeCategoryDto> {
        let url_ = this.baseUrl + "/api/lookup/timeCategory/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationResultOfListOfTimeCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationResultOfListOfTimeCategoryDto>;
        }));
    }

    protected processGetByCaseId(response: HttpResponseBase): Observable<ApplicationResultOfListOfTimeCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationResultOfListOfTimeCategoryDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All
     * @param query (optional) 
     * @param limit (optional) 
     */
    match(query?: string | undefined, limit?: number | undefined): Observable<LookUpDto[]> {
        let url_ = this.baseUrl + "/api/lookup/timeCategory/match?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookUpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookUpDto[]>;
        }));
    }

    protected processMatch(response: HttpResponseBase): Observable<LookUpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookUpDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnauthorizedResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ApplicationResult {
    succeed: boolean;
    errors: string[];
}

export interface ApplicationResultOfUserInfoDto extends ApplicationResult {
    data: UserInfoDto | undefined;
}

export interface UserInfoDto {
    id: number;
    email: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    avatarUrl: string | undefined;
    phoneNumber: string | undefined;
    isFromUsa: boolean;
    userName: string | undefined;
}

export interface ProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;

    [key: string]: any;
}

export interface HttpValidationProblemDetails extends ProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export interface ValidationProblemDetails extends HttpValidationProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export interface UpdateUserProfileCommand {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
}

export interface ApplicationResultOfAccountResultDto extends ApplicationResult {
    data: AccountResultDto | undefined;
}

export interface AccountResultDto {
    userId: number;
    accessToken: string;
    refreshToken: string;
    communicationServiceId: string | undefined;
}

export interface LoginCommand {
    email: string | undefined;
    password: string | undefined;
    scopes: string[];
}

export interface RefreshAuthTokenCommand {
    refreshToken: string | undefined;
    userId: number;
}

export interface ResetPasswordRequestCommand {
    email: string;
}

export interface ResetPasswordCommand {
    token: string | undefined;
    password: string | undefined;
}

export interface RegisterUserCommand {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    password: string | undefined;
    referralToken: string | undefined;
    referralSource: string | undefined;
    phoneNumber: string | undefined;
}

export interface RegisterCompanyUserCommand extends RegisterUserCommand {
}

export interface ApplicationResultOfCreateCompanyResponse extends ApplicationResult {
    data: CreateCompanyResponse | undefined;
}

export interface CreateCompanyResponse {
    id: number;
    name: string | undefined;
    streetName1: string | undefined;
    streetName2: string | undefined;
    address: AddressDto | undefined;
    billingInfo: CompanyBillingInfoDto | undefined;
    userId: number;
    companyId: number;
    accessToken: string;
    refreshToken: string;
    communicationServiceId: string | undefined;
}

export interface AddressDto {
    stateId: number | undefined;
    state: LocationDto | undefined;
    cityId: number | undefined;
    countryId: number;
    country: CountryDto;
    city: string | undefined;
    zip: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
}

export interface LookUpDto {
    id: number;
    name: string | undefined;
}

export interface LocationDto extends LookUpDto {
    code: string | undefined;
}

export interface CountryDto extends LocationDto {
    hasState: boolean;
}

export interface CompanyBillingInfoDto {
    contact: string | undefined;
    phone: string | undefined;
    address: AddressDto;
}

export interface RegisterInternalCompanyUserCommand extends RegisterUserCommand {
    companyName: string | undefined;
    timeZoneId: number;
}

export interface ApplicationResultOfUserVerificationResultDto extends ApplicationResult {
    data: UserVerificationResultDto | undefined;
}

export interface UserVerificationResultDto {
    email: string;
}

export interface VerifyUserCommand {
    token: string | undefined;
}

export interface CompanyUserExistCommand {
    securityCode: string | undefined;
}

export interface VerifyUser2FARequestCommand {
    email: string | undefined;
}

export interface RegisterReviewerCommand extends RegisterUserCommand {
    isInternal: boolean;
    countryId: number | undefined;
}

export interface ApplicationResultOfAcceptReviewerInviteResponse extends ApplicationResult {
    data: AcceptReviewerInviteResponse | undefined;
}

export interface AcceptReviewerInviteResponse {
    accessToken: string | undefined;
    refreshToken: string | undefined;
}

export interface AcceptCompanyStaffReviewerInviteCommand {
    securityCode: string | undefined;
    email: string | undefined;
}

export interface RequestJoinCommand {
    email: string;
    role: DemoJoinRequestRole;
}

export enum DemoJoinRequestRole {
    Client = "Client",
    Reviewer = "Reviewer",
}

export interface ChangePasswordCommand {
    currentPassword: string;
    newPassword: string;
}

export interface ApplicationResultOfListOfUserCompanyPermissionsDto extends ApplicationResult {
    data: UserCompanyPermissionsDto[] | undefined;
}

export interface UserCompanyPermissionsDto {
    companyId: number;
    userPermissionRoleId: number | undefined;
    permissions: string[];
}

export interface ApplicationResultOfListOfAdditionalServiceWithReviewerTypeDto extends ApplicationResult {
    data: AdditionalServiceWithReviewerTypeDto[] | undefined;
}

export interface ReviewerTypeAdditionalServiceDto {
    id: number;
    additionalServiceId: number;
    additionalServiceName: string | undefined;
    additionalServicePrice: number;
    additionalServiceRequiresMonthsSelect: boolean;
    checkIfOlderThanMonths: number | undefined;
    status: ReviewerTypeAdditionalServiceStatus;
}

export interface AdditionalServiceWithReviewerTypeDto extends ReviewerTypeAdditionalServiceDto {
    reviewerTypeId: number;
    reviewerTypeName: string;
    reviewerTypeCaseId: number;
    reviewerTypeCaseName: string;
    reviewerTypeCaseCompanyId: number;
    reviewerTypeCaseCompanyName: string;
}

export enum ReviewerTypeAdditionalServiceStatus {
    Pending = "Pending",
    Completed = "Completed",
}

export interface UpdateReviewerTypeAdditionalCheckStatusCommand {
    id: number;
    status: ReviewerTypeAdditionalServiceStatus;
}

export interface ApplicationResultOfListOfAgencyDto extends ApplicationResult {
    data: AgencyDto[] | undefined;
}

export interface AgencyDto {
    id: number;
    name: string;
    projectsCount: number;
    projects: AgencyProjectDto[];
}

export interface AgencyProjectDto {
    id: number;
    name: string | undefined;
    caseName: string | undefined;
    companyName: string | undefined;
}

export interface ApplicationResultOfAgencyDto extends ApplicationResult {
    data: AgencyDto | undefined;
}

export interface CreateAgencyCommand {
    name: string;
}

export interface ApplicationResultOfListOfLookUpDto extends ApplicationResult {
    data: LookUpDto[] | undefined;
}

export interface ApplicationResultOfAnnouncementManageDto extends ApplicationResult {
    data: AnnouncementManageDto | undefined;
}

export interface AnnouncementManageDto {
    reviewer: AnnouncementDetailsDto | undefined;
    company: AnnouncementDetailsDto | undefined;
}

export interface AnnouncementDetailsDto {
    id: number;
    message: string | undefined;
    isActive: boolean;
}

export interface SaveAnnouncementsCommand {
    reviewer: AnnouncementMutationModel;
    company: AnnouncementMutationModel;
}

export interface AnnouncementMutationModel {
    message: string;
    isActive: boolean;
}

export interface ApplicationResultOfListOfTempBillingDto extends ApplicationResult {
    data: TempBillingDto[] | undefined;
}

export interface TempBillingDto {
    companyId: number;
    companyName: string;
    monthWorked: string | undefined;
    amount: number | undefined;
    dueDate: Date | undefined;
    lateFeesAdded: number | undefined;
    totalOwed: number | undefined;
    paidDate: Date | undefined;
    invoiceId: string | undefined;
    invoiceDate: Date | undefined;
    daysUntilDue: number | undefined;
    url: string | undefined;
    project: string | undefined;
}

export interface ApplicationResultOfListOfReviewerSearchDto extends ApplicationResult {
    data: ReviewerSearchDto[] | undefined;
}

export interface ReviewerSearchDto {
    id: number;
    email: string;
    name: string;
}

export interface SearchReviewersQuery {
}

export interface ApplicationResultOfListOfNotificationTypeDto extends ApplicationResult {
    data: NotificationTypeDto[] | undefined;
}

export interface NotificationTypeDto {
    id: number;
    type: string | undefined;
    name: string | undefined;
    description: string | undefined;
    userNotificationSetting: UserNotificationSettingDto | undefined;
}

export interface UserNotificationSettingDto {
    hasEmail: boolean;
    hasSms: boolean;
    includeInDigest: boolean;
}

export interface ApplicationResultOfPaginatedResultOfNotificationsHistoryDto extends ApplicationResult {
    data: PaginatedResultOfNotificationsHistoryDto | undefined;
}

export interface PaginatedResultOfNotificationsHistoryDto {
    totalRecords: number;
    results: NotificationsHistoryDto[];
}

export interface NotificationsHistoryDto {
    id: number;
    userEmail: string;
    title: string;
    content: string;
    createdDate: Date;
    notificationTypeName: string;
    delivery: NotificationDeliveryMethodProjectable | undefined;
    status: NotificationStatus | undefined;
    exceptions: string[];
}

export enum NotificationDeliveryMethodProjectable {
    EmailSms = "EmailSms",
    Email = "Email",
    Sms = "Sms",
    AppOnly = "AppOnly",
}

export enum NotificationStatus {
    Delivered = "Delivered",
    SmsFail = "SmsFail",
    EmailFail = "EmailFail",
}

export interface PaginatedRequestOfNotificationsHistoryQueryFilters {
    first: number;
    rows: number;
    sortField: string | undefined;
    sortOrder: number | undefined;
    filters: NotificationsHistoryQueryFilters | undefined;
}

export interface NotificationsHistoryQuery extends PaginatedRequestOfNotificationsHistoryQueryFilters {
}

export interface NotificationsHistoryQueryFilters {
    content: StringQueryFilter | undefined;
    createdDate: DateQueryFilter | undefined;
    title: StringQueryFilter | undefined;
    userEmail: StringQueryFilter | undefined;
    notificationTypeName: ArrayQueryFilterOfString | undefined;
    delivery: ArrayQueryFilterOfString | undefined;
    status: ArrayQueryFilterOfString | undefined;
    exceptions: StringQueryFilter | undefined;
}

export interface QueryFilterOfStringAndString {
    value: string | undefined;
}

export interface StringQueryFilter extends QueryFilterOfStringAndString {
    matchMode: StringMatchMode;
}

export enum StringMatchMode {
    Contains = "Contains",
}

export interface QueryFilterOfNullableDateTimeOffsetAndNullableDateTimeOffset {
    value: Date | undefined;
}

export interface DateQueryFilter extends QueryFilterOfNullableDateTimeOffsetAndNullableDateTimeOffset {
    matchMode: DateMatchMode;
    operator: MultiFilterOperator | undefined;
}

export enum DateMatchMode {
    DateIs = "DateIs",
    DateIsNot = "DateIsNot",
    DateAfter = "DateAfter",
    DateBefore = "DateBefore",
}

export enum MultiFilterOperator {
    And = "And",
    Or = "Or",
}

export interface QueryFilterOfListOfStringAndString {
    value: string[] | undefined;
}

export interface ArrayQueryFilterOfString extends QueryFilterOfListOfStringAndString {
    matchMode: ArrayMatchMode;
}

export enum ArrayMatchMode {
    In = "In",
    Contains = "Contains",
}

export interface ApplicationResultOfListOfBackgroundCheckReviewerDto extends ApplicationResult {
    data: BackgroundCheckReviewerDto[] | undefined;
}

export interface ReviewerBasicDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    name: string | undefined;
    email: string;
    lastLoginDate: Date | undefined;
}

export interface BackgroundCheckReviewerDto extends ReviewerBasicDto {
    onProjectStatus: ReviewerOnProjectStatus;
    lastBackgroundCheckDate: Date | undefined;
    reviewerCreatedDate: Date | undefined;
    backgroundChecks: BackgroundCheckDto[];
    hasDocument: boolean;
}

export enum ReviewerOnProjectStatus {
    AddedToProject = "AddedToProject",
    AppliedOnProject = "AppliedOnProject",
    NeverAdded = "NeverAdded",
}

export interface BackgroundCheckDto {
    id: number;
    reviewerId: number;
    checkDate: Date;
    isClear: boolean;
    notes: string | undefined;
    reportDocumentId: number | undefined;
    reportDocument: DocumentDto | undefined;
}

export interface DocumentDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    url: string;
    key: string | undefined;
    createdDate: Date;
    fileExtension: string | undefined;
}

export interface ApplicationResultOfBackgroundCheckDto extends ApplicationResult {
    data: BackgroundCheckDto | undefined;
}

/** The result of running a validator */
export interface ValidationResult {
    /** Whether validation succeeded */
    isValid: boolean;
    /** A collection of errors */
    errors: ValidationFailure[] | undefined;
    /** The RuleSets that were executed during the validation run. */
    ruleSetsExecuted: string[] | undefined;
}

/** Defines a validation failure */
export interface ValidationFailure {
    /** The name of the property. */
    propertyName: string | undefined;
    /** The error message */
    errorMessage: string | undefined;
    /** The property value that caused the failure. */
    attemptedValue: any | undefined;
    /** Custom state associated with the failure. */
    customState: any | undefined;
    /** Custom severity level associated with the failure. */
    severity: Severity;
    /** Gets or sets the error code. */
    errorCode: string | undefined;
    /** Gets or sets the formatted message placeholder values. */
    formattedMessagePlaceholderValues: { [key: string]: any; } | undefined;
}

/** Specifies the severity of a rule. */
export enum Severity {
    Error = "Error",
    Warning = "Warning",
    Info = "Info",
}

export interface UpdateReviewerBackgroundCheckCommand {
    id: number;
    checkDate: Date;
    isClear: boolean;
    notes: string | undefined;
    reportDocumentId: number | undefined;
}

export interface CreateReviewerBackgroundCheckCommand {
    reviewerId: number;
    checkDate: Date;
    isClear: boolean;
    notes: string | undefined;
    reportDocumentId: number | undefined;
}

export interface ApplicationResultOfListOfLanguageTestReviewerDto extends ApplicationResult {
    data: LanguageTestReviewerDto[] | undefined;
}

export interface LanguageTestReviewerDto extends ReviewerBasicDto {
    reviewerCreatedDate: Date | undefined;
    reviewerLanguageTests: ReviewerLanguageTestDto[];
}

export interface ReviewerLanguageTestDto {
    id: number;
    languageId: number;
    languageName: string;
    isConfirmed: boolean;
    testLevel: string;
    testDate: Date;
    score: number;
    documents: DocumentDto[];
}

export interface ApplicationResultOfReviewerLanguageTestDto extends ApplicationResult {
    data: ReviewerLanguageTestDto | undefined;
}

export interface CreateReviewerLanguageTestCommand {
    reviewerId: number;
    languageId: number;
    isConfirmed: boolean;
    testLevel: string;
    testDate: Date;
    score: number;
    documentIds: number[];
}

export interface UpdateReviewerLanguageTestCommand {
    id: number;
    languageId: number;
    isConfirmed: boolean;
    testLevel: string;
    testDate: Date;
    score: number;
    documentIds: number[];
}

export interface ApplicationResultOfListOfAdminReviewerDto extends ApplicationResult {
    data: AdminReviewerDto[] | undefined;
}

export interface AdminReviewerDto {
    id: number;
    fullName: string;
    email: string;
    isActive: boolean;
    isBlocked: boolean;
    blocks: number;
    favorites: number;
    agency: AgencyDto | undefined;
}

export interface UpdateGlobalBlockCommand {
    reviewerId: number;
    isBlocked: boolean;
}

export interface UpdateReviewerAgencyCommand {
    reviewerId: number;
    agencyId: number | undefined;
}

export interface ApplicationResultOfAnnouncementDto extends ApplicationResult {
    data: AnnouncementDto | undefined;
}

export interface AnnouncementDto {
    id: number;
    message: string;
}

export interface MarkAnnouncementAcknowledgedCommand {
    announcementId: number;
}

export interface SignBoldsignDocumentCommand {
    documentId: number;
}

export interface DeclineBoldsignDocumentCommand {
    documentId: number;
}

export interface ApplicationResultOfDocumentDto extends ApplicationResult {
    data: DocumentDto | undefined;
}

export interface ApplicationResultOfListOfBoldsignTemplateDto extends ApplicationResult {
    data: BoldsignTemplateDto[] | undefined;
}

export interface BoldsignTemplateDto {
    id: number;
    name: string;
    description: string | undefined;
    documentTitle: string | undefined;
    boldsignTemplateStatus: BoldsignTemplateStatus;
    documentTypeId: BoldsignDocumentType;
    allowedToDelete: boolean;
    updatedDate: Date;
}

export enum BoldsignTemplateStatus {
    Draft = "Draft",
    Active = "Active",
    Inactive = "Inactive",
    Incomplete = "Incomplete",
    Copying = "Copying",
    CopyingFailed = "CopyingFailed",
}

export enum BoldsignDocumentType {
    ClientSubscriptionAgreement = "ClientSubscriptionAgreement",
    ReviewerTypeApplication = "ReviewerTypeApplication",
    CompanyForm = "CompanyForm",
    AltorneyFormsLibrary = "AltorneyFormsLibrary",
}

export interface ApplicationResultOfBoldsignTemplateEditDto extends ApplicationResult {
    data: BoldsignTemplateEditDto | undefined;
}

export interface BoldSignTemplateMutationModel {
    name: string;
    description: string | undefined;
    documentTitle: string | undefined;
    documentMessage: string | undefined;
}

export interface BoldsignTemplateEditDto extends BoldSignTemplateMutationModel {
    id: number;
    editUrl: string | undefined;
    viewUrl: string;
    completeCreationUrl: string;
    boldsignTemplateStatus: BoldsignTemplateStatus;
    documentTypeId: BoldsignDocumentType;
}

export interface ApplicationResultOfBoldsignTemplateStatus extends ApplicationResult {
    data: BoldsignTemplateStatus;
}

export interface ApplicationResultOfBoldSignTemplateCreateResult extends ApplicationResult {
    data: BoldSignTemplateCreateResult | undefined;
}

export interface BoldSignTemplateCreateResult {
    templateId: number;
    editLink: string;
}

export interface UpdateBoldsignTemplateCommand extends BoldSignTemplateMutationModel {
    templateId: number;
}

export interface ApplicationResultOfInteger extends ApplicationResult {
    data: number;
}

export interface CopyBoldsignTemplateCommand {
    originTemplateId: number;
    newName: string;
    newDocumentTitle: string;
}

export interface ApplicationResultOfListOfBoldsignDocumentDto extends ApplicationResult {
    data: BoldsignDocumentDto[] | undefined;
}

export interface BoldsignDocumentDto {
    id: number;
    userId: number;
    userName: string;
    status: BoldsignRequestStatus;
    dateSigned: Date | undefined;
    dateDeclined: Date | undefined;
    declineReason: string | undefined;
    reviewerTypeId: number | undefined;
    reviewerTypeCaseName: string | undefined;
    reviewerTypeName: string | undefined;
    signedDocument: DocumentDto | undefined;
    boldsignTemplateId: number;
    boldsignTemplateName: string | undefined;
}

export enum BoldsignRequestStatus {
    None = "None",
    WaitingForMe = "WaitingForMe",
    WaitingForOthers = "WaitingForOthers",
    NeedAttention = "NeedAttention",
    Completed = "Completed",
    Declined = "Declined",
    Revoked = "Revoked",
    Expired = "Expired",
    Draft = "Draft",
}

export interface ApplicationResultOfListOfBoldsignTemplateUsageDto extends ApplicationResult {
    data: BoldsignTemplateUsageDto[] | undefined;
}

export interface BoldsignTemplateUsageDto {
    caseDocumentId: number;
    caseId: number;
    caseName: string;
    reviewerTypeId: number | undefined;
    reviewerTypeName: string | undefined;
    documentType: CaseDocumentType;
    status: CaseDocumentStatus;
    signType: CaseDocumentSignType;
    isProjectDocument: boolean;
    isApplicationDocument: boolean;
    isAllowedToDelete: boolean;
}

export enum CaseDocumentType {
    Application = "Application",
    Project = "Project",
    All = "All",
}

export enum CaseDocumentStatus {
    Inactive = "Inactive",
    Active = "Active",
}

export enum CaseDocumentSignType {
    SignableForm = "SignableForm",
    ViewOnlyDocument = "ViewOnlyDocument",
}

export interface ApplicationResultOfListOfBoldsignTemplateSignerDto extends ApplicationResult {
    data: BoldsignTemplateSignerDto[] | undefined;
}

export interface BoldsignTemplateSignerDto {
    boldsignDocumentId: number | undefined;
    boldsignTemplateId: number;
    boldsignTemplateName: string;
    caseDocumentId: number | undefined;
    caseId: number | undefined;
    caseName: string | undefined;
    reviewerTypeId: number | undefined;
    reviewerTypeName: string | undefined;
    userId: number;
    userName: string;
    status: FormSigningStatus;
    dateSigned: Date | undefined;
    dateDeclined: Date | undefined;
    declineReason: string | undefined;
}

export enum FormSigningStatus {
    NotSigned = "NotSigned",
    Completed = "Completed",
    Declined = "Declined",
    Expired = "Expired",
    Revoked = "Revoked",
    Draft = "Draft",
    Sent = "Sent",
    WaitingForMe = "WaitingForMe",
    WaitingForOthers = "WaitingForOthers",
    NeedAttention = "NeedAttention",
}

export interface UpdateBoldsignTemplateStatusCommand {
    templateId: number;
    status: BoldsignTemplateStatus;
}

export interface ApplicationResultOfLinkRequestResult extends ApplicationResult {
    data: LinkRequestResult | undefined;
}

export interface LinkRequestResult {
    link: string;
    documentId: number;
    boldsignDocumentStatus: BoldsignRequestStatus;
}

export interface SignDocumentCommand {
    boldsignTemplateId: number;
}

export interface ApplicationResultOfListOfReviewerTypeAnnouncementDto extends ApplicationResult {
    data: ReviewerTypeAnnouncementDto[] | undefined;
}

export interface ReviewerTypeAnnouncementDto {
    id: number;
    reviewerTypeId: number | undefined;
    reviewerTypeName: string | undefined;
    canBeAcknowledged: boolean;
    content: string;
    createdDate: Date;
    endDate: Date | undefined;
}

export interface AddReviewerTypeAnnouncementCommand {
    caseId: number;
    reviewerTypeId: number | undefined;
    content: string;
    canBeAcknowledged: boolean;
    endDate: Date | undefined;
}

export interface ApplicationResultOfListOfAnnouncementAcknowledgementDto extends ApplicationResult {
    data: AnnouncementAcknowledgementDto[] | undefined;
}

export interface AnnouncementAcknowledgementDto {
    reviewerId: number;
    reviewerFullName: string;
    hasAcknowledged: boolean;
    acknowledgedDate: Date | undefined;
}

export interface ApplicationResultOfCreateCaseResponse extends ApplicationResult {
    data: CreateCaseResponse | undefined;
}

export interface CreateCaseResponse {
    id: number;
}

export interface CreateCaseCommand {
    name: string;
    userCaseId: string | undefined;
    estimatedDocCount: number;
    azureUserCreateThreshold: number;
    azureUserRemoveThreshold: number;
    relativityUserCreateThreshold: number;
    reviewerEmailsManageType: ReviewerEmailsManageType;
    chatMode: CompanyChatMode;
    isMobileChatsEnabled: boolean;
    timeEntryType: TimeEntryType;
    reviewerTimeEntryRemindNotificationTimeoutDays: number;
    reviewerTimeEntryPlatformDiffNotificationThresholdMinutes: number;
    relativityAuditsPollingStopThresholdDays: number;
    timeEntryMinuteInterval: number;
    timeEntryEnteringMaxDays: number;
    reviewerSummariesRequirement: RequiredValues;
    isTimeNotificationsEnabled: boolean;
    purgeAfterDays: number | undefined;
    timeZoneId: number | undefined;
    chatsAutoDeleteThresholdDays: number | undefined;
    isChatsAutoDeletePermanent: boolean;
    caseUsers: number[];
    caseClient: LookUpDto[];
    caseType: LookUpDto[];
    caseOutsideFirmName: LookUpDto[];
    opposingFirmName: LookUpDto[];
    caseLocation: LookUpDto[];
    actionCode: LookUpDto[];
    matterCode: LookUpDto[];
    casePhaseCode: LookUpDto[];
    caseTaskCode: LookUpDto[];
    caseOutsideAttorneyName: LookUpDto[];
    opposingAttorneyName: LookUpDto[];
    opposingParty: LookUpDto[];
    specificCaseRequirement: LookUpDto[];
    caseReviewerTechnology: LookUpDto[];
    technologyServiceProvider: LookUpDto[];
}

export enum ReviewerEmailsManageType {
    Altorney = "Altorney",
    Company = "Company",
    User = "User",
}

export enum CompanyChatMode {
    Enabled = "Enabled",
    Disabled = "Disabled",
    ReadOnly = "ReadOnly",
}

export enum TimeEntryType {
    Manual = "Manual",
    ClockIn = "ClockIn",
    None = "None",
}

export enum RequiredValues {
    No = "No",
    Yes = "Yes",
    Optional = "Optional",
}

export interface UpdateCaseCommand {
    caseId: number;
    name: string | undefined;
    userCaseId: string | undefined;
    estimatedDocCount: number;
    azureUserCreateThreshold: number;
    azureUserRemoveThreshold: number;
    relativityUserCreateThreshold: number;
    reviewerEmailsManageType: ReviewerEmailsManageType;
    chatMode: CompanyChatMode;
    isMobileChatsEnabled: boolean;
    purgeAfterDays: number | undefined;
    isTimeNotificationsEnabled: boolean;
    timeEntryType: TimeEntryType;
    reviewerTimeEntryRemindNotificationTimeoutDays: number;
    reviewerTimeEntryPlatformDiffNotificationThresholdMinutes: number;
    relativityAuditsPollingStopThresholdDays: number;
    timeEntryMinuteInterval: number;
    timeEntryEnteringMaxDays: number;
    reviewerSummariesRequirement: RequiredValues;
    timeZoneId: number | undefined;
    chatsAutoDeleteThresholdDays: number | undefined;
    isChatsAutoDeletePermanent: boolean;
    caseClient: LookUpDto[];
    caseType: LookUpDto[];
    caseOutsideFirmName: LookUpDto[];
    opposingFirmName: LookUpDto[];
    caseLocation: LookUpDto[];
    actionCode: LookUpDto[];
    matterCode: LookUpDto[];
    casePhaseCode: LookUpDto[];
    caseTaskCode: LookUpDto[];
    caseOutsideAttorneyName: LookUpDto[];
    opposingAttorneyName: LookUpDto[];
    opposingParty: LookUpDto[];
    specificCaseRequirement: LookUpDto[];
    caseReviewerTechnology: LookUpDto[];
    technologyServiceProvider: LookUpDto[];
}

export interface ApplicationResultOfListOfCompanyCaseDto extends ApplicationResult {
    data: CompanyCaseDto[] | undefined;
}

export interface CompanyCaseDto {
    id: number | undefined;
    name: string | undefined;
    companyId: number;
    companyName: string | undefined;
    numberOfReviewers: number;
    numberOfPendingReviewers: number;
    numberOfRequiredReviewers: number;
    cost: number;
    startDate: Date | undefined;
    endDate: Date | undefined;
    status: CaseStatus;
    chatMode: CompanyChatMode;
    totalHours: number;
    reviewStatus: ReviewerTypeReviewStatus;
}

export enum CaseStatus {
    Pending = "Pending",
    Closed = "Closed",
    Active = "Active",
}

export enum ReviewerTypeReviewStatus {
    NotAvailable = "NotAvailable",
    Loading = "Loading",
    AheadOfSchedule = "AheadOfSchedule",
    OnTime = "OnTime",
    BehindSchedule = "BehindSchedule",
    Completed = "Completed",
}

export interface ApplicationResultOfCaseDetailsResponse extends ApplicationResult {
    data: CaseDetailsResponse | undefined;
}

export interface CaseDetailsResponse {
    id: number;
    name: string | undefined;
    createdDate: Date;
    endDate: Date | undefined;
    companyId: number;
    companyIsInternalReviewers: boolean;
    companyReviewerEmailsManageType: ReviewerEmailsManageType;
    userCaseId: string | undefined;
    estimatedDocCount: number;
    numberOfReviewers: number;
    numberOfReviewerTypes: number;
    cost: number;
    relativityInstanceId: number | undefined;
    relativityWorkspaceId: number | undefined;
    relativityClientArtifactId: number | undefined;
    forecastLookbackDays: number;
    reviewerEmailsManageType: ReviewerEmailsManageType;
    chatMode: CompanyChatMode;
    isMobileChatsEnabled: boolean;
    isTimeNotificationsEnabled: boolean;
    timeEntryType: TimeEntryType;
    reviewerTimeEntryRemindNotificationTimeoutDays: number;
    reviewerTimeEntryPlatformDiffNotificationThresholdMinutes: number;
    timeEntryMinuteInterval: number;
    timeEntryEnteringMaxDays: number;
    isW2Company: boolean;
    totalHours: number;
    timeZoneId: number | undefined;
    timeZoneName: string | undefined;
    azureGroup: LookUpDto | undefined;
    languages: LookUpDto[];
    specialties: LookUpDto[];
    reviewerTechnologies: LookUpDto[];
    technologyServiceProviders: LookUpDto[];
    clients: LookUpDto[];
    caseTypes: LookUpDto[];
    firmsOutside: LookUpDto[];
    firmsOpposing: LookUpDto[];
    caseLocations: LookUpDto[];
    matterCodes: LookUpDto[];
    phaseCodes: LookUpDto[];
    taskCodes: LookUpDto[];
    phaseCodeIdsUsedInTimeEntries: number[];
    taskCodeIdsUsedInTimeEntries: number[];
    actionCodes: ActionCodeDto[];
    attorneysOutside: LookUpDto[];
    attorneysOpposing: LookUpDto[];
    caseRequirements: LookUpDto[];
    parties: LookUpDto[];
    status: CaseStatus;
    isRelativityInitialized: boolean;
    relativityManageUsers: boolean;
    relativityAccessAudits: boolean;
    isTemplate: boolean;
    azureUserCreateThreshold: number;
    azureUserRemoveThreshold: number;
    relativityUserCreateThreshold: number;
    canBeDeleted: boolean;
    purgeAfterDays: number | undefined;
    chatsAutoDeleteThresholdDays: number | undefined;
    isChatsAutoDeletePermanent: boolean;
    companyChatsAutoDeleteThresholdDays: number | undefined;
    companyIsChatsAutoDeletePermanent: boolean;
    relativityAuditsPollingStopThresholdDays: number;
    revenue: number;
    clientBudget: number;
    clientRemainingBudget: number;
    clientRemainingHours: number;
    clientSpend: number;
    netProfit: number;
}

export interface ActionCodeDto extends LookUpDto {
    companyId: number;
}

export interface ApplicationResultOfCasePendingReviewersResponse extends ApplicationResult {
    data: CasePendingReviewersResponse | undefined;
}

export interface CasePendingReviewersResponse {
    reviewerTypeQuestions: LookUpDto[];
    reviewers: CasePendingReviewerDto[];
}

export interface CasePendingReviewerDto {
    companyId: number;
    reviewerReviewerTypeId: number | undefined;
    reviewerId: number | undefined;
    reviewerRoleId: number;
    reviewerName: string | undefined;
    reviewerFirstName: string | undefined;
    reviewerLastName: string | undefined;
    dateSubmitted: Date | undefined;
    reviewerTypeName: string | undefined;
    reviewerTypeStartDate: Date;
    reviewerTypeId: number;
    reviewerTypeCaseId: number;
    reviewerTypeCaseName: string;
    reviewerRole: string | undefined;
    conflicts: string | undefined;
    status: ReviewerReviewerTypeStatus;
    approvalExpirationDate: Date | undefined;
    meetsRequirements: string;
    modifiedDate: Date | undefined;
    rating: number | undefined;
    numberOfRatings: number;
    reviewerTypeStatus: ReviewerTypeStatus;
    reviewerTypeInvitationId: number | undefined;
    inviteExpirationDate: Date | undefined;
    platformDocsReviewed: number;
    averageDocsPerHour: number;
    averageBilledHours: number | undefined;
    isActiveOnOtherProject: boolean;
    activeProjectEndDate: Date | undefined;
    reviewerTypeIsCompleted: boolean;
    relativityWorkspaceUser: RelativityOverallMetric | undefined;
    reviewerTags: ReviewerTagDto[];
    reviewerPendingQuestionYesNoAnswers: ReviewerPendingQuestionYesNoAnswerDto[];
    availableOnWeekend: boolean;
    specialties: string[];
    backgroundCheck: boolean;
    reviewerLocation: string | undefined;
    experienceLevelName: string | undefined;
    reviewTechnology: string | undefined;
    availableOnHoliday: boolean;
    languages: string[];
    barAdmission: boolean;
    timeZoneName: string | undefined;
    securityClearance: boolean;
    residency: string | undefined;
    militaryAssociation: boolean;
    isReviewerBlocked: boolean;
}

export enum ReviewerReviewerTypeStatus {
    Pending = "Pending",
    Approved = "Approved",
    Rejected = "Rejected",
    Declined = "Declined",
    Active = "Active",
    Inactive = "Inactive",
    Completed = "Completed",
    InviteDeclined = "InviteDeclined",
    Invited = "Invited",
    PendingStart = "PendingStart",
    InviteExpired = "InviteExpired",
    ApplicationExpired = "ApplicationExpired",
    OnHold = "OnHold",
    ApplicationPending = "ApplicationPending",
    Withdrawn = "Withdrawn",
}

export enum ReviewerTypeStatus {
    Paused = "Paused",
    Recruiting = "Recruiting",
    Pending = "Pending",
    Filled = "Filled",
    Completed = "Completed",
    Active = "Active",
    OnHold = "OnHold",
}

export interface RelativityFieldMetrics {
    docsReviewed: number;
    edits: number;
    score: number;
    overturns: number;
}

export interface RelativityMetrics extends RelativityFieldMetrics {
    minutes: number;
    speed: number;
}

export interface RelativityOverallMetric extends RelativityMetrics {
    scorePercentile: number;
    docsReviewedPercentile: number;
    speedPercentile: number;
}

export interface ReviewerTagDto {
    id: number;
    name: string;
    companyId: number | undefined;
    caseId: number | undefined;
    isArchived: boolean;
    isDefault: boolean;
    isCompany: boolean;
    isCase: boolean;
}

export interface ReviewerPendingQuestionYesNoAnswerDto {
    reviewerReviewerTypeId: number;
    reviewerTypeQuestionId: number;
    answer: boolean;
}

export interface ApplicationResultOfListOfCaseReviewerListDto extends ApplicationResult {
    data: CaseReviewerListDto[] | undefined;
}

export interface CaseReviewerListDto {
    id: number;
    reviewerReviewerTypeId: number;
    reviewerId: number;
    reviewerTypeId: number;
    reviewerTypeRoleId: number;
    caseId: number;
    caseCompanyId: number;
    hoursWorked: number;
    reviewerFirstName: string | undefined;
    reviewerLastName: string | undefined;
    reviewerName: string | undefined;
    reviewerFullName: string | undefined;
    reviewerEmail: string | undefined;
    reviewerPhoneNumber: string | undefined;
    reviewerTypeCaseName: string | undefined;
    reviewerTypeName: string | undefined;
    reviewerTypeRoleName: string | undefined;
    createdDate: Date;
    isActive: boolean;
    reviewerRating: number | undefined;
    reviewerRatingNumberOfRatings: number;
    reviewerOverallRating: number | undefined;
    reviewerOverallRatingNumberOfRatings: number;
    reviewerTypeStatus: ReviewerTypeStatus;
    status: ReviewerReviewerTypeStatus;
    startDate: Date | undefined;
    endDate: Date | undefined;
    averageBilledHours: number | undefined;
    isW2Company: boolean;
    isOnboarded: boolean;
    activeLeaveRequest: ReviewerReviewerTypeLeaveRequestDto | undefined;
    platformUserName: string | undefined;
    reviewerTags: ReviewerTagDto[];
    isReviewerBlocked: boolean;
}

export interface ReviewerReviewerTypeLeaveRequestDto {
    id: number;
    dateOfNotice: Date;
    lastDateAvailable: Date;
    comment: string | undefined;
    status: ReviewerReviewerTypeLeaveRequestStatus;
    feedback: string | undefined;
    withdrawReasonId: number;
    withdrawReasonName: string | undefined;
    allowWeekend: RequiredValues;
    allowHoliday: RequiredValues;
}

export enum ReviewerReviewerTypeLeaveRequestStatus {
    Pending = "Pending",
    Approved = "Approved",
    Denied = "Denied",
    Revoked = "Revoked",
}

export interface ApplicationResultOfListOfCasePendingRatingDto extends ApplicationResult {
    data: CasePendingRatingDto[] | undefined;
}

export interface CasePendingRatingDto {
    id: number;
    reviewerId: number;
    reviewerTypeId: number;
    reviewerTypeRoleId: number;
    reviewerReviewerTypeId: number;
    caseId: number;
    hoursWorked: number;
    reviewerName: string | undefined;
    reviewerFirstName: string | undefined;
    reviewerLastName: string | undefined;
    reviewerEmail: string | undefined;
    reviewerPhoneNumber: string | undefined;
    reviewerTypeName: string | undefined;
    reviewerTypeRoleName: string | undefined;
    createdDate: Date;
    startDate: Date;
    endDate: Date | undefined;
    ratingCloseDate: Date | undefined;
    reviewerTypeStatus: ReviewerTypeStatus;
    reviewerRating: RatingDto | undefined;
    status: ReviewerReviewerTypeStatus;
}

export interface RatingDto {
    id: number;
    rating: number;
    ratingComment: string | undefined;
    ratingReply: string | undefined;
    canBeReplied: boolean;
    status: RatingStatus;
    startDate: Date;
    endDate: Date | undefined;
    type: RatingType;
    revisionReason: string | undefined;
}

export enum RatingStatus {
    Pending = "Pending",
    Locked = "Locked",
    Visible = "Visible",
    LockedFeedback = "LockedFeedback",
    VisibleFeedback = "VisibleFeedback",
    NeedsRevision = "NeedsRevision",
    Rejected = "Rejected",
}

export enum RatingType {
    Reviewer = "Reviewer",
    Company = "Company",
}

export interface ApplicationResultOfListOfCaseDocumentDto extends ApplicationResult {
    data: CaseDocumentDto[] | undefined;
}

export interface CaseDocumentDto {
    id: number;
    name: string | undefined;
    internalName: string | undefined;
    status: CaseDocumentStatus;
    isAllowedToEdit: boolean;
    isAllowedToDelete: boolean;
    document: DocumentDto;
    boldsignTemplateId: number | undefined;
    signType: CaseDocumentSignType;
    documentType: CaseDocumentType;
    reviewerTypeId: number | undefined;
    signedDocument: BoldsignDocumentDto | undefined;
    isProjectDocument: boolean;
    isApplicationDocument: boolean;
}

export interface CreateSignableCaseDocumentCommand {
    caseId: number;
    reviewerTypeId: number | undefined;
    documentType: CaseDocumentType;
    boldsignTemplateId: number;
}

export interface ApplicationResultOfCaseDocumentDto extends ApplicationResult {
    data: CaseDocumentDto | undefined;
}

export interface UpdateCaseDocumentCommand {
    id: number;
    status: CaseDocumentStatus;
    documentType: CaseDocumentType;
}

export interface ApplicationResultOfCaseReviewerDto extends ApplicationResult {
    data: CaseReviewerDto | undefined;
}

export interface ReviewerDto {
    id: number;
    userId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    name: string | undefined;
    lawSchoolId: number | undefined;
    lawSchoolGraduationDate: Date | undefined;
    lawSchoolName: string | undefined;
    hasSecurityClearance: boolean;
    hasMilitaryAssociation: boolean;
    availableOnHolidays: boolean;
    availableOnWeekends: boolean;
    timeZone: LookUpDto | undefined;
    hasContractorAgreement: boolean;
    contractorAgreementSignature: string | undefined;
    contractorAgreementDate: Date | undefined;
    hasMutualArbitrationAgreement: boolean;
    mutualArbitrationAgreementSignature: string | undefined;
    mutualArbitrationAgreementDate: Date | undefined;
    bio: string | undefined;
    lastLoginLocation: string | undefined;
    lastLoginTime: Date | undefined;
    lastLoginIpAddress: string | undefined;
    currentLocation: AddressDto;
    totalHours: number;
    totalProjects: number;
    resumeDocument: DocumentDto | undefined;
    hasCovidVax: boolean;
    isInternal: boolean;
    reviewerProjectNotificationMode: ReviewerProjectNotificationMode;
    reviewerPayRates: ReviewerPayRateDto[];
    reviewerAvailabilities: ReviewerAvailibilityDto[];
    reviewerCalendars: ReviewerCalendarDto[];
    specialties: LookUpDto[];
    languages: LookUpDto[];
    reviewerTechnologies: ReviewerReviewerTechnologyDto[];
    reviewerBarMemberships: ProfileBarMembership[];
    reviewerLanguageTests: ReviewerLanguageTestDto[];
    completion: ReviewerProfileValidationResult | undefined;
    availableHours: number;
    altorneyEmailAddress: string | undefined;
    minAvailableDailyHours: number;
    minAvailableDailyHoursWeekDays: number;
    agencyId: number | undefined;
    agencyRate: number;
    emails: string[];
    createdDate: Date;
}

export interface CompanyReviewerDto extends ReviewerDto {
    rating: number | undefined;
    numberOfRatings: number;
    platformDocsReviewed: number;
    platformHours: number;
    averageDocsPerHour: number;
    alternateEmailAddress: string | undefined;
    platformUserName: string | undefined;
    clientEmployeeId: string | undefined;
    averageDailyBilledHours: number | undefined;
    productiveTime: number | undefined;
    isFavorite: boolean;
    isBlocked: boolean;
    reviewerId: number;
    isGlobalBlocked: boolean;
    trustedIps: CompanyTrustedIpDto[];
    backgroundChecks: CompanyReviewerBackgroundCheckDto[];
}

export interface CaseReviewerDto extends CompanyReviewerDto {
    additionalRequirementAnswers: AdditionalRequirementAnswers[];
    reviewerReviewerType: CaseReviewerReviewerReviewerTypeDto;
    hasAnyConflicts: boolean;
    hasProjectsHistory: boolean;
    reviewerCompany: CaseReviewerCompanyDto | undefined;
    blockedByCompaniesCount: number;
}

export interface AdditionalRequirementAnswers {
    reviewerRequirement: string | undefined;
    requirementAnswer: string | undefined;
}

export interface CaseReviewerReviewerReviewerTypeDto {
    id: number;
    isActive: boolean;
    isPendingStart: boolean;
    isOnHold: boolean;
    isOnboarded: boolean;
    reviewerId: number;
    reviewerTypeId: number;
    dateApproved: Date | undefined;
    companyReviewedDate: Date | undefined;
    reviewerDeclinedDate: Date | undefined;
    appliedDate: Date | undefined;
    status: ReviewerReviewerTypeStatus;
    reviewerType: CaseReviewerTypeDto;
    reviewerRating: number | undefined;
    reviewerRatingNumberOfRatings: number;
    companyRating: number | undefined;
    companyRatingNumberOfRatings: number;
    platformDocsReviewed: number;
    platformMinutes: number;
    platformHours: number;
    averageDocsPerHour: number;
    isRelativityActivatedInCase: boolean;
    reviewerRejectedReasonId: number | undefined;
    reviewerRejectedReasonName: string | undefined;
    reviewerRejectedOtherReason: string | undefined;
    reviewerTags: ReviewerTagDto[];
}

export interface CaseReviewerTypeDto {
    name: string | undefined;
    caseReviewerEmailsManageType: ReviewerEmailsManageType;
    caseName: string | undefined;
    numberOfRequiredReviewers: number;
    numberOfAppliedReviewers: number;
    numberOfPendingReviewers: number;
    numberOfAccepted: number;
    numberOfInvitedReviewers: number;
    numberOfActiveReviewers: number;
    startDate: Date;
    endDate: Date;
    status: ReviewerTypeStatus;
}

export interface CaseReviewerCompanyDto {
    companyId: number;
    isFavorite: boolean;
    isBlocked: boolean;
    alternateEmailAddress: string | undefined;
    platformUserName: string | undefined;
    clientEmployeeId: string | undefined;
    trustedIps: CompanyTrustedIpDto[];
}

export interface CompanyTrustedIpDto {
    id: number;
    ipAddress: string;
}

export interface CompanyReviewerBackgroundCheckDto {
    id: number;
    reviewerId: number;
    checkDate: Date;
    isClear: boolean;
    reportDocumentId: number | undefined;
}

export enum ReviewerProjectNotificationMode {
    All = "All",
    OnlyW2 = "OnlyW2",
    Only1099 = "Only1099",
}

export interface ReviewerPayRateDto {
    reviewerTypeRoleId: number;
    reviewerTypeRoleName: string;
    payRate: number;
}

export interface ReviewerAvailibilityDto {
    reviewerId: number;
    dayOfWeek: number;
    startTime: string | undefined;
    endTime: string | undefined;
}

export interface ReviewerCalendarDto {
    calendarDate: Date;
    isAvailable: boolean;
}

export interface ReviewerReviewerTechnologyDto {
    reviewerTechnologyName: string | undefined;
    technologyDurationDuration: string | undefined;
}

export interface ProfileBarMembership {
    stateName: string | undefined;
    countryName: string;
    countryCode: string;
    barId: string | undefined;
    isInactive: boolean;
    isActive: boolean;
    lastDateBarConfirmed: Date | undefined;
    stateBarStatuses: LookUpDto[];
    barConfirmationScreenshotDocument: DocumentDto | undefined;
    notes: string | undefined;
    stateBarHyperlink: string | undefined;
}

export interface ReviewerProfileValidationResult {
    isCompleted: boolean;
    errors: string[];
    createdDate: Date;
}

export interface ApplicationResultOfListOfOverallCasesSummaryDto extends ApplicationResult {
    data: OverallCasesSummaryDto[] | undefined;
}

export interface OverallCasesSummaryDto {
    id: number;
    name: string | undefined;
    createdDate: Date;
    caseTypes: LookUpDto[];
    clients: LookUpDto[];
    numberOfReviewers: number;
    numberOfReviewerTypes: number;
    cost: number;
    status: CaseStatus;
    companyId: number;
    companyName: string;
    totalHours: number;
    reviewStatus: ReviewerTypeReviewStatus;
    firstCaseType: LookUpDto | undefined;
    firstClient: LookUpDto | undefined;
    revenue: number;
}

export interface ApplicationResultOfListOfCaseBillingResponse extends ApplicationResult {
    data: CaseBillingResponse[] | undefined;
}

export interface CaseBillingResponse {
    caseId: number;
    caseName: string | undefined;
    dateIssued: Date | undefined;
    dateDue: Date | undefined;
    datePaid: Date | undefined;
    amount: number;
    discount: number;
    total: number;
    status: InvoiceStatus;
    daysPastDue: number | undefined;
}

export enum InvoiceStatus {
    Open = "Open",
    Paid = "Paid",
    PastDue = "PastDue",
}

export interface ApplicationResultOfDecimal extends ApplicationResult {
    data: number;
}

export interface ActivateReviewerCommand {
    reviewerId: number;
    reviewerTypeId: number;
}

export interface DeactivateReviewersCommand {
    reviewerReviewerTypeIds: number[];
    reviewerReviewerTypeDeactivateReasonId: number;
    reviewerReviewerTypeDeactivateOtherReason: string | undefined;
}

export interface UpdateRelativityFieldsCommand {
    caseId: number;
    relativityWorkspaceId: number | undefined;
    relativityClientArtifactId: number | undefined;
    relativityManageUsers: boolean;
    relativityAccessAudits: boolean;
}

export interface DownloadReviewersFilesCommand {
    caseId: number;
    reviewerIds: number[];
    reviewerReviewerTypeIds: number[];
    includeResumes: boolean;
    includeApplicationDocument: boolean;
    includeProjectDocuments: boolean;
}

export interface ApplicationResultOfCaseRelativityStatistic extends ApplicationResult {
    data: CaseRelativityStatistic | undefined;
}

export interface CaseRelativityStatistic {
    docsReviewed: number;
    totalMinutes: number;
    reviewersCount: number;
    averageDocsPerHour: number;
}

export interface ApplicationResultOfListOfReviewerOverallMetricsDto extends ApplicationResult {
    data: ReviewerOverallMetricsDto[] | undefined;
}

export interface ReviewerOverallMetricsDto extends RelativityOverallMetric {
    reviewerReviewerTypes: ReviewerMetricsProjectDto[];
    reviewerId: number;
    reviewer: ReviewerBasicDto;
    isActive: boolean;
    fields: ReviewerFieldOverallMetrics[];
}

export interface ReviewerMetricsProjectDto {
    id: number;
    reviewerId: number;
    reviewerTypeId: number;
    reviewerTypeName: string | undefined;
}

export interface FieldOverallMetrics extends RelativityFieldMetrics {
    fieldName: string;
}

export interface ReviewerFieldOverallMetrics extends FieldOverallMetrics {
    reviewerId: number;
}

export interface ApplicationResultOfRelativityOverallMetric extends ApplicationResult {
    data: RelativityOverallMetric | undefined;
}

export interface ApplicationResultOfListOfReviewerTimeSeriesMetricsDto extends ApplicationResult {
    data: ReviewerTimeSeriesMetricsDto[];
}

export interface ReviewerTimeSeriesMetricsDto {
    reviewerReviewerTypes: ReviewerMetricsProjectDto[];
    reviewer: ReviewerBasicDto;
    metrics: RelativityTimeSeriesMetrics[];
}

export interface RelativityTimeSeriesMetrics extends RelativityMetrics {
    dateWorked: Date;
}

export enum CaseMetricsInterval {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export interface ApplicationResultOfListOfBaseRelativityFieldDto extends ApplicationResult {
    data: BaseRelativityFieldDto[] | undefined;
}

export interface BaseRelativityFieldDto {
    id: number;
    name: string;
    fieldType: string;
    artifactId: number;
}

export interface ApplicationResultOfCaseActivityMetricsDto extends ApplicationResult {
    data: CaseActivityMetricsDto;
}

export interface CaseActivityMetricsDto {
    types: string[];
    samplingIntervalMinutes: number;
    timeSeries: CaseActivityTimeSeriesDto[];
}

export interface CaseActivityTimeSeriesDto {
    dateTime: Date;
    values: { [key: string]: number; };
}

export interface ApplicationResultOfListOfRelativityFieldStatisticDto extends ApplicationResult {
    data: RelativityFieldStatisticDto[] | undefined;
}

export interface RelativityFieldStatisticDto {
    documentArtifactId: number;
    score: number;
    firstEdit: Date;
    finalValue: string | undefined;
    currentValue: string | undefined;
    lastEdit: Date;
    relativityField: RelativityFieldMetricsDto;
    case: LookUpDto;
}

export interface RelativityFieldMetricsDto {
    id: number;
    artifactId: number;
    name: string;
    workspace: RelativityWorkspaceMetricsDto;
}

export interface RelativityWorkspaceMetricsDto {
    id: number;
    artifactId: number;
    instanceId: number;
    instanceUrl: string;
}

export interface ApplicationResultOfListOfRelativityCaseDto extends ApplicationResult {
    data: RelativityCaseDto[] | undefined;
}

export interface RelativityCaseDto {
    id: number;
    name: string | undefined;
    relativityWorkspaceId: number | undefined;
    reviewerTechnologies: LookUpDto[] | undefined;
    relativityWorkspace: RelativityWorkspaceCaseDto | undefined;
}

export interface RelativityWorkspaceCaseDto {
    id: number;
    name: string;
    relativityName: string | undefined;
    instanceId: number;
    instanceUrl: string;
    instanceName: string;
    workspaceName: string;
}

export interface SendNotificationToReviewersCommand {
    caseId: number;
    reviewerIds: number[];
    message: string;
}

export interface ApplicationResultOfListOfCaseMetricsExportScheduleDto extends ApplicationResult {
    data: CaseMetricsExportScheduleDto[] | undefined;
}

export interface CaseMetricsExportScheduleDto {
    id: number;
    schedule: string;
    isPaused: boolean;
    targets: CaseMetricsExportScheduleTargetDto[];
}

export interface CaseMetricsExportScheduleTargetDto {
    id: number;
    email: string;
}

export interface SaveCaseMetricsScheduleSettingsCommand {
    caseId: number;
    schedule: CaseMetricsExportScheduleMutationModel;
}

export interface CaseMetricsExportScheduleMutationModel {
    id: number;
    schedule: string;
    isPaused: boolean;
    emails: string[];
}

export interface ApplicationResultOfListOfCaseMeetingDto extends ApplicationResult {
    data: CaseMeetingDto[] | undefined;
}

export interface CaseMeetingDto {
    id: number;
    name: string;
    start: Date;
    end: Date | undefined;
    timeZoneName: string | undefined;
    timeZoneFormat: string | undefined;
}

export interface ApplicationResultOfCaseMeetingDetailsDto extends ApplicationResult {
    data: CaseMeetingDetailsDto | undefined;
}

export interface CaseMeetingDetailsDto extends CaseMeetingDto {
    timeZoneId: number | undefined;
    timeZoneFormat: string | undefined;
    description: string | undefined;
    isRecurringEvent: boolean;
    frequency: FrequencyType | undefined;
    interval: number | undefined;
    lastOccurrenceDate: Date | undefined;
    untilDate: Date | undefined;
    url: string | undefined;
    weekDays: number[];
    excludedDays: Date[];
    reviewerTypeIds: number[];
    reviewerTypeInitialTrainings: ReviewerTypeListDto[];
}

export enum FrequencyType {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
    Yearly = "Yearly",
}

export interface ReviewerTypeListDto {
    id: number;
    caseId: number;
    name: string | undefined;
    reviewerTypeRole: LookUpDto | undefined;
    documentCount: number;
    startDate: Date;
    endDate: Date;
    createdDate: Date;
    numberOfActiveReviewers: number;
    numberOfPendingReviewers: number;
    numberOfRequiredReviewers: number;
    numberOfAccepted: number;
    numberOfInvitedReviewers: number;
    rate: number;
    status: ReviewerTypeStatus;
    recruitingStatus: ReviewerTypeRecruitingStatus;
    isRecruitingStatus: boolean;
    isRequirementsCompleted: boolean;
    isInternal: boolean;
}

export enum ReviewerTypeRecruitingStatus {
    Inactive = "Inactive",
    Active = "Active",
}

export interface BaseCaseMeetingMutationCommand {
    name: string;
    description: string | undefined;
    url: string | undefined;
    start: Date;
    end: Date | undefined;
    timeZoneId: number | undefined;
    isRecurringEvent: boolean;
    frequency: FrequencyType | undefined;
    interval: number | undefined;
    lastOccurrenceDate: Date | undefined;
    weekDays: DayOfWeek[];
    reviewerTypeIds: number[];
}

export interface CreateCaseMeetingCommand extends BaseCaseMeetingMutationCommand {
    caseId: number;
}

export enum DayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export interface ApplicationResultOfCaseMeetingDto extends ApplicationResult {
    data: CaseMeetingDto | undefined;
}

export interface UpdateCaseMeetingCommand extends BaseCaseMeetingMutationCommand {
    id: number;
}

export interface ExcludeDateFromRecurringEventCommand {
    caseMeetingId: number;
    start: Date;
    end: Date;
}

export interface DeleteThisAndTheFollowingEventsCommand {
    caseMeetingId: number;
    start: Date;
    end: Date;
}

export interface SetIsPausedCaseMetricsScheduleCommand {
    id: number;
    isPaused: boolean;
}

export interface ApplicationResultOfCaseMetricsExportScheduleUnsubscribeResultDto extends ApplicationResult {
    data: CaseMetricsExportScheduleUnsubscribeResultDto | undefined;
}

export interface CaseMetricsExportScheduleUnsubscribeResultDto {
    caseName: string | undefined;
    companyName: string | undefined;
}

export interface ApplicationResultOfCompanyCaseSettingsDto extends ApplicationResult {
    data: CompanyCaseSettingsDto | undefined;
}

export interface CompanyCaseSettingsDto {
    timeEntryType: TimeEntryType;
    reviewerEmailsManageType: ReviewerEmailsManageType;
    inviteExpirationHours: number;
    reviewerTimeEntryRemindNotificationTimeoutDays: number;
    reviewerTimeEntryPlatformDiffNotificationThresholdMinutes: number;
    timeEntryMinuteInterval: number;
    azureUserCreateThreshold: number;
    azureUserRemoveThreshold: number;
    relativityUserCreateThreshold: number;
    weeklyThresholdWarningValue: number;
    weeklyThresholdDangerValue: number;
    weeklyTimeEntriesThresholdType: TimeEntriesThresholdType;
    dailyThresholdWarningValue: number;
    dailyThresholdDangerValue: number;
    dailyTimeEntriesThresholdType: TimeEntriesThresholdType;
    azureDLPrefix: string;
    companyChatCloseTimeoutDays: number;
    autoApplyAllocationsDayOfWeek: number;
    autoApplyAllocationsTime: string;
    chatMode: CompanyChatMode;
    isMobileChatsEnabled: boolean;
    timeEntryEnteringMaxDays: number;
    chatsAutoDeleteThresholdDays: number | undefined;
    isChatsAutoDeletePermanent: boolean;
    reviewerRatingsVisibility: ReviewerRatingsVisibility;
    relativityAuditsPollingStopThresholdDays: number;
    allowOvertimeByRule: boolean;
    reviewerSummariesRequirement: RequiredValues;
    reviewerSummariesType: ReviewerSummaryDateType;
    isPhaseAndTaskCodesEnabled: boolean;
    relativityIdleTimeSeconds: number;
}

export enum TimeEntriesThresholdType {
    Percentage = "Percentage",
    Hours = "Hours",
}

export enum ReviewerRatingsVisibility {
    Global = "Global",
    Company = "Company",
}

export enum ReviewerSummaryDateType {
    Daily = "Daily",
    Weekly = "Weekly",
}

export interface UpdateCompanyEmailSettingsCommand {
    reviewerEmailsManageType: ReviewerEmailsManageType;
    azureUserCreateThreshold: number;
    azureUserRemoveThreshold: number;
    azureDLPrefix: string;
}

export interface UpdateCompanyRelativitySettings {
    relativityUserCreateThreshold: number;
    relativityAuditsPollingStopThresholdDays: number;
    relativityIdleTimeSeconds: number;
}

export interface UpdateCompanyReviewerInviteSettingsCommand {
    inviteExpirationHours: number;
}

export interface UpdateCompanyTimeEntryTypeCommand {
    weeklyThresholdWarningValue: number;
    weeklyThresholdDangerValue: number;
    weeklyTimeEntriesThresholdType: TimeEntriesThresholdType;
    dailyThresholdWarningValue: number;
    dailyThresholdDangerValue: number;
    dailyTimeEntriesThresholdType: TimeEntriesThresholdType;
    timeEntryType: TimeEntryType;
    reviewerTimeEntryRemindNotificationTimeoutDays: number;
    reviewerTimeEntryPlatformDiffNotificationThresholdMinutes: number;
    timeEntryMinuteInterval: number;
    timeEntryEnteringMaxDays: number;
    allowOvertimeByRule: boolean;
    reviewerSummariesRequirement: RequiredValues;
    reviewerSummariesType: ReviewerSummaryDateType;
}

export interface UpdateCompanyChatSettingsCommand {
    companyChatCloseTimeoutDays: number;
    chatMode: CompanyChatMode;
    isMobileChatsEnabled: boolean;
    chatsAutoDeleteThresholdDays: number | undefined;
    isChatsAutoDeletePermanent: boolean;
}

export interface UpdateInternalCompanySettingsCommand {
    autoApplyAllocationsDayOfWeek: number;
    autoApplyAllocationsTime: string;
}

export interface ApplicationResultOfUserCompanySettingsDto extends ApplicationResult {
    data: UserCompanySettingsDto | undefined;
}

export interface UserCompanySettingsDto {
    autoFillStartFromPrevious: boolean;
}

export interface UpdateUserCompanySettingsCommand {
    autoFillStartFromPrevious: boolean;
}

export interface UpdateCompanyRatingSettingsCommand {
    reviewerRatingsVisibility: ReviewerRatingsVisibility;
}

export interface UpdateCompanyPhaseAndTaskCodesSettingsCommand {
    isPhaseAndTaskCodesEnabled: boolean;
}

export interface ApplicationResultOfListOfCaseUserDto extends ApplicationResult {
    data: CaseUserDto[] | undefined;
}

export interface CaseUserDto {
    userId: number;
    email: string;
    fullName: string;
    name: string;
    role: string;
    caseId: number;
    caseName: string;
    notificationsEnabled: boolean;
}

export interface ApplicationResultOfListOfUserCompanyDto extends ApplicationResult {
    data: UserCompanyDto[] | undefined;
}

export interface UserCompanyDto {
    id: number;
    userId: number;
    companyId: number;
    userFirstName: string | undefined;
    userLastName: string | undefined;
    userEmail: string | undefined;
    userName: string | undefined;
    roleId: number | undefined;
    isActive: boolean;
    isPrimary: boolean;
    roleName: string | undefined;
    userPermissionRoleName: string | undefined;
    displayRoleName: string | undefined;
    status: string | undefined;
    userPermissionRoleId: number | undefined;
}

export interface ApplicationResultOfListOfAvailableCaseDto extends ApplicationResult {
    data: AvailableCaseDto[] | undefined;
}

export interface AvailableCaseDto {
    id: number;
    name: string;
    companyName: string;
    createdDate: Date;
    caseTypes: LookUpDto[];
    clients: LookUpDto[];
    firstCaseType: LookUpDto | undefined;
    firstClient: LookUpDto | undefined;
    status: CaseStatus;
    numberOfReviewers: number;
    numberOfReviewerTypes: number;
    userCompanyId: number | undefined;
    isAssignedToCase: boolean;
}

export interface ApplicationResultOfListOfInteger extends ApplicationResult {
    data: number[] | undefined;
}

export interface ApplicationResultOfCaseUserDto extends ApplicationResult {
    data: CaseUserDto | undefined;
}

export interface UpdateCaseUserNotificationSettingsCommand {
    caseId: number;
    notificationsEnabled: boolean;
}

export interface ApplicationResultOfCommunicationServiceTokenResponse extends ApplicationResult {
    data: CommunicationServiceTokenResponse | undefined;
}

export interface CommunicationServiceTokenResponse {
    token: string;
    endpointUrl: string;
    expiresOn: Date;
    communicationServiceUserId: string;
}

export interface ApplicationResultOfListOfChatThreadListDto extends ApplicationResult {
    data: ChatThreadListDto[] | undefined;
}

export interface ChatThreadListDto {
    id: number;
    topic: string;
    threadId: string;
    displayName: string;
    additionalInfo: string;
    createdDate: Date;
    lastActivity: Date | undefined;
    unreadMessages: number;
    isMentioned: boolean;
    isReadOnly: boolean;
    isMobileEnabled: boolean;
    isArchived: boolean;
    isPinned: boolean;
    lastMessage: ChatMessageBasicDto | undefined;
}

export interface ChatMessageBasicDto {
    id: number;
    userId: number;
    senderDisplayName: string;
    senderRole: string;
    companyName: string | undefined;
    createdDate: Date | undefined;
    content: string;
    status: ChatMessageDeliveryStatus;
    uuid: string | undefined;
    externalId: string | undefined;
    parentMessageId: number | undefined;
    replyInThreadAndChatMessageId: number | undefined;
}

export enum ChatMessageDeliveryStatus {
    Sent = "Sent",
    Read = "Read",
}

export interface ChatThreadsQuery {
}

export interface ApplicationResultOfSyncDataModelOfChatThreadListDto extends ApplicationResult {
    data: SyncDataModelOfChatThreadListDto | undefined;
}

export interface SyncDataModelOfChatThreadListDto {
    modified: ChatThreadListDto[];
    deleted: number[];
    nextCheckpoint: Date;
    hasMore: boolean;
}

export interface ApplicationResultOfChatThreadDto extends ApplicationResult {
    data: ChatThreadDto | undefined;
}

export interface ChatThreadDto extends ChatThreadListDto {
    chatParticipants: ChatParticipantDto[];
    isGroupThread: boolean;
    isCaseThread: boolean;
    isReviewerTypeThread: boolean;
    isSupportThread: boolean;
    isCompanySupportThread: boolean;
    isClientGroupThread: boolean;
    isP2PThread: boolean;
    status: ChatThreadStatus;
    mode: CompanyChatMode;
    firstUnreadMessageId: number | undefined;
    replyMessageId: number | undefined;
    replyMessage: ChatMessageDto | undefined;
    parentThreadId: number | undefined;
    parentThreadStatus: ChatThreadStatus | undefined;
    parentThreadParticipants: ChatParticipantDto[] | undefined;
}

export interface ChatParticipantDto {
    id: number;
    userId: number;
    displayName: string;
    isAddedByUser: boolean;
    userRole: string;
    companyName: string | undefined;
    userCommunicationServiceId: string;
}

export enum ChatThreadStatus {
    Active = "Active",
    Closed = "Closed",
    ReadOnly = "ReadOnly",
}

export interface ChatMessageDto extends ChatMessageBasicDto {
    parentMessage: ChatParentMessageDto | undefined;
    hasAttachments: boolean;
    attachments: DocumentDto[];
    chatMessageReactions: ChatMessageReactionDto[];
    chatMessageMentions: ChatMessageMentionDto[];
    isStarred: boolean;
    replyThreadId: number | undefined;
    replyMessagesCount: number | undefined;
    lastReplyAt: Date | undefined;
    unreadMessages: number;
}

export interface ChatParentMessageDto {
    id: number;
    userId: number;
    senderDisplayName: string;
    senderRole: string;
    companyName: string | undefined;
    content: string;
    createdDate: Date | undefined;
    attachments: DocumentDto[];
    replyThreadId: number | undefined;
}

export interface ChatMessageReactionDto {
    userId: number;
    userName: string;
    userRole: string;
    companyName: string | undefined;
    emojiKey: string;
    emojiName: string;
    emojiNative: string;
    emojiSkinKey: string | undefined;
}

export interface ChatMessageMentionDto {
    userId: number;
    userName: string;
}

export interface DeleteChatThreadCommand {
    threadId: number;
    communicationServiceToken: string;
}

export interface ApplicationResultOfListOfChatMessageDto extends ApplicationResult {
    data: ChatMessageDto[] | undefined;
}

export interface ApplicationResultOfChatMessageDto extends ApplicationResult {
    data: ChatMessageDto | undefined;
}

export interface SendChatMessageCommand {
    threadId: number;
    message: string;
    communicationServiceToken: string | undefined;
    attachments: DocumentDto[];
    uuid: string;
    parentMessageId: number | undefined;
    replyMessageId: number | undefined;
    alsoSendToChat: boolean | undefined;
}

export interface AddMessageReactionCommand {
    chatMessageId: number;
    emojiKey: string;
    emojiName: string;
    emojiNative: string;
    emojiSkinKey: string | undefined;
}

export interface RemoveMessageReactionCommand {
    chatMessageId: number;
    emojiKey: string;
}

export interface ApplicationResultOfChatSearchResponse extends ApplicationResult {
    data: ChatSearchResponse | undefined;
}

export interface ChatSearchResponse {
    messages: ChatSearchMessageDto[];
}

export interface ChatSearchMessageDto {
    id: number;
    userId: number;
    createdDate: Date | undefined;
    content: string;
    status: ChatMessageDeliveryStatus;
    uuid: string | undefined;
    chatThreadId: number;
    chatThreadThreadId: string;
    displayName: string | undefined;
    attachments: ChatSearchMessageAttachmentDto[];
}

export interface ChatSearchMessageAttachmentDto {
    name: string | undefined;
    description: string | undefined;
    fileExtension: string | undefined;
}

export interface GetOrCreatePeerToPeerChatThreadCommand {
    communicationServiceToken: string;
    secondUserId: number;
}

export interface CreateGroupChatThreadCommand {
    communicationServiceToken: string;
    participantUserIds: number[];
    chatName: string;
}

export interface GetOrCreateReplyMessageThreadCommand {
    communicationServiceToken: string;
    replyMessageId: number;
}

export interface ApplicationResultOfChatUnreadMessagesResponse extends ApplicationResult {
    data: ChatUnreadMessagesResponse | undefined;
}

export interface ChatUnreadMessagesResponse {
    unreadMessages: number;
}

export interface ApplicationResultOfChatUnreadMessagesGroupedResponse extends ApplicationResult {
    data: ChatUnreadMessagesGroupedResponse | undefined;
}

export interface ChatUnreadMessagesGroupedResponse {
    unreadMessages: { [key: string]: number; };
    mentionedThreads: string[];
}

export interface SetThreadAsReadCommand {
    threadId: number;
    communicationServiceToken: string | undefined;
}

export interface ApplicationResultOfListOfChatParticipantDto extends ApplicationResult {
    data: ChatParticipantDto[] | undefined;
}

export interface AddParticipantsToGroupChatCommand {
    threadId: number;
    participantUserIds: number[];
    communicationServiceToken: string;
    isHidden: boolean;
    isAddedByUser: boolean;
}

export interface ApplicationResultOfListOfUserDto extends ApplicationResult {
    data: UserDto[] | undefined;
}

export interface UserDto {
    id: number;
    name: string | undefined;
    email: string;
    isActive: boolean;
    emailConfirmed: boolean;
    createdDate: Date | undefined;
    fullName: string;
    roles: RoleDto[];
    companies: LookUpDto[];
    role: RoleDto;
    company: LookUpDto | undefined;
    isLoggedIn: boolean;
    canBeDeleted: boolean;
}

export interface RoleDto {
    id: number;
    name: string;
}

export interface ApplicationResultOfChatReviewerReviewerTypesResponse extends ApplicationResult {
    data: ChatReviewerReviewerTypesResponse | undefined;
}

export interface ChatReviewerReviewerTypesResponse {
    companies: ChatCompanyResponse[];
}

export interface ChatCompanyResponse {
    id: number;
    name: string;
    cases: ChatCaseResponse[];
}

export interface ChatCaseResponse {
    id: number;
    name: string;
    reviewerTypes: ChatReviewerTypeResponse[];
}

export interface ChatReviewerTypeResponse {
    id: number;
    name: string;
}

export interface ErrorResponse {
    statusCode: number;
    title: string | undefined;
    details: string | undefined;
}

export interface UnauthorizedResponse extends ErrorResponse {
    statusCode: number;
}

export interface ForbiddenResponse extends ErrorResponse {
    statusCode: number;
}

export interface ApplicationResultOfFileUrlDto extends ApplicationResult {
    data: FileUrlDto | undefined;
}

export interface FileUrlDto {
    url: string | undefined;
}

export interface ApplicationResultOfListOfDocumentDto extends ApplicationResult {
    data: DocumentDto[] | undefined;
}

export interface ExportChatThreadCommand {
    chatThreadId: number;
    chatDisplayName: string | undefined;
}

export interface ArchiveChatThreadCommand {
    chatThreadId: number;
    isArchived: boolean;
}

export interface PinChatThreadCommand {
    chatThreadId: number;
    isPinned: boolean;
}

export interface ApplicationResultOfChatSearchTitleResponse extends ApplicationResult {
    data: ChatSearchTitleResponse | undefined;
}

export interface ChatSearchTitleResponse {
    threads: ChatThreadListDto[];
}

export interface ApplicationResultOfListOfChatRingtoneDto extends ApplicationResult {
    data: ChatRingtoneDto[] | undefined;
}

export interface ChatRingtoneDto {
    id: number;
    name: string | undefined;
    fileName: string | undefined;
}

export interface ApplicationResultOfClientAgreementStatus extends ApplicationResult {
    data: ClientAgreementStatus;
}

export enum ClientAgreementStatus {
    Created = "Created",
    Signed = "Signed",
    Declined = "Declined",
    Legacy = "Legacy",
}

export interface GenerateClientSubscriptionAgreementLinkCommand {
}

export interface ApplicationResultOfListOfUserUserCompanyDto extends ApplicationResult {
    data: UserUserCompanyDto[] | undefined;
}

export interface UserUserCompanyDto {
    companyId: number;
    companyName: string | undefined;
    companyReviewerEmailsManageType: ReviewerEmailsManageType;
    companyIsSignedClientAgreementOrLegacy: boolean;
    companyIsSignedClientAgreement: boolean;
    companyIsFilledBillingInfo: boolean;
    companyIsInternalReviewers: boolean;
    companyIsCompleted: boolean;
    companyAddress: AddressDto;
    companyClientAgreementStatus: ClientAgreementStatus;
    companyTimeEntryEnteringMaxDays: number;
    roleName: string;
    userName: string;
    companyTimeEntryType: TimeEntryType;
}

export interface ApplicationResultOfSelectCompanyResultDto extends ApplicationResult {
    data: SelectCompanyResultDto | undefined;
}

export interface SelectCompanyResultDto {
    accessToken: string;
}

export interface ApplicationResultOfCompanyDto extends ApplicationResult {
    data: CompanyDto | undefined;
}

export interface CompanyDto {
    id: number;
    name: string | undefined;
    reviewerEmailsManageType: ReviewerEmailsManageType;
    azureUserCreateThreshold: number;
    azureUserRemoveThreshold: number;
    relativityUserCreateThreshold: number;
    isSignedClientAgreementOrLegacy: boolean;
    isFilledBillingInfo: boolean;
    isInternalReviewers: boolean;
    isCompleted: boolean;
    address: AddressDto;
    clientAgreementStatus: ClientAgreementStatus;
    chatMode: CompanyChatMode;
    isMobileChatsEnabled: boolean;
    timeEntryType: TimeEntryType;
    reviewerTimeEntryRemindNotificationTimeoutDays: number;
    reviewerTimeEntryPlatformDiffNotificationThresholdMinutes: number;
    timeEntryMinuteInterval: number;
    timeEntryEnteringMaxDays: number;
    timeZoneId: number | undefined;
    chatsAutoDeleteThresholdDays: number | undefined;
    isChatsAutoDeletePermanent: boolean;
    relativityAuditsPollingStopThresholdDays: number;
}

export interface ApplicationResultOfCompanyManageInfoDto extends ApplicationResult {
    data: CompanyManageInfoDto | undefined;
}

export interface CompanyManageInfoDto {
    name: string | undefined;
    timeZoneId: number | undefined;
    address: AddressDto;
    billingInfo: CompanyBillingInfoDto;
    billingEmailAddresses: string[];
    compensationType: CompanyCompensationType;
}

export enum CompanyCompensationType {
    Standard = "Standard",
    W2 = "W2",
}

export interface CreateCompanyCommand {
    name: string | undefined;
    contactNumber: string | undefined;
    timeZoneId: number;
    address: AddressDto | undefined;
    billingInfo: CreateCompanyBillingInfoModel | undefined;
}

export interface CreateCompanyBillingInfoModel {
    contact: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    address: AddressDto | undefined;
}

export interface ApplicationResultOfIListOfUserCompanyDto extends ApplicationResult {
    data: UserCompanyDto[] | undefined;
}

export interface DeleteCompanyUserCommand {
    userId: number;
    companyId: number;
}

export interface UpdateCompanyBillingInfoCommand {
    name: string | undefined;
    billingEmailAddresses: string[];
    phone: string | undefined;
    contact: string;
    billingAddress: AddressDto;
}

export interface UpdateCompanyInfoCommand {
    name: string | undefined;
    timeZoneId: number | undefined;
    address: AddressDto;
}

export interface UpdateCompanyUserCommand {
    companyId: number;
    userId: number;
    userPermissionRoleId: number | undefined;
    isActive: boolean;
    roleId: number;
}

export interface ApplicationResultOfCompanyDashboardTilesDto extends ApplicationResult {
    data: CompanyDashboardTilesDto | undefined;
}

export interface CompanyDashboardTilesDto {
    totalProjects: number;
    totalHours: number;
    totalPendingHours: number;
    rating: number | undefined;
    numberOfRatings: number;
    totalSpending: number;
    relativity: CompanyRelativityStatDto;
}

export interface CompanyRelativityStatDto {
    docsReviewed: number;
    totalMinutes: number;
}

export interface ApplicationResultOfListOfDashboardTimeEntryDto extends ApplicationResult {
    data: DashboardTimeEntryDto[] | undefined;
}

export interface DashboardTimeEntryDto {
    caseName: string | undefined;
    reviewerTypeName: string | undefined;
    reviewerName: string | undefined;
    dateWorked: Date;
    minutes: number;
}

export interface ApplicationResultOfListOfAdminCompanyDto extends ApplicationResult {
    data: AdminCompanyDto[] | undefined;
}

export interface AdminCompanyDto {
    id: number;
    name: string | undefined;
    markupRate: number;
    compensationType: CompanyCompensationType;
}

export interface UpdateCompanyForAdminCommand {
    companyId: number;
    name: string | undefined;
    markupRate: number;
    compensationType: CompanyCompensationType;
}

export interface UpdateCompanyUserTimeEntriesThresholdCommand {
    timeEntriesThresholdRangeType: TimeEntriesThresholdRangeType;
    thresholdWarningValue: number;
    thresholdDangerValue: number;
    timeEntriesThresholdType: TimeEntriesThresholdType;
}

export enum TimeEntriesThresholdRangeType {
    Weekly = "Weekly",
    Daily = "Daily",
}

export interface ApplicationResultOfCompanyUserTimeEntriesThresholdDto extends ApplicationResult {
    data: CompanyUserTimeEntriesThresholdDto | undefined;
}

export interface CompanyUserTimeEntriesThresholdDto {
    weeklyThresholdWarningValue: number;
    weeklyThresholdDangerValue: number;
    weeklyTimeEntriesThresholdType: TimeEntriesThresholdType;
    dailyThresholdWarningValue: number;
    dailyThresholdDangerValue: number;
    dailyTimeEntriesThresholdType: TimeEntriesThresholdType;
}

export interface ApplicationResultOfListOfReviewerExperienceDto extends ApplicationResult {
    data: ReviewerExperienceDto[] | undefined;
}

export interface ReviewerExperienceDto {
    id: number;
    reviewerId: number;
    companyName: string | undefined;
    caseName: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    partyUnableToDisclose: boolean;
    clientUnableToDisclose: boolean;
    firmOutsideUnableToDisclose: boolean;
    firmOpposingUnableToDisclose: boolean;
    clients: LookUpDto[] | undefined;
    reviewerTypeRole: LookUpDto[];
    attorneyOutside: LookUpDto[];
    attorneyOpposing: LookUpDto[];
    firmOutside: LookUpDto[];
    firmOpposing: LookUpDto[];
    parties: LookUpDto[];
    isAltorneyProject: boolean;
}

export interface ApplicationResultOfReviewerExperienceDto extends ApplicationResult {
    data: ReviewerExperienceDto | undefined;
}

export interface UpsertReviewerExperienceCommand {
    reviewerId: number;
    reviewerProjectId: number;
    companyName: string | undefined;
    caseName: string | undefined;
    reviewerTypeRoles: LookUpDto[];
    startDate: Date | undefined;
    endDate: Date | undefined;
    partyUnableToDisclose: boolean;
    clientUnableToDisclose: boolean;
    firmOutsideUnableToDisclose: boolean;
    firmOpposingUnableToDisclose: boolean;
    caseClient: LookUpDto[];
    caseOutsideFirmName: LookUpDto[];
    caseOutsideAttorneyName: LookUpDto[];
    opposingParty: LookUpDto[];
    opposingFirmName: LookUpDto[];
    opposingAttorneyName: LookUpDto[];
}

export interface ApplicationResultOfUploadReviewerProjectHistoryResponse extends ApplicationResult {
    data: UploadReviewerProjectHistoryResponse | undefined;
}

export interface UploadReviewerProjectHistoryResponse {
    invalidRows: UploadReviewerProjectHistoryErrorItem[];
    isSuccess: boolean;
    projectsAdded: number;
}

export interface UploadReviewerProjectHistoryErrorItem {
    rowIndex: number;
    errors: string[];
}

export interface ApplicationResultOfListOfReviewerLanguageTestDto extends ApplicationResult {
    data: ReviewerLanguageTestDto[] | undefined;
}

export interface ApplicationResultOfListOfReviewerForCompanyDto extends ApplicationResult {
    data: ReviewerForCompanyDto[] | undefined;
}

export interface ReviewerForCompanyDto {
    id: number;
    reviewerId: number;
    reviewerName: string | undefined;
    name: string;
    isInternal: boolean;
    type: string;
    activeProjects: number;
    projectsAccepted: number;
    projectsInvited: number;
    projectsApplied: number;
    isFavorite: boolean;
    isBlocked: boolean;
    reviewerIsBlocked: boolean;
    isReviewerBlocked: boolean;
    reviewerRating: number | undefined;
    reviewerNumberOfRatings: number;
    companyId: number;
    companyName: string;
    averageDailyBilledHours: number | undefined;
    relativityWorkspaceUser: RelativityOverallMetric | undefined;
}

export interface ApplicationResultOfListOfReviewerCompanyInviteDto extends ApplicationResult {
    data: ReviewerCompanyInviteDto[] | undefined;
}

export interface ReviewerCompanyInviteDto {
    id: number;
    userId: number | undefined;
    email: string;
    companyId: number;
    companyName: string;
    status: string;
    createdDate: Date;
    dateJoined: Date | undefined;
}

export interface ApplicationResultOfCompanyReviewerDto extends ApplicationResult {
    data: CompanyReviewerDto | undefined;
}

export interface MarkReviewerAsFavoriteCommand {
    reviewerId: number;
}

export interface ApplicationResultOfBoolean extends ApplicationResult {
    data: boolean;
}

export interface MarkReviewerAsBlockedCommand {
    reviewerId: number;
    removeFromActiveProjects: boolean;
}

export interface ResetReviewerStatusCommand {
    reviewerId: number;
}

export interface UpdateCompanyReviewerCommand {
    reviewerId: number;
    companyId: number;
    alternateEmailAddress: string | undefined;
    platformUserName: string | undefined;
    trustedIps: CompanyTrustedIpDto[];
}

export interface UpdateReviewerPlatformUserNameCommand {
    reviewerId: number;
    platformUserName: string;
}

export interface UpdateClientEmployeeIdCommand {
    reviewerId: number;
    clientEmployeeId: string | undefined;
}

export interface ApplicationResultOfInviteCompanyStaffReviewersResultDto extends ApplicationResult {
    data: InviteCompanyStaffReviewersResultDto | undefined;
}

export interface InviteCompanyStaffReviewersResultDto {
    createdInvitesCount: number;
    errors: InviteCompanyStaffReviewersErrorDto[];
}

export interface InviteCompanyStaffReviewersErrorDto {
    email: string | undefined;
    errors: string[];
}

export interface InviteCompanyStaffReviewersCommand {
    emails: string[];
    message: string;
}

export interface ApplicationResultOfListOfCaseOverallMetricsDto extends ApplicationResult {
    data: CaseOverallMetricsDto[] | undefined;
}

export interface CaseOverallMetricsDto extends RelativityOverallMetric {
    case: CaseMetricsDto;
    fields: FieldOverallMetrics[];
}

export interface CaseMetricsDto {
    id: number;
    name: string | undefined;
    relativityWorkspaceId: number | undefined;
}

export interface ApplicationResultOfListOfCaseTimeSeriesMetricsDto extends ApplicationResult {
    data: CaseTimeSeriesMetricsDto[] | undefined;
}

export interface CaseTimeSeriesMetricsDto {
    case: LookUpDto;
    metrics: RelativityTimeSeriesMetrics[];
}

export interface ApplicationResultOfReviewerProfileDto extends ApplicationResult {
    data: ReviewerProfileDto | undefined;
}

export interface ReviewerProfileDto extends ReviewerDto {
    totalEarning: number;
    reviewerProjects: ReviewerProfileProjectsDto[];
    backgroundChecks: ReviewerBackgroundCheckDto[];
    reviewerCompanies: ReviewerCompanyListDto[];
}

export interface ReviewerProfileProjectsDto {
    caseName: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    clients: LookUpDto[] | undefined;
    clientUnableToDisclose: boolean;
}

export interface ReviewerBackgroundCheckDto {
    id: number;
    reviewerId: number;
    checkDate: Date;
    isClear: boolean;
    reportDocumentId: number | undefined;
    reportDocument: DocumentDto | undefined;
}

export interface ReviewerCompanyListDto {
    id: number;
    companyName: string;
    clientEmployeeId: string | undefined;
}

export interface ApplicationResultOfReviewerDetailsDto extends ApplicationResult {
    data: ReviewerDetailsDto | undefined;
}

export interface ReviewerDetailsDto {
    name: string | undefined;
    resume: string | undefined;
    bio: string | undefined;
    address: AddressDto;
    lawSchoolId: number | undefined;
    lawSchoolGraduationDate: Date | undefined;
    currentLocationState: string | undefined;
    city: string | undefined;
    country: string | undefined;
    countryCode: string | undefined;
    currentLocationCity: string | undefined;
    hasContractorAgreement: boolean;
    contractorAgreementSignature: string | undefined;
    contractorAgreementDate: Date | undefined;
    hasMutualArbitrationAgreement: boolean;
    mutualArbitrationAgreementSignature: string | undefined;
    mutualArbitrationAgreementDate: Date | undefined;
    resumeDocument: DocumentDto | undefined;
    hasAcceptedLegacyPolicies: boolean;
}

export interface ApplicationResultOfReviewerRequirementsDto extends ApplicationResult {
    data: ReviewerRequirementsDto | undefined;
}

export interface ReviewerRequirementsDto {
    reviewerSpecialty: LookUpDto[] | undefined;
    reviewerLanguage: LookUpDto[] | undefined;
    reviewerTechnologyDurations: ReviewerTechnologyDurationDto[] | undefined;
    hasMilitaryAssociation: boolean;
    hasSecurityClearance: boolean;
}

export interface ReviewerTechnologyDurationDto {
    reviewerTechnologyId: number | undefined;
    technologyDurationId: number | undefined;
}

export interface ApplicationResultOfReviewerBasicInfoResponse extends ApplicationResult {
    data: ReviewerBasicInfoResponse | undefined;
}

export interface ReviewerBasicInfoResponse {
    id: number;
    currentLocation: AddressDto;
    reviewerBars: ReviewerBarMembershipDto[] | undefined;
    hasSecurityClearance: boolean;
    hasCovidVax: boolean | undefined;
    reviewerProjectNotificationMode: ReviewerProjectNotificationMode;
}

export interface ReviewerBarMembershipDto {
    id: number;
    stateId: number | undefined;
    stateName: string | undefined;
    countryId: number | undefined;
    countryName: string | undefined;
    barId: string | undefined;
    isInactive: boolean;
    isActive: boolean;
    lastDateBarConfirmed: Date | undefined;
    stateBarStatuses: LookUpDto[];
}

export interface ApplicationResultOfProfileSaveResultDto extends ApplicationResult {
    data: ProfileSaveResultDto | undefined;
}

export interface ProfileSaveResultDto {
    completion: ReviewerProfileValidationResult;
}

export interface ReviewerBasicInfoCommand {
    reviewerId: number;
    currentLocation: AddressDto;
    reviewerBars: ReviewerBarMembershipDto[];
    hasCovidVax: boolean;
}

export interface CreateGeneralExperienceCommand {
    reviewerId: number;
    lawSchool: LookUpDto | undefined;
    lawSchoolGraduationDate: Date | undefined;
    bio: string | undefined;
}

export interface ApplicationResultOfReviewerScheduleResponseDto extends ApplicationResult {
    data: ReviewerScheduleResponseDto | undefined;
}

export interface ReviewerScheduleResponseDto extends ProfileSaveResultDto {
    availabilities: Availability[] | undefined;
    reviewerCalendars: ReviewerCalendarDto[] | undefined;
    timeZoneId: number | undefined;
    timeZone: LookUpDto | undefined;
    availableOnHolidays: boolean;
    availableOnWeekends: boolean;
    errors: string[] | undefined;
}

export interface Availability {
    dayOfWeek: number;
    startTime: string;
    endTime: string;
}

export interface SaveReviewerScheduleCommand {
    reviewerId: number;
    reviewerSchedule: ReviewerScheduleDto[];
    availableOnHolidays: boolean;
    availableOnWeekends: boolean;
    deleted: ReviewerScheduleDto[];
    timeZoneId: number | undefined;
    reviewerCalendar: ReviewerCalendarDto[];
}

export interface ReviewerScheduleDto {
    dayOfWeek: number;
    startTime: Date;
    endTime: Date;
}

export interface ApplicationResultOfReviewerProfileValidationResult extends ApplicationResult {
    data: ReviewerProfileValidationResult | undefined;
}

export interface CreateReviewerRequirementCommand {
    reviewerId: number;
    reviewerSpeciality: LookUpDto[];
    reviewerLanguage: LookUpDto[];
    hasMilitaryAssociation: boolean;
    hasSecurityClearance: boolean;
    reviewerTechnologyDurations: ReviewerTechnologyDurationDto[];
}

export interface DeleteReviewerBarMembershipCommand {
    reviewerId: number | undefined;
    stateId: number | undefined;
    countryId: number | undefined;
}

export interface ApplicationResultOfListOfReviewerReviewerTypeSpanListDto extends ApplicationResult {
    data: ReviewerReviewerTypeSpanListDto[] | undefined;
}

export interface ReviewerReviewerTypeSpanListDto {
    id: number;
    caseId: number;
    caseName: string;
    reviewerTypeId: number;
    reviewerTypeName: string;
    startDate: Date;
    endDate: Date | undefined;
    reviewerRating: RatingDto | undefined;
    companyRating: RatingDto | undefined;
    isAvailableForRating: boolean;
}

export interface ApplicationResultOfReviewerDirectorySearchResultDto extends ApplicationResult {
    data: ReviewerDirectorySearchResultDto | undefined;
}

export interface ReviewerDirectorySearchResultDto {
    count: number;
}

export interface SearchReviewersDirectoryQuery {
    reviewerTypeRoleId: number | undefined;
    rate: number;
    allowWeekend: RequiredValues;
    allowHoliday: RequiredValues;
    minimumWeeklyHours: number;
    minimumDailyHours: number;
    specialties: LookUpDto[];
    languages: LookUpDto[];
    experienceLevelId: number | undefined;
    hasJD: boolean;
    hasBarAdmission: boolean;
    isBarAdmissionStateMatchingLocation: boolean;
    requiresSecurityClearance: boolean;
    requiresMilitaryAssociation: boolean;
    requiresCurrentBackgroundCheck: boolean;
    barCountries: LookUpDto[];
    barStates: LookUpDto[];
    residencyCountries: LookUpDto[];
    residencyStates: LookUpDto[];
    locationCountries: LookUpDto[];
    locationStates: LookUpDto[];
    timeZones: LookUpDto[];
}

export interface ApplicationResultOfReviewerResumeDto extends ApplicationResult {
    data: ReviewerResumeDto | undefined;
}

export interface ReviewerResumeDto {
    viewUrl: string;
    fileExtension: string;
}

export interface ApplicationResultOfListOfReviewerInactiveReviewerTypeListDto extends ApplicationResult {
    data: ReviewerInactiveReviewerTypeListDto[] | undefined;
}

export interface ReviewerInactiveReviewerTypeListDto {
    reviewerReviewerTypeId: number | undefined;
    reviewerTypeCaseName: string;
    reviewerTypeName: string;
    status: ReviewerReviewerTypeStatus;
    reviewerTypeCaseId: number;
    reviewerTypeId: number;
}

export interface ApplicationResultOfCompanyInviteReviewersByEmailResultDto extends ApplicationResult {
    data: CompanyInviteReviewersByEmailResultDto | undefined;
}

export interface CompanyInviteReviewersByEmailResultDto {
    createdInvitesCount: number;
    errors: InviteReviewersByEmailWithoutCaseErrorDto[];
}

export interface InviteReviewersByEmailWithoutCaseErrorDto {
    email: string | undefined;
    errors: string[];
}

export interface CompanyInviteReviewersByEmailCommand {
    emails: string[];
    message: string;
}

export interface ApplicationResultOfListOfCompanyReviewerNoteDto extends ApplicationResult {
    data: CompanyReviewerNoteDto[] | undefined;
}

export interface CompanyReviewerNoteDto {
    id: number;
    note: string;
    createdDate: Date;
    createdUserId: number | undefined;
    createdUser: UserLookUpDto | undefined;
}

export interface UserLookUpDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    name: string | undefined;
    email: string | undefined;
}

export interface ApplicationResultOfCompanyReviewerNoteDto extends ApplicationResult {
    data: CompanyReviewerNoteDto | undefined;
}

export interface CreateCompanyReviewerNotesCommand {
    note: string;
    reviewerId: number;
    companyId: number;
}

export interface UpdateCompanyReviewerNotesCommand {
    id: number;
    note: string;
}

export interface ApplicationResultOfListOfCompanyReviewerSummaryDto extends ApplicationResult {
    data: CompanyReviewerSummaryDto[] | undefined;
}

export interface CompanyReviewerSummaryDto {
    id: number;
    reviewerTypeId: number;
    reviewerTypeName: string;
    reviewerTypeCaseId: number;
    reviewerTypeCaseName: string;
    dateWorked: Date;
    dateType: ReviewerSummaryDateType;
    summaryText: string;
    reviewerId: number;
    reviewerName: string;
    type: CompanyReviewerSummaryType;
}

export enum CompanyReviewerSummaryType {
    New = "New",
    Edited = "Edited",
}

export interface ApplicationResultOfListOfReviewerSummaryNotificationScheduleDto extends ApplicationResult {
    data: ReviewerSummaryNotificationScheduleDto[] | undefined;
}

export interface ReviewerSummaryNotificationScheduleDto {
    id: number;
    schedule: string;
    isPaused: boolean;
    targets: string[];
}

export interface UpdateReviewerSummaryNotificationScheduleCommand {
    reviewerTypeId: number;
    schedules: ReviewerSummaryNotificationScheduleMutationModel[];
}

export interface ReviewerSummaryNotificationScheduleMutationModel {
    id: number;
    schedule: string;
    isPaused: boolean;
    emails: string[];
}

export interface SetIsPausedReviewerSummaryScheduleCommand {
    scheduleId: number;
    isPaused: boolean;
}

export interface ContactUsCommand {
    messageText: string | undefined;
}

export interface ApplicationResultOfListOfDateDimensionDto extends ApplicationResult {
    data: DateDimensionDto[] | undefined;
}

export interface DateDimensionDto {
    id: number;
    theDate: Date;
    theMonth: number;
    theDay: number;
    theYear: number;
    isWeekend: boolean;
    isHoliday: boolean;
    dayOfWeek: number;
    weekOfYear: number;
    monthName: string;
    dayName: string;
    theWeekOfYearDate: Date | undefined;
}

export interface ApplicationResultOfListOfString extends ApplicationResult {
    data: string[] | undefined;
}

export interface GenerateReviewerTypeLinksCommand {
}

export interface UpdateDocuSignDocumentStatusCommand {
    event: string;
    apiVersion: string;
    uri: string;
    retryCount: number;
    configurationId: number;
    generatedDateTime: string;
    data: DocusignWebhookDataPayload;
}

export interface DocusignWebhookDataPayload {
    accountId: string;
    userId: string;
    envelopeId: string;
    envelopeSummary: EnvelopeSummary;
}

export interface EnvelopeSummary {
    status: string;
    documentsUri: string;
    recipientsUri: string;
    attachmentsUri: string;
    envelopeUri: string;
    emailSubject: string;
    envelopeId: string;
    signingLocation: string;
    customFieldsUri: string;
    notificationUri: string;
    enableWetSign: string;
    allowMarkup: string;
    allowReassign: string;
    createdDateTime: Date;
    lastModifiedDateTime: Date;
    deliveredDateTime: Date;
    initialSentDateTime: Date;
    sentDateTime: Date;
    completedDateTime: Date;
    statusChangedDateTime: Date;
    documentsCombinedUri: string;
    certificateUri: string;
    templatesUri: string;
    expireEnabled: string;
    expireDateTime: Date;
    expireAfter: string;
    sender: Sender;
    customFields: CustomFields;
    purgeState: string;
    envelopeIdStamping: string;
    is21CFRPart11: string;
    signerCanSignOnMobile: string;
    autoNavigation: string;
    isSignatureProviderEnvelope: string;
    hasFormDataChanged: string;
    allowComments: string;
    hasComments: string;
    allowViewHistory: string;
    envelopeMetadata: EnvelopeMetadata;
    envelopeLocation: string;
    isDynamicEnvelope: string;
    burnDefaultTabData: string;
}

export interface Sender {
    userName: string;
    userId: string;
    accountId: string;
    email: string;
}

export interface CustomFields {
    textCustomFields: TextCustomField[];
    listCustomFields: any[];
}

export interface TextCustomField {
    fieldId: string;
    name: string;
    show: string;
    required: string;
    value: string;
}

export interface EnvelopeMetadata {
    allowAdvancedCorrect: string;
    enableSignWithNotary: string;
    allowCorrect: string;
}

export interface ApplicationResultOfITemplate extends ApplicationResult {
    data: ITemplate | undefined;
}

export interface ITemplate {
    content: string | undefined;
    title: string | undefined;
}

export interface ApplicationResultOfListOfFaqDto extends ApplicationResult {
    data: FaqDto[] | undefined;
}

export interface FaqDto {
    id: number;
    faqType: FAQType;
    order: number;
    questionText: string | undefined;
    answerText: string | undefined;
    uiElementId: string | undefined;
}

export enum FAQType {
    Reviewer = "Reviewer",
    Client = "Client",
}

export interface ApplicationResultOfFaqDto extends ApplicationResult {
    data: FaqDto | undefined;
}

export interface CreateFaqCommand {
    faqType: FAQType;
    questionText: string;
    answerText: string;
}

export interface UpdateFaqCommand {
    id: number;
    questionText: string | undefined;
    answerText: string | undefined;
}

export interface ReorderFaqsCommand {
    faqType: FAQType;
    movedFaqId: number;
    newIndex: number;
}

export interface FlatFileAuthResult {
    token: string;
}

export interface FlatFileImportResult {
    success: boolean;
    errors: FlatFileRecordErrorModel[];
}

export interface FlatFileRecordErrorModel {
    id: string;
    errors: FlatFileFieldErrorModel[];
}

export interface FlatFileFieldErrorModel {
    field: string;
    message: string;
}

export interface FlatFileImportModel {
    records: FlatFileRecordModel[];
    sheetId: string;
    workbookId: string;
    spaceId: string;
    options: { [key: string]: any; };
}

export interface FlatFileRecordModel {
    id: string;
    data: { [key: string]: string; };
}

export interface ApplicationResultOfListOfHolidayDto extends ApplicationResult {
    data: HolidayDto[] | undefined;
}

export interface HolidayDto {
    holidayDate: Date;
    holidayName: string | undefined;
}

export interface ApplicationResultOfInviteCompanyUserResult extends ApplicationResult {
    data: InviteCompanyUserResult | undefined;
}

export interface InviteCompanyUserResult {
    invitedCount: number;
    errors: InviteCompanyUserError[];
}

export interface InviteCompanyUserError {
    email: string;
    error: string;
}

export interface InviteCompanyUserCommand {
    roleId: number;
    emails: string[];
    message: string | undefined;
}

export interface RevokeCompanyUserInvite {
    inviteId: number;
}

export interface ApplicationResultOfAcceptCompanyInviteResponse extends ApplicationResult {
    data: AcceptCompanyInviteResponse | undefined;
}

export interface AcceptCompanyInviteResponse {
    accessToken: string;
    refreshToken: string;
    companyName: string;
    userId: number;
    email: string;
}

export interface AcceptCompanyInviteCommand {
    securityCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    password: string | undefined;
    phoneNumber: string | undefined;
}

export interface SendReferralInviteCommand {
    emails: string[];
    message: string;
}

export interface AcceptReferralInviteCommand {
    securityCode: string;
}

export interface ApplicationResultOfListOfCompanyRolesDto extends ApplicationResult {
    data: CompanyRolesDto[] | undefined;
}

export interface CompanyRolesDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
}

export interface ApplicationResultOfGenerateInvoiceResult extends ApplicationResult {
    data: GenerateInvoiceResult | undefined;
}

export interface GenerateInvoiceResult {
    items: GenerateInvoiceResultItem[];
    reviewerItems: GenerateInvoiceCase[];
    c5ReviewerTables: GenerateInvoiceReviewerC5Result[];
    earliestDate: Date | undefined;
    grandTotalAmount: number;
}

export interface GenerateInvoiceResultItem {
    caseId: number;
    clientName: string | undefined;
    billingInfoContact: string | undefined;
    billingInfoEmail: string | undefined;
    dateIssue: Date;
    attorneyPayRate: number;
    markupPct: number;
    description: string | undefined;
    clientBillRate: number;
    hours: number;
    minutes: number;
    projectName: string | undefined;
    notes: string | undefined;
    netDaysToPay: number;
    dateDue: Date;
    lateFee: string | undefined;
    totalAmount: number;
    userCaseId: string | undefined;
    invoiceDates: string | undefined;
    matterCodes: string | undefined;
}

export interface GenerateInvoiceCase {
    caseName: string;
    companyName: string;
    companyId: number;
    caseId: number;
    items: GenerateInvoiceResultReviewerItem[];
    details: GenerateInvoiceReviewerDetailsItem[];
}

export interface GenerateInvoiceResultReviewerItem {
    reviewerId: number;
    lastName: string;
    firstName: string;
    reviewerTypeName: string;
    hours: number;
    caseName: string;
    companyName: string;
    companyId: number;
    caseId: number;
    phaseAndTaskCodes: string | undefined;
    clientBillRate: number;
    matterCodes: string | undefined;
    actionCodes: string | undefined;
}

export interface GenerateInvoiceReviewerDetailsItem {
    lastName: string;
    firstName: string;
    caseName: string;
    reviewerTypeName: string;
    hours: number;
    minutes: number;
    notes: string | undefined;
    dateWorked: Date;
    reviewerId: number;
    caseId: number;
    reviewerTypeId: number;
    phaseAndTaskCodes: string | undefined;
    clientBillRate: number;
    matterCodes: string | undefined;
    actionCodes: string | undefined;
}

export interface GenerateInvoiceReviewerC5Result {
    items: GenerateInvoiceResultReviewerC5Item[];
}

export interface GenerateInvoiceResultReviewerC5Item {
    rnk: number;
    reviewerId: number;
    reviewer: string | undefined;
    project: string | undefined;
    date: Date;
    hours: number;
    role: string | undefined;
    description: string | undefined;
    cost: number;
    type: string | undefined;
}

export interface GenerateInvoicesCommand {
    endDate: Date;
    companyIds: number[];
    testRun: boolean;
    issueDate: Date;
}

export interface ApplicationResultOfListOfInvoiceDto extends ApplicationResult {
    data: InvoiceDto[] | undefined;
}

export interface InvoiceDto {
    id: number;
    case: InvoiceCaseDto;
    reviewerType: InvoiceReviewerTypeDto | undefined;
    dateIssued: Date | undefined;
    dateDue: Date | undefined;
    datePaid: Date | undefined;
    amount: number;
    discount: number;
    total: number;
    status: InvoiceStatus;
    daysPastDue: number | undefined;
}

export interface InvoiceCaseDto {
    id: number;
    name: string;
    company: LookUpDto;
}

export interface InvoiceReviewerTypeDto {
    id: number;
    name: string;
}

/** A locale specific string. */
export interface LocalizedString {
    /** The name of the string in the resource it was loaded from. */
    name: string;
    /** The actual string. */
    value: string;
    /** Whether the string was not found in a resource. If true, an alternate string value was used. */
    resourceNotFound: boolean;
    /** The location which was searched for a localization value. */
    searchedLocation: string | undefined;
}

export interface ApplicationResultOfListOfCountryDto extends ApplicationResult {
    data: CountryDto[] | undefined;
}

export interface ApplicationResultOfListOfStateDto extends ApplicationResult {
    data: StateDto[] | undefined;
}

export interface StateDto extends LocationDto {
    parentId: number | undefined;
    isParent: boolean;
    isAnyState: boolean;
    countryId: number;
}

export interface ApplicationResultOfListOfLocationDto extends ApplicationResult {
    data: LocationDto[] | undefined;
}

export interface MatchResult {
    isMatching: boolean;
    matchMessages: string[];
    notMatchMessages: string[];
}

export enum MatchingMode {
    Filter = "Filter",
    Profile = "Profile",
    Matching = "Matching",
    Project = "Project",
    All = "All",
}

export interface ApplicationResultOfListOfReviewerMatchingDto extends ApplicationResult {
    data: ReviewerMatchingDto[] | undefined;
}

export interface ReviewerMatchingDto {
    id: number;
    userFirstName: string | undefined;
    userLastName: string | undefined;
    name: string | undefined;
    userEmail: string;
    userIsActive: boolean;
    userHasNotificationOptout: boolean;
    receivedMatchingNotification: boolean;
}

export interface ApplicationResultOfListOfNotificationDto extends ApplicationResult {
    data: NotificationDto[] | undefined;
}

export interface NotificationDto {
    id: number;
    userId: number;
    title: string | undefined;
    content: string | undefined;
    createdDate: Date;
    isArchived: boolean;
    delivery: NotificationDeliveryMethodProjectable | undefined;
    status: NotificationStatus | undefined;
    notificationAttachments: NotificationAttachmentDto[];
}

export interface NotificationAttachmentDto {
    id: number;
    notificationId: number;
    fileName: string | undefined;
    contentType: string | undefined;
}

export interface ArchiveNotificationCommand {
    notificationId: number;
}

export interface SaveUserNotificationSettingsCommand {
    unreadMessagesIntervalMinutes: number;
    hasNotificationOptout: boolean;
    hasEnabledNotificationSound: boolean;
    chatRingtoneId: number | undefined;
    notificationTypes: SaveUserNotificationTypeSettingMutationModel[];
}

export interface SaveUserNotificationTypeSettingMutationModel {
    notificationTypeId: number;
    hasEmail: boolean;
    hasSms: boolean;
    includeInDigest: boolean;
}

export interface SendAdminNotificationCommand {
    reviewerIds: number[];
    reviewerTypeId: number | undefined;
    title: string;
    message: string;
    receiverType: NotificationReceiverType;
}

export enum NotificationReceiverType {
    SpecificReviewers = "SpecificReviewers",
    AllReviewers = "AllReviewers",
    AllCompanyUsers = "AllCompanyUsers",
    AllUsers = "AllUsers",
    AllReviewersInReviewerType = "AllReviewersInReviewerType",
    AllReviewerMatchedInReviewerType = "AllReviewerMatchedInReviewerType",
    AllActiveReviewers = "AllActiveReviewers",
}

export interface ApplicationResultOfNotificationCountDto extends ApplicationResult {
    data: NotificationCountDto | undefined;
}

export interface NotificationCountDto {
    id: number;
    notificationCount: number;
}

export interface ApplicationResultOfPaginatedResultOfNotificationDto extends ApplicationResult {
    data: PaginatedResultOfNotificationDto | undefined;
}

export interface PaginatedResultOfNotificationDto {
    totalRecords: number;
    results: NotificationDto[];
}

export interface PaginatedRequestOfNotificationsQueryFilters {
    first: number;
    rows: number;
    sortField: string | undefined;
    sortOrder: number | undefined;
    filters: NotificationsQueryFilters | undefined;
}

export interface GetUserNotificationsPagedQuery extends PaginatedRequestOfNotificationsQueryFilters {
    isArchived: boolean;
}

export interface NotificationsQueryFilters {
    createdDate: (DateQueryFilter | undefined)[] | undefined;
    title: StringQueryFilter | undefined;
    content: StringQueryFilter | undefined;
    delivery: ArrayQueryFilterOfString | undefined;
    status: ArrayQueryFilterOfString | undefined;
}

export interface ApplicationResultOfListOfPayrollDateDto extends ApplicationResult {
    data: PayrollDateDto[] | undefined;
}

export interface PayrollDateDto {
    payDate: Date;
}

export interface ApplicationResultOfRunPayrollResult extends ApplicationResult {
    data: RunPayrollResult | undefined;
}

export interface RunPayrollResult {
    items: RunPayrollResultItem[];
    minDateWorked: Date | undefined;
    grandTotalAmount: number;
}

export interface RunPayrollResultItem {
    email: string | undefined;
    collaboratorId: string | undefined;
    externalContractorId: string | undefined;
    amount: number;
    lineItemTitle: string | undefined;
    dueDate: Date;
    lineItemDescription: string | undefined;
    lineItemHourlyRate: number | undefined;
    lineItemHours: number;
    lineItemMinutes: number;
}

export interface RunPayrollsCommand {
    datePaid: Date;
    dateCutOff: Date;
    testRun: boolean;
    autoApproveTime: boolean;
    reviewerIds: number[];
    w2Status: number;
}

export interface ApplicationResultOfListOfPayrollDto extends ApplicationResult {
    data: PayrollDto[] | undefined;
}

export interface PayrollDto {
    id: number;
    reviewerName: string;
    reviewerTypeName: string | undefined;
    status: number;
    dateIssued: Date;
    datePaid: Date | undefined;
    minutes: number;
    hours: number;
    amount: number;
}

export interface ApplicationResultOfPermissionNode extends ApplicationResult {
    data: PermissionNode | undefined;
}

export interface PermissionNode {
    name: string;
    fullName: string;
    isLeaf: boolean;
    rolesAllowedToGrant: string[];
    requires: string[];
    requiredBy: string[];
    children: PermissionNode[];
}

export interface ApplicationResultOfUserCompanyPermissionsDto extends ApplicationResult {
    data: UserCompanyPermissionsDto | undefined;
}

export interface UpdateUserCompanyPermissionsCommand {
    userId: number;
    permissions: string[];
}

export interface ApplicationResultOfReviewerProjectResponse extends ApplicationResult {
    data: ReviewerProjectResponse | undefined;
}

export interface ReviewerProjectResponse {
    projects: ProjectDto[];
}

export interface ProjectDto {
    id: number | undefined;
    name: string | undefined;
    caseName: string | undefined;
    caseCompanyName: string | undefined;
    reviewerTypeRole: LookUpDto | undefined;
    locationStates: StateDto[];
    locationCountries: CountryDto[];
    barStates: StateDto[];
    barCountries: CountryDto[];
    startDate: Date;
    endDate: Date;
    createdDate: Date;
    rate: number;
    dateStartedRecruiting: Date | undefined;
    caseCompanyCompensationType: CompanyCompensationType;
    isMatchedByProfile: boolean;
    isBarAdmissionStateMatchingLocation: boolean;
    reviewersLeftCount: number;
}

export interface ReviewerUpdateApplicationCommand {
    reviewerTypeId: number;
    caseRequirements: RequirementAgreementDto[];
    reviewerTypeRequirements: RequirementAgreementDto[];
    reviewerPendingQuestionYesNoAnswers: ReviewerPendingQuestionYesNoAnswerDto[];
}

export interface RequirementAgreementDto {
    id: number;
    answerText: string | undefined;
}

export interface UnApproveForProjectCommand {
    reviewerId: number;
    reviewerTypeId: number;
}

export interface UnApproveForProjectBulkCommand {
    reviewerProjects: ReviewerReviewerTypeModel[];
}

export interface ReviewerReviewerTypeModel {
    reviewerId: number;
    reviewerTypeId: number;
}

export interface RejectForProjectCommand {
    reviewerId: number;
    reviewerTypeId: number;
    reviewerRejectedReasonId: number | undefined;
    reviewerRejectedOtherReason: string | undefined;
}

export interface RejectForProjectBulkCommand {
    reviewerProjects: ReviewerReviewerTypeModel[];
    reviewerRejectedReasonId: number | undefined;
    reviewerRejectedOtherReason: string | undefined;
}

export interface PendForProjectCommand {
    reviewerId: number;
    reviewerTypeId: number;
}

export interface PendForProjectBulkCommand {
    reviewerProjects: ReviewerReviewerTypeModel[];
}

export interface ApplicationResultOfAcceptProjectResponse extends ApplicationResult {
    data: AcceptProjectResponse | undefined;
}

export interface AcceptProjectResponse {
    status: ReviewerReviewerTypeStatus;
    isPendingStart: boolean;
}

export interface AcceptProjectCommand {
    reviewerTypeId: number;
}

export interface DeclineProjectCommand {
    reviewerTypeId: number;
}

export interface WithdrawDeclineProjectCommand {
    reviewerTypeId: number;
}

export interface ReviewerWithdrawApplicationCommand {
    reviewerTypeId: number;
}

export interface ApplicationResultOfInviteReviewersResultDto extends ApplicationResult {
    data: InviteReviewersResultDto | undefined;
}

export interface InviteReviewersResultDto {
    invitedCount: number;
    createdInvitesCount: number;
    errors: InviteReviewerErrorDto[];
}

export interface InviteReviewerErrorDto {
    reviewer: ReviewerBasicDto;
    errors: string[];
}

export interface InviteReviewersBulkCommand {
    reviewerProjects: ReviewerReviewerTypeModel[];
}

export interface ApplicationResultOfNextPendingReviewerDto extends ApplicationResult {
    data: NextPendingReviewerDto | undefined;
}

export interface NextPendingReviewerDto {
    reviewerTypeId: number;
    reviewerId: number;
}

export interface ApplicationResultOfListOfReviewerProjectDto extends ApplicationResult {
    data: ReviewerProjectDto[] | undefined;
}

export interface ReviewerProjectDto {
    id: number;
    reviewerId: number;
    caseId: number | undefined;
    caseName: string | undefined;
    reviewerTypeId: number | undefined;
    reviewerTypeName: string | undefined;
    clientId: number | undefined;
    companyId: number | undefined;
    companyName: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    clients: LookUpDto[];
    parties: LookUpDto[];
    firmOutside: LookUpDto[];
    firmOpposing: LookUpDto[];
    firms: LookUpDto[];
    reviewerTypeRole: LookUpDto[];
    conflicts: ConflictDto[];
    partyUnableToDisclose: boolean;
    clientUnableToDisclose: boolean;
    firmOutsideUnableToDisclose: boolean;
    firmOpposingUnableToDisclose: boolean;
    reviewerRating: RatingDto | undefined;
    lastDeactivatedSpan: LastDeactivatedSpanDto | undefined;
    isAltorneyProject: boolean;
    scorePercentile: number | undefined;
    speedPercentile: number | undefined;
    hasConflicts: boolean;
}

export interface ConflictDto {
    id: number;
    client: LookUpDto | undefined;
    firm: LookUpDto | undefined;
    isClient: boolean;
    isParty: boolean;
    isFirm: boolean;
}

export interface LastDeactivatedSpanDto {
    deactivateReasonId: number | undefined;
    deactivateReason: string | undefined;
    deactivateOtherReason: string | undefined;
}

export interface ApplicationResultOfProjectDetailDto extends ApplicationResult {
    data: ProjectDetailDto | undefined;
}

export interface ProjectDetailDto {
    id: number;
    name: string | undefined;
    caseId: number;
    case: ProjectCaseDto;
    reviewerTypeRole: LookUpDto | undefined;
    residencyStates: LocationDto[];
    residencyCountries: LocationDto[];
    locationStates: LocationDto[];
    locationCountries: LocationDto[];
    barStates: LocationDto[];
    barCountries: LocationDto[];
    timeZones: TimeZoneDto[];
    reviewerRequirements: LookUpDto[];
    reviewerTypeQuestions: LookUpDto[];
    caseDocuments: CaseDocumentDto[];
    startDate: Date;
    endDate: Date;
    createdDate: Date;
    rate: number;
    experienceLevel: ExperienceLevelDto | undefined;
    projectApplication: ProjectApplicationDto | undefined;
    limitHoursPerWeek: boolean;
    maximumWeeklyHours: number;
    minimumWeeklyHours: number;
    limitHoursPerDay: boolean;
    minimumDailyHours: number;
    maximumDailyHours: number;
    allowOvertimeByRule: boolean;
    allowOvertime: boolean;
    allowWeekend: RequiredValues;
    allowHoliday: RequiredValues;
    allowConcurrent: boolean;
    requiresMilitaryAssociation: boolean;
    overtimeRate: number;
    weekendRate: number;
    holidayRate: number;
    overtimeHours: number;
    specialties: LookUpDto[];
    languages: LookUpDto[];
    hasBarAdmission: boolean;
    hasJD: boolean;
    requiresCovidVax: boolean;
    requiresSecurityClearance: boolean;
    managerContactName: string | undefined;
    managerContactEmail: string | undefined;
    reviewerEmail: string | undefined;
    initialTrainingDetails: string | undefined;
    initialTrainingMeetingLink: string | undefined;
    initialTrainingDateTime: Date | undefined;
    initialTrainingTimeZone: TimeZoneDto | undefined;
    additionalInformation: string | undefined;
    dateStartedRecruiting: Date | undefined;
    isBarAdmissionStateMatchingLocation: boolean;
    status: ReviewerTypeStatus;
    reviewLikelihood: LookUpDto | undefined;
    caseReviewerEmailsManageType: ReviewerEmailsManageType;
    isEditable: boolean;
    numberOfRequiredReviewers: number;
    numberOfAppliedReviewers: number;
    numberOfPendingReviewers: number;
    numberOfAccepted: number;
    numberOfActiveReviewers: number;
    caseTimeEntryEnteringMaxDays: number;
    caseTimeEntryType: TimeEntryType;
    isOnHold: boolean;
    estimatedResumeDate: Date | undefined;
    clientEmployeeId: string | undefined;
    compensationSource: string | undefined;
    isReviewerBlocked: boolean;
}

export interface ProjectCaseDto {
    name: string | undefined;
    chatMode: CompanyChatMode;
    company: ProjectCompanyDto;
    reviewerTechnologies: LookUpDto[];
    technologyServiceProviders: LookUpDto[];
    caseTypes: LookUpDto[];
    caseRequirements: LookUpDto[];
    reviewerEmailsManageType: ReviewerEmailsManageType;
}

export interface ProjectCompanyDto {
    id: number;
    name: string | undefined;
    rating: number | undefined;
    numberOfRatings: number;
    compensationType: CompanyCompensationType;
}

export interface TimeZoneDto {
    id: number;
    offset: number;
    name: string | undefined;
    format: string | undefined;
    offsetHours: number | undefined;
    offsetMinutes: number | undefined;
}

export interface ExperienceLevelDto extends LookUpDto {
    year: number | undefined;
}

export interface ProjectApplicationDto {
    id: number;
    reviewerId: number;
    reviewerTypeId: number;
    isOnboarded: boolean;
    status: ReviewerReviewerTypeStatus;
    appliedDate: Date | undefined;
    isOnHold: boolean;
    isActive: boolean;
    isCompleted: boolean;
    isPendingStart: boolean;
    hasReviewerEmail: boolean;
    reviewerRating: number | undefined;
    reviewerRatingNumberOfRatings: number;
    companyRating: number | undefined;
    companyRatingNumberOfRatings: number;
    reviewerTypeInvitationId: number | undefined;
    startDate: Date;
    reviewerRejectedReasonName: string | undefined;
    reviewerRejectedOtherReason: string | undefined;
    companyReviewedDate: Date | undefined;
    approvalExpirationDate: Date | undefined;
    reviewerWithdrawnDate: Date | undefined;
    applicationDocuments: DocumentDto[];
    additionalRequirementAnswers: AdditionalRequirementAnswers[];
    reviewerPendingQuestionYesNoAnswers: ReviewerPendingQuestionYesNoAnswerDto[];
}

export interface ApplicationResultOfApplyToProjectResponse extends ApplicationResult {
    data: ApplyToProjectResponse | undefined;
}

export interface ApplyToProjectResponse {
    inviteStatus: InviteStatus | undefined;
    status: ReviewerReviewerTypeStatus;
    isPendingStart: boolean;
    showReferralPopup: boolean;
}

export enum InviteStatus {
    Invited = "Invited",
    Accepted = "Accepted",
    Revoked = "Revoked",
    Declined = "Declined",
}

export interface ReviewerApplyToProjectCommand {
    reviewerTypeId: number;
    caseRequirements: RequirementAgreementDto[];
    reviewerTypeRequirements: RequirementAgreementDto[];
    reviewerPendingQuestionYesNoAnswers: ReviewerPendingQuestionYesNoAnswerDto[];
}

export interface ApproveForProjectCommand {
    reviewerId: number;
    reviewerTypeId: number;
}

export interface SignReviewerDocumentCommand {
    reviewerTypeId: number;
    boldsignTemplateId: number;
}

export interface SubscribeForPushNotificationsCommand {
    registrationId: string;
    userId: number | undefined;
    type: DeviceType;
    deviceId: string | undefined;
}

export enum DeviceType {
    Ios = "Ios",
    Android = "Android",
    Unknown = "Unknown",
}

export interface UnSubscribeFromPushNotificationsCommand {
    registrationId: string;
}

export interface ApplicationResultOfListOfRelativityInstanceListDto extends ApplicationResult {
    data: RelativityInstanceListDto[] | undefined;
}

export interface RelativityInstanceListDto {
    id: number;
    name: string;
    instanceUrl: string;
    relativityAccountEmail: string;
    lastConnectionDate: Date;
    lastSuccessConnectionDate: Date | undefined;
    lastConnectionStatus: RelativityConnectionStatus;
    authType: RelativityAuthType;
    hasRelativityWorkspaces: boolean;
}

export enum RelativityConnectionStatus {
    Failed = "Failed",
    Success = "Success",
}

export enum RelativityAuthType {
    Password = "Password",
    OAuth = "OAuth",
    Import = "Import",
}

export interface ApplicationResultOfRelativityInstanceListDto extends ApplicationResult {
    data: RelativityInstanceListDto | undefined;
}

export interface RelativityCredentialsCommand {
    instanceUrl: string;
    relativityAccountEmail: string;
    relativityAccountPassword: string;
    isRawPassword: boolean;
    authType: RelativityAuthType;
    isRelativityServer: boolean;
}

export interface ConnectRelativityInstanceCommand extends RelativityCredentialsCommand {
    name: string;
}

export interface ApplicationResultOfRelativityInstanceDto extends ApplicationResult {
    data: RelativityInstanceDto | undefined;
}

export interface RelativityInstanceDto {
    id: number;
    name: string;
    instanceUrl: string;
    relativityAccountEmail: string;
    relativityAccountPassword: string;
    lastConnectionDate: Date;
    lastSuccessConnectionDate: Date | undefined;
    lastConnectionStatus: RelativityConnectionStatus;
    isRelativityServer: boolean;
    workspaces: RelativityWorkspaceListDto[];
    authType: RelativityAuthType;
}

export interface RelativityWorkspaceListDto {
    id: number;
    name: string;
    relativityName: string | undefined;
    artifactId: number;
    instanceId: number;
    instanceName: string;
    pollSchedule: string;
    fieldNameSource: RelativityFieldNameSource;
    clientArtifactId: number | undefined;
    lastPullStatus: RelativityPullStatus | undefined;
    lastPullDate: Date | undefined;
    lastSuccessPullDate: Date | undefined;
}

export enum RelativityFieldNameSource {
    Name = "Name",
    ArtifactId = "ArtifactId",
}

export enum RelativityPullStatus {
    Processing = "Processing",
    Success = "Success",
    Error = "Error",
    Skipped = "Skipped",
}

export interface UpdateRelativityInstanceCommand extends RelativityCredentialsCommand {
    id: number;
    name: string;
}

export interface ApplicationResultOfListOfRelativityWorkspaceListDto extends ApplicationResult {
    data: RelativityWorkspaceListDto[] | undefined;
}

export interface ApplicationResultOfListOfRelativityAuditsLogDto extends ApplicationResult {
    data: RelativityAuditsLogDto[] | undefined;
}

export interface RelativityAuditsLogDto {
    id: number;
    workspaceArtifactId: number;
    relativityInstanceId: number;
    dateRun: Date;
    dateQueryFrom: Date;
    status: RelativityPullStatus;
    exception: string | undefined;
    formattedException: string | undefined;
    auditsExpected: number;
    auditsImported: number;
    lastAuditDate: Date | undefined;
}

export interface ApplicationResultOfRelativityWorkspaceDto extends ApplicationResult {
    data: RelativityWorkspaceDto | undefined;
}

export interface RelativityWorkspaceDto {
    id: number;
    name: string;
    relativityName: string;
    artifactId: number;
    fields: RelativityFieldWithDocumentsDto[];
    instance: RelativityInstanceDto;
    instanceName: string;
    instanceId: number;
    clientArtifactId: number | undefined;
    fieldNameSource: RelativityFieldNameSource;
    pollSchedule: string;
    idleTimeSeconds: number;
    caseNames: string[];
    lastPullStatus: RelativityPullStatus | undefined;
    lastPullDate: Date | undefined;
    lastSuccessPullDate: Date | undefined;
}

export interface RelativityFieldDto extends BaseRelativityFieldDto {
    scoreForCorrect: number;
    scoreForOverturn: number;
    isEnabled: boolean;
}

export interface RelativityFieldWithDocumentsDto extends RelativityFieldDto {
    documents: number;
}

export interface ConnectRelativityWorkspaceCommand {
    instanceId: number;
    name: string;
    workspace: Workspace;
    clientArtifactId: number | undefined;
    fieldNameSource: RelativityFieldNameSource;
    fields: RelativityFieldDto[];
    pollSchedule: string;
    idleTimeSeconds: number;
}

export interface Workspace {
    name: string;
    artifactID: number;
    workspaceArtifactID: number;
}

export interface ApplicationResultOfRelativityWorkspaceStatusDto extends ApplicationResult {
    data: RelativityWorkspaceStatusDto | undefined;
}

export interface RelativityWorkspaceStatusDto {
    lastPullStatus: RelativityPullStatus | undefined;
    lastPullDate: Date | undefined;
    lastSuccessPullDate: Date | undefined;
    firstPullDate: Date | undefined;
    lastRequestStartDate: Date | undefined;
    auditsCount: number;
    editsCount: number;
    documentsCount: number;
    auditsExpected: number;
    auditsImported: number;
    error: string | undefined;
}

export interface UpdateRelativityWorkspaceCommand {
    id: number;
    name: string;
    clientArtifactId: number | undefined;
    pollSchedule: string;
    fields: RelativityFieldDto[];
    fieldNameSource: RelativityFieldNameSource;
    idleTimeSeconds: number;
}

export interface ScheduleAuditsPollingCommand {
    workspaceId: number;
    dateFrom: Date;
}

export interface ApplicationResultOfListOfWorkspace extends ApplicationResult {
    data: Workspace[] | undefined;
}

export interface ApplicationResultOfListOfClient extends ApplicationResult {
    data: Client[] | undefined;
}

export interface Client {
    name: string;
    artifactID: number;
}

export interface ApplicationResultOfListOfGroup extends ApplicationResult {
    data: Group[] | undefined;
}

export interface Group {
    name: string | undefined;
    artifactID: number;
    workspaceArtifactID: number;
}

export interface ApplicationResultOfListOfSavedSearchDto extends ApplicationResult {
    data: SavedSearchDto[] | undefined;
}

export interface SavedSearchDto {
    id: number | undefined;
    savedSearch: SavedSearch;
}

export interface SavedSearch {
    artifactId: number;
    artifactTypeId: number;
    name: string;
}

export interface ApplicationResultOfListOfRelativityWorkspaceUserDto extends ApplicationResult {
    data: RelativityWorkspaceUserDto[] | undefined;
}

export interface RelativityWorkspaceUserDto {
    user: User;
    matchedUserId: number | undefined;
}

export interface User {
    name: string;
    email: string;
    artifactID: number;
    groupArtifactID: number;
}

export interface ApplicationResultOfRelativitySavedSearchDto extends ApplicationResult {
    data: RelativitySavedSearchDto | undefined;
}

export interface RelativitySavedSearchDto {
    id: number;
    artifactId: number;
    workspaceArtifactId: number;
    relativityInstanceId: number;
    artifactTypeId: number;
}

export interface ConnectSavedSearchCommand {
    workspaceId: number;
    savedSearch: SavedSearch;
}

export interface ApplicationResultOfListOfField extends ApplicationResult {
    data: Field[] | undefined;
}

export interface Field {
    name: string;
    fieldType: string;
    artifactID: number;
}

export interface ConfirmRelativityCredentialsCommand extends RelativityCredentialsCommand {
}

export interface ApplicationResultOfListOfRelativityChoiceDto extends ApplicationResult {
    data: RelativityChoiceDto[] | undefined;
}

export interface RelativityChoiceDto {
    relativityInstanceId: number;
    workspaceArtifactId: number;
    fieldArtifactId: number;
    choiceArtifactId: number;
    name: string;
}

export interface ApplicationResultOfListOfRelativityUserDto extends ApplicationResult {
    data: RelativityUserDto[] | undefined;
}

export interface RelativityUserDto {
    id: number;
    userId: number;
    user: UserLookUpDto | undefined;
    relativityUserArtifactId: number;
    companyName: string;
    relativityInstanceName: string;
    hasAccess: boolean;
    hasLoginProfile: boolean;
    emailAddress: string | undefined;
    platformUserName: string;
    accessLog: RelativityUserAccessLogDto[];
}

export interface RelativityUserAccessLogDto {
    timestamp: Date;
    event: string;
    data: any | undefined;
}

export interface UpdateRelativityUserPasswordCommand {
    relativityUserId: number;
    password: string;
}

export interface UpdateRelativityUserAccessCommand {
    relativityUserId: number;
    hasAccess: boolean;
}

export interface ApplicationResultOfPaginatedResultOfRelativityAuditsLogDto extends ApplicationResult {
    data: PaginatedResultOfRelativityAuditsLogDto | undefined;
}

export interface PaginatedResultOfRelativityAuditsLogDto {
    totalRecords: number;
    results: RelativityAuditsLogDto[];
}

export interface PaginatedRequestOfGetRelativityPullAuditPagedQueryFilters {
    first: number;
    rows: number;
    sortField: string | undefined;
    sortOrder: number | undefined;
    filters: GetRelativityPullAuditPagedQueryFilters | undefined;
}

export interface GetRelativityPullAuditPagedQuery extends PaginatedRequestOfGetRelativityPullAuditPagedQueryFilters {
    workspaceArtifactId: number;
    relativityInstanceId: number;
}

export interface GetRelativityPullAuditPagedQueryFilters {
    dateRun: (DateQueryFilter | undefined)[] | undefined;
    status: ArrayQueryFilterOfString | undefined;
    formattedException: StringQueryFilter | undefined;
    auditsExpected: IntQueryFilter | undefined;
    auditsImported: IntQueryFilter | undefined;
}

export interface QueryFilterOfNullableIntegerAndNullableInteger {
    value: number | undefined;
}

export interface IntQueryFilter extends QueryFilterOfNullableIntegerAndNullableInteger {
    matchMode: NumberMatchMode;
}

export enum NumberMatchMode {
    Equals = "Equals",
    NotEquals = "NotEquals",
    Lt = "Lt",
    Lte = "Lte",
    Gt = "Gt",
    Gte = "Gte",
}

export interface ApplicationResultOfListOfRelativityActionDto extends ApplicationResult {
    data: RelativityActionDto[] | undefined;
}

export interface RelativityActionDto {
    id: number;
    name: string;
    description: string | undefined;
    isShowByDefault: boolean;
    order: number;
}

export interface ApplicationResultOfListOfReleaseHistoryDto extends ApplicationResult {
    data: ReleaseHistoryDto[] | undefined;
}

export interface ReleaseHistoryDto {
    id: number;
    order: number;
    name: string;
    notes: string;
}

export interface ApplicationResultOfListOfReviewerBarStatusDto extends ApplicationResult {
    data: ReviewerBarStatusDto[] | undefined;
}

export interface ReviewerBarStatusDto {
    reviewerId: number;
    reviewerName: string | undefined;
    reviewerFirstName: string | undefined;
    reviewerLastName: string | undefined;
    reviewerEmail: string;
    reviewerCreatedDate: Date | undefined;
    reviewerLastLoginDate: Date | undefined;
    lastDateBarConfirmed: Date | undefined;
    reviewerOnProjectStatus: ReviewerOnProjectStatus;
    barMemberships: BarMembershipDto[];
}

export interface BarMembershipDto {
    id: number;
    reviewerId: number;
    countryId: number;
    countryName: string;
    stateId: number | undefined;
    stateName: string | undefined;
    barId: string | undefined;
    stateBarHyperlink: string | undefined;
    notes: string | undefined;
    barConfirmationScreenshotDocumentId: number | undefined;
    lastDateBarConfirmed: Date | undefined;
    barConfirmationScreenshotDocument: DocumentDto | undefined;
    stateBarStatuses: LookUpDto[];
    isInactive: boolean;
}

export interface GetBarStatusesQuery {
}

export interface ApproveBarStatusCommand {
    id: number;
    stateBarHyperlink: string | undefined;
    notes: string | undefined;
    stateBarStatuses: LookUpDto[];
}

export interface AcknowledgeReviewerTypeAnnouncementCommand {
    announcementId: number;
}

export interface MarkAnnouncementsAsSeenCommand {
    announcementsIds: number[];
}

export interface BulkAcknowledgeAnnouncementCommand {
    reviewerTypeAnnouncementIds: number[];
}

export interface ApplicationResultOfListOfCurrentReviewerTypeAnnouncementDto extends ApplicationResult {
    data: CurrentReviewerTypeAnnouncementDto[] | undefined;
}

export interface CurrentReviewerTypeAnnouncementDto extends ReviewerTypeAnnouncementDto {
    caseId: number;
    caseName: string;
    hasSeen: boolean;
    hasAcknowledged: boolean;
}

export interface ApplicationResultOfListOfReviewerCaseDto extends ApplicationResult {
    data: ReviewerCaseDto[] | undefined;
}

export interface BaseReviewerCaseDto {
    reviewerType: ReviewerCaseReviewerTypeDto;
    dateApplied: Date | undefined;
    invitedDate: Date | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
}

export interface ReviewerCaseDto extends BaseReviewerCaseDto {
    earnings: number;
    hoursWorked: number;
    dateClosed: Date | undefined;
    status: ReviewerReviewerTypeStatus;
    reviewerTypeStartDate: Date;
    reviewerRating: number | undefined;
    companyRating: number | undefined;
    inviteDeclinedDate: Date | undefined;
    inviteExpirationDate: Date | undefined;
    currentSpanStartDate: Date | undefined;
    currentSpanEndDate: Date | undefined;
    reviewerWithdrawnDate: Date | undefined;
    companyReviewedDate: Date | undefined;
    reviewerDeclinedDate: Date | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    isChatAvailable: boolean;
    hasAdditionalRequirements: boolean;
    hasApplicationDocuments: boolean;
    reviewerTypeInvitationId: number | undefined;
    isInvitation: boolean;
    isReviewerBlocked: boolean;
    isAvailableForRating: boolean;
    statusSort: number;
}

export interface ReviewerCaseReviewerTypeDto {
    id: number;
    caseName: string | undefined;
    caseChatMode: CompanyChatMode;
    companyId: number;
    companyName: string | undefined;
    name: string | undefined;
    reviewerTypeRoleName: string | undefined;
    startDate: Date;
    endDate: Date;
    status: ReviewerTypeStatus;
}

export interface ReviewerCasesQuery {
}

export interface ApplicationResultOfCreateReviewerResultDto extends ApplicationResult {
    data: CreateReviewerResultDto | undefined;
}

export interface CreateReviewerResultDto {
    reviewerTypeInvite: ReviewerTypeInvitationDto | undefined;
}

export interface ReviewerTypeInvitationDto {
    id: number;
    reviewerTypeId: number;
    status: InviteStatus;
    isExpired: boolean;
    expirationDate: Date | undefined;
}

export interface CreateReviewerCommand {
    address: AddressDto | undefined;
    phone: string | undefined;
}

export interface UpdateReviewerAddressCommand {
    address: AddressDto;
}

export interface ApplicationResultOfListOfReviewerReviewerTypesDto extends ApplicationResult {
    data: ReviewerReviewerTypesDto[] | undefined;
}

export interface ReviewerReviewerTypesDto {
    id: number | undefined;
    name: string | undefined;
    case: LookUpDto | undefined;
    reviewerTypeRole: LookUpDto | undefined;
}

export interface ApplicationResultOfListOfPayrollResponseDto extends ApplicationResult {
    data: PayrollResponseDto[] | undefined;
}

export interface PayrollResponseDto {
    id: number;
    reviewerTypeName: string | undefined;
    caseName: string | undefined;
    reviewerId: number;
    status: number;
    dateIssued: Date;
    datePaid: Date | undefined;
    minutes: number;
    amount: number;
    isPremium: boolean;
}

export interface UpdateReviewerCompensationAndNotificationCommand {
    reviewerPayRates: ReviewerPayRateDto[];
    reviewerProjectNotificationMode: ReviewerProjectNotificationMode;
}

export interface ApplicationResultOfListOfReviewerPayRateDto extends ApplicationResult {
    data: ReviewerPayRateDto[] | undefined;
}

export interface DeleteReviewerPayRatesCommand {
    reviewerRoleTypeIds: number[] | undefined;
}

export interface SaveReviewerPolicyCommand {
    hasContractorAgreement: boolean;
    contractorAgreementSignature: string | undefined;
    contractorAgreementDate: Date;
    hasMutualArbitrationAgreement: boolean;
    mutualArbitrationAgreementSignature: string | undefined;
    mutualArbitrationAgreementDate: Date;
}

export interface ApplicationResultOfReviewerDashboardDto extends ApplicationResult {
    data: ReviewerDashboardDto | undefined;
}

export interface ReviewerDashboardDto {
    rating: number | undefined;
    numberOfRatings: number;
    total: ReviewerDashboardMetricsDto;
    lastThirtyDays: ReviewerDashboardMetricsDto;
}

export interface ReviewerDashboardMetricsDto {
    totalEarnings: number;
    totalProjects: number;
    totalActiveMinutes: number;
    totalPendingMinutes: number;
}

export interface ApplicationResultOfApplyResumeParsedValuesResultDto extends ApplicationResult {
    data: ApplyResumeParsedValuesResultDto | undefined;
}

export interface ApplyResumeParsedValuesResultDto {
    values: ResumeParsedValueDto[];
}

export interface ResumeParsedValueDto {
    id: number;
    key: string;
    data: any;
    currentValue: any | undefined;
    isApplied: boolean;
}

export interface ApplyResumeParsedValuesCommand {
    valueIds: number[];
}

export interface ApplicationResultOfResumeParsingResultDto extends ApplicationResult {
    data: ResumeParsingResultDto | undefined;
}

export interface ResumeParsingResultDto {
    status: ResumeProcessingStatus;
    hasParsingTask: boolean;
    values: ResumeParsedValueDto[];
    steps: ResumeParsingStepResultDto[];
}

export enum ResumeProcessingStatus {
    Created = "Created",
    InProgress = "InProgress",
    Success = "Success",
    Failed = "Failed",
}

export interface ResumeParsingStepResultDto {
    name: string;
    status: ResumeProcessingStatus;
}

export interface ApplicationResultOfListOfReviewerPerksDto extends ApplicationResult {
    data: ReviewerPerksDto[] | undefined;
}

export interface ReviewerPerksDto {
    id: number;
    title: string;
    shortDescription: string;
    content: string;
    category: string;
    status: string;
    position: number;
}

export interface ReviewerPerksQuery {
}

export interface ApplicationResultOfListOfProjectWithPendingBoldsignDocumentDto extends ApplicationResult {
    data: ProjectWithPendingBoldsignDocumentDto[] | undefined;
}

export interface ProjectWithPendingBoldsignDocumentDto {
    caseId: number;
    caseName: string;
    reviewerTypeId: number;
    reviewerTypeName: string;
    boldsignTemplateId: number;
    boldsignTemplateName: string;
}

export interface ApplicationResultOfReviewerTypeInvitationDto extends ApplicationResult {
    data: ReviewerTypeInvitationDto;
}

export interface ApplicationResultOfListOfReviewerAvailableDto extends ApplicationResult {
    data: ReviewerAvailableDto[] | undefined;
}

export interface ReviewerAvailableDto {
    id: number;
    reviewerId: number;
    name: string;
    isInternal: boolean;
    activeProjects: number;
    projectsAccepted: number;
    projectsInvited: number;
    projectsApplied: number;
    isFavorite: boolean;
    isBlocked: boolean;
    reviewerRating: number | undefined;
    reviewerNumberOfRatings: number;
    isMatching: boolean;
    isActiveOnOtherProject: boolean;
    activeProjectEndDate: Date | undefined;
}

export interface InviteReviewersCommand {
    reviewerTypeId: number;
    reviewerIds: number[];
    message: string | undefined;
}

export interface InviteFavoriteReviewersCommand {
    reviewerTypeId: number;
    message: string | undefined;
}

export interface InviteMatchedReviewersCommand {
    reviewerTypeId: number;
    message: string | undefined;
}

export interface ApplicationResultOfInviteReviewersByEmailResultDto extends ApplicationResult {
    data: InviteReviewersByEmailResultDto | undefined;
}

export interface InviteReviewersByEmailResultDto {
    invitedCount: number;
    invitedUsersCount: number;
    invitedEmailsCount: number;
    inviteReviewersResult: InviteReviewersResultDto;
    errors: InviteReviewerByEmailErrorDto[];
}

export interface InviteReviewerByEmailErrorDto {
    email: string;
    errors: string[];
}

export interface InviteReviewersByEmailsCommand {
    reviewerTypeId: number;
    emails: string[];
    message: string | undefined;
}

export interface RevokeReviewerInvitationBulkCommand {
    inviteIds: number[];
}

export interface WithdrawDeclineReviewerTypeInvitationCommand {
    reviewerTypeId: number;
}

export interface ApplicationResultOfListOfReviewerPlatformTimeDto extends ApplicationResult {
    data: ReviewerPlatformTimeDto[] | undefined;
}

export interface ReviewerPlatformTimeDto {
    id: number;
    dateWorked: Date;
    minsInSystem: number;
    hrsInSystem: number;
    documents: number;
    docsPerHour: number;
}

export interface ApplicationResultOfReviewerReviewerTypeSpanDto extends ApplicationResult {
    data: ReviewerReviewerTypeSpanDto;
}

export interface ReviewerReviewerTypeSpanDto {
    id: number;
    startDate: Date;
    endDate: Date | undefined;
    deactivateReasonId: number | undefined;
    deactivateReason: string | undefined;
    deactivateOtherReason: string | undefined;
    withdrawReasonId: number | undefined;
    withdrawReason: string | undefined;
    withdrawOtherReason: string | undefined;
    isAvailableForRating: boolean;
    companyRating: RatingDto | undefined;
    reviewerRating: RatingDto | undefined;
    activeLeaveRequest: ReviewerReviewerTypeLeaveRequestDto | undefined;
}

export interface UpdateReviewerActiveSpanCommand {
    reviewerTypeId: number;
    reviewerId: number;
    startDate: Date | undefined;
    endDate: Date | undefined;
}

export interface ApplicationResultOfReviewerSummaryDto extends ApplicationResult {
    data: ReviewerSummaryDto;
}

export interface ReviewerSummaryDto {
    id: number;
    reviewerTypeId: number;
    reviewerTypeName: string;
    reviewerTypeCaseId: number;
    reviewerTypeCaseName: string;
    dateWorked: Date;
    dateType: ReviewerSummaryDateType;
    summaryText: string;
}

export interface ApplicationResultOfListOfReviewerSummaryDto extends ApplicationResult {
    data: ReviewerSummaryDto[] | undefined;
}

export interface ApplicationResultOfListOfReviewerSummaryMissingDto extends ApplicationResult {
    data: ReviewerSummaryMissingDto[] | undefined;
}

export interface ReviewerSummaryMissingDto {
    reviewerTypeId: number;
    reviewerTypeName: string;
    dateWorked: Date | undefined;
    reviewerSummaryDateType: ReviewerSummaryDateType;
}

export interface ApplicationResultOfListOfReviewerSummaryCaseDto extends ApplicationResult {
    data: ReviewerSummaryCaseDto[] | undefined;
}

export interface ReviewerSummaryCaseDto {
    id: number;
    name: string;
    reviewerTypes: ReviewerSummaryReviewerTypeDto[];
}

export interface ReviewerSummaryReviewerTypeDto {
    id: number;
    caseId: number;
    name: string;
    reviewerSummariesType: ReviewerSummaryDateType;
    spans: ReviewerSummaryReviewerTypeSpanDto[];
}

export interface ReviewerSummaryReviewerTypeSpanDto {
    startDate: Date;
    endDate: Date | undefined;
}

export interface UpsertReviewerSummaryCommand {
    reviewerTypeId: number;
    dateWorked: Date;
    summaryText: string;
}

export interface ApplicationResultOfListOfReviewerTagDto extends ApplicationResult {
    data: ReviewerTagDto[] | undefined;
}

export interface ApplicationResultOfReviewerTagDto extends ApplicationResult {
    data: ReviewerTagDto | undefined;
}

export interface CreateReviewerTagCommand {
    name: string;
    caseId: number | undefined;
}

export interface CreateAndSelectReviewerTagCommand {
    name: string;
    reviewerReviewerTypeId: number;
    caseId: number | undefined;
}

export interface UpdateReviewerTagCommand {
    id: number;
    name: string;
    caseId: number | undefined;
}

export interface ArchiveReviewerTagCommand {
    id: number;
    isArchived: boolean;
}

export interface BatchUpdateReviewerReviewerTypeTagsCommand {
    reviewerReviewerTypeId: number;
    tagIdsToAdd: number[];
    tagIdsToRemove: number[];
}

export interface ApplicationResultOfForecastChartDto extends ApplicationResult {
    data: ForecastChartDto | undefined;
}

export interface ForecastChartDto {
    groupedReviewerTimeEntryEarning: GroupedReviewerTimeEntryEarningDto[];
    summary: ForecastChartSummaryDto;
}

export interface GroupedReviewerTimeEntryEarningDto {
    dateWorked: Date;
    totalEarningsActiveRts: number;
    totalEarningsClosedRts: number;
    totalEarningsTotal: number;
    totalEarningsCumulative: number;
    totalPendingEarnings: number;
    totalApprovedMinutes: number;
    totalApprovedHours: number;
    totalPendingMinutes: number;
    totalPendingHours: number;
    activeReviewers: number;
    budgetRemaining: number;
    type: GroupedReviewerTimeEntryEarningType;
}

export enum GroupedReviewerTimeEntryEarningType {
    Actual = "Actual",
    Forecast = "Forecast",
}

export interface ForecastChartSummaryDto {
    originalTotalBudget: number;
    actualSpendToDate: number;
    forecastedFutureSpend: number;
    forecastedTotalSpend: number;
    remainingBudget: number;
    lookbackStartDate: Date;
}

export interface ApplicationResultOfGroupedReviewerTypeAssignmentsDto extends ApplicationResult {
    data: GroupedReviewerTypeAssignmentsDto | undefined;
}

export interface GroupedReviewerTypeAssignmentsDto {
    projects: GroupedReviewerTypeAssignmentProjectDto[];
    reviewers: ReviewerAvailabilityDto[];
    assignments: GroupedReviewerTypeAssignmentReviewerDto[];
    previousAssignments: GroupedReviewerTypePreviousAssignmentDto[];
    isEmpty: boolean;
}

export interface GroupedReviewerTypeAssignmentProjectDto {
    reviewerTypeId: number;
    reviewerTypeName: string | undefined;
    caseId: number;
    caseName: string;
    minutes: number;
    isInternal: boolean;
}

export interface ReviewerAvailabilityDto {
    reviewerId: number;
    reviewerName: string | undefined;
    availableWeeklyHours: number;
}

export interface GroupedReviewerTypeAssignmentReviewerDto {
    reviewerTypeId: number;
    reviewerId: number;
    reviewerName: string | undefined;
    minutes: number;
}

export interface GroupedReviewerTypePreviousAssignmentDto {
    reviewerTypeId: number;
    reviewerId: number;
}

export interface UpdateReviewerTypeAssignmentCommand {
    reviewerTypeId: number;
    weekOfYear: number;
    year: number;
    minutes: number;
}

export interface UpdateReviewerTypeReviewerAssignmentsCommand {
    assignments: GroupedReviewerTypeAssignmentReviewerDto[];
    projects: GroupedReviewerTypeAssignmentProjectDto[];
    weekOfYear: number;
    year: number;
}

export interface UpdateReviewerTypeReviewerAssignmentCommand {
    reviewerTypeId: number;
    reviewerId: number;
    weekOfYear: number;
    year: number;
    minutes: number;
}

export interface ApplicationResultOfListOfGroupedReviewerTypeAssignmentReviewerDto extends ApplicationResult {
    data: GroupedReviewerTypeAssignmentReviewerDto[] | undefined;
}

export interface AutoAssignReviewerTypeAssignmentsCommand {
    year: number;
    weekOfYear: number;
    autoFillStartFromPrevious: boolean;
    projects: GroupedReviewerTypeAssignmentProjectDto[];
    assignments: GroupedReviewerTypeAssignmentReviewerDto[];
}

export interface ApplyReviewerReviewerTypeAllocationsCommand {
    year: number;
    weekOfYear: number;
}

export interface ApplicationResultOfAllocationAssignmentsDto extends ApplicationResult {
    data: AllocationAssignmentsDto | undefined;
}

export interface AllocationAssignmentsDto {
    reviewers: ReviewerAssignmentDto[];
    weeks: Date[];
    projects: ProjectsAssignmentDto[];
}

export interface ReviewerAssignmentDto {
    reviewerId: number;
    reviewerName: string | undefined;
    isInternal: boolean;
}

export interface ProjectsAssignmentDto {
    reviewerId: number;
    week: Date;
    projects: ProjectAssignmentDto[];
}

export interface ProjectAssignmentDto {
    reviewerTypeId: number;
    reviewerTypeName: string | undefined;
    caseId: number;
    caseName: string;
}

export interface ApplicationResultOfReviewerTypeListDto extends ApplicationResult {
    data: ReviewerTypeListDto | undefined;
}

export interface BaseReviewerTypeMutationCommand {
    name: string;
    caseId: number;
    reviewerTypeRoleId: number;
    allowOvertime: boolean;
    overtimeRate: number;
    overtimeHours: number;
    allowWeekend: RequiredValues;
    weekendRate: number;
    allowHoliday: RequiredValues;
    allowConcurrent: boolean;
    holidayRate: number;
    limitHoursPerWeek: boolean;
    minimumWeeklyHours: number;
    maximumWeeklyHours: number;
    limitHoursPerDay: boolean;
    minimumDailyHours: number;
    maximumDailyHours: number;
    managerContactName: string;
    managerContactEmail: string;
    initialTrainingDetails: string | undefined;
    initialTrainingMeetingLink: string | undefined;
    initialTrainingStart: Date | undefined;
    initialTrainingEnd: Date | undefined;
    initialTrainingTimezoneId: number | undefined;
    additionalInformation: string | undefined;
    relativityGroupArtifactId: number | undefined;
    estimatedDocumentsPerHour: number;
    documentCount: number;
    requiresCovidVax: boolean;
    hasBarAdmission: boolean;
    requiresMilitaryAssociation: boolean;
    requiresCurrentBackgroundCheck: boolean;
    isBarAdmissionStateMatchingLocation: boolean;
    hasJD: boolean;
    requiresSecurityClearance: boolean;
    experienceLevelId: number | undefined;
    projectedCostMode: ReviewerTypeProjectedCostMode;
    isInternal: boolean;
    chatsAutoDeleteThresholdDays: number | undefined;
    isChatsAutoDeletePermanent: boolean;
    reviewLikelihoodId: number | undefined;
    performBackgroundCheckIfOlderThanMonths: number | undefined;
    performBarConfirmationIfOlderThanMonths: number | undefined;
    performAdditionalLanguageTest: boolean;
    additionalServicesInformation: string | undefined;
    relativitySavedSearchId: number | undefined;
    allowOvertimeByRule: boolean;
    reviewerSummariesRequirement: RequiredValues;
    reviewerSummariesType: ReviewerSummaryDateType;
    reviewerSummaryNotificationSchedule: string | undefined;
    reviewerSummariesSubmitByDay: DaysOfWeek;
    reviewerSummariesSubmitByTime: string;
    reviewerSummaryNotificationIsPaused: boolean;
    reviewerSummaryNotificationEmails: ReviewerSummaryNotificationEmailDto[];
    specialties: LookUpDto[];
    languages: LookUpDto[];
    barCountries: LookUpDto[];
    barStates: LookUpDto[];
    residencyStates: LookUpDto[];
    residencyCountries: LookUpDto[];
    reviewerRequirements: LookUpDto[];
    locationStates: LookUpDto[];
    locationCountries: LookUpDto[];
    timeZones: LookUpDto[];
    reviewerTypeQuestions: LookUpDto[];
    actionCodes: LookUpDto[];
    additionalServices: ReviewerTypeAdditionalServiceMutationModel[];
}

export interface CreateReviewerTypeCommand extends BaseReviewerTypeMutationCommand {
    startDate: Date;
    endDate: Date;
    rate: number;
    copyFromReviewerTypeId: number | undefined;
}

export enum ReviewerTypeProjectedCostMode {
    DocumentsCount = "DocumentsCount",
    NumberOfReviewers = "NumberOfReviewers",
}

export enum DaysOfWeek {
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
    Sunday = "Sunday",
}

export interface ReviewerSummaryNotificationEmailDto {
    id: number;
    email: string;
}

export interface ReviewerTypeAdditionalServiceMutationModel {
    additionalServiceId: number;
    checkIfOlderThanMonths: number | undefined;
}

export interface UpdateReviewerTypeCommand extends BaseReviewerTypeMutationCommand {
    id: number;
}

export interface ApplicationResultOfReviewerTypeDto extends ApplicationResult {
    data: ReviewerTypeDto | undefined;
}

export interface ReviewerTypeDto {
    id: number;
    caseId: number;
    case: CaseDto;
    name: string | undefined;
    reviewerTypeRoleId: number;
    reviewerTypeRole: LookUpDto | undefined;
    minimumWeeklyHours: number;
    limitHoursPerWeek: boolean;
    maximumWeeklyHours: number;
    limitHoursPerDay: boolean;
    minimumDailyHours: number;
    maximumDailyHours: number;
    deadline: Date;
    allowOvertime: boolean;
    allowOvertimeByRule: boolean;
    overtimeRate: number;
    overtimeHours: number;
    allowWeekend: RequiredValues;
    weekendRate: number;
    allowHoliday: RequiredValues;
    holidayRate: number;
    startDate: Date;
    endDate: Date;
    isPendingStart: boolean;
    documentCount: number;
    hasBarAdmission: boolean;
    hasJD: boolean;
    requiresSecurityClearance: boolean;
    allowConcurrent: boolean;
    requiresMilitaryAssociation: boolean;
    requiresCurrentBackgroundCheck: boolean;
    experienceLevelId: number | undefined;
    experienceLevel: LookUpDto | undefined;
    numberOfRequiredReviewers: number;
    rate: number;
    isRateSet: boolean;
    canInviteReviewers: boolean;
    projectedCostMode: ReviewerTypeProjectedCostMode;
    requiresCovidVax: boolean;
    managerContactName: string;
    managerContactEmail: string;
    hasInitialTraining: boolean;
    initialTrainingDetails: string | undefined;
    initialTrainingMeetingLink: string | undefined;
    initialTrainingStart: Date | undefined;
    initialTrainingEnd: Date | undefined;
    initialTrainingTimeZoneId: number | undefined;
    initialTrainingTimeZone: TimeZoneDto | undefined;
    additionalInformation: string | undefined;
    estimatedDocumentsPerHour: number;
    isBarAdmissionStateMatchingLocation: boolean;
    relativityGroupArtifactId: number | undefined;
    projectedCost: number;
    projectedNumberOfReviewers: number;
    performBackgroundCheckIfOlderThanMonths: number | undefined;
    performBarConfirmationIfOlderThanMonths: number | undefined;
    performAdditionalLanguageTest: boolean;
    relativitySavedSearchId: number | undefined;
    reviewerSummariesRequirement: RequiredValues;
    reviewerSummariesType: ReviewerSummaryDateType;
    specialties: LookUpDto[] | undefined;
    languages: LookUpDto[] | undefined;
    countries: LocationDto[] | undefined;
    barStates: LocationDto[];
    barCountries: LocationDto[];
    locationCountries: LocationDto[];
    locationStates: LocationDto[];
    residencyCountries: LocationDto[];
    residencyStates: LocationDto[];
    reviewerRequirements: LookUpDto[];
    reviewerTypeQuestions: LookUpDto[];
    actionCodes: LookUpDto[];
    additionalServices: ReviewerTypeAdditionalServiceDto[];
    timeZones: TimeZoneDto[] | undefined;
    status: ReviewerTypeStatus;
    recruitingStatus: ReviewerTypeRecruitingStatus;
    isRecruitingStatus: boolean;
    isRequirementsCompleted: boolean;
    numberOfPendingReviewers: number;
    numberOfActiveReviewers: number;
    numberOfAccepted: number;
    numberOfInvitedReviewers: number;
    isTemplate: boolean;
    isInternal: boolean;
    isAnyReviewerApplied: boolean;
    isRateLocked: boolean;
    unFilledPositions: number;
    canBeDeleted: boolean;
    companyIsInternalReviewers: boolean;
    chatsAutoDelete: boolean;
    chatsAutoDeleteThresholdDays: number | undefined;
    isChatsAutoDeletePermanent: boolean;
    reviewLikelihoodId: number | undefined;
    reviewLikelihood: LookUpDto | undefined;
    additionalServicesInformation: string | undefined;
    isCompleted: boolean;
    reviewerSummaryNotificationSchedule: string | undefined;
    reviewerSummariesSubmitByDay: DaysOfWeek;
    reviewerSummariesSubmitByTime: string;
    reviewerSummaryNotificationIsPaused: boolean;
    reviewerSummaryNotificationEmails: ReviewerSummaryNotificationEmailDto[];
    caseTimeZoneId: number | undefined;
    caseTimeZone: TimeZoneDto | undefined;
    isOnHold: boolean;
    clientRate: number | undefined;
    maxHours: number | undefined;
    isEnabledClientBudgeting: boolean;
    revenue: number;
    clientBudget: number;
    clientRemainingBudget: number;
    clientRemainingHours: number;
    clientSpend: number;
    netProfit: number;
}

export interface CaseDto {
    id: number;
    name: string | undefined;
    estimatedDocCount: number;
    companyIsInternalReviewers: boolean;
    companyId: number;
    timeZoneId: number;
    timeZoneName: string;
    isTemplate: boolean;
    companyCompensationType: CompanyCompensationType;
    chatMode: CompanyChatMode;
    company: LookUpDto | undefined;
    reviewerTechnologies: LookUpDto[] | undefined;
    technologyServiceProviders: LookUpDto[] | undefined;
    clients: LookUpDto[] | undefined;
    caseTypes: LookUpDto[] | undefined;
    attorneysOutside: LookUpDto[] | undefined;
    attorneysOpposing: LookUpDto[] | undefined;
    firmsOutside: LookUpDto[] | undefined;
    firmsOpposing: LookUpDto[] | undefined;
    parties: LookUpDto[] | undefined;
    caseRequirements: LookUpDto[] | undefined;
    timeEntryMinuteInterval: number;
    chatsAutoDeleteThresholdDays: number | undefined;
    isChatsAutoDeletePermanent: boolean;
    isW2Company: boolean;
    relativityManageUsers: boolean;
    relativityAccessAudits: boolean;
}

export interface ApplicationResultOfListOfReviewerTypeListDto extends ApplicationResult {
    data: ReviewerTypeListDto[] | undefined;
}

export interface ApplicationResultOfListOfReviewerTypeActiveDto extends ApplicationResult {
    data: ReviewerTypeActiveDto[] | undefined;
}

export interface ReviewerTypeActiveDto {
    id: number;
    name: string | undefined;
}

export interface ApplicationResultOfReviewerRequirementResponse extends ApplicationResult {
    data: ReviewerRequirementResponse | undefined;
}

export interface ReviewerRequirementResponse {
    caseName: string | undefined;
    reviewerTypeName: string | undefined;
    reviewerRole: string | undefined;
    estimatedDocCount: number;
}

export interface UpdateReviewersCountCommand {
    reviewerTypeId: number;
    numberOfRequiredReviewers: number;
}

export interface UpdateReviewerTypeRateCommand {
    reviewerTypeId: number;
    rate: number;
    changeRetroactively: boolean;
}

export interface UpdateReviewerTypeClientBudgetCommand {
    reviewerTypeId: number;
    clientRate: number | undefined;
    maxHours: number | undefined;
}

export interface ApplicationResultOfCalculatedReviewerTypeClientBudgetDto extends ApplicationResult {
    data: CalculatedReviewerTypeClientBudgetDto | undefined;
}

export interface CalculatedReviewerTypeClientBudgetDto {
    reviewerTypeId: number;
    maxHours: number | undefined;
    clientRate: number | undefined;
    isEnabledClientBudgeting: boolean;
    revenue: number;
    clientBudget: number;
    clientRemainingBudget: number;
    clientRemainingHours: number;
    clientSpend: number;
    netProfit: number;
}

export interface CalculateReviewerTypeClientBudgetCommand {
    reviewerTypeId: number;
    clientRate: number | undefined;
    maxHours: number | undefined;
}

export interface ApplicationResultOfUpdateReviewerTypeDatesResponse extends ApplicationResult {
    data: UpdateReviewerTypeDatesResponse | undefined;
}

export interface UpdateReviewerTypeDatesResponse {
    message: string | undefined;
    warnings: string[];
}

export interface UpdateReviewerTypeDatesCommand {
    reviewerTypeId: number;
    startDate: Date;
    endDate: Date;
}

export interface UpdateReviewLikelihoodCommand {
    reviewerTypeId: number;
    reviewLikelihoodId: number;
}

export interface TransferReviewerCommand {
    reviewerId: number;
    destinationReviewerTypeId: number;
}

export interface TransferReviewersCommand {
    reviewerIds: number[];
    destinationReviewerTypeId: number;
}

export interface ApplicationResultOfRecruitmentStatisticDto extends ApplicationResult {
    data: RecruitmentStatisticDto | undefined;
}

export interface RecruitmentStatisticDto {
    potentialsMatches: number;
    pendingReviewers: number;
    acceptedReviewers: number;
    activeReviewers: number;
    unfilledReviewers: number;
}

export interface CalculateRecruitmentStatisticCommand extends BaseReviewerTypeMutationCommand {
    id: number;
    excludeRequirements: string[];
}

export interface ApplicationResultOfSuggestedRateDto extends ApplicationResult {
    data: SuggestedRateDto | undefined;
}

export interface SuggestedRateDto {
    suggestedRate: number;
    averageRate: number;
    matchedReviewers: number;
}

export interface ApplicationResultOfListOfReviewerTypeTemplateListDto extends ApplicationResult {
    data: ReviewerTypeTemplateListDto[] | undefined;
}

export interface ReviewerTypeTemplateListDto {
    id: number;
    caseId: number;
    name: string | undefined;
    reviewerTypeRole: LookUpDto | undefined;
    documentCount: number;
    startDate: Date;
    endDate: Date;
    createdDate: Date;
}

export interface LeaveReviewerTypeCommand {
    reviewerTypeId: number;
    withdrawReasonId: number;
    lastDateAvailable: Date;
    comment: string | undefined;
}

export interface ApplicationResultOfReviewerTypeProjectedCostCalculationResult extends ApplicationResult {
    data: ReviewerTypeProjectedCostCalculationResult | undefined;
}

export interface ReviewerTypeProjectedCostCalculationResult {
    estimatedNumberOfReviewers: number;
    estimatedProjectCost: number;
}

export interface ReviewerTypeProjectedCostInputModel {
    reviewerTypeId: number;
    projectedCostMode: ReviewerTypeProjectedCostMode;
    estimatedDocumentsPerHour: number;
    documentCount: number;
    numberOfRequiredReviewers: number;
    rate: number;
    startDate: Date;
    endDate: Date;
    minimumWeeklyHours: number;
    minimumDailyHours: number;
    allowHoliday: RequiredValues;
    allowWeekend: RequiredValues;
}

export interface GetProjectedCostQuery extends ReviewerTypeProjectedCostInputModel {
}

export interface ApplicationResultOfReviewerTypeContacts extends ApplicationResult {
    data: ReviewerTypeContacts | undefined;
}

export interface ReviewerTypeContacts {
    managerContactName: string | undefined;
    managerContactEmail: string | undefined;
}

export interface SendFollowUpNotificationsCommand {
    reviewerTypeId: number;
    message: string | undefined;
}

export interface ApplicationResultOfReviewerTypeReviewerResponse extends ApplicationResult {
    data: ReviewerTypeReviewerResponse | undefined;
}

export interface ReviewerTypeReviewerResponse {
    reviewerTypePendingQuestions: LookUpDto[];
    reviewers: ReviewerTypeReviewerDto[];
}

export interface ReviewerTypeReviewerDto {
    reviewerReviewerTypeId: number | undefined;
    reviewerTypeInvitationId: number | undefined;
    reviewerId: number;
    reviewerTypeCaseId: number;
    reviewerTypeId: number;
    reviewerTypeStatus: ReviewerTypeStatus;
    reviewerName: string | undefined;
    reviewerFullName: string | undefined;
    status: ReviewerReviewerTypeStatus;
    isMeetingRequirements: boolean | undefined;
    hasConflict: boolean | undefined;
    isOnboarded: boolean | undefined;
    isCompleted: boolean | undefined;
    reviewerTypeIsCompleted: boolean;
    reviewerTypeCaseName: string | undefined;
    reviewerTypeName: string | undefined;
    reviewerTypeStartDate: Date;
    isW2Company: boolean;
    approvalExpirationDate: Date | undefined;
    inviteExpirationDate: Date | undefined;
    isActiveOnOtherProject: boolean;
    activeProjectEndDate: Date | undefined;
    reviewerPendingQuestionYesNoAnswers: ReviewerPendingQuestionYesNoAnswerDto[];
    reviewerTags: ReviewerTagDto[];
    isReviewerBlocked: boolean;
}

export interface ApplicationResultOfReviewerTypePrioritiesDto extends ApplicationResult {
    data: ReviewerTypePrioritiesDto | undefined;
}

export interface ReviewerTypePrioritiesDto {
    allocationPriorityType: CompanyReviewerAllocationPriorityType;
    reviewerTypes: ReviewerTypeDto[];
}

export enum CompanyReviewerAllocationPriorityType {
    ByBestMatch = "ByBestMatch",
    ByReviewerType = "ByReviewerType",
}

export interface UpdateReviewerTypePrioritiesCommand {
    allocationPriorityType: CompanyReviewerAllocationPriorityType;
    reviewerTypeIds: number[];
}

export interface ApproveLeaveProjectRequestCommand {
    requestId: number;
}

export interface DenyLeaveProjectRequestCommand {
    requestId: number;
    feedback: string;
}

export interface RevokeLeaveRequestCommand {
    requestId: number;
}

export interface HoldReviewerTypeCommand {
    reviewerTypeId: number;
    estimatedResumeDate: Date | undefined;
}

export interface ResumeReviewerTypeCommand {
    reviewerTypeId: number;
}

export interface ApplicationResultOfListOfReviewerTypeReviewStatusListDto extends ApplicationResult {
    data: ReviewerTypeReviewStatusListDto[] | undefined;
}

export interface ReviewerTypeReviewStatusListDto {
    id: number;
    name: string | undefined;
    estimatedEndDate: Date | undefined;
    estimatedRemainingDocuments: number;
    reviewStatus: ReviewerTypeReviewStatus;
    startDate: Date;
    endDate: Date;
}

export interface ApplicationResultOfReviewerTypeReviewStatusDto extends ApplicationResult {
    data: ReviewerTypeReviewStatusDto | undefined;
}

export interface ReviewerTypeReviewStatusDto {
    reviewerTypeName: string;
    status: ReviewerTypeReviewStatus;
    dailyDocuments: number;
    dailyDocsPerHour: number;
    completedDocuments: number;
    remainingDocuments: number;
    totalDocuments: number;
    percentCompleted: number;
    docsPerHour: number;
    docsPerDay: number;
    hoursPerDay: number;
    totalApprovedHours: number;
    totalHours: number;
    totalPlatformHours: number;
    fields: ReviewStatusFieldDto[];
    projectLength: number;
    hoursRemaining: number;
    estimatedEndDate: Date | undefined;
}

export interface ReviewStatusFieldDto {
    id: number;
    artifactId: number;
    fieldName: string;
    choices: ReviewStatusFieldChoiceDto[];
}

export interface ReviewStatusFieldChoiceDto {
    artifactId: string;
    name: string | undefined;
    count: number;
    percent: number;
}

export interface ApplicationResultOfReviewerTypeBurnDownReportDto extends ApplicationResult {
    data: ReviewerTypeBurnDownReportDto | undefined;
}

export interface ReviewerTypeBurnDownReportDto {
    isAvailable: boolean;
    startDate: Date;
    endDate: Date;
    timeSeries: ReviewerTypeBurnDownReportTimeSeriesDto[];
}

export interface ReviewerTypeBurnDownReportTimeSeriesDto {
    date: Date;
    documentsReviewed: number;
    documentsLeft: number;
}

export interface ApplicationResultOfPaginatedResultOfCompanyTimeEntryDto extends ApplicationResult {
    data: PaginatedResultOfCompanyTimeEntryDto | undefined;
}

export interface PaginatedResultOfCompanyTimeEntryDto {
    totalRecords: number;
    results: CompanyTimeEntryDto[];
}

export interface CompanyTimeEntryDto {
    id: number;
    reviewerId: number;
    reviewerName: string | undefined;
    reviewerFirstName: string | undefined;
    reviewerLastName: string | undefined;
    caseName: string | undefined;
    caseLocationNames: string[];
    matterCodes: string[];
    phaseTaskCode: string | undefined;
    phaseCodeName: string | undefined;
    taskCodeName: string | undefined;
    reviewerType: string | undefined;
    reviewerTypeRole: string | undefined;
    actionCodeNames: string[];
    dateWorked: Date | undefined;
    weekOf: Date | undefined;
    minutes: number;
    status: ReviewerTimeEntryStatus;
    displayStatus: ReviewerTimeEntryDisplayStatus;
    cost: number | undefined;
    description: string | undefined;
    timeCategoryId: number | undefined;
    isReviewTime: boolean;
    type: string;
    actualMinutesWorked: number | undefined;
    companyNotes: string | undefined;
    reviewerNotes: string | undefined;
    entryType: ReviewerTypeEntryType;
    createdDate: Date | undefined;
    modifiedDate: Date | undefined;
    lastExportedDate: Date | undefined;
    exportStatus: TimeEntryExportStatus;
    companyId: number;
    companyName: string;
    isReadOnly: boolean;
    reviewerTimeEntryRejectedReasonName: string | undefined;
    reviewerTimeEntryRejectedOtherReason: string | undefined;
    duration: string;
    durationFormatted: string;
    actualMinutesWorkedFormatted: string;
    minutesOT: number | undefined;
    costOT: number | undefined;
    rate: number;
    reviewerClientEmployeeId: string | undefined;
    reviewerPersonalEmail: string | undefined;
    altorneyEmail: string | undefined;
    companyEmail: string | undefined;
}

export enum ReviewerTimeEntryStatus {
    Pending = "Pending",
    Approved = "Approved",
    Rejected = "Rejected",
}

export enum ReviewerTimeEntryDisplayStatus {
    Pending = "Pending",
    Approved = "Approved",
    Rejected = "Rejected",
    AutoApproved = "AutoApproved",
}

export enum ReviewerTypeEntryType {
    Manual = "Manual",
    Clock = "Clock",
    Import = "Import",
}

export enum TimeEntryExportStatus {
    Unexported = "Unexported",
    Exported = "Exported",
    PartiallyExported = "PartiallyExported",
    ExportedButModified = "ExportedButModified",
}

export interface GetCompanyTimeEntriesQuery {
    caseId: number | undefined;
    query: PaginatedRequestOfCompanyTimeEntryFilters | undefined;
}

export interface PaginatedRequestOfCompanyTimeEntryFilters {
    first: number;
    rows: number;
    sortField: string | undefined;
    sortOrder: number | undefined;
    filters: CompanyTimeEntryFilters | undefined;
}

export interface CompanyTimeEntryFilters {
    caseName: ArrayQueryFilterOfString | undefined;
    description: ArrayQueryFilterOfString | undefined;
    createdDate: DateQueryFilter[];
    dateWorked: DateQueryFilter[];
    displayStatus: ArrayQueryFilterOfReviewerTimeEntryDisplayStatus | undefined;
    entryType: ArrayQueryFilterOfReviewerTypeEntryType | undefined;
    reviewerName: ArrayQueryFilterOfString | undefined;
    reviewerType: ArrayQueryFilterOfString | undefined;
    reviewerNotes: StringQueryFilter | undefined;
    reviewerTypeRole: ArrayQueryFilterOfString | undefined;
    timeCategoryId: ArrayQueryFilterOfNullableInteger | undefined;
    weekOf: DateQueryFilter[];
    lastExportedDate: DateQueryFilter[];
    type: ArrayQueryFilterOfString | undefined;
    rate: DecimalQueryFilter | undefined;
    cost: DecimalQueryFilter | undefined;
    caseLocationNames: ArrayQueryFilterOfString | undefined;
    matterCodes: ArrayQueryFilterOfString | undefined;
    actionCodeNames: ArrayQueryFilterOfString | undefined;
    exportStatus: ArrayQueryFilterOfTimeEntryExportStatus | undefined;
    phaseTaskCode: ArrayQueryFilterOfString | undefined;
    phaseCodeName: ArrayQueryFilterOfString | undefined;
    taskCodeName: ArrayQueryFilterOfString | undefined;
}

export interface QueryFilterOfListOfReviewerTimeEntryDisplayStatusAndReviewerTimeEntryDisplayStatus {
    value: ReviewerTimeEntryDisplayStatus[] | undefined;
}

export interface ArrayQueryFilterOfReviewerTimeEntryDisplayStatus extends QueryFilterOfListOfReviewerTimeEntryDisplayStatusAndReviewerTimeEntryDisplayStatus {
    matchMode: ArrayMatchMode;
}

export interface QueryFilterOfListOfReviewerTypeEntryTypeAndReviewerTypeEntryType {
    value: ReviewerTypeEntryType[] | undefined;
}

export interface ArrayQueryFilterOfReviewerTypeEntryType extends QueryFilterOfListOfReviewerTypeEntryTypeAndReviewerTypeEntryType {
    matchMode: ArrayMatchMode;
}

export interface QueryFilterOfListOfNullableIntegerAndNullableInteger {
    value: (number | undefined)[] | undefined;
}

export interface ArrayQueryFilterOfNullableInteger extends QueryFilterOfListOfNullableIntegerAndNullableInteger {
    matchMode: ArrayMatchMode;
}

export interface QueryFilterOfNullableDecimalAndNullableDecimal {
    value: number | undefined;
}

export interface DecimalQueryFilter extends QueryFilterOfNullableDecimalAndNullableDecimal {
    matchMode: NumberMatchMode;
}

export interface QueryFilterOfListOfTimeEntryExportStatusAndTimeEntryExportStatus {
    value: TimeEntryExportStatus[] | undefined;
}

export interface ArrayQueryFilterOfTimeEntryExportStatus extends QueryFilterOfListOfTimeEntryExportStatusAndTimeEntryExportStatus {
    matchMode: ArrayMatchMode;
}

export interface GetCompanyTimeEntriesCountQuery {
    caseId: number | undefined;
    filters: CompanyTimeEntryFilters | undefined;
}

export interface ApplicationResultOfFiltersModel extends ApplicationResult {
    data: FiltersModel | undefined;
}

export interface FiltersModel {
    filters: { [key: string]: LookUpDto[]; };
}

export interface ApplicationResultOfListOfCompanyAggregatedDailyTimeEntryDto extends ApplicationResult {
    data: CompanyAggregatedDailyTimeEntryDto[] | undefined;
}

export interface BaseAggregatedTimeEntryDto {
    caseId: number;
    caseName: string | undefined;
    caseLocationNames: string[];
    matterCodes: string[];
    phaseCodes: PhaseCodeDto[];
    taskCodes: TaskCodeDto[];
    reviewerTypeRole: string | undefined;
    actionCodeNames: string[];
    dateWorked: Date;
    minutes: number;
    status: AggregatedTimeEntryStatus;
    timeEntriesIds: number[];
    type: string | undefined;
    actualMinutesWorked: number | undefined;
    docsReviewed: number | undefined;
    companyId: number;
    reviewTime: AggregatedTimeEntriesReviewTime;
    reviewTimeMinutes: number;
    reviewTimeMinutesThreshold: number;
    duration: string;
    hasReviewerNotes: boolean;
    rate: number;
    dateApproved: Date | undefined;
    dateRejected: Date | undefined;
    createdDate: Date | undefined;
    modifiedDate: Date | undefined;
    reviewerNotes: ReviewerNoteDto[];
    durationFormatted: string;
    dateApprovedRejected: Date | undefined;
    varianceMinutes: number | undefined;
    variancePercent: number | undefined;
}

export interface CompanyAggregatedTimeEntryDto extends BaseAggregatedTimeEntryDto {
    reviewerId: number;
    reviewerName: string | undefined;
    reviewerTypeName: string | undefined;
    reviewerFirstName: string | undefined;
    reviewerLastName: string | undefined;
    reviewerClientEmployeeId: string | undefined;
    minutesApproved: number;
    minutesAutoApproved: number;
    minutesPending: number;
    minutesOT: number | undefined;
    cost: number | undefined;
    costOT: number | undefined;
    isAnyPending: boolean;
    isReadOnly: boolean;
    reviewerPersonalEmail: string | undefined;
    altorneyEmail: string | undefined;
    companyEmail: string | undefined;
    exportStatus: TimeEntryExportStatus;
    lastExportedDate: Date | undefined;
}

export interface CompanyAggregatedDailyTimeEntryDto extends CompanyAggregatedTimeEntryDto {
}

export interface PhaseCodeDto extends LookUpDto {
    companyId: number;
    taskCodes: TaskCodeDto[];
}

export interface TaskCodeDto extends LookUpDto {
    phaseCodeId: number;
    phaseCode: PhaseCodeDto | undefined;
}

export enum AggregatedTimeEntryStatus {
    Pending = "Pending",
    Approved = "Approved",
    Rejected = "Rejected",
    AutoApproved = "AutoApproved",
    Mixed = "Mixed",
}

export enum AggregatedTimeEntriesReviewTime {
    ReviewTime = "ReviewTime",
    NonReviewTime = "NonReviewTime",
    Mixed = "Mixed",
}

export interface ReviewerNoteDto {
    note: string;
    minutes: number;
    createdDate: Date;
}

export interface ApplicationResultOfListOfCompanyAggregatedWeeklyTimeEntryDto extends ApplicationResult {
    data: CompanyAggregatedWeeklyTimeEntryDto[] | undefined;
}

export interface CompanyAggregatedWeeklyTimeEntryDto extends CompanyAggregatedTimeEntryDto {
    weekOfYear: number;
    year: number;
}

export interface MarkTimeEntriesAsExportedCommand {
    timeEntryIds: number[];
}

export interface ApplicationResultOfReviewerTimeEntriesResultDto extends ApplicationResult {
    data: ReviewerTimeEntriesResultDto | undefined;
}

export interface ReviewerTimeEntriesResultDto {
    items: ReviewerTimeEntryListDto[];
    isPhaseAndTaskCodesEnabled: boolean;
}

export interface ReviewerTimeEntryListDto {
    id: number;
    caseName: string | undefined;
    caseId: number;
    reviewerType: string | undefined;
    reviewerTypeRole: string | undefined;
    reviewerTypeRoleId: number;
    dateWorked: Date | undefined;
    minutes: number;
    earningSum: number | undefined;
    status: ReviewerTimeEntryStatus;
    displayStatus: ReviewerTimeEntryDisplayStatus;
    earningsDescription: string | undefined;
    reviewerNotes: string | undefined;
    companyNotes: string | undefined;
    entryType: ReviewerTypeEntryType;
    caseTimeEntryType: TimeEntryType;
    reviewerTimeEntryRejectedReasonName: string | undefined;
    reviewerTimeEntryRejectedOtherReason: string | undefined;
    phaseCode: string | undefined;
    taskCode: string | undefined;
    description: string | undefined;
    dateApproved: Date | undefined;
    dateRejected: Date | undefined;
    createdDate: Date | undefined;
    modifiedDate: Date | undefined;
    dateApprovedRejected: Date | undefined;
}

export interface ApplicationResultOfListOfReviewerAggregatedTimeEntryDto extends ApplicationResult {
    data: ReviewerAggregatedTimeEntryDto[] | undefined;
}

export interface ReviewerAggregatedTimeEntryDto extends BaseAggregatedTimeEntryDto {
    earnings: number | undefined;
    reviewerType: string | undefined;
    description: string | undefined;
}

export interface ApplicationResultOfReviewerTimeEntryDto extends ApplicationResult {
    data: ReviewerTimeEntryDto | undefined;
}

export interface ReviewerTimeEntryDto {
    id: number;
    reviewerId: number;
    caseId: number;
    reviewerTypeId: number;
    reviewerTypeRoleId: number;
    dateWorked: Date;
    minutes: number;
    status: ReviewerTimeEntryStatus;
    timeCategoryId: number | undefined;
    entryType: ReviewerTypeEntryType;
    reviewerNotes: string | undefined;
    secondsFromClock: number | undefined;
    clockStartTime: Date | undefined;
    clockStopTime: Date | undefined;
    isReadOnly: boolean;
    phaseCodeId: number | undefined;
    taskCodeId: number | undefined;
}

export interface ApplicationResultOfUpsertTimeEntryResult extends ApplicationResult {
    data: UpsertTimeEntryResult | undefined;
}

export interface UpsertTimeEntryResult {
    warning: string;
}

export interface BaseTimeEntryCommand {
    dateWorked: Date;
    reviewerTypeId: number;
    minutes: number;
    timeCategoryId: number | undefined;
    reviewerNotes: string | undefined;
    phaseTaskCodeId: number | undefined;
}

export interface UpsertTimeEntryCommand extends BaseTimeEntryCommand {
    id: number;
    secondsFromClock: number | undefined;
    clockStartTime: Date | undefined;
    clockStopTime: Date | undefined;
    entryType: ReviewerTypeEntryType;
    reviewerSummary: string | undefined;
}

export interface CreateTimeEntryForReviewer extends BaseTimeEntryCommand {
    reviewerId: number;
    force: boolean;
}

export interface ApplicationResultOfListOfTimeEntriesCaseDto extends ApplicationResult {
    data: TimeEntriesCaseDto[] | undefined;
}

export interface TimeEntriesCaseDto extends LookUpDto {
    reviewerTypes: TimeEntriesReviewerTypeDto[];
    timeEntryMinuteInterval: number;
    isW2Company: boolean;
    timeEntryType: TimeEntryType;
    hasActiveReviewerTypes: boolean;
    isPhaseAndTaskCodesEnabled: boolean;
}

export interface TimeEntriesReviewerTypeDto extends LookUpDto {
    reviewerSummariesRequirement: RequiredValues;
    reviewerSummariesType: ReviewerSummaryDateType;
    isActive: boolean;
}

export interface ApplicationResultOfListOfTimeEntryAvailableTimeSpanDto extends ApplicationResult {
    data: TimeEntryAvailableTimeSpanDto[] | undefined;
}

export interface TimeEntryAvailableTimeSpanDto {
    startDate: Date;
    endDate: Date;
}

export interface UpdateTimeEntryStatusCommand {
    reviewerTimeEntryId: number;
    status: ReviewerTimeEntryStatus;
}

export interface RejectTimeEntryCommand {
    reviewerTimeEntryId: number;
    reviewerTimeEntryRejectedReasonId: number;
    reviewerTimeEntryRejectedOtherReason: string | undefined;
}

export interface BulkUpdateTimeEntryStatus {
    timeEntryIds: number[];
    status: ReviewerTimeEntryStatus;
}

export interface BulkRejectTimeEntryCommand {
    timeEntryIds: number[];
    reviewerTimeEntryRejectedReasonId: number;
    reviewerTimeEntryRejectedOtherReason: string | undefined;
}

export interface ApplicationResultOfActualWorkingTimeDto extends ApplicationResult {
    data: ActualWorkingTimeDto | undefined;
}

export interface ActualWorkingTimeDto {
    minutesWorked: number | undefined;
    docsReviewed: number | undefined;
    speed: number | undefined;
    lastSyncDate: Date | undefined;
}

export interface ApplicationResultOfEnteredWorkingTimeDto extends ApplicationResult {
    data: EnteredWorkingTimeDto | undefined;
}

export interface EnteredWorkingTimeDto {
    minutesWorked: number;
}

export interface ApplicationResultOfListOfRelativityAuditsTimeSpanDto extends ApplicationResult {
    data: RelativityAuditsTimeSpanDto[] | undefined;
}

export interface RelativityAuditsTimeSpanDto {
    reviewerName: string;
    workspaceName: string;
    startSpan: Date;
    endSpan: Date;
    spanLengthMinutes: number;
    spanLengthHours: number;
    spanBreakHours: number;
    startAudit: string;
    endAudit: string;
    userArtifactId: number | undefined;
    edits: number;
}

export interface ApplicationResultOfListOfTimeZoneDto extends ApplicationResult {
    data: TimeZoneDto[] | undefined;
}

export interface ApplicationResultOfListOfCompanyTrustedIpDto extends ApplicationResult {
    data: CompanyTrustedIpDto[] | undefined;
}

export interface ApplicationResultOfListOfAdminUserDto extends ApplicationResult {
    data: AdminUserDto[] | undefined;
}

export interface AdminUserDto {
    id: number;
    name: string | undefined;
    email: string;
    isActive: boolean;
    emailConfirmed: boolean;
    lastLoginDate: Date | undefined;
    lastLoginOrImpersonationDate: Date | undefined;
    createdDate: Date | undefined;
    fullName: string;
    roles: RoleDto[];
    companies: LookUpDto[];
    userCompanyRole: string | undefined;
    role: RoleDto;
    company: LookUpDto | undefined;
    isLoggedIn: boolean;
    canBeDeleted: boolean;
}

export interface CreateAdminCommand {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
}

export interface ApplicationResultOfListOfUserPermissionRoleDto extends ApplicationResult {
    data: UserPermissionRoleDto[] | undefined;
}

export interface UserPermissionRoleDto {
    id: number;
    name: string;
    permissions: string[];
}

export interface ApplicationResultOfUserSettingsDto extends ApplicationResult {
    data: UserSettingsDto | undefined;
}

export interface UserSettingsDto {
    hasNotificationOptout: boolean;
    minutesBeforeTimeOut: number;
    hasEnabledNotificationSound: boolean;
    unreadMessagesIntervalMinutes: number;
    chatRingtoneId: number | undefined;
    chatRingtone: ChatRingtoneDto | undefined;
}

export interface SaveUserSettingsCommand {
    minutesBeforeTimeOut: number;
}

export interface ApplicationResultOfUserStateDto extends ApplicationResult {
    data: UserStateDto | undefined;
}

export interface UserStateDto {
    key: string;
    state: string | undefined;
}

export interface SaveUserStateCommand {
    key: string;
    state: string | undefined;
}

export interface ApplicationResultOfListOfAdminRatingDto extends ApplicationResult {
    data: AdminRatingDto[] | undefined;
}

export interface AdminRatingDto {
    id: number;
    reviewerName: string;
    companyId: number | undefined;
    companyName: string | undefined;
    caseName: string | undefined;
    reviewerTypeName: string | undefined;
    dateOfRating: Date;
    rating: number;
    ratingComment: string | undefined;
    isApproved: boolean;
    isLocked: boolean;
    ratingReply: string | undefined;
    isReplyApproved: boolean;
    isReplyLocked: boolean;
    revisionReason: string | undefined;
    status: RatingStatus;
    sortOrder: number;
}

export interface AdminGetReviewerRatingsQuery {
}

export interface ApplicationResultOfAdminRatingDto extends ApplicationResult {
    data: AdminRatingDto | undefined;
}

export interface AdminBulkApproveRatingsCommand {
    ratingIds: number[];
}

export interface AdminBulkApproveReviewerRatingsCommand extends AdminBulkApproveRatingsCommand {
}

export interface AdminSendReviewerRatingForRevisionCommand {
    id: number;
    reason: string;
}

export interface AdminGetCompanyRatingsQuery {
}

export interface AdminBulkApproveCompanyRatingsCommand extends AdminBulkApproveRatingsCommand {
}

export interface AdminSendCompanyRatingForRevisionCommand {
    id: number;
    reason: string;
}

export interface CompanyRateReviewerCommand {
    reviewerSpanId: number;
    rating: number;
    ratingComment: string | undefined;
}

export interface CompanyRepliesReviewerRatingCommand {
    ratingId: number;
    reply: string;
}

export interface CompanyBulkRateReviewersCommand {
    spanIds: number[];
}

export interface ApplicationResultOfListOfRatingDto extends ApplicationResult {
    data: RatingDto[] | undefined;
}

export interface ApplicationResultOfListOfRatingSpanDto extends ApplicationResult {
    data: RatingSpanDto[] | undefined;
}

export interface RatingSpanDto {
    id: number;
    companyName: string;
    reviewerName: string;
    caseName: string;
    reviewerTypeName: string;
    startDate: Date;
    endDate: Date | undefined;
    ratingCloseDate: Date | undefined;
    ratingReplyLockDate: Date | undefined;
    ratingCloseDisplayDate: Date | undefined;
    rating: RatingDto | undefined;
    currentUserCanRate: boolean;
    currentUserCanReply: boolean;
}

export interface ReviewerRateCompanyCommand {
    reviewerSpanId: number;
    rating: number;
    ratingComment: string | undefined;
}

export interface ReviewerRepliesCompanyRatingCommand {
    ratingId: number;
    reply: string;
}

export interface ApplicationResultOfActionCodeDto extends ApplicationResult {
    data: ActionCodeDto | undefined;
}

export interface CreateActionCodeCommand {
    name: string;
}

export interface UpdateActionCodeCommand {
    id: number;
    name: string;
}

export interface AdditionalServiceDto extends LookUpDto {
    price: number;
    requiresMonthsSelect: boolean;
    group: string | undefined;
}

export interface CreateLookUpCommandOfAdditionalServiceAndAdditionalServiceDto {
    name: string | undefined;
}

export interface CreateLookUpCommandOfAttorneyAndLookUpDto {
    name: string | undefined;
}

export interface CreateLookUpCommandOfCaseRequirementAndLookUpDto {
    name: string | undefined;
}

export interface CaseSettingLocationDto extends LookUpDto {
    isDefault: boolean;
    companyId: number;
}

export interface CaseSettingLocationQuery {
}

export interface ApplicationResultOfCaseSettingLocationDto extends ApplicationResult {
    data: CaseSettingLocationDto | undefined;
}

export interface CreateCaseSettingLocationCommand {
    name: string;
    isDefault: boolean;
}

export interface UpdateCaseSettingLocationCommand {
    id: number;
    name: string;
    isDefault: boolean;
}

export interface CreateLookUpCommandOfCaseTypeAndLookUpDto {
    name: string | undefined;
}

export interface CreateLookUpCommandOfClientAndLookUpDto {
    name: string | undefined;
}

export interface CreateLookUpCommandOfExperienceLevelAndExperienceLevelDto {
    name: string | undefined;
}

export interface CreateLookUpCommandOfFirmAndLookUpDto {
    name: string | undefined;
}

export interface CreateLookUpCommandOfLanguageAndLookUpDto {
    name: string | undefined;
}

export interface CreateLookUpCommandOfLanguageForCredentialAndLookUpDto {
    name: string | undefined;
}

export interface CreateLookUpCommandOfLawSchoolAndLookUpDto {
    name: string | undefined;
}

export interface MatterCodeDto extends LookUpDto {
    companyId: number;
}

export interface MatterCodeQuery {
}

export interface ApplicationResultOfMatterCodeDto extends ApplicationResult {
    data: MatterCodeDto | undefined;
}

export interface CreateMatterCodeCommand {
    name: string;
}

export interface UpdateMatterCodeCommand {
    id: number;
    name: string;
}

export interface ApplicationResultOfPhaseCodeDto extends ApplicationResult {
    data: PhaseCodeDto | undefined;
}

export interface CreatePhaseCodeCommand {
    name: string;
}

export interface UpdatePhaseCodeCommand {
    id: number;
    name: string;
}

export interface CreateLookUpCommandOfReviewerRejectedReasonAndLookUpDto {
    name: string | undefined;
}

export interface CreateLookUpCommandOfReviewerRequirementAndLookUpDto {
    name: string | undefined;
}

export interface ReviewerTechnologyDto extends LookUpDto {
    order: number;
}

export interface CreateLookUpCommandOfReviewerTechnologyAndReviewerTechnologyDto {
    name: string | undefined;
}

export interface CreateLookUpCommandOfReviewerTimeEntryRejectedReasonAndLookUpDto {
    name: string | undefined;
}

export interface CreateLookUpCommandOfReviewerTypeDeactivateReasonAndLookUpDto {
    name: string | undefined;
}

export interface CreateLookUpCommandOfReviewerTypeWithdrawReasonAndLookUpDto {
    name: string | undefined;
}

export interface CreateLookUpCommandOfReviewerTypeQuestionAndLookUpDto {
    name: string | undefined;
}

export interface CreateLookUpCommandOfReviewerTypeRoleAndLookUpDto {
    name: string | undefined;
}

export interface ReviewerTypeReviewLikelihoodDto extends LookUpDto {
}

export interface CreateLookUpCommandOfReviewerTypeReviewLikelihoodAndReviewerTypeReviewLikelihoodDto {
    name: string | undefined;
}

export interface CreateLookUpCommandOfSpecialtyAndLookUpDto {
    name: string | undefined;
}

export interface CreateLookUpCommandOfStateBarStatusAndLookUpDto {
    name: string | undefined;
}

export interface ApplicationResultOfTaskCodeDto extends ApplicationResult {
    data: TaskCodeDto | undefined;
}

export interface CreateTaskCodeCommand {
    name: string;
    phaseCodeId: number;
}

export interface UpdateTaskCodeCommand {
    id: number;
    name: string;
    phaseCodeId: number;
}

export interface ApplicationResultOfListOfTechnologyProficiencyDto extends ApplicationResult {
    data: TechnologyProficiencyDto[] | undefined;
}

export interface TechnologyProficiencyDto {
    id: number;
    duration: string | undefined;
}

export interface CreateLookUpCommandOfTechnologyServiceProviderAndLookUpDto {
    name: string | undefined;
}

export interface UpdateTimeCategoryCommand {
    id: number;
    name: string | undefined;
    isReviewTime: boolean;
    type: TimeCategoryType;
}

export enum TimeCategoryType {
    Both = "Both",
    Standard = "Standard",
    W2 = "W2",
}

export interface ApplicationResultOfListOfTimeCategoryDto extends ApplicationResult {
    data: TimeCategoryDto[] | undefined;
}

export interface CompanyLookUpDto extends LookUpDto {
    companyId: number | undefined;
}

export interface TimeCategoryDto extends CompanyLookUpDto {
    isReviewTime: boolean;
    type: TimeCategoryType;
}

export interface CreateLookUpCommandOfTimeCategoryAndTimeCategoryDto {
    name: string | undefined;
}

export interface CreateTimeCategoryCommand extends CreateLookUpCommandOfTimeCategoryAndTimeCategoryDto {
    isReviewTime: boolean;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}